const ymm = {
    "1980": {
        "Buick": {
            "Riviera": [
                ""
            ]
        },
        "Cadillac": {
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        }
    },
    "1981": {
        "Buick": {
            "Riviera": [
                ""
            ]
        },
        "Cadillac": {
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        }
    },
    "1982": {
        "Buick": {
            "Regal": [
                ""
            ],
            "Riviera": [
                ""
            ]
        },
        "Cadillac": {
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        },
        "Chevrolet": {
            "Camaro": [
                "Drum rear brakes"
            ],
            "El Camino": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "S10": [
                ""
            ]
        },
        "GMC": {
            "Caballero": [
                ""
            ],
            "S15": [
                ""
            ]
        },
        "Pontiac": {
            "Bonneville": [
                ""
            ],
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ]
        }
    },
    "1983": {
        "Buick": {
            "Regal": [
                ""
            ],
            "Riviera": [
                ""
            ]
        },
        "Cadillac": {
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        },
        "Chevrolet": {
            "Camaro": [
                "Drum rear brakes"
            ],
            "El Camino": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD"
            ]
        },
        "GMC": {
            "Caballero": [
                ""
            ],
            "S15": [
                "4WD",
                "RWD"
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD"
            ]
        },
        "Pontiac": {
            "Bonneville": [
                ""
            ],
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ]
        }
    },
    "1984": {
        "Buick": {
            "Regal": [
                ""
            ],
            "Riviera": [
                ""
            ]
        },
        "Cadillac": {
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        },
        "Chevrolet": {
            "Camaro": [
                "Drum rear brakes"
            ],
            "El Camino": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD"
            ]
        },
        "GMC": {
            "Caballero": [
                ""
            ],
            "S15": [
                "4WD",
                "RWD"
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD"
            ]
        },
        "Pontiac": {
            "Bonneville": [
                ""
            ],
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ]
        }
    },
    "1985": {
        "Buick": {
            "Regal": [
                ""
            ],
            "Riviera": [
                ""
            ]
        },
        "Cadillac": {
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        },
        "Chevrolet": {
            "Camaro": [
                ""
            ],
            "El Camino": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD"
            ]
        },
        "GMC": {
            "Caballero": [
                ""
            ],
            "Jimmy": [
                ""
            ],
            "S15": [
                "4WD",
                "RWD"
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD"
            ]
        },
        "Pontiac": {
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ]
        }
    },
    "1986": {
        "Buick": {
            "Regal": [
                ""
            ]
        },
        "Chevrolet": {
            "Camaro": [
                ""
            ],
            "El Camino": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD"
            ]
        },
        "GMC": {
            "Caballero": [
                ""
            ],
            "Jimmy": [
                ""
            ],
            "S15": [
                "4WD",
                "RWD"
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD"
            ]
        },
        "Pontiac": {
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ]
        }
    },
    "1987": {
        "Buick": {
            "Regal": [
                ""
            ]
        },
        "Chevrolet": {
            "Camaro": [
                ""
            ],
            "El Camino": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD"
            ]
        },
        "GMC": {
            "Caballero": [
                ""
            ],
            "Jimmy": [
                ""
            ],
            "S15": [
                "4WD",
                "RWD"
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD"
            ]
        },
        "Pontiac": {
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Prix": [
                "With 9-1/2\" x 2\" Rear Drum Brakes"
            ]
        }
    },
    "1988": {
        "Chevrolet": {
            "C1500": [
                "With Heavy Duty Chassis"
            ],
            "Camaro": [
                "Drum rear brakes. Without Performance Package"
            ],
            "K3500": [
                "With Single Rear Wheels and 6-3/8\" Wide Drum"
            ],
            "Monte Carlo": [
                ""
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD"
            ]
        },
        "GMC": {
            "C1500": [
                "With Heavy Duty Suspension"
            ],
            "Jimmy": [
                ""
            ],
            "K3500": [
                "With Single Rear Wheels and 13\" x 2-1/2\" Size Drum and Total Drum Depth Of 6.16\""
            ],
            "S15": [
                "4WD",
                "RWD"
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD"
            ]
        },
        "Pontiac": {
            "Firebird": [
                "Drum rear brakes. Without Performance Package"
            ]
        }
    },
    "1989": {
        "Chevrolet": {
            "C1500": [
                "With Heavy Duty Chassis"
            ],
            "Camaro": [
                "",
                "Disc rear brakes. 1LE Performance Option",
                "Drum rear brakes"
            ],
            "K3500": [
                "With Single Rear Wheels and 6-3/8\" Wide Drum"
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD"
            ]
        },
        "GMC": {
            "C1500": [
                "With Heavy Duty Suspension"
            ],
            "K3500": [
                "With Single Rear Wheels and 13\" x 2-1/2\" Size Drum and Total Drum Depth Of 6.16\""
            ],
            "S15": [
                "4WD",
                "RWD"
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD"
            ]
        },
        "Pontiac": {
            "Firebird": [
                "Drum rear brakes. With Single Piston Caliper and With 10-1/2\" Diameter Rotor"
            ]
        },
        "Toyota": {
            "Pickup": [
                "4WD"
            ]
        }
    },
    "1990": {
        "Buick": {
            "Skylark": [
                "With Performance Package and WS6, or With Performance Package"
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD and with 4-Wheel ABS"
            ],
            "C1500": [
                "With Heavy Duty Chassis"
            ],
            "Camaro": [
                "",
                "Disc rear brakes. 1LE Performance Option",
                "Drum rear brakes"
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD"
            ]
        },
        "GMC": {
            "C1500": [
                "With Heavy Duty Suspension"
            ],
            "Jimmy": [
                ""
            ],
            "S15": [
                "4WD",
                "RWD"
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD"
            ],
            "Safari": [
                "AWD",
                "RWD. With 4 Wheel ABS"
            ]
        },
        "Honda": {
            "Accord": [
                "Sedan. With Akebono Calipers"
            ]
        },
        "Jeep": {
            "Cherokee": [
                "4WD. With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "With 9\" x 2-1/2\" Size Drum"
            ]
        },
        "Pontiac": {
            "Firebird": [
                "Drum rear brakes. With Single Piston Caliper"
            ],
            "Grand Am": [
                "With Performance Package and WS6"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Pickup": [
                "4WD"
            ]
        }
    },
    "1991": {
        "Acura": {
            "Legend": [
                ""
            ]
        },
        "BMW": {
            "325is": [
                ""
            ]
        },
        "Buick": {
            "Skylark": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD and with 4-Wheel ABS"
            ],
            "C1500": [
                "With Heavy Duty Chassis"
            ],
            "Camaro": [
                "",
                "Disc rear brakes. 1LE Performance Option",
                "Drum rear brakes"
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without Wear Sensor"
            ]
        },
        "GMC": {
            "C1500": [
                "With Heavy Duty Suspension"
            ],
            "Jimmy": [
                ""
            ],
            "S15 Jimmy": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Safari": [
                "AWD",
                "RWD. With 4 Wheel ABS"
            ],
            "Sonoma": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Syclone": [
                ""
            ]
        },
        "Honda": {
            "Accord": [
                "Sedan and with Disc rear brakes. With Akebono Calipers",
                "Sedan and with Drum rear brakes. With Akebono Calipers"
            ]
        },
        "INFINITI": {
            "G20": [
                ""
            ]
        },
        "Jeep": {
            "Cherokee": [
                "4WD and with 4-Wheel ABS. With 9\" Diameter Drum",
                "4WD. With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "With 9\" x 2-1/2\" Size Drum"
            ]
        },
        "Pontiac": {
            "Firebird": [
                "Drum rear brakes. With Single Piston Caliper"
            ],
            "Grand Am": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "To 06/91"
            ],
            "Pickup": [
                "4WD"
            ],
            "Tercel": [
                ""
            ]
        }
    },
    "1992": {
        "Acura": {
            "Integra": [
                "GS-R"
            ],
            "Legend": [
                ""
            ]
        },
        "BMW": {
            "318i": [
                "Sedan"
            ],
            "318is": [
                ""
            ],
            "320i": [
                ""
            ],
            "325i": [
                "Sedan"
            ],
            "325is": [
                ""
            ]
        },
        "Buick": {
            "Skylark": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD and with 4-Wheel ABS"
            ],
            "Beretta": [
                "Except Vehicles Built For USA Market",
                "Vehicles Built For USA Market"
            ],
            "Blazer": [
                "4WD",
                "4WD. With 10\" Diameter Drum",
                "4WD. With 11\" Diameter Drum"
            ],
            "Camaro": [
                "",
                "Disc rear brakes. 1LE Performance Option",
                "Drum rear brakes"
            ],
            "Cavalier": [
                "With 200mm x 45mm Size Drum"
            ],
            "Corsica": [
                ""
            ],
            "K1500": [
                "With 10\" Diameter Drum"
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without Wear Sensor"
            ]
        },
        "GMC": {
            "Jimmy": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Safari": [
                "AWD",
                "RWD. With 4 Wheel ABS"
            ],
            "Sonoma": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Typhoon": [
                ""
            ],
            "Yukon": [
                "4WD. With 10\" Diameter Drum and With 5 Lug Wheels",
                "4WD. With 10\" Diameter Drum and With 6 Lug Wheels",
                "RWD. With 10\" Diameter Drum and With 5 Lug Wheels",
                "RWD. With 10\" Diameter Drum and With 6 Lug Wheels"
            ]
        },
        "Honda": {
            "Accord": [
                "Sedan. With Akebono Calipers"
            ],
            "Civic": [
                "LX/DX and with Sedan and Automatic transmission",
                "LX/DX and with Sedan and Automatic transmission and Drum rear brakes"
            ]
        },
        "INFINITI": {
            "G20": [
                ""
            ]
        },
        "Jeep": {
            "Cherokee": [
                "4WD and with 4-Wheel ABS. With 9\" Diameter Drum",
                "4WD. With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "With 9\" x 2-1/2\" Size Drum"
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ]
        },
        "Pontiac": {
            "Firebird": [
                "Drum rear brakes. With Single Piston Caliper"
            ],
            "Grand Am": [
                ""
            ],
            "Sunbird": [
                ""
            ]
        },
        "Toyota": {
            "Camry": [
                "2.2L",
                "Sedan and with 2.2L",
                "Sedan and with 3.0L",
                "Wagon and with 2.2L",
                "Wagon and with 3.0L"
            ],
            "Pickup": [
                "4WD"
            ],
            "Tercel": [
                ""
            ]
        }
    },
    "1993": {
        "Acura": {
            "Integra": [
                "GS-R"
            ],
            "Legend": [
                "Sedan"
            ]
        },
        "BMW": {
            "318i": [
                ""
            ],
            "318is": [
                "To 05/93"
            ],
            "320i": [
                ""
            ],
            "325i": [
                "To 05/93"
            ],
            "325is": [
                "To 05/93"
            ]
        },
        "Buick": {
            "Skylark": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Beretta": [
                "Except Vehicles Built For USA Market",
                "Vehicles Built For USA Market"
            ],
            "Blazer": [
                "4WD",
                "4WD. With 10\" Diameter Drum",
                "4WD. With 11\" Diameter Drum"
            ],
            "C2500": [
                "Standard Cab Pickup. With 13\" Diameter Drum and With 8600 Lb GVW",
                "Standard Cab Pickup. With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "Standard Cab Pickup. With 8600 Lb GVW and With 13\" Diameter Drum"
            ],
            "Cavalier": [
                "With 200mm x 45mm Size Drum"
            ],
            "Corsica": [
                ""
            ],
            "K1500": [
                "With 10\" Diameter Drum"
            ],
            "S10": [
                "4WD",
                "RWD"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without Wear Sensor"
            ]
        },
        "GMC": {
            "Jimmy": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sonoma": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Typhoon": [
                ""
            ],
            "Yukon": [
                "4WD. With 10\" Diameter Drum and With 5 Lug Wheels",
                "4WD. With 10\" Diameter Drum and With 6 Lug Wheels",
                "RWD. With 10\" Diameter Drum and With 5 Lug Wheels",
                "RWD. With 10\" Diameter Drum and With 6 Lug Wheels"
            ]
        },
        "Honda": {
            "Accord": [
                "Sedan and with Disc rear brakes. With Akebono Calipers",
                "Sedan and with Drum rear brakes. With Akebono Calipers"
            ],
            "Civic del Sol": [
                "Disc rear brakes"
            ],
            "Civic": [
                "DX and with Coupe and Manual transmission",
                "DX and with Sedan/Coupe and Automatic transmission",
                "Si"
            ]
        },
        "INFINITI": {
            "G20": [
                ""
            ]
        },
        "Jeep": {
            "Cherokee": [
                "4-Wheel ABS. With 9\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "With 9\" x 2-1/2\" Size Drum"
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ]
        },
        "Nissan": {
            "Altima": [
                "Disc rear brakes"
            ]
        },
        "Pontiac": {
            "Grand Am": [
                ""
            ],
            "Sunbird": [
                ""
            ]
        },
        "Toyota": {
            "Camry": [
                "2.2L",
                "Sedan and with 2.2L and Disc rear brakes",
                "Sedan and with 3.0L and Disc rear brakes",
                "Wagon and with 2.2L and Disc rear brakes",
                "Wagon and with 3.0L and Disc rear brakes"
            ],
            "Corolla": [
                ""
            ],
            "Pickup": [
                "4WD"
            ],
            "Tercel": [
                "Non-ABS"
            ]
        },
        "Volkswagen": {
            "Golf": [
                "2.0L"
            ]
        }
    },
    "1994": {
        "Acura": {
            "Integra": [
                ""
            ],
            "Legend": [
                "Sedan"
            ]
        },
        "BMW": {
            "318i": [
                ""
            ],
            "318is": [
                ""
            ],
            "320i": [
                ""
            ],
            "325i": [
                ""
            ],
            "325is": [
                ""
            ]
        },
        "Buick": {
            "LeSabre": [
                ""
            ],
            "Park Avenue": [
                ""
            ],
            "Skylark": [
                ""
            ]
        },
        "Cadillac": {
            "DeVille": [
                ""
            ],
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Beretta": [
                "Vehicles Built For USA Market"
            ],
            "Blazer": [
                "4WD",
                "4WD. With 10\" Diameter Drum",
                "4WD. With 11\" Diameter Drum"
            ],
            "Camaro": [
                "Drum rear brakes"
            ],
            "Cavalier": [
                "With 200mm x 45mm Size Drum"
            ],
            "Corsica": [
                "Vehicles Built For USA Market"
            ],
            "K1500": [
                "With 10\" Diameter Drum"
            ],
            "Lumina APV": [
                ""
            ],
            "S10": [
                "4WD",
                "RWD and with 2-Wheel ABS",
                "RWD and with 4-Wheel ABS"
            ],
            "S10 Blazer": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without Wear Sensor"
            ]
        },
        "Dodge": {
            "Ram 1500": [
                "4WD",
                "RWD"
            ]
        },
        "Ford": {
            "E-150 Econoline": [
                "2-Wheel ABS",
                "2-Wheel ABS. 15/16\" Bore",
                "4-Wheel ABS",
                "4-Wheel ABS. 15/16\" Bore"
            ],
            "E-150 Econoline Club Wagon": [
                "",
                "15/16\" Bore"
            ],
            "F-150": [
                "RWD",
                "RWD. 15/16\" Bore"
            ],
            "Taurus": [
                "LX/GL",
                "SHO"
            ]
        },
        "GMC": {
            "C2500": [
                "With 13\" Diameter Drum and With 8600 Lb GVW and With Full Floating Axle",
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "With 8600 Lb GVW and With 13\" Diameter Drum and With Full Floating Axle"
            ],
            "Jimmy": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sonoma": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Yukon": [
                "4WD. With 10\" Diameter Drum and With 5 Lug Wheels",
                "4WD. With 10\" Diameter Drum and With 6 Lug Wheels",
                "RWD. With 10\" Diameter Drum and With 5 Lug Wheels",
                "RWD. With 10\" Diameter Drum and With 6 Lug Wheels"
            ]
        },
        "Honda": {
            "Accord": [
                "Sedan/Coupe and with Disc rear brakes. Nissin Calipers",
                "Sedan/Coupe and with Drum rear brakes"
            ],
            "Civic del Sol": [
                "S/Si",
                "VTEC"
            ],
            "Civic": [
                "DX and with Coupe and Manual transmission",
                "DX and with Sedan/Coupe and Automatic transmission",
                "EX and with 2 doors and Coupe and Automatic transmission",
                "EX and with 2 doors and Coupe and Manual transmission",
                "EX and with Coupe",
                "EX and with Coupe and Automatic transmission",
                "EX and with Coupe and Manual transmission",
                "EX and with Sedan and 4-Wheel ABS",
                "EX and with Sedan and Automatic transmission and 4-Wheel ABS",
                "EX and with Sedan and Automatic transmission and Non-ABS",
                "EX and with Sedan and Non-ABS",
                "Si and with 4-Wheel ABS",
                "Si and with Non-ABS"
            ]
        },
        "INFINITI": {
            "G20": [
                "From 02/94",
                "To 01/94"
            ]
        },
        "Jeep": {
            "Cherokee": [
                "4-Wheel ABS. With 9\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Grand Cherokee": [
                "Disc rear brakes. From Chassis/VIN #358321 or To Chassis/VIN #358321"
            ],
            "Wrangler": [
                ""
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ]
        },
        "Mercury": {
            "Sable": [
                "Disc rear brakes"
            ]
        },
        "Nissan": {
            "Altima": [
                "Disc rear brakes"
            ],
            "Maxima": [
                "Disc rear brakes"
            ]
        },
        "Pontiac": {
            "Bonneville": [
                "",
                "Vehicles Built For USA Market"
            ],
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Am": [
                ""
            ],
            "Sunbird": [
                "Vehicles Built For USA Market"
            ],
            "Trans Sport": [
                ""
            ]
        },
        "Toyota": {
            "Camry": [
                "2.2L",
                "Sedan/Coupe and with 2.2L and Disc rear brakes",
                "Sedan/Coupe and with 3.0L and Disc rear brakes",
                "Wagon and with 2.2L and Disc rear brakes",
                "Wagon and with 3.0L and Disc rear brakes"
            ],
            "Corolla": [
                ""
            ],
            "Pickup": [
                "4WD"
            ],
            "Tercel": [
                "Non-ABS"
            ]
        },
        "Volkswagen": {
            "Golf": [
                "2.0L"
            ]
        }
    },
    "1995": {
        "Acura": {
            "Integra": [
                ""
            ],
            "Legend": [
                "Sedan"
            ]
        },
        "BMW": {
            "318i": [
                ""
            ],
            "318is": [
                ""
            ],
            "320i": [
                ""
            ],
            "325i": [
                ""
            ],
            "325is": [
                ""
            ]
        },
        "Buick": {
            "LeSabre": [
                ""
            ],
            "Park Avenue": [
                ""
            ],
            "Riviera": [
                ""
            ],
            "Skylark": [
                ""
            ]
        },
        "Cadillac": {
            "DeVille": [
                ""
            ],
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Beretta": [
                "Vehicles Built For USA Market"
            ],
            "Blazer": [
                "4WD",
                "RWD. With ABS Tone Ring"
            ],
            "C2500": [
                "Standard Cab Pickup. With 13\" Diameter Drum and With 8600 Lb GVW",
                "Standard Cab Pickup. With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "Standard Cab Pickup. With 8600 Lb GVW and With 13\" Diameter Drum"
            ],
            "Camaro": [
                "",
                "Drum rear brakes"
            ],
            "Corsica": [
                "Vehicles Built For USA Market"
            ],
            "K1500": [
                "With 10\" Diameter Drum"
            ],
            "Lumina APV": [
                ""
            ],
            "Lumina": [
                "Drum rear brakes. With 10-1/2\" Diameter Rotor",
                "Drum rear brakes. With 11-1/4\" Diameter Rotor"
            ],
            "Monte Carlo": [
                "Drum rear brakes. With 10-1/2\" Diameter Rotor",
                "Drum rear brakes. With 11-1/4\" Diameter Rotor"
            ],
            "S10": [
                "4WD",
                "RWD and with 2-Wheel ABS",
                "RWD and with 4-Wheel ABS"
            ]
        },
        "Chrysler": {
            "Cirrus": [
                "Disc rear brakes. With 14\" Factory Wheels",
                "Disc rear brakes. With 15\" Factory Wheels"
            ],
            "Concorde": [
                ""
            ],
            "Intrepid": [
                ""
            ],
            "LHS": [
                ""
            ],
            "New Yorker": [
                ""
            ]
        },
        "Dodge": {
            "Intrepid": [
                "Disc rear brakes"
            ],
            "Ram 1500": [
                "4WD",
                "RWD"
            ],
            "Stratus": [
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ]
        },
        "Ford": {
            "E-150 Econoline": [
                "2-Wheel ABS",
                "2-Wheel ABS. 15/16\" Bore",
                "4-Wheel ABS",
                "4-Wheel ABS. 15/16\" Bore"
            ],
            "E-150 Econoline Club Wagon": [
                "",
                "15/16\" Bore"
            ],
            "Explorer": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "RWD",
                "RWD. 15/16\" Bore"
            ],
            "Taurus": [
                "LX/GL/SE",
                "SHO"
            ]
        },
        "GMC": {
            "C2500": [
                "With 13\" Diameter Drum and With 8600 Lb GVW and With Full Floating Axle",
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "With 8600 Lb GVW and With 13\" Diameter Drum and With Full Floating Axle"
            ],
            "Jimmy": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sonoma": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Yukon": [
                "2 doors and with 4WD and DIESEL engine. With 10\" Diameter Drum",
                "2 doors and with 4WD and DIESEL engine. With 11\" Diameter Drum",
                "2 doors and with 4WD and GAS engine. With 10\" Diameter Drum",
                "2 doors and with 4WD and GAS engine. With 11\" Diameter Drum",
                "RWD and with DIESEL engine. With 10\" Diameter Drum",
                "RWD and with DIESEL engine. With 11\" Diameter Drum",
                "RWD and with GAS engine. With 10\" Diameter Drum",
                "RWD and with GAS engine. With 11\" Diameter Drum"
            ]
        },
        "Honda": {
            "Accord": [
                "Coupe",
                "Sedan and with 2.2L"
            ],
            "Civic del Sol": [
                "Si",
                "VTEC"
            ],
            "Civic": [
                "DX and with Coupe and Manual transmission",
                "DX and with Sedan/Coupe and Automatic transmission",
                "EX and with Coupe",
                "EX and with Coupe and Automatic transmission",
                "EX and with Coupe and Manual transmission",
                "EX and with Sedan and 4-Wheel ABS",
                "EX and with Sedan and Automatic transmission and 4-Wheel ABS",
                "EX and with Sedan and Automatic transmission and Non-ABS",
                "EX and with Sedan and Non-ABS",
                "Si and with 4-Wheel ABS",
                "Si and with Non-ABS"
            ],
            "Odyssey": [
                ""
            ]
        },
        "INFINITI": {
            "G20": [
                ""
            ]
        },
        "Jeep": {
            "Cherokee": [
                "4-Wheel ABS. With 9\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Grand Cherokee": [
                ""
            ],
            "Wrangler": [
                ""
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ]
        },
        "Mercury": {
            "Sable": [
                "Disc rear brakes"
            ]
        },
        "Nissan": {
            "Altima": [
                "Disc rear brakes"
            ],
            "Maxima": [
                ""
            ]
        },
        "Pontiac": {
            "Bonneville": [
                "",
                "Vehicles Built For USA Market"
            ],
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Am": [
                ""
            ],
            "Sunfire": [
                ""
            ],
            "Trans Sport": [
                ""
            ]
        },
        "Toyota": {
            "Camry": [
                "2.2L",
                "Sedan/Coupe and with 2.2L",
                "Sedan/Coupe and with 3.0L",
                "Wagon and with 2.2L",
                "Wagon and with 3.0L"
            ],
            "Corolla": [
                ""
            ],
            "Pickup": [
                "4WD"
            ],
            "Tacoma": [
                "4WD. With 6 Lug Wheels"
            ],
            "Tercel": [
                "Non-ABS"
            ]
        },
        "Volkswagen": {
            "Golf": [
                "2.0L. With 4 Lug Wheels"
            ]
        }
    },
    "1996": {
        "Acura": {
            "Integra": [
                ""
            ],
            "RL": [
                ""
            ]
        },
        "BMW": {
            "318i": [
                ""
            ],
            "318is": [
                ""
            ],
            "328i": [
                "With 276mm Diameter Rear Rotor",
                "With 280mm Diameter Rear Rotor",
                "With 294mm Diameter Rear Rotor"
            ],
            "328is": [
                "With 280mm Diameter Rear Rotor",
                "With 294mm Diameter Rear Rotor"
            ]
        },
        "Buick": {
            "LeSabre": [
                ""
            ],
            "Park Avenue": [
                ""
            ],
            "Riviera": [
                ""
            ],
            "Skylark": [
                ""
            ]
        },
        "Cadillac": {
            "DeVille": [
                ""
            ],
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Beretta": [
                "Vehicles Built For USA Market"
            ],
            "Blazer": [
                "4WD",
                "RWD. With ABS Tone Ring"
            ],
            "C2500": [
                "With 13\" Diameter Drum and With 8600 Lb GVW and With Full Floating Axle",
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "With 8600 Lb GVW and With 13\" Diameter Drum and With Full Floating Axle"
            ],
            "Camaro": [
                "",
                "Drum rear brakes"
            ],
            "Corsica": [
                "Vehicles Built For USA Market"
            ],
            "K1500": [
                "With 10\" Diameter Drum"
            ],
            "Lumina APV": [
                ""
            ],
            "Lumina": [
                "Drum rear brakes"
            ],
            "Monte Carlo": [
                "Drum rear brakes"
            ],
            "S10": [
                "4WD",
                "RWD"
            ]
        },
        "Chrysler": {
            "Cirrus": [
                "Disc rear brakes. With 14\" Factory Wheels",
                "Disc rear brakes. With 15\" Factory Wheels"
            ],
            "Concorde": [
                ""
            ],
            "Intrepid": [
                ""
            ],
            "LHS": [
                ""
            ],
            "New Yorker": [
                ""
            ],
            "Sebring": [
                "Convertible"
            ],
            "Town and Country": [
                "With 15\" Factory Wheels and With 16\" Factory Wheels",
                "With 15\" Factory Wheels and With 16\" Factory Wheels, or With 16\" Factory Wheels and With 15\" Factory Wheels"
            ]
        },
        "Dodge": {
            "Caravan": [
                "With 15\" Factory Wheels and With 16\" Factory Wheels",
                "With 15\" Factory Wheels and With 16\" Factory Wheels, or With 16\" Factory Wheels and With 15\" Factory Wheels"
            ],
            "Grand Caravan": [
                "With 15\" Factory Wheels and With 16\" Factory Wheels",
                "With 15\" Factory Wheels and With 16\" Factory Wheels, or With 16\" Factory Wheels and With 15\" Factory Wheels"
            ],
            "Intrepid": [
                "Disc rear brakes"
            ],
            "Ram 1500": [
                "4WD",
                "RWD"
            ],
            "Stratus": [
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ]
        },
        "Ford": {
            "E-150 Econoline": [
                "2-Wheel ABS",
                "2-Wheel ABS. 15/16\" Bore",
                "4-Wheel ABS",
                "4-Wheel ABS. 15/16\" Bore"
            ],
            "E-150 Econoline Club Wagon": [
                "",
                "15/16\" Bore"
            ],
            "Econoline Super Duty": [
                "2-Wheel ABS. With Single Rear Wheels",
                "4-Wheel ABS. With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "4-Wheel ABS. With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "4-Wheel ABS. With Single Rear Wheels"
            ],
            "Explorer": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "RWD",
                "RWD. 15/16\" Bore"
            ],
            "Taurus": [
                "LX/GL/G",
                "SHO"
            ]
        },
        "GMC": {
            "C2500": [
                "With 13\" Diameter Drum and With 8600 Lb GVW and With Full Floating Axle",
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "With 8600 Lb GVW and With 13\" Diameter Drum and With Full Floating Axle"
            ],
            "Jimmy": [
                "4WD",
                "RWD. With ABS Tone Ring",
                "RWD. Without ABS Tone Ring"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sonoma": [
                "4WD",
                "RWD"
            ],
            "Yukon": [
                "2 doors and with 4WD and DIESEL engine. With 10\" Diameter Drum",
                "2 doors and with 4WD and DIESEL engine. With 11\" Diameter Drum",
                "2 doors and with 4WD and GAS engine. With 10\" Diameter Drum",
                "2 doors and with 4WD and GAS engine. With 11\" Diameter Drum",
                "RWD and with DIESEL engine. With 10\" Diameter Drum",
                "RWD and with DIESEL engine. With 11\" Diameter Drum",
                "RWD and with GAS engine. With 10\" Diameter Drum",
                "RWD and with GAS engine. With 11\" Diameter Drum"
            ]
        },
        "Honda": {
            "Accord": [
                "Coupe",
                "Sedan and with 2.2L"
            ],
            "Civic": [
                "CX/DX/HX",
                "EX/Si",
                "LX and with Automatic transmission and 4-Wheel ABS",
                "LX and with Manual transmission and 4-Wheel ABS",
                "LX and with Non-ABS"
            ],
            "Civic del Sol": [
                "Si",
                "VTEC"
            ],
            "Odyssey": [
                ""
            ]
        },
        "INFINITI": {
            "G20": [
                ""
            ],
            "I30": [
                ""
            ]
        },
        "Isuzu": {
            "Hombre": [
                ""
            ],
            "Oasis": [
                ""
            ]
        },
        "Jeep": {
            "Cherokee": [
                "4-Wheel ABS. With 9\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Grand Cherokee": [
                ""
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "E320": [
                ""
            ]
        },
        "Mercury": {
            "Sable": [
                "Disc rear brakes"
            ]
        },
        "Nissan": {
            "Altima": [
                "Disc rear brakes"
            ],
            "Maxima": [
                ""
            ],
            "Pathfinder": [
                ""
            ]
        },
        "Pontiac": {
            "Bonneville": [
                ""
            ],
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Am": [
                ""
            ],
            "Sunfire": [
                "",
                "Except Vehicles Built For USA Market"
            ],
            "Trans Sport": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 15\" Factory Wheels and From 11/95",
                "With 16\" Factory Wheels and From 11/95"
            ],
            "Camry": [
                "2.2L",
                "3.0L",
                "Sedan/Coupe and with 2.2L",
                "Sedan/Coupe and with 3.0L",
                "Wagon and with 2.2L",
                "Wagon and with 3.0L"
            ],
            "Corolla": [
                ""
            ],
            "Paseo": [
                "Non-ABS"
            ],
            "RAV4": [
                ""
            ],
            "Tacoma": [
                "4WD. With 6 Lug Wheels"
            ],
            "Tercel": [
                "Non-ABS"
            ]
        },
        "Volkswagen": {
            "Golf": [
                "1.9L. With 4 Lug Wheels",
                "2.0L. With 4 Lug Wheels"
            ],
            "Passat": [
                "1.9L"
            ]
        }
    },
    "1997": {
        "Acura": {
            "CL": [
                "2.2L"
            ],
            "EL": [
                ""
            ],
            "Integra": [
                "RS/GS/GS-R/LS",
                "Type R"
            ],
            "RL": [
                ""
            ]
        },
        "BMW": {
            "318i": [
                ""
            ],
            "318is": [
                ""
            ],
            "328i": [
                "With 276mm Diameter Rear Rotor",
                "With 280mm Diameter Rear Rotor",
                "With 294mm Diameter Rear Rotor"
            ],
            "328is": [
                "With 280mm Diameter Rear Rotor",
                "With 294mm Diameter Rear Rotor"
            ],
            "528i": [
                ""
            ]
        },
        "Buick": {
            "Century": [
                ""
            ],
            "LeSabre": [
                ""
            ],
            "Park Avenue": [
                ""
            ],
            "Regal": [
                ""
            ],
            "Riviera": [
                ""
            ],
            "Skylark": [
                ""
            ]
        },
        "Cadillac": {
            "DeVille": [
                "Disc rear brakes"
            ],
            "Eldorado": [
                ""
            ],
            "Seville": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Blazer": [
                "4WD and with Disc rear brakes",
                "4WD and with Drum rear brakes",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "C2500": [
                "With 13\" Diameter Drum and With 8600 Lb GVW and With Full Floating Axle",
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "With 8600 Lb GVW and With 13\" Diameter Drum and With Full Floating Axle"
            ],
            "Camaro": [
                "",
                "Drum rear brakes"
            ],
            "Corvette": [
                ""
            ],
            "K1500": [
                "With 10\" Diameter Drum"
            ],
            "K2500": [
                "With 6 Lug Wheels"
            ],
            "Lumina": [
                "Drum rear brakes"
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                "Drum rear brakes"
            ],
            "S10": [
                "4WD",
                "4WD and with Drum rear brakes",
                "RWD",
                "RWD and with Drum rear brakes"
            ],
            "Venture": [
                ""
            ]
        },
        "Chrysler": {
            "Cirrus": [
                "Disc rear brakes. With 14\" Factory Wheels",
                "Disc rear brakes. With 15\" Factory Wheels"
            ],
            "Concorde": [
                "Disc rear brakes"
            ],
            "Intrepid": [
                ""
            ],
            "LHS": [
                ""
            ],
            "Sebring": [
                "Convertible"
            ],
            "Town and Country": [
                "With 15\" Factory Wheels and With 16\" Factory Wheels",
                "With 15\" Factory Wheels or With 16\" Factory Wheels"
            ]
        },
        "Dodge": {
            "Caravan": [
                "With 15\" Factory Wheels or With 16\" Factory Wheels or With 17\" Factory Wheels"
            ],
            "Grand Caravan": [
                "With 15\" Factory Wheels or With 16\" Factory Wheels or With 17\" Factory Wheels"
            ],
            "Intrepid": [
                "Disc rear brakes"
            ],
            "Ram 1500": [
                "4WD",
                "RWD"
            ],
            "Stratus": [
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ]
        },
        "Ford": {
            "E-150 Econoline": [
                "2-Wheel ABS",
                "2-Wheel ABS. 1\" Bore",
                "2-Wheel ABS. 15/16\" Bore",
                "4-Wheel ABS",
                "4-Wheel ABS. 1\" Bore",
                "4-Wheel ABS. 15/16\" Bore"
            ],
            "E-150 Econoline Club Wagon": [
                "",
                "1\" Bore",
                "15/16\" Bore"
            ],
            "Econoline Super Duty": [
                "2-Wheel ABS. With Single Rear Wheels",
                "4-Wheel ABS. With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "4-Wheel ABS. With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "4-Wheel ABS. With Single Rear Wheels"
            ],
            "Explorer": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "4WD",
                "RWD and with 4-Wheel ABS"
            ],
            "F-250": [
                "4WD. With 7 Lug Wheels",
                "RWD and with 4-Wheel ABS. With 7 Lug Wheels"
            ],
            "F-250 HD": [
                "4WD. With 7 Lug Wheels and Under 8500 Lb GVW",
                "RWD. With 7 Lug Wheels and Under 8500 Lb GVW"
            ],
            "Taurus": [
                "LX/GL/G",
                "SHO"
            ]
        },
        "GMC": {
            "C2500": [
                "With 13\" Diameter Drum and With 8600 Lb GVW and With Full Floating Axle",
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "With 8600 Lb GVW and With 13\" Diameter Drum and With Full Floating Axle"
            ],
            "Jimmy": [
                "4WD and with Drum rear brakes. With Rear Disc Brakes",
                "4WD. With Rear Disc Brakes",
                "RWD and with Drum rear brakes. With Rear Drum Brakes",
                "RWD. With Rear Drum Brakes"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sonoma": [
                "4WD",
                "4WD and with Drum rear brakes",
                "RWD",
                "RWD and with Drum rear brakes"
            ],
            "Yukon": [
                "2 doors and with 4WD and DIESEL engine. With 10\" Diameter Drum",
                "2 doors and with 4WD and DIESEL engine. With 11\" Diameter Drum",
                "2 doors and with 4WD and GAS engine. With 10\" Diameter Drum",
                "2 doors and with 4WD and GAS engine. With 11\" Diameter Drum",
                "RWD and with DIESEL engine. With 10\" Diameter Drum",
                "RWD and with DIESEL engine. With 11\" Diameter Drum",
                "RWD and with GAS engine. With 10\" Diameter Drum",
                "RWD and with GAS engine. With 11\" Diameter Drum"
            ]
        },
        "Honda": {
            "Accord": [
                "Coupe",
                "Sedan and with 2.2L"
            ],
            "Civic": [
                "CX/DX/HX",
                "EX/Si",
                "LX and with 4-Wheel ABS",
                "LX and with Non-ABS"
            ],
            "Civic del Sol": [
                "Si",
                "VTEC"
            ],
            "CR-V": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Prelude": [
                ""
            ]
        },
        "INFINITI": {
            "I30": [
                ""
            ],
            "QX4": [
                ""
            ]
        },
        "Isuzu": {
            "Hombre": [
                ""
            ],
            "Oasis": [
                ""
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                ""
            ],
            "TJ": [
                "",
                "4-Wheel ABS. With 9\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "",
                "4-Wheel ABS. With 9\" Diameter Drum",
                "With 9\" Diameter Drum"
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "E320": [
                ""
            ]
        },
        "Mercury": {
            "Mountaineer": [
                "4WD",
                "RWD"
            ],
            "Sable": [
                "Disc rear brakes"
            ]
        },
        "Nissan": {
            "Altima": [
                "Disc rear brakes"
            ],
            "Maxima": [
                ""
            ],
            "Pathfinder": [
                ""
            ]
        },
        "Pontiac": {
            "Bonneville": [
                ""
            ],
            "Firebird": [
                "Drum rear brakes"
            ],
            "Grand Am": [
                ""
            ],
            "Grand Prix": [
                ""
            ],
            "Sunfire": [
                "",
                "Except Vehicles Built For USA Market"
            ],
            "Trans Sport": [
                ""
            ]
        },
        "Saab": {
            "900": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Camry": [
                "2.2L",
                "3.0L"
            ],
            "Corolla": [
                ""
            ],
            "RAV4": [
                ""
            ],
            "Tacoma": [
                "4WD. With 6 Lug Wheels"
            ],
            "Tercel": [
                "Non-ABS"
            ]
        },
        "Volkswagen": {
            "Golf": [
                "2.0L/1.9L. With 4 Lug Wheels"
            ],
            "Passat": [
                "1.9L"
            ]
        }
    },
    "1998": {
        "Acura": {
            "CL": [
                "2.3L"
            ],
            "EL": [
                ""
            ],
            "Integra": [
                "RS/GS/GS-R/LS",
                "Type R"
            ],
            "RL": [
                ""
            ]
        },
        "BMW": {
            "318i": [
                ""
            ],
            "318is": [
                ""
            ],
            "323i": [
                "Sedan"
            ],
            "323is": [
                ""
            ],
            "328i": [
                "Convertible. With 276mm Diameter Rear Rotor",
                "Convertible. With 280mm Diameter Rear Rotor",
                "Convertible. With 294mm Diameter Rear Rotor",
                "Sedan. With 276mm Diameter Rear Rotor",
                "Sedan. With 280mm Diameter Rear Rotor",
                "Sedan. With 294mm Diameter Rear Rotor"
            ],
            "328is": [
                "With 280mm Diameter Rear Rotor",
                "With 294mm Diameter Rear Rotor"
            ],
            "528i": [
                ""
            ]
        },
        "Buick": {
            "Century": [
                ""
            ],
            "LeSabre": [
                ""
            ],
            "Park Avenue": [
                ""
            ],
            "Regal": [
                ""
            ],
            "Riviera": [
                ""
            ],
            "Skylark": [
                ""
            ]
        },
        "Cadillac": {
            "DeVille": [
                "Disc rear brakes"
            ],
            "Eldorado": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Blazer": [
                "4WD"
            ],
            "C1500 Suburban": [
                "DIESEL engine. With 10\" Diameter Drum",
                "DIESEL engine. With 13\" Diameter Drum",
                "GAS engine. With 10\" Diameter Drum",
                "GAS engine. With 13\" Diameter Drum"
            ],
            "C2500": [
                "With 13\" Diameter Drum and With 8600 Lb GVW and With Full Floating Axle",
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "With 8600 Lb GVW and With 13\" Diameter Drum and With Full Floating Axle"
            ],
            "Corvette": [
                ""
            ],
            "K1500": [
                "With 10\" Diameter Drum"
            ],
            "Lumina": [
                "Drum rear brakes"
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                "Drum rear brakes"
            ],
            "Prizm": [
                "",
                "Non-ABS"
            ],
            "S10": [
                "4WD",
                "4WD and with Disc rear brakes",
                "4WD and with Drum rear brakes",
                "RWD",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "Venture": [
                ""
            ]
        },
        "Chrysler": {
            "Cirrus": [
                "Disc rear brakes. With 14\" Factory Wheels",
                "Disc rear brakes. With 15\" Factory Wheels"
            ],
            "Concorde": [
                "With 16\" Factory Wheels and With 17\" Factory Wheels"
            ],
            "Intrepid": [
                "With 16\" Factory Wheels"
            ],
            "Sebring": [
                "Convertible"
            ],
            "Town and Country": [
                "With 15\" Factory Wheels and With 16\" Factory Wheels",
                "With 15\" Factory Wheels or With 16\" Factory Wheels"
            ]
        },
        "Dodge": {
            "Caravan": [
                "With 15\" Factory Wheels or With 16\" Factory Wheels or With 17\" Factory Wheels"
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                "With 15\" Factory Wheels or With 16\" Factory Wheels or With 17\" Factory Wheels"
            ],
            "Intrepid": [
                "With 16\" Factory Wheels"
            ],
            "Ram 1500": [
                "4WD",
                "RWD"
            ],
            "Stratus": [
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ]
        },
        "Ford": {
            "E-150 Econoline": [
                "2-Wheel ABS",
                "4-Wheel ABS"
            ],
            "E-150 Econoline Club Wagon": [
                ""
            ],
            "E-350 Econoline": [
                "2-Wheel ABS. With Single Rear Wheels",
                "4-Wheel ABS. With Dual Rear Wheels",
                "4-Wheel ABS. With Single Rear Wheels"
            ],
            "E-350 Econoline Club Wagon": [
                "2-Wheel ABS. With Single Rear Wheels and With Rear Wheel ABS",
                "4-Wheel ABS. With Dual Rear Wheels",
                "4-Wheel ABS. With Single Rear Wheels"
            ],
            "Econoline Super Duty": [
                "2-Wheel ABS. With Single Rear Wheels",
                "4-Wheel ABS. With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "4-Wheel ABS. With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "4-Wheel ABS. With Single Rear Wheels"
            ],
            "Explorer": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "4WD",
                "RWD and with 4-Wheel ABS"
            ],
            "F-250": [
                "4WD. With 7 Lug Wheels",
                "RWD and with 4-Wheel ABS. With 7 Lug Wheels"
            ],
            "Ranger": [
                "4WD",
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Coil front springs",
                "RWD and with 2-Wheel ABS and Coil front springs. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Coil front springs. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs. With 9\" Diameter Drum",
                "RWD and with 4-Wheel ABS. With 261mm Diameter Front Rotor",
                "RWD and with 4-Wheel ABS. With 287mm Diameter Front Rotor"
            ],
            "Taurus": [
                "LX/SE/SE Comfort",
                "SHO"
            ]
        },
        "GMC": {
            "C1500 Suburban": [
                "DIESEL engine. With 13\" Diameter Drum",
                "GAS engine. With 13\" Diameter Drum"
            ],
            "C2500": [
                "With 13\" Diameter Drum and With 8600 Lb GVW and With Full Floating Axle",
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum",
                "With 8600 Lb GVW and With 13\" Diameter Drum and With Full Floating Axle"
            ],
            "Jimmy": [
                "4WD"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sonoma": [
                "4WD",
                "RWD",
                "RWD and with Drum rear brakes"
            ],
            "Yukon": [
                "4WD. With 10\" Diameter Drum and With 5 Lug Wheels",
                "4WD. With 10\" Diameter Drum and With 6 Lug Wheels",
                "RWD. With 10\" Diameter Drum and With 5 Lug Wheels",
                "RWD. With 10\" Diameter Drum and With 6 Lug Wheels"
            ]
        },
        "Honda": {
            "Accord": [
                "3.0L",
                "Coupe and with 2.3L",
                "Sedan and with 2.3L"
            ],
            "Civic": [
                "EX/Si",
                "LX/CX/GX/DX/HX"
            ],
            "CR-V": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Prelude": [
                ""
            ]
        },
        "Hyundai": {
            "Elantra": [
                "Disc rear brakes. From 08/16/98"
            ],
            "Tiburon": [
                "Disc rear brakes. From 8/16/98"
            ]
        },
        "INFINITI": {
            "I30": [
                ""
            ],
            "QX4": [
                ""
            ]
        },
        "Isuzu": {
            "Hombre": [
                "4WD and with Disc rear brakes",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "Oasis": [
                ""
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                ""
            ],
            "TJ": [
                "",
                "4-Wheel ABS. With 9\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "",
                "4-Wheel ABS. With 9\" Diameter Drum",
                "With 9\" Diameter Drum"
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ],
            "GS300": [
                ""
            ],
            "GS400": [
                ""
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ]
        },
        "Mazda": {
            "B2500": [
                "With 10\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "B3000": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD. With 10\" Diameter Drum",
                "RWD. With 9\" Diameter Drum"
            ],
            "B4000": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS. With 9\" Diameter Drum",
                "RWD and with 4-Wheel ABS. With 10\" Diameter Drum",
                "RWD and with 4-Wheel ABS. With 9\" Diameter Drum"
            ]
        },
        "Mercedes-Benz": {
            "E320": [
                "Sedan"
            ],
            "E430": [
                ""
            ],
            "ML320": [
                "From 12/98"
            ]
        },
        "Mercury": {
            "Mountaineer": [
                "4WD",
                "RWD"
            ],
            "Sable": [
                "Disc rear brakes"
            ]
        },
        "Nissan": {
            "Altima": [
                "Disc rear brakes"
            ],
            "Maxima": [
                ""
            ],
            "Pathfinder": [
                "From 12/1998",
                "To 12/1998"
            ]
        },
        "Pontiac": {
            "Bonneville": [
                ""
            ],
            "Grand Am": [
                ""
            ],
            "Grand Prix": [
                ""
            ],
            "Sunfire": [
                "",
                "Except Vehicles Built For USA Market"
            ],
            "Trans Sport": [
                ""
            ]
        },
        "Saab": {
            "900": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "",
                "4-Wheel ABS"
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Camry": [
                "2.2L",
                "3.0L"
            ],
            "Corolla": [
                "",
                "Non-ABS"
            ],
            "Paseo": [
                "Non-ABS"
            ],
            "RAV4": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "4WD. With 6 Lug Wheels",
                "Pre Runner and with RWD. With 6 Lug Wheels"
            ],
            "Tercel": [
                "Non-ABS"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                ""
            ],
            "Golf": [
                "2.0L/1.9L. With 4 Lug Wheels"
            ]
        },
        "Volvo": {
            "C70": [
                "With 280mm Diameter Front Rotor"
            ]
        }
    },
    "1999": {
        "Acura": {
            "CL": [
                "2.3L"
            ],
            "EL": [
                ""
            ],
            "Integra": [
                "GS/GS-R/LS",
                "Type R"
            ],
            "TL": [
                ""
            ]
        },
        "Audi": {
            "A4": [
                "From 02/99"
            ]
        },
        "BMW": {
            "318i": [
                ""
            ],
            "318is": [
                ""
            ],
            "323i": [
                "Convertible"
            ],
            "323is": [
                ""
            ],
            "328i": [
                "Convertible. With 276mm Diameter Rear Rotor",
                "Convertible. With 294mm Diameter Rear Rotor",
                "Sedan. With 276mm Diameter Rear Rotor",
                "Sedan. With 294mm Diameter Rear Rotor"
            ],
            "328is": [
                ""
            ],
            "528i": [
                ""
            ]
        },
        "Buick": {
            "Century": [
                ""
            ],
            "LeSabre": [
                ""
            ],
            "Park Avenue": [
                ""
            ],
            "Regal": [
                ""
            ],
            "Riviera": [
                ""
            ]
        },
        "Cadillac": {
            "DeVille": [
                "Disc rear brakes"
            ],
            "Eldorado": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Blazer": [
                "4WD"
            ],
            "C1500 Suburban": [
                "DIESEL engine. With 10\" Diameter Drum",
                "DIESEL engine. With 13\" Diameter Drum",
                "GAS engine. With 10\" Diameter Drum",
                "GAS engine. With 13\" Diameter Drum"
            ],
            "Corvette": [
                ""
            ],
            "K1500": [
                "With 10\" Diameter Drum"
            ],
            "Lumina": [
                "Drum rear brakes"
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                "Drum rear brakes"
            ],
            "Prizm": [
                "",
                "Non-ABS"
            ],
            "S10": [
                "4WD",
                "4WD and with Disc rear brakes",
                "4WD and with Drum rear brakes",
                "RWD",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "Silverado 1500": [
                ""
            ],
            "Silverado 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Venture": [
                ""
            ]
        },
        "Chrysler": {
            "300M": [
                "With 16\" Factory Wheels and With 17\" Factory Wheels"
            ],
            "Cirrus": [
                "Disc rear brakes. With 14\" Factory Wheels",
                "Disc rear brakes. With 15\" Factory Wheels"
            ],
            "Concorde": [
                "With 16\" Factory Wheels and With 17\" Factory Wheels"
            ],
            "Intrepid": [
                "With 16\" Factory Wheels"
            ],
            "LHS": [
                "With 16\" Factory Wheels and With 17\" Factory Wheels"
            ],
            "Sebring": [
                "Convertible"
            ],
            "Town and Country": [
                "With 15\" Factory Wheels and With 16\" Factory Wheels",
                "With 15\" Factory Wheels or With 16\" Factory Wheels"
            ]
        },
        "Dodge": {
            "Caravan": [
                "With 15\" Factory Wheels or With 16\" Factory Wheels or With 17\" Factory Wheels"
            ],
            "Dakota": [
                "With 9\" Diameter Drum"
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                "With 15\" Factory Wheels or With 16\" Factory Wheels or With 17\" Factory Wheels"
            ],
            "Intrepid": [
                "With 16\" Factory Wheels"
            ],
            "Ram 1500": [
                "4WD",
                "RWD"
            ],
            "Stratus": [
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ]
        },
        "Ford": {
            "E-150 Econoline": [
                "2-Wheel ABS",
                "4-Wheel ABS"
            ],
            "E-150 Econoline Club Wagon": [
                ""
            ],
            "E-250 Econoline": [
                "2-Wheel ABS",
                "4-Wheel ABS"
            ],
            "E-350 Econoline Club Wagon": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Econoline": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "With Single Rear Wheels"
            ],
            "Econoline Super Duty": [
                "With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "With Single Rear Wheels"
            ],
            "Expedition": [
                "4WD. With 14mm Wheel Lugs"
            ],
            "Explorer": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "4WD. With 5 Lug Wheels",
                "4WD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "4WD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "4WD. With 7 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "RWD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "RWD. With 7 Lug Wheels and With 12mm Wheel Lugs and With 4 Wheel ABS"
            ],
            "F-250": [
                "4WD. With 7 Lug Wheels",
                "RWD and with 4-Wheel ABS. With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With 13.03\" Diameter Rotor and From 03/22/99",
                "4WD. With 13.03\" Diameter Rotor and To 03/22/99",
                "4WD. With 14.53\" Diameter Rotor and From 03/22/99"
            ],
            "F-350 Super Duty": [
                "RWD and with 4-Wheel ABS. With Dual Rear Wheels and With Twin I-Beam Axle"
            ],
            "F-450 Super Duty": [
                "2-Wheel ABS. With Dual Rear Wheels and With Rear Wheel ABS and From 03/22/99",
                "With 13.03\" Diameter Rotor and To 03/22/99",
                "With Single Rear Wheels and From 03/22/99"
            ],
            "F-53 Motorhome Chassis": [
                ""
            ],
            "F-550 Super Duty": [
                "2-Wheel ABS. With Dual Rear Wheels and With Rear Wheel ABS and From 03/22/99",
                "With 13.03\" Diameter Rotor and To 03/22/99",
                "With Single Rear Wheels and From 03/22/99"
            ],
            "Mustang": [
                "Base/GT"
            ],
            "Ranger": [
                "4WD",
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Coil front springs",
                "RWD and with 2-Wheel ABS and Coil front springs. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Coil front springs. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs. With 9\" Diameter Drum",
                "RWD and with 4-Wheel ABS. With 261mm Diameter Front Rotor",
                "RWD and with 4-Wheel ABS. With 287mm Diameter Front Rotor"
            ],
            "Taurus": [
                "LX/SE",
                "SHO"
            ]
        },
        "GMC": {
            "C1500 Suburban": [
                "DIESEL engine. With 13\" Diameter Drum",
                "GAS engine. With 13\" Diameter Drum"
            ],
            "C2500": [
                "With 7200 Lb GVW and With 11-5/32\" Diameter Drum"
            ],
            "Jimmy": [
                "4WD"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sierra 1500": [
                ""
            ],
            "Sierra 2500": [
                "Automatic transmission",
                "Manual transmission"
            ],
            "Sonoma": [
                "4WD",
                "RWD",
                "RWD and with Drum rear brakes"
            ],
            "Yukon": [
                "RWD. With 10\" Diameter Drum and With 5 Lug Wheels"
            ]
        },
        "Honda": {
            "Accord": [
                "3.0L",
                "Coupe and with 2.3L",
                "Sedan and with 2.3L"
            ],
            "Civic": [
                "EX and with Drum rear brakes",
                "LX/CX/GX/DX/Value Package/HX and with Drum rear brakes",
                "Si"
            ],
            "CR-V": [
                ""
            ],
            "Prelude": [
                ""
            ]
        },
        "Hyundai": {
            "Elantra": [
                "Disc rear brakes"
            ],
            "Sonata": [
                "Disc rear brakes"
            ],
            "Tiburon": [
                "Disc rear brakes"
            ]
        },
        "INFINITI": {
            "G20": [
                ""
            ],
            "I30": [
                ""
            ],
            "QX4": [
                ""
            ]
        },
        "Isuzu": {
            "Hombre": [
                "4WD and with Disc rear brakes",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "Oasis": [
                ""
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                "With Akebono Calipers",
                "With Teves & ATE Caliper"
            ],
            "TJ": [
                "With 1-1/2\" Wheel Stud",
                "With 1-1/8\" Wheel Stud"
            ],
            "Wrangler": [
                "With 1-1/2\" Wheel Stud",
                "With 1-1/8\" Wheel Stud"
            ]
        },
        "Lexus": {
            "ES300": [
                "From 09/99",
                "To 08/99"
            ],
            "GS300": [
                ""
            ],
            "GS400": [
                ""
            ],
            "RX300": [
                "AWD",
                "FWD"
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ],
            "Navigator": [
                "4WD. With 14mm Wheel Lugs"
            ]
        },
        "Mazda": {
            "B2500": [
                "With 10\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "B3000": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD. With 10\" Diameter Drum",
                "RWD. With 9\" Diameter Drum"
            ],
            "B4000": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS. With 9\" Diameter Drum",
                "RWD and with 4-Wheel ABS. With 10\" Diameter Drum",
                "RWD and with 4-Wheel ABS. With 9\" Diameter Drum"
            ]
        },
        "Mercedes-Benz": {
            "E320": [
                "Sedan"
            ],
            "E430": [
                ""
            ],
            "ML320": [
                ""
            ],
            "ML430": [
                ""
            ]
        },
        "Mercury": {
            "Mountaineer": [
                "4WD",
                "RWD"
            ],
            "Sable": [
                "Disc rear brakes"
            ]
        },
        "Nissan": {
            "Altima": [
                "Disc rear brakes"
            ],
            "Maxima": [
                "From 04/1999",
                "To 03/1999"
            ],
            "Pathfinder": [
                ""
            ]
        },
        "Pontiac": {
            "Bonneville": [
                ""
            ],
            "Grand Am": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ],
            "Montana": [
                ""
            ],
            "Sunfire": [
                ""
            ],
            "Trans Sport": [
                ""
            ]
        },
        "Saab": {
            "9-3": [
                "Base/SE",
                "Viggen"
            ],
            "9-5": [
                "From Chassis/VIN #3025752",
                "To Chassis/VIN #3025751"
            ]
        },
        "Subaru": {
            "Forester": [
                "",
                "4-Wheel ABS"
            ],
            "Impreza": [
                "2.5L and with Disc rear brakes"
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Camry": [
                "2.2L",
                "3.0L"
            ],
            "Corolla": [
                "",
                "Non-ABS"
            ],
            "Paseo": [
                ""
            ],
            "RAV4": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                "2.2L",
                "3.0L. From 09/99",
                "3.0L. To 08/99"
            ],
            "Tercel": [
                ""
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "1.8L",
                "2.0L/1.9L"
            ],
            "Cabrio": [
                "Disc rear brakes"
            ],
            "Golf": [
                "2.0L/1.9L. With 5 Lug Wheels and 7th And 8th Digit Of VIN Is \"1J\"",
                "2.8L. With 5 Lug Wheels and 7th And 8th Digit Of VIN Is \"1J\""
            ],
            "Passat": [
                "AWD. From Chassis/VIN #3BX124708",
                "FWD. From Chassis/VIN #3BX124708"
            ]
        },
        "Volvo": {
            "C70": [
                "With 280mm Diameter Front Rotor"
            ],
            "S80": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ]
        }
    },
    "2000": {
        "Acura": {
            "EL": [
                ""
            ],
            "Integra": [
                "GS/GS-R/LS",
                "Type R"
            ],
            "TL": [
                ""
            ]
        },
        "Audi": {
            "A6": [
                "With 288mm Diameter Front Rotor and With 312mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor and With 288mm Diameter Front Rotor"
            ],
            "S4": [
                ""
            ],
            "TT": [
                ""
            ]
        },
        "BMW": {
            "323Ci": [
                "Convertible",
                "Coupe"
            ],
            "323i": [
                "Sedan",
                "Wagon"
            ],
            "328Ci": [
                ""
            ],
            "328i": [
                ""
            ],
            "528i": [
                ""
            ],
            "540i": [
                "From 03/00"
            ],
            "X5": [
                ""
            ]
        },
        "Buick": {
            "Century": [
                ""
            ],
            "LeSabre": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Park Avenue": [
                ""
            ],
            "Regal": [
                ""
            ]
        },
        "Cadillac": {
            "DeVille": [
                "With 5 Lug Wheels"
            ],
            "Eldorado": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Blazer": [
                "4WD"
            ],
            "Corvette": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Lumina": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "Prizm": [
                "",
                "Non-ABS"
            ],
            "S10": [
                "4WD",
                "4WD and with Disc rear brakes",
                "4WD and with Drum rear brakes",
                "RWD",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "Silverado 1500": [
                ""
            ],
            "Silverado 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Suburban 1500": [
                "With 13\" Diameter Drum",
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Suburban 2500": [
                ""
            ],
            "Tracker": [
                ""
            ],
            "Venture": [
                ""
            ]
        },
        "Chrysler": {
            "300M": [
                ""
            ],
            "Cirrus": [
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ],
            "Concorde": [
                "With 16\" Factory Wheels and With 17\" Factory Wheels"
            ],
            "Grand Voyager": [
                "With 5 Lug Wheels and With 256mm Diameter Front Rotor",
                "With 5 Lug Wheels and With 281mm Diameter Front Rotor"
            ],
            "Intrepid": [
                "With 16\" Factory Wheels"
            ],
            "LHS": [
                "With 16\" Factory Wheels"
            ],
            "Neon": [
                ""
            ],
            "Sebring": [
                "Convertible"
            ],
            "Town and Country": [
                "With 15\" Factory Wheels and With 16\" Factory Wheels",
                "With 15\" Factory Wheels or With 16\" Factory Wheels"
            ],
            "Voyager": [
                "With 15\" Factory Wheels"
            ]
        },
        "Dodge": {
            "Caravan": [
                "With 15\" Factory Wheels or With 16\" Factory Wheels or With 17\" Factory Wheels"
            ],
            "Dakota": [
                "With 11\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                "With 15\" Factory Wheels or With 16\" Factory Wheels or With 17\" Factory Wheels"
            ],
            "Intrepid": [
                "With 16\" Factory Wheels"
            ],
            "Neon": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Ram 1500": [
                "4WD",
                "RWD"
            ],
            "Stratus": [
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ]
        },
        "Ford": {
            "E-250 Econoline": [
                ""
            ],
            "E-350 Econoline Club Wagon": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Econoline": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "With Single Rear Wheels"
            ],
            "E-450 Econoline Super Duty": [
                "With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "With Single Rear Wheels and With Metric Bolt Circle",
                "With Single Rear Wheels and With Standard Bolt Circle"
            ],
            "Excursion": [
                "4WD. From 03/22/99",
                "4WD. To 03/22/99"
            ],
            "Expedition": [
                "4WD. With 14mm Wheel Lugs"
            ],
            "Explorer": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "4WD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "4WD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "4WD. With 7 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "RWD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "RWD. With 7 Lug Wheels and With 12mm Wheel Lugs and With 4 Wheel ABS"
            ],
            "F-250 Super Duty": [
                "4WD. With 13.03\" Diameter Rotor",
                "4WD. With 14.53\" Diameter Rotor"
            ],
            "F-350 Super Duty": [
                "RWD. With Dual Rear Wheels and With Twin I-Beam Axle"
            ],
            "F-450 Super Duty": [
                "4 X 2. With Monobeam Front Axle and With 14.53\" Diameter Rotor",
                "4 X 4. With 13.03\" Diameter Rotor"
            ],
            "F-53 Motorhome Chassis": [
                ""
            ],
            "F-550 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Focus": [
                "",
                "Without ABS Tone Ring and Wheel Bearing Included"
            ],
            "Mustang": [
                "Base/GT"
            ],
            "Ranger": [
                "4WD",
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Coil front springs",
                "RWD and with 2-Wheel ABS and Coil front springs. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Coil front springs. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs. With 9\" Diameter Drum",
                "RWD and with 4-Wheel ABS. With 261mm Diameter Front Rotor",
                "RWD and with 4-Wheel ABS. With 287mm Diameter Front Rotor"
            ],
            "Taurus": [
                "Disc rear brakes"
            ]
        },
        "GMC": {
            "Jimmy": [
                "4WD"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sierra 1500": [
                ""
            ],
            "Sierra 2500": [
                "Automatic transmission",
                "Manual transmission"
            ],
            "Sonoma": [
                "4WD",
                "RWD and with Drum rear brakes. With ABS Tone Ring",
                "RWD. With ABS Tone Ring"
            ],
            "Yukon": [
                "Disc rear brakes. With Dual Piston Caliper",
                "Disc rear brakes. With Single Piston Caliper",
                "Drum rear brakes. With Dual Piston Caliper",
                "Drum rear brakes. With Single Piston Caliper"
            ],
            "Yukon XL 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Yukon XL 2500": [
                ""
            ]
        },
        "Honda": {
            "Accord": [
                "3.0L",
                "Coupe and with 2.3L",
                "Sedan and with 2.3L"
            ],
            "Civic": [
                "EX and with Drum rear brakes",
                "LX/CX/GX/DX/HX and with Drum rear brakes",
                "Si"
            ],
            "CR-V": [
                ""
            ],
            "Prelude": [
                ""
            ]
        },
        "Hyundai": {
            "Elantra": [
                "Disc rear brakes"
            ],
            "Sonata": [
                ""
            ],
            "Tiburon": [
                ""
            ]
        },
        "INFINITI": {
            "G20": [
                ""
            ],
            "I30": [
                ""
            ],
            "QX4": [
                ""
            ]
        },
        "Isuzu": {
            "Hombre": [
                "4WD and with Disc rear brakes",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ]
        },
        "Jaguar": {
            "S-Type": [
                ""
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                "With Akebono Calipers",
                "With Teves & ATE Caliper"
            ],
            "TJ": [
                "",
                "With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "",
                "With 9\" Diameter Drum"
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ],
            "GS300": [
                ""
            ],
            "GS400": [
                ""
            ],
            "RX300": [
                "AWD",
                "FWD"
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ],
            "LS": [
                ""
            ],
            "Navigator": [
                "4WD. With 14mm Wheel Lugs"
            ]
        },
        "Mercedes-Benz": {
            "C230": [
                "1 Pin Rear Pad or 2 Pin Rear Pad"
            ],
            "CLK320": [
                ""
            ],
            "E320": [
                "Sedan"
            ],
            "E430": [
                "RWD"
            ],
            "ML320": [
                ""
            ],
            "SLK230": [
                "Single Pin rear pad or Two Pin Rear Pad"
            ]
        },
        "Mercury": {
            "Mountaineer": [
                "4WD",
                "RWD"
            ],
            "Sable": [
                "Disc rear brakes"
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "3.0L"
            ]
        },
        "Nissan": {
            "Altima": [
                ""
            ],
            "Maxima": [
                "From 10/00",
                "To 10/00"
            ],
            "Pathfinder": [
                ""
            ],
            "Sentra": [
                "1.8L",
                "2.0L"
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "Bonneville": [
                "SE",
                "SLE/SSEi"
            ],
            "Grand Am": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ],
            "Montana": [
                ""
            ],
            "Sunfire": [
                ""
            ]
        },
        "Saab": {
            "9-3": [
                "Base/SE",
                "Viggen"
            ],
            "9-5": [
                "With 288mm Diameter Front Rotor",
                "With 308mm Diameter Front Rotor"
            ]
        },
        "Saturn": {
            "LS": [
                "Disc rear brakes"
            ],
            "LS1": [
                ""
            ],
            "LS2": [
                "Disc rear brakes"
            ],
            "LW1": [
                ""
            ],
            "LW2": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "",
                "4-Wheel ABS"
            ],
            "Impreza": [
                "Disc rear brakes"
            ],
            "Legacy": [
                "Disc rear brakes. With 276mm Diameter Front Rotor and With Dual Piston Caliper",
                "Disc rear brakes. With Dual Piston Caliper and With 293mm Diameter Front Rotor"
            ],
            "Outback": [
                ""
            ]
        },
        "Suzuki": {
            "Grand Vitara": [
                ""
            ],
            "Vitara": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                "2.2L. With 14\" Factory Wheels",
                "2.2L. With 15\" Factory Wheels",
                "3.0L. Vehicles Manufactured In Japan",
                "3.0L. Vehicles Manufactured In USA"
            ],
            "Celica": [
                "GT",
                "GTS"
            ],
            "Corolla": [
                "",
                "Non-ABS"
            ],
            "Echo": [
                "From 08/00",
                "To 08/00"
            ],
            "RAV4": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                "",
                "2.2L"
            ],
            "Tacoma": [
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                "4.7\" Pad Plate Length",
                "5.3\" Pad Plate Length"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "1.8L",
                "2.0L/1.9L"
            ],
            "Cabrio": [
                ""
            ],
            "Golf": [
                "1.9L",
                "2.0L. With 280mm Diameter Front Rotor",
                "2.0L. With 288mm Diameter Front Rotor",
                "2.8L/1.8L"
            ],
            "Jetta": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "Passat": [
                "Naturally Aspirated",
                "Turbocharged"
            ]
        },
        "Volvo": {
            "C70": [
                "With 280mm Diameter Front Rotor"
            ],
            "S80": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "V70": [
                "FWD. With 279mm Diameter Front Rotor"
            ]
        }
    },
    "2001": {
        "Acura": {
            "EL": [
                ""
            ],
            "Integra": [
                "GS/GS-R/LS",
                "Type R"
            ],
            "MDX": [
                ""
            ],
            "TL": [
                ""
            ]
        },
        "Audi": {
            "A6": [
                "With 288mm Diameter Front Rotor and With 312mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor and With 288mm Diameter Front Rotor"
            ],
            "S4": [
                ""
            ],
            "TT": [
                ""
            ],
            "TT Quattro": [
                "With 256mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "325Ci": [
                ""
            ],
            "325i": [
                ""
            ],
            "325xi": [
                ""
            ],
            "330Ci": [
                ""
            ],
            "330i": [
                ""
            ],
            "330xi": [
                ""
            ],
            "525i": [
                ""
            ],
            "530i": [
                ""
            ],
            "540i": [
                ""
            ],
            "X5": [
                ""
            ]
        },
        "Buick": {
            "Century": [
                ""
            ],
            "LeSabre": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Park Avenue": [
                ""
            ],
            "Regal": [
                ""
            ]
        },
        "Cadillac": {
            "DeVille": [
                "With 5 Lug Wheels"
            ],
            "Eldorado": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Blazer": [
                "4WD"
            ],
            "Corvette": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Lumina": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "Prizm": [
                "",
                "Non-ABS"
            ],
            "S10": [
                "4WD",
                "4WD and with Disc rear brakes",
                "4WD and with Drum rear brakes",
                "RWD",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "Silverado 1500 HD": [
                ""
            ],
            "Silverado 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Silverado 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Silverado 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Silverado 3500": [
                ""
            ],
            "Suburban 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Suburban 2500": [
                "6.0L",
                "8.1L"
            ],
            "Tahoe": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Tracker": [
                ""
            ],
            "Venture": [
                ""
            ]
        },
        "Chrysler": {
            "300M": [
                ""
            ],
            "Concorde": [
                "With 16\" Factory Wheels and With 17\" Factory Wheels"
            ],
            "Grand Voyager": [
                ""
            ],
            "Intrepid": [
                "With 16\" Factory Wheels"
            ],
            "LHS": [
                "With 16\" Factory Wheels and With 17\" Factory Wheels"
            ],
            "Neon": [
                ""
            ],
            "PT Cruiser": [
                "Disc rear brakes"
            ],
            "Sebring": [
                "Convertible/Sedan",
                "Coupe and with Disc rear brakes"
            ],
            "Town and Country": [
                ""
            ],
            "Voyager": [
                ""
            ]
        },
        "Dodge": {
            "Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Dakota": [
                "With 11\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Intrepid": [
                "With 16\" Factory Wheels"
            ],
            "Neon": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Ram 1500": [
                "4WD",
                "RWD"
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Stratus": [
                "Coupe and with Disc rear brakes",
                "Sedan"
            ]
        },
        "Ford": {
            "E-250 Econoline": [
                "Disc rear brakes. With Single Rear Wheels"
            ],
            "E-350 Econoline Club Wagon": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "With Single Rear Wheels"
            ],
            "E-450 Econoline Super Duty": [
                "With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "With Single Rear Wheels and With Metric Bolt Circle",
                "With Single Rear Wheels and With Standard Bolt Circle"
            ],
            "Escape": [
                ""
            ],
            "Excursion": [
                "4WD"
            ],
            "Expedition": [
                "4WD. With 14mm Wheel Lugs"
            ],
            "Explorer": [
                "AWD/4WD. From 01/02/01",
                "AWD/4WD. To 01/01/01",
                "RWD. From 01/02/01",
                "RWD. To 01/01/01"
            ],
            "Explorer Sport": [
                "4WD. With Phenolic Piston",
                "4WD. With Steel Piston",
                "RWD. With Phenolic Piston",
                "RWD. With Steel Piston"
            ],
            "Explorer Sport Trac": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "4WD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "4WD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "4WD. With 7 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "RWD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "RWD. With 7 Lug Wheels and With 12mm Wheel Lugs and With 4 Wheel ABS"
            ],
            "F-250 Super Duty": [
                "4WD. With 13.03\" Diameter Rotor",
                "4WD. With 14.53\" Diameter Rotor"
            ],
            "F-350 Super Duty": [
                "RWD. With Dual Rear Wheels and With Twin I-Beam Axle"
            ],
            "F-450 Super Duty": [
                "With 13.03\" Diameter Rotor",
                "With Monobeam Front Axle and With 14.53\" Diameter Rotor"
            ],
            "F-53 Motorhome Chassis": [
                ""
            ],
            "F-550 Super Duty": [
                "With 13.03\" Diameter Rotor and With 8 Lug Wheels and 3.91\" Overall Height",
                "With 8 Lug Wheels and With 14.53\" Diameter Rotor and 3.86\" Overall Height"
            ],
            "Focus": [
                "",
                "Without ABS Tone Ring and Wheel Bearing Included"
            ],
            "Mustang": [
                "Base/GT/GT Bullitt",
                "GT Bullitt. Left or Right"
            ],
            "Ranger": [
                "4WD",
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Coil front springs",
                "RWD and with 2-Wheel ABS and Coil front springs. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Coil front springs. With 9\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs. With 10\" Diameter Drum",
                "RWD and with 2-Wheel ABS and Torsion Bar front springs. With 9\" Diameter Drum",
                "RWD and with 4-Wheel ABS. With 287mm Diameter Front Rotor"
            ],
            "Taurus": [
                "Disc rear brakes. With Police or Taxi Package",
                "Disc rear brakes. Without Police Package",
                "Drum rear brakes. With Police or Taxi Package",
                "Drum rear brakes. Without Police Package",
                "Sedan and with Drum rear brakes. With Police or Taxi Package",
                "Sedan and with Drum rear brakes. Without Police Package"
            ]
        },
        "GMC": {
            "Jimmy": [
                "4WD"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sierra 1500 HD": [
                ""
            ],
            "Sierra 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Sierra 2500": [
                "Automatic transmission",
                "Manual transmission"
            ],
            "Sierra 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Sierra 3500": [
                ""
            ],
            "Sonoma": [
                "4WD",
                "RWD and with Drum rear brakes. With ABS Tone Ring",
                "RWD. With ABS Tone Ring"
            ],
            "Yukon": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Yukon XL 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Yukon XL 2500": [
                "6.0L",
                "8.1L"
            ]
        },
        "Honda": {
            "Accord": [
                "3.0L",
                "Coupe and with 2.3L",
                "LX and with Coupe and 2.3L and Drum rear brakes",
                "LX/DX/Value Package and with Sedan and 2.3L and Drum rear brakes",
                "Sedan and with 2.3L"
            ],
            "Civic": [
                ""
            ],
            "CR-V": [
                ""
            ],
            "Prelude": [
                ""
            ]
        },
        "Hyundai": {
            "Elantra": [
                ""
            ],
            "Santa Fe": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Sonata": [
                ""
            ],
            "Tiburon": [
                ""
            ]
        },
        "INFINITI": {
            "G20": [
                "From 12/01",
                "To 12/01"
            ],
            "I30": [
                "From 10/00",
                "To 09/00"
            ],
            "QX4": [
                ""
            ]
        },
        "Jaguar": {
            "S-Type": [
                ""
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                "With Akebono Calipers",
                "With Teves & ATE Caliper"
            ],
            "TJ": [
                "",
                "With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "",
                "With 9\" Diameter Drum"
            ]
        },
        "Kia": {
            "Magentis": [
                ""
            ],
            "Optima": [
                ""
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ],
            "GS300": [
                ""
            ],
            "GS430": [
                ""
            ],
            "IS300": [
                ""
            ],
            "RX300": [
                "AWD",
                "FWD"
            ]
        },
        "Lincoln": {
            "Continental": [
                ""
            ],
            "LS": [
                ""
            ],
            "Navigator": [
                "4WD. With 14mm Wheel Lugs"
            ]
        },
        "Mazda": {
            "Protege": [
                "2.0L and with Disc rear brakes. With 4 Lug Wheels",
                "2.0L and with Disc rear brakes. With 5 Lug Wheels"
            ],
            "Tribute": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "C240": [
                ""
            ],
            "C320": [
                ""
            ],
            "CLK320": [
                ""
            ],
            "CLK430": [
                ""
            ],
            "E320": [
                "Sedan"
            ],
            "E430": [
                "RWD"
            ],
            "ML320": [
                ""
            ],
            "SLK230": [
                ""
            ],
            "SLK320": [
                ""
            ]
        },
        "Mercury": {
            "Mountaineer": [
                "4WD",
                "RWD"
            ],
            "Sable": [
                "Disc rear brakes",
                "Drum rear brakes",
                "Sedan and with Drum rear brakes"
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L. From 06/01",
                "3.0L"
            ],
            "Galant": [
                "2.4L. From 06/01",
                "3.0L"
            ]
        },
        "Nissan": {
            "Altima": [
                ""
            ],
            "Maxima": [
                "From 10/00",
                "To 10/00"
            ],
            "Pathfinder": [
                ""
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "Aztek": [
                "AWD and with Disc rear brakes",
                "AWD and with Drum rear brakes",
                "FWD and with Disc rear brakes",
                "FWD and with Drum rear brakes"
            ],
            "Bonneville": [
                "SE",
                "SLE/SSEi"
            ],
            "Grand Am": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ],
            "Montana": [
                ""
            ],
            "Sunfire": [
                ""
            ]
        },
        "Saab": {
            "9-3": [
                "Base/SE/Turbo",
                "Viggen"
            ],
            "9-5": [
                "With 288mm Diameter Front Rotor",
                "With 308mm Diameter Front Rotor"
            ]
        },
        "Saturn": {
            "L100": [
                ""
            ],
            "L200": [
                ""
            ],
            "L300": [
                ""
            ],
            "LW200": [
                ""
            ],
            "LW300": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "",
                "4-Wheel ABS"
            ],
            "Impreza": [
                "Disc rear brakes"
            ],
            "Legacy": [
                "Disc rear brakes. With 276mm Diameter Front Rotor and With Dual Piston Caliper",
                "With Dual Piston Caliper and With 293mm Diameter Front Rotor"
            ],
            "Outback": [
                ""
            ]
        },
        "Suzuki": {
            "Grand Vitara": [
                "JLX Plus/JLS/JLS Plus/Limited/JLS Plus SE/JLX Plus SE/JLX and with 2.5L",
                "XL-7/XL-7 Plus/XL-7 Touring/XL-7 Limited and with 2.7L"
            ],
            "Vitara": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "Limited/Base/SR5. With 15\" Factory Wheels",
                "Limited/Base/SR5. With 16\" Factory Wheels",
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                "3.0L. Vehicles Manufactured In Japan",
                "3.0L. Vehicles Manufactured In USA"
            ],
            "Celica": [
                "GT",
                "GTS"
            ],
            "Corolla": [
                "",
                "Non-ABS"
            ],
            "Echo": [
                ""
            ],
            "Highlander": [
                "AWD",
                "FWD"
            ],
            "RAV4": [
                "BATTERY EV (EV/BEV) engine",
                "GAS engine",
                "GAS engine. 3/4\" Bore"
            ],
            "Sequoia": [
                "4.7\" Pad Plate Length",
                "5.3\" Pad Plate Length"
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                "2.2L",
                "Disc rear brakes"
            ],
            "Tacoma": [
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                "4.7\" Pad Plate Length",
                "5.3\" Pad Plate Length"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "1.8L",
                "2.0L/1.9L"
            ],
            "Cabrio": [
                ""
            ],
            "Golf": [
                "1.9L",
                "2.0L. With 280mm Diameter Front Rotor",
                "2.0L. With 288mm Diameter Front Rotor",
                "2.8L/1.8L"
            ],
            "Jetta": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "Passat": [
                "AWD",
                "FWD"
            ]
        },
        "Volvo": {
            "S60": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "S80": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "V70": [
                "AWD. With 15\" Factory Wheels",
                "AWD. With 16\" Factory Wheels"
            ]
        }
    },
    "2002": {
        "Acura": {
            "EL": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RSX": [
                "Base",
                "Type-S"
            ],
            "TL": [
                ""
            ]
        },
        "Audi": {
            "A6": [
                "With 312mm Diameter Front Rotor"
            ],
            "TT": [
                ""
            ],
            "TT Quattro": [
                "With 256mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "325Ci": [
                ""
            ],
            "325i": [
                ""
            ],
            "325xi": [
                ""
            ],
            "330Ci": [
                ""
            ],
            "330i": [
                ""
            ],
            "330xi": [
                ""
            ],
            "525i": [
                ""
            ],
            "530i": [
                ""
            ],
            "540i": [
                ""
            ],
            "X5": [
                "3.0L/4.4L"
            ]
        },
        "Buick": {
            "Century": [
                ""
            ],
            "LeSabre": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Park Avenue": [
                ""
            ],
            "Regal": [
                ""
            ],
            "Rendezvous": [
                "AWD",
                "FWD"
            ]
        },
        "Cadillac": {
            "DeVille": [
                "With 5 Lug Wheels"
            ],
            "Eldorado": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "Escalade": [
                "With Akebono Calipers",
                "With PBR Calipers"
            ]
        },
        "Chevrolet": {
            "Astro": [
                "AWD",
                "RWD"
            ],
            "Avalanche 1500": [
                "With 330mm Diameter Rear Rotor and With Dual Piston Caliper",
                "With Dual Piston Caliper and With 330mm Diameter Rear Rotor",
                "With Single Piston Caliper and With 325mm Diameter Rear Rotor"
            ],
            "Avalanche 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Blazer": [
                "4WD"
            ],
            "Corvette": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "Prizm": [
                "",
                "Non-ABS"
            ],
            "S10": [
                "4WD",
                "4WD and with Disc rear brakes",
                "4WD and with Drum rear brakes",
                "RWD",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "Silverado 1500 HD": [
                ""
            ],
            "Silverado 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Silverado 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Silverado 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Silverado 3500": [
                ""
            ],
            "Suburban 1500": [
                "4WD. With Dual Piston Caliper",
                "RWD. With Dual Piston Caliper"
            ],
            "Suburban 2500": [
                "6.0L",
                "8.1L"
            ],
            "Tahoe": [
                "4WD",
                "RWD"
            ],
            "Tracker": [
                ""
            ],
            "Trailblazer": [
                ""
            ],
            "Trailblazer EXT": [
                ""
            ],
            "Venture": [
                "AWD",
                "AWD and with Drum rear brakes",
                "FWD",
                "FWD and with Drum rear brakes"
            ]
        },
        "Chrysler": {
            "300M": [
                ""
            ],
            "Concorde": [
                "With Performance Package or Without Performance Package"
            ],
            "Grand Voyager": [
                ""
            ],
            "Intrepid": [
                ""
            ],
            "Neon": [
                ""
            ],
            "PT Cruiser": [
                "Disc rear brakes"
            ],
            "Sebring": [
                "Convertible/Sedan",
                "Coupe and with Disc rear brakes"
            ],
            "Town and Country": [
                ""
            ],
            "Voyager": [
                "Disc rear brakes",
                "Drum rear brakes"
            ]
        },
        "Dodge": {
            "Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Dakota": [
                "With 11\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Intrepid": [
                "With Performance & Handling Suspension"
            ],
            "Neon": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Ram 1500": [
                ""
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Stratus": [
                "Coupe and with Disc rear brakes",
                "Sedan"
            ]
        },
        "Ford": {
            "E-250 Econoline": [
                "Disc rear brakes"
            ],
            "E-350 Econoline Club Wagon": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Econoline Super Duty": [
                "With Dual Rear Wheels and With Driveline Mounted Parking Brake",
                "With Dual Rear Wheels and With Drum In Hat Parking Brake",
                "With Single Rear Wheels"
            ],
            "E-550 Econoline Super Duty": [
                ""
            ],
            "Escape": [
                ""
            ],
            "Excursion": [
                "4WD"
            ],
            "Explorer": [
                ""
            ],
            "Explorer Sport": [
                "4WD. With Phenolic Piston",
                "4WD. With Steel Piston",
                "RWD. With Phenolic Piston",
                "RWD. With Steel Piston"
            ],
            "Explorer Sport Trac": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "4WD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "4WD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "4WD. With 7 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "RWD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "RWD. With 7 Lug Wheels and With 12mm Wheel Lugs and With 4 Wheel ABS"
            ],
            "F-250 Super Duty": [
                "4WD. With 13.03\" Diameter Rotor",
                "4WD. With 14.53\" Diameter Rotor"
            ],
            "F-350 Super Duty": [
                "RWD and with 4-Wheel ABS. With Dual Rear Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "With ABS Tone Ring",
                "Without ABS Tone Ring"
            ],
            "Focus": [
                "LX/SE/ZTS/ZTW/ZX3/ZX5",
                "LX/SE/ZTS/ZTW/ZX3/ZX5. Without ABS Tone Ring and Wheel Bearing Included"
            ],
            "Mustang": [
                ""
            ],
            "Ranger": [
                "4WD",
                "4WD and with 4-Wheel ABS",
                "4WD and with 4-Wheel ABS. With 10\" Diameter Drum",
                "4WD and with 4-Wheel ABS. With 9\" Diameter Drum",
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD and with BATTERY EV (EV/BEV) engine. With 287mm Diameter Front Rotor",
                "RWD and with GAS/FLEX engine. With 261mm Diameter Front Rotor"
            ],
            "Taurus": [
                "Disc rear brakes. With Police or Taxi Package",
                "Drum rear brakes. With Police or Taxi Package",
                "Drum rear brakes. Without Police Package",
                "Sedan and with Drum rear brakes. With Police or Taxi Package",
                "Sedan and with Drum rear brakes. Without Police Package"
            ],
            "Thunderbird": [
                ""
            ]
        },
        "GMC": {
            "Envoy": [
                ""
            ],
            "Envoy XL": [
                ""
            ],
            "Jimmy": [
                "4WD"
            ],
            "Safari": [
                "AWD",
                "RWD"
            ],
            "Sierra 1500 HD": [
                ""
            ],
            "Sierra 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Sierra 2500": [
                "Automatic transmission",
                "Manual transmission"
            ],
            "Sierra 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Sierra 3500": [
                ""
            ],
            "Sonoma": [
                "4WD",
                "RWD and with Drum rear brakes. With ABS Tone Ring",
                "RWD. With ABS Tone Ring"
            ],
            "Yukon": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 1500": [
                "AWD",
                "RWD"
            ],
            "Yukon XL 2500": [
                "6.0L",
                "8.1L"
            ]
        },
        "Honda": {
            "Accord": [
                "3.0L",
                "Coupe and with 2.3L",
                "Sedan and with 2.3L"
            ],
            "Civic": [
                "Drum rear brakes",
                "SiR/Si"
            ],
            "CR-V": [
                ""
            ],
            "Odyssey": [
                ""
            ]
        },
        "Hyundai": {
            "Elantra": [
                "Disc rear brakes. From 11/01/01",
                "Disc rear brakes. To 10/31/01",
                "Drum rear brakes. From 11/01/01",
                "Drum rear brakes. To 10/31/01"
            ],
            "Santa Fe": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Sonata": [
                ""
            ]
        },
        "INFINITI": {
            "G20": [
                ""
            ],
            "I35": [
                ""
            ],
            "QX4": [
                ""
            ]
        },
        "Jaguar": {
            "S-Type": [
                ""
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                "With Akebono Calipers",
                "With Teves & ATE Caliper"
            ],
            "Liberty": [
                ""
            ],
            "TJ": [
                "",
                "With 9\" Diameter Drum"
            ],
            "Wrangler": [
                "",
                "With 9\" Diameter Drum"
            ]
        },
        "Kia": {
            "Magentis": [
                "From 07/02/02",
                "To 07/02/02"
            ],
            "Optima": [
                "From 07/02",
                "To 07/02"
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ],
            "GS300": [
                ""
            ],
            "GS430": [
                ""
            ],
            "IS300": [
                ""
            ],
            "RX300": [
                "AWD",
                "FWD"
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "Blackwood": [
                ""
            ],
            "Continental": [
                ""
            ],
            "LS": [
                ""
            ]
        },
        "Mazda": {
            "Protege": [
                "2.0L and with Disc rear brakes. With 4 Lug Wheels",
                "2.0L and with Disc rear brakes. With 5 Lug Wheels"
            ],
            "Protege5": [
                ""
            ],
            "Tribute": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "C230": [
                ""
            ],
            "C240": [
                ""
            ],
            "C320": [
                ""
            ],
            "CLK320": [
                ""
            ],
            "CLK430": [
                ""
            ],
            "E320": [
                "Sedan"
            ],
            "E430": [
                "RWD"
            ],
            "ML320": [
                ""
            ],
            "SLK230": [
                ""
            ],
            "SLK320": [
                ""
            ]
        },
        "Mercury": {
            "Mountaineer": [
                ""
            ],
            "Sable": [
                "Disc rear brakes. Without Police or Taxi Package",
                "Drum rear brakes. Without Police or Taxi Package",
                "Sedan and with Drum rear brakes. Without Police or Taxi Package"
            ]
        },
        "Mini": {
            "Cooper": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor and With 4 Lug Wheels"
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "",
                "2.4L"
            ],
            "Galant": [
                "2.4L",
                "3.0L"
            ],
            "Lancer": [
                "ES. With 14\" Diameter Drum",
                "ES. With 15\" Diameter Drum",
                "OZ Rally/LS. With 14\" Diameter Drum",
                "OZ Rally/LS. With 15\" Diameter Drum"
            ]
        },
        "Nissan": {
            "Altima": [
                ""
            ],
            "Maxima": [
                ""
            ],
            "Pathfinder": [
                "RWD/4WD"
            ],
            "Sentra": [
                "1.8L",
                "2.5L. With 4 Piston Caliper",
                "2.5L. With Single Piston Caliper"
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "Aztek": [
                "AWD and with Disc rear brakes",
                "AWD and with Drum rear brakes",
                "FWD and with Disc rear brakes",
                "FWD and with Drum rear brakes"
            ],
            "Bonneville": [
                "SE",
                "SLE/SSEi"
            ],
            "Grand Am": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ],
            "Montana": [
                "AWD and with Disc rear brakes",
                "AWD and with Drum rear brakes",
                "FWD and with Disc rear brakes",
                "FWD and with Drum rear brakes"
            ],
            "Sunfire": [
                ""
            ]
        },
        "Saab": {
            "9-3": [
                "SE/Turbo",
                "Viggen"
            ]
        },
        "Saturn": {
            "L100": [
                ""
            ],
            "L200": [
                ""
            ],
            "L300": [
                ""
            ],
            "LW200": [
                ""
            ],
            "LW300": [
                ""
            ],
            "Vue": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "",
                "4-Wheel ABS"
            ],
            "Impreza": [
                "Outback/RS/TS",
                "WRX"
            ],
            "Legacy": [
                "GT. From 06/02",
                "GT Limited. From 06/02",
                "GT Limited. To 04/02",
                "GT. To 04/02"
            ],
            "Outback": [
                "From 10/01",
                "To 09/01"
            ]
        },
        "Suzuki": {
            "Aerio": [
                ""
            ],
            "Grand Vitara": [
                ""
            ],
            "Vitara": [
                "",
                "From Chassis/VIN #2S3TA03C26109627"
            ],
            "XL-7": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "Limited/SR5. With 15\" Factory Wheels",
                "Limited/SR5. With 16\" Factory Wheels",
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Avalon": [
                ""
            ],
            "Celica": [
                "",
                "Disc rear brakes"
            ],
            "Corolla": [
                "From 04/02",
                "Non-ABS. From 04/02",
                "Non-ABS. To 03/02",
                "To 03/02"
            ],
            "Echo": [
                ""
            ],
            "Highlander": [
                "AWD",
                "FWD"
            ],
            "RAV4": [
                "BATTERY EV (EV/BEV) engine",
                "GAS engine"
            ],
            "Sequoia": [
                "4.7\" Pad Plate Length",
                "5.3\" Pad Plate Length"
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                "2.4L",
                "Disc rear brakes"
            ],
            "Tacoma": [
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                "4.7\" Pad Plate Length",
                "5.3\" Pad Plate Length"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "1.8L",
                "2.0L/1.9L"
            ],
            "Cabrio": [
                ""
            ],
            "Golf": [
                "GL/GLS",
                "GTI 1.8T/GTI VR6",
                "GTI 337"
            ],
            "Passat": [
                "AWD and with 2.8L. With Dual Piston Caliper",
                "AWD and with 2.8L. With Single Piston Caliper",
                "FWD. With Dual Piston Caliper",
                "FWD. With Single Piston Caliper"
            ]
        },
        "Volvo": {
            "S60": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "S80": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "V70": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ]
        }
    },
    "2003": {
        "Acura": {
            "EL": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RSX": [
                "Base",
                "Type-S"
            ],
            "TL": [
                ""
            ]
        },
        "Audi": {
            "TT": [
                ""
            ],
            "TT Quattro": [
                "With 256mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "325Ci": [
                ""
            ],
            "325i": [
                ""
            ],
            "325xi": [
                ""
            ],
            "330Ci": [
                ""
            ],
            "330i": [
                ""
            ],
            "330xi": [
                ""
            ],
            "525i": [
                ""
            ],
            "530i": [
                ""
            ],
            "540i": [
                ""
            ],
            "X5": [
                "3.0L/4.4L"
            ]
        },
        "Buick": {
            "Century": [
                ""
            ],
            "LeSabre": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Park Avenue": [
                "Base",
                "Ultra"
            ],
            "Regal": [
                ""
            ],
            "Rendezvous": [
                "AWD",
                "FWD"
            ]
        },
        "Cadillac": {
            "CTS": [
                "With Sport Suspension",
                "With Standard Suspension"
            ],
            "DeVille": [
                "With 5 Lug Wheels"
            ],
            "Escalade": [
                "AWD",
                "RWD"
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "Seville": [
                "With Solid Rotor",
                "With Vented Rotor"
            ]
        },
        "Chevrolet": {
            "Astro": [
                ""
            ],
            "Avalanche 1500": [
                "4WD",
                "RWD"
            ],
            "Avalanche 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Blazer": [
                "4WD"
            ],
            "Cavalier": [
                "With 225mm x 45mm Size Drum",
                "With 230mm x 42mm Size Drum"
            ],
            "Corvette": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "With 6 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Monte Carlo": [
                ""
            ],
            "S10": [
                "4WD",
                "4WD and with Disc rear brakes",
                "4WD and with Drum rear brakes",
                "RWD",
                "RWD and with Disc rear brakes",
                "RWD and with Drum rear brakes"
            ],
            "Silverado 1500 HD": [
                ""
            ],
            "Silverado 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Silverado 2500 HD": [
                "With Four Wheel Steering",
                "With Two Wheel Steering and 4.63\" Diameter Center Hole",
                "With Two Wheel Steering and 4.84\" Diameter Center Hole"
            ],
            "Silverado 2500": [
                "With Four Wheel Steering",
                "With Two Wheel Steering and 4.63\" Diameter Center Hole",
                "With Two Wheel Steering and 4.84\" Diameter Center Hole"
            ],
            "Silverado 3500": [
                ""
            ],
            "SSR": [
                ""
            ],
            "Suburban 1500": [
                "4WD",
                "RWD"
            ],
            "Suburban 2500": [
                "6.0L/8.1L. With 6 Lug Wheels and With Four Wheel Steering",
                "6.0L. With Two Wheel Steering",
                "8.1L. With Two Wheel Steering"
            ],
            "Tahoe": [
                "4WD",
                "RWD"
            ],
            "Tracker": [
                ""
            ],
            "Trailblazer EXT": [
                ""
            ],
            "Trailblazer": [
                "With 305mm Diameter Front Rotor",
                "With 325mm Diameter Front Rotor"
            ],
            "Venture": [
                "AWD",
                "AWD and with Drum rear brakes",
                "FWD",
                "FWD and with Drum rear brakes"
            ]
        },
        "Chrysler": {
            "300M": [
                ""
            ],
            "Concorde": [
                "With Performance Package or Without Performance Package"
            ],
            "Intrepid": [
                ""
            ],
            "PT Cruiser": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Sebring": [
                "Convertible/Sedan",
                "Coupe and with Disc rear brakes"
            ],
            "Town and Country": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Voyager": [
                "Drum rear brakes and with 4-Wheel ABS",
                "Drum rear brakes and with Non-ABS"
            ]
        },
        "Dodge": {
            "Caravan": [
                "Disc rear brakes",
                "Drum rear brakes and with 4-Wheel ABS",
                "Drum rear brakes and with Non-ABS"
            ],
            "Dakota": [
                ""
            ],
            "Grand Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Intrepid": [
                "With Performance & Handling Suspension"
            ],
            "Neon": [
                "LE/R/T/SXT/SE",
                "SRT-4"
            ],
            "Ram 1500": [
                ""
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Stratus": [
                "Coupe and with Disc rear brakes",
                "Sedan"
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Club Wagon": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels and With 8 Lug Wheels and With 11000 Lb Axle and With 11-1/4\" Ring Gear"
            ],
            "E-550 Super Duty": [
                ""
            ],
            "Escape": [
                ""
            ],
            "Excursion": [
                "4WD",
                "RWD"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                "Limited/XLS/Eddie Bauer/XLT"
            ],
            "Explorer Sport": [
                "4WD",
                "RWD"
            ],
            "Explorer Sport Trac": [
                "4WD",
                "RWD"
            ],
            "F-150": [
                "4WD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "4WD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "4WD. With 7 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 12mm Wheel Lugs",
                "RWD. With 5 Lug Wheels and With 14mm Wheel Lugs",
                "RWD. With 7 Lug Wheels and With 12mm Wheel Lugs and With 4 Wheel ABS"
            ],
            "F-250 Super Duty": [
                "4WD. With 13.03\" Diameter Rotor",
                "RWD and with 4-Wheel ABS",
                "With 14.53\" Diameter Rotor"
            ],
            "F-350 Super Duty": [
                "RWD and with 4-Wheel ABS. With Single Rear Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "With ABS Tone Ring",
                "Without ABS Tone Ring"
            ],
            "Focus": [
                "LX/SE/ZTS/ZTW/ZX3/ZX5",
                "LX/SE/ZTS/ZTW/ZX3/ZX5. Without ABS Tone Ring and Wheel Bearing Included"
            ],
            "Mustang": [
                "Base/SVT Cobra 10th Anniversary/GT/Mach 1",
                "Mach 1. Left or Right"
            ],
            "Taurus": [
                "Disc rear brakes. With Police or Taxi Package",
                "Sedan and with Drum rear brakes"
            ],
            "Thunderbird": [
                ""
            ]
        },
        "GMC": {
            "Envoy": [
                ""
            ],
            "Envoy XL": [
                ""
            ],
            "Jimmy": [
                "4WD"
            ],
            "Safari": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Sierra 1500 HD": [
                ""
            ],
            "Sierra 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Sierra 2500": [
                "Automatic transmission. With Two Wheel Steering",
                "Manual transmission. With Two Wheel Steering",
                "With Four Wheel Steering"
            ],
            "Sierra 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Sierra 3500": [
                ""
            ],
            "Sonoma": [
                "4WD",
                "RWD and with Drum rear brakes. With ABS Tone Ring",
                "RWD. With ABS Tone Ring"
            ],
            "Yukon": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 1500": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 2500": [
                "6.0L",
                "8.1L"
            ]
        },
        "Honda": {
            "Accord": [
                "2.4L. Excluding Vehicles Built For Canadian Market",
                "2.4L. Vehicles Built For Canadian Market",
                "Coupe and with 3.0L and Automatic transmission",
                "Coupe and with 3.0L and Manual transmission",
                "Sedan and with 3.0L"
            ],
            "Civic": [
                "DX/HX and with Coupe",
                "GX/DX and with Sedan",
                "LX/EX and with Sedan/Coupe",
                "Si and with Coupe. With 4 Lug Wheels",
                "SiR/Si"
            ],
            "CR-V": [
                ""
            ],
            "Element": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Elantra": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Santa Fe": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Sonata": [
                ""
            ],
            "Tiburon": [
                ""
            ],
            "XG350": [
                "From 03/12/03"
            ]
        },
        "INFINITI": {
            "FX35": [
                ""
            ],
            "FX45": [
                ""
            ],
            "G35": [
                "With Brembo Brakes"
            ],
            "I35": [
                ""
            ],
            "QX4": [
                ""
            ]
        },
        "Isuzu": {
            "Ascender": [
                ""
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                ""
            ],
            "Liberty": [
                ""
            ],
            "TJ": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Wrangler": [
                "Disc rear brakes",
                "Drum rear brakes"
            ]
        },
        "Kia": {
            "Magentis": [
                ""
            ],
            "Optima": [
                ""
            ],
            "Sorento": [
                ""
            ]
        },
        "Lexus": {
            "ES300": [
                ""
            ],
            "GS300": [
                ""
            ],
            "GS430": [
                ""
            ],
            "GX470": [
                ""
            ],
            "IS300": [
                ""
            ],
            "RX300": [
                "AWD",
                "FWD"
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "Blackwood": [
                ""
            ],
            "LS": [
                ""
            ],
            "Navigator": [
                ""
            ],
            "Town Car": [
                "Sedan"
            ]
        },
        "Mazda": {
            "6": [
                ""
            ],
            "Protege": [
                "ES"
            ],
            "Protege5": [
                ""
            ],
            "Tribute": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "C230": [
                "Coupe",
                "Sedan. With Sport Package",
                "Sedan. Without Sport Package"
            ],
            "C240": [
                "Sedan and with RWD",
                "Sedan/Wagon and with AWD",
                "Wagon and with RWD"
            ],
            "C320": [
                "AWD",
                "RWD. With Sport Package",
                "RWD. Without Sport Package"
            ],
            "CLK320": [
                "Convertible",
                "Coupe"
            ],
            "CLK430": [
                ""
            ],
            "ML320": [
                ""
            ],
            "ML350": [
                ""
            ],
            "SLK230": [
                ""
            ],
            "SLK320": [
                ""
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Marauder": [
                ""
            ],
            "Mountaineer": [
                ""
            ],
            "Sable": [
                "",
                "Sedan"
            ]
        },
        "Mini": {
            "Cooper": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor and With 4 Lug Wheels"
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "",
                "2.4L"
            ],
            "Galant": [
                "2.4L",
                "3.0L"
            ],
            "Lancer": [
                "ES. With 14\" Diameter Drum",
                "ES. With 15\" Diameter Drum",
                "OZ Rally/LS. With 14\" Diameter Drum",
                "OZ Rally/LS. With 15\" Diameter Drum"
            ]
        },
        "Nissan": {
            "350Z": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ],
            "Altima": [
                ""
            ],
            "Frontier": [
                "3.3L",
                "4WD and with 3.3L"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Sentra": [
                "1.8L"
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "Aztek": [
                "AWD and with Disc rear brakes",
                "AWD and with Drum rear brakes",
                "FWD and with Disc rear brakes",
                "FWD and with Drum rear brakes"
            ],
            "Bonneville": [
                "SE",
                "SLE/SSEi"
            ],
            "Grand Am": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ],
            "Montana": [
                "AWD and with Disc rear brakes",
                "AWD and with Drum rear brakes",
                "FWD and with Disc rear brakes",
                "FWD and with Drum rear brakes"
            ],
            "Sunfire": [
                ""
            ],
            "Vibe": [
                "",
                "AWD",
                "FWD"
            ]
        },
        "Saab": {
            "9-3": [
                "Convertible"
            ]
        },
        "Saturn": {
            "Ion": [
                "",
                "From VIN 3Z100144",
                "To VIN 3Z100143"
            ],
            "L200": [
                ""
            ],
            "L300": [
                ""
            ],
            "LW200": [
                ""
            ],
            "LW300": [
                ""
            ],
            "Vue": [
                "",
                "From Chassis/VIN #3S823795"
            ]
        },
        "Subaru": {
            "Baja": [
                ""
            ],
            "Forester": [
                ""
            ],
            "Impreza": [
                "Outback/RS/TS",
                "Outback/RS/TS. From 10/01/02",
                "Outback/RS/TS. To 10/01/02",
                "WRX. From 07/02",
                "WRX. To 06/02"
            ],
            "Legacy": [
                "GT",
                "L/L SE"
            ],
            "Outback": [
                ""
            ]
        },
        "Suzuki": {
            "Aerio": [
                ""
            ],
            "Grand Vitara": [
                ""
            ],
            "Vitara": [
                ""
            ],
            "XL-7": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 16\" Factory Wheels",
                "With 17\" Factory Wheels"
            ],
            "Avalon": [
                ""
            ],
            "Celica": [
                "",
                "Disc rear brakes"
            ],
            "Corolla": [
                "From 04/03 and Japan Production Identified By 1st Digit Of VIN J",
                "Japan Production Identified By 1st Digit Of VIN J and To 03/03, or North American Production Identified By 1st Digit Of VIN 1, 2, 4 Or 5"
            ],
            "Echo": [
                ""
            ],
            "Highlander": [
                "AWD",
                "FWD"
            ],
            "Matrix": [
                "",
                "AWD",
                "FWD"
            ],
            "RAV4": [
                "BATTERY EV (EV/BEV) engine",
                "GAS engine"
            ],
            "Sequoia": [
                "4.7\" Pad Plate Length",
                "5.3\" Pad Plate Length"
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                "2.4L",
                "Disc rear brakes"
            ],
            "Tacoma": [
                "With 6 Lug Wheels and With Heavy Duty Brakes",
                "With 6 Lug Wheels and With Standard Brakes"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "1.8L",
                "2.0L/1.9L"
            ],
            "Golf": [
                "GL/GLS",
                "GTI 1.8T/GTI VR6",
                "GTI 20th Anniversary"
            ],
            "Passat": [
                "AWD and with 2.8L",
                "FWD and with 2.8L/1.8L"
            ]
        },
        "Volvo": {
            "S60": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "S80": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "V70": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "XC70": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2004": {
        "Acura": {
            "EL": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RSX": [
                "Base",
                "Type-S"
            ],
            "TL": [
                "Automatic transmission",
                "Manual transmission"
            ],
            "TSX": [
                ""
            ]
        },
        "Audi": {
            "A6": [
                "With 312mm Diameter Front Rotor"
            ],
            "TT": [
                ""
            ],
            "TT Quattro": [
                "1.8L. With 256mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "325Ci": [
                ""
            ],
            "325i": [
                ""
            ],
            "325xi": [
                ""
            ],
            "330Ci": [
                ""
            ],
            "330i": [
                ""
            ],
            "330xi": [
                ""
            ],
            "525i": [
                "Automatic transmission"
            ],
            "530i": [
                ""
            ],
            "545i": [
                ""
            ],
            "645Ci": [
                ""
            ],
            "X3": [
                ""
            ],
            "X5": [
                "3.0L/4.4L"
            ]
        },
        "Buick": {
            "Century": [
                ""
            ],
            "LeSabre": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Park Avenue": [
                "Base",
                "Ultra"
            ],
            "Rainier": [
                "4.2L",
                "5.3L"
            ],
            "Regal": [
                ""
            ],
            "Rendezvous": [
                "AWD",
                "FWD"
            ]
        },
        "Cadillac": {
            "CTS": [
                "Base. With Sport Suspension",
                "Base. With Standard Suspension"
            ],
            "DeVille": [
                "With 5 Lug Wheels"
            ],
            "Escalade": [
                "AWD",
                "RWD"
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "Seville": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "SRX": [
                "JE-2 Suspension or JE-5 Suspension"
            ],
            "XLR": [
                "",
                "Naturally Aspirated"
            ]
        },
        "Chevrolet": {
            "Astro": [
                ""
            ],
            "Avalanche 1500": [
                "4WD",
                "RWD"
            ],
            "Avalanche 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Aveo": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Blazer": [
                "4WD"
            ],
            "Cavalier": [
                "With 230mm x 42mm Size Drum"
            ],
            "Classic": [
                "",
                "Base/LS"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "With 6 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                "Disc rear brakes. With 276mm Diameter Front Rotor",
                "Disc rear brakes. With 296mm Diameter Front Rotor",
                "Drum rear brakes. With 276mm Diameter Front Rotor",
                "Drum rear brakes. With 296mm Diameter Front Rotor"
            ],
            "Monte Carlo": [
                ""
            ],
            "Optra": [
                "With 258mm Diameter Rear Rotor",
                "With 276mm Diameter Rear Rotor"
            ],
            "S10": [
                ""
            ],
            "Silverado 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Silverado 2500 HD": [
                "With Two Wheel Steering and 4.63\" Diameter Center Hole",
                "With Two Wheel Steering and 4.84\" Diameter Center Hole"
            ],
            "Silverado 2500": [
                "With Two Wheel Steering and 4.63\" Diameter Center Hole",
                "With Two Wheel Steering and 4.84\" Diameter Center Hole"
            ],
            "Silverado 3500": [
                "With 12000 Lb GVW",
                "With 9900 Lb GVW"
            ],
            "SSR": [
                ""
            ],
            "Suburban 1500": [
                "4WD",
                "RWD"
            ],
            "Suburban 2500": [
                "6.0L. With Two Wheel Steering",
                "8.1L. With Two Wheel Steering"
            ],
            "Tahoe": [
                "4WD",
                "RWD"
            ],
            "Tracker": [
                ""
            ],
            "Trailblazer EXT": [
                ""
            ],
            "Trailblazer": [
                "With 305mm Diameter Front Rotor",
                "With 325mm Diameter Front Rotor"
            ],
            "Venture": [
                "AWD",
                "AWD and with Drum rear brakes",
                "FWD",
                "FWD and with Drum rear brakes"
            ]
        },
        "Chrysler": {
            "300M": [
                ""
            ],
            "Concorde": [
                "With Performance Package or Without Performance Package"
            ],
            "Crossfire": [
                ""
            ],
            "Intrepid": [
                ""
            ],
            "Pacifica": [
                ""
            ],
            "PT Cruiser": [
                "Naturally Aspirated",
                "Naturally Aspirated. With 9\" Diameter Drum",
                "Turbocharged",
                "Turbocharged. With 9\" Diameter Drum"
            ],
            "Sebring": [
                "Convertible/Sedan",
                "Coupe and with Disc rear brakes"
            ],
            "Town and Country": [
                "Disc rear brakes",
                "Drum rear brakes"
            ]
        },
        "Dodge": {
            "Caravan": [
                "Disc rear brakes",
                "Drum rear brakes and with 4-Wheel ABS",
                "Drum rear brakes and with Non-ABS"
            ],
            "Dakota": [
                ""
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Intrepid": [
                ""
            ],
            "Neon": [
                "SRT-4",
                "SXT/SE"
            ],
            "Ram 1500": [
                "SLT/ST"
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Stratus": [
                "Coupe and with Disc rear brakes",
                "Sedan"
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-150": [
                ""
            ],
            "E-150 Club Wagon": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Club Wagon": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels and With 8 Lug Wheels and With 11000 Lb Axle and With 11-1/4\" Ring Gear"
            ],
            "Escape": [
                ""
            ],
            "Excursion": [
                "4WD",
                "RWD"
            ],
            "Expedition": [
                ""
            ],
            "Explorer Sport Trac": [
                "4WD",
                "RWD"
            ],
            "Explorer": [
                "With Phenolic Piston"
            ],
            "F-150": [
                "4WD. With 5 Lug Wheels and 11th Digit Of Vin Is C",
                "4WD. With 6 Lug Wheels and 11th Digit Of Vin Is K, N, or F",
                "4WD. With 7 Lug Wheels and With Vented Rear Rotors and 11th Digit Of Vin Is K, N, or F",
                "RWD. With 5 Lug Wheels and 11th Digit Of Vin Is C",
                "RWD. With 6 Lug Wheels and 11th Digit Of Vin Is K, N, or F",
                "RWD. With 7 Lug Wheels and With Vented Rear Rotors and 11th Digit Of Vin Is K, N, or F"
            ],
            "F-150 Heritage": [
                "4WD. With 5 Lug Wheels and With 7 Lug Wheels",
                "4WD. With 7 Lug Wheels and With 5 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With 13.03\" Diameter Rotor",
                "RWD and with 4-Wheel ABS",
                "With Monobeam Front Axle"
            ],
            "F-350 Super Duty": [
                "RWD and with 4-Wheel ABS. With Single Rear Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "With ABS Tone Ring",
                "Without ABS Tone Ring"
            ],
            "Focus": [
                "LX/Mid/High/SE/ZTS/ZTW/ZX3/ZX5. From 04/05/04",
                "LX/SE/ZTS/ZTW/ZX3/ZX5. To 04/04/04"
            ],
            "Freestar": [
                ""
            ],
            "Mustang": [
                "Base/GT/Mach 1",
                "Mach 1. Left or Right"
            ],
            "Ranger": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum"
            ],
            "Taurus": [
                "",
                "Sedan and with Drum rear brakes"
            ],
            "Thunderbird": [
                ""
            ]
        },
        "GMC": {
            "Canyon": [
                ""
            ],
            "Envoy": [
                ""
            ],
            "Envoy XL": [
                ""
            ],
            "Envoy XUV": [
                ""
            ],
            "Jimmy": [
                "4WD"
            ],
            "Safari": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Sierra 1500": [
                "With Dual Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Sierra 2500": [
                "Automatic transmission",
                "Manual transmission"
            ],
            "Sierra 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Sierra 3500": [
                "With 12000 Lb GVW",
                "With 9900 Lb GVW"
            ],
            "Sonoma": [
                ""
            ],
            "Yukon": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 1500": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 2500": [
                "6.0L. With Two Wheel Steering",
                "8.1L. With Two Wheel Steering"
            ]
        },
        "Honda": {
            "Accord": [
                "2.4L. Excluding Vehicles Built For Canadian Market",
                "2.4L. Vehicles Built For Canadian Market",
                "Coupe and with 3.0L and Automatic transmission",
                "Coupe and with 3.0L and Manual transmission",
                "Sedan and with 3.0L"
            ],
            "Civic": [
                "DX/Value Package/HX and with Coupe",
                "DX/Value Package/HX and with Coupe and 1.7L",
                "GX/DX/Value Package and with Sedan",
                "GX/DX/Value Package and with Sedan and 1.7L",
                "LX/EX and with Sedan/Coupe",
                "LX/EX and with Sedan/Coupe and 1.7L",
                "Si and with Coupe and 1.7L. With 4 Lug Wheels",
                "Si and with Coupe. With 4 Lug Wheels",
                "Si. With 5 Lug Wheels",
                "SiR"
            ],
            "CR-V": [
                ""
            ],
            "Element": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Elantra": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Santa Fe": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Sonata": [
                "From 09/04/03",
                "To 09/03/03"
            ],
            "Tiburon": [
                "",
                "Base"
            ],
            "XG350": [
                ""
            ]
        },
        "INFINITI": {
            "FX35": [
                ""
            ],
            "FX45": [
                ""
            ],
            "G35": [
                "With Brembo Brakes"
            ],
            "I35": [
                ""
            ],
            "QX56": [
                ""
            ]
        },
        "Isuzu": {
            "Ascender": [
                "113.0\" wheel base",
                "129.0\" wheel base"
            ]
        },
        "Jaguar": {
            "S-Type": [
                "Naturally Aspirated. With 300mm Diameter Front Rotor"
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                ""
            ],
            "Liberty": [
                ""
            ],
            "TJ": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Wrangler": [
                "Disc rear brakes",
                "Drum rear brakes"
            ]
        },
        "Kia": {
            "Amanti": [
                ""
            ],
            "Magentis": [
                ""
            ],
            "Optima": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Spectra": [
                "2.0L"
            ]
        },
        "Lexus": {
            "ES330": [
                ""
            ],
            "GS300": [
                ""
            ],
            "GS430": [
                ""
            ],
            "GX470": [
                ""
            ],
            "IS300": [
                ""
            ],
            "RX330": [
                ""
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "LS": [
                ""
            ],
            "Navigator": [
                ""
            ],
            "Town Car": [
                "Sedan"
            ]
        },
        "Mazda": {
            "3": [
                "2.0L",
                "2.3L"
            ],
            "6": [
                ""
            ],
            "MPV": [
                ""
            ],
            "RX-8": [
                "With Sport Suspension"
            ],
            "Tribute": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "C230": [
                "Coupe",
                "Sedan. With Sport Package",
                "Sedan. Without Sport Package"
            ],
            "C240": [
                "Sedan and with RWD",
                "Sedan/Wagon and with AWD",
                "Wagon and with RWD"
            ],
            "C320": [
                "AWD",
                "Sedan and with RWD. With Sport Package and From 04/21/04",
                "Sedan and with RWD. With Sport Package and To 04/20/04",
                "Sedan/Wagon/Coupe and with RWD. Without Sport Package",
                "Wagon/Coupe and with RWD. With Sport Package"
            ],
            "CLK320": [
                ""
            ],
            "E320": [
                "AWD. With Solid Rotor",
                "AWD. With Vented Rotor"
            ],
            "E500": [
                "AWD. Without Sport Package"
            ],
            "ML350": [
                ""
            ],
            "SLK230": [
                ""
            ],
            "SLK320": [
                ""
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Marauder": [
                ""
            ],
            "Monterey": [
                ""
            ],
            "Mountaineer": [
                ""
            ],
            "Sable": [
                "Disc rear brakes",
                "Drum rear brakes",
                "Sedan and with Drum rear brakes"
            ]
        },
        "Mini": {
            "Cooper": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor and With 4 Lug Wheels"
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L and with Drum rear brakes",
                "Disc rear brakes"
            ],
            "Endeavor": [
                ""
            ],
            "Galant": [
                "2.4L",
                "3.8L"
            ],
            "Lancer": [
                "ES. With 14\" Factory Wheels",
                "ES. With 15\" Factory Wheels",
                "OZ Rally/LS. With 14\" Factory Wheels",
                "OZ Rally/LS. With 15\" Factory Wheels",
                "Ralliart/Sportback Ralliart"
            ]
        },
        "Nissan": {
            "350Z": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ],
            "Altima": [
                ""
            ],
            "Frontier": [
                "3.3L",
                "4WD and with 3.3L"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "Pathfinder Armada": [
                ""
            ],
            "Pathfinder": [
                "From 08/04",
                "To 07/04"
            ],
            "Quest": [
                ""
            ],
            "Sentra": [
                "1.8L"
            ],
            "TITAN": [
                ""
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "Aztek": [
                "AWD and with Disc rear brakes",
                "AWD and with Drum rear brakes",
                "FWD and with Disc rear brakes",
                "FWD and with Drum rear brakes"
            ],
            "Bonneville": [
                "GXP",
                "SE",
                "SLE"
            ],
            "Grand Am": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Grand Prix": [
                ""
            ],
            "Montana": [
                "AWD and with Disc rear brakes",
                "AWD and with Drum rear brakes",
                "FWD and with Disc rear brakes",
                "FWD and with Drum rear brakes"
            ],
            "Sunfire": [
                ""
            ],
            "Vibe": [
                "",
                "AWD",
                "FWD"
            ]
        },
        "Saturn": {
            "Ion": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "L300": [
                ""
            ],
            "Vue": [
                ""
            ]
        },
        "Subaru": {
            "Baja": [
                ""
            ],
            "Forester": [
                ""
            ],
            "Impreza": [
                "Outback/RS/TS",
                "WRX"
            ],
            "Legacy": [
                "GT",
                "L"
            ],
            "Outback": [
                ""
            ]
        },
        "Suzuki": {
            "Aerio": [
                ""
            ],
            "Forenza": [
                ""
            ],
            "Grand Vitara": [
                "From Chassis/VIN #44103257",
                "To Chassis/VIN #44103256"
            ],
            "Vitara": [
                ""
            ],
            "XL-7": [
                "From Chassis/VIN #44106616 and #44103257",
                "To Chassis/VIN #44106615 and #44103256"
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 16\" Factory Wheels",
                "With 17\" Factory Wheels"
            ],
            "Avalon": [
                ""
            ],
            "Celica": [
                "",
                "Disc rear brakes"
            ],
            "Corolla": [
                "Japan Production Identified By 1st Digit Of VIN J",
                "North American Production Identified By 1st Digit Of VIN 1, 2, 4 Or 5"
            ],
            "Echo": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Matrix": [
                "",
                "AWD",
                "Base/XR and with FWD",
                "FWD"
            ],
            "Prius": [
                ""
            ],
            "RAV4": [
                "Drum rear brakes"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                ""
            ],
            "Tundra": [
                ""
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "Golf": [
                "2.0L/1.9L",
                "2.8L/1.8L"
            ],
            "Passat": [
                "AWD and with 2.8L/1.8L",
                "FWD and with 2.0L/2.8L/1.8L"
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 350mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "S40": [
                "2.4L/2.5L. With 320mm Diameter Front Rotor and With 5 Lug Wheels",
                "2.4L/2.5L. With 5 Lug Wheels and With 320mm Diameter Front Rotor",
                "With 5 Lug Wheels and With 278mm Diameter Front Rotor",
                "With 5 Lug Wheels and With 320mm Diameter Front Rotor"
            ],
            "S60": [
                "2.4/2.5T/2.5T AWD/T5. With 15\" Factory Wheels",
                "2.4/2.5T/2.5T AWD/T5. With 16\" Factory Wheels"
            ],
            "S80": [
                "With 286mm Diameter Front Rotor",
                "With 305mm Diameter Front Rotor"
            ],
            "V70": [
                "2.4/2.5T/2.5T AWD/T5. With 286mm Diameter Front Rotor",
                "2.4/2.5T/2.5T AWD/T5. With 305mm Diameter Front Rotor"
            ],
            "XC70": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2005": {
        "Acura": {
            "EL": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RL": [
                ""
            ],
            "RSX": [
                "Base",
                "Type-S"
            ],
            "TL": [
                "Automatic transmission",
                "Manual transmission"
            ],
            "TSX": [
                ""
            ]
        },
        "Audi": {
            "TT": [
                ""
            ],
            "TT Quattro": [
                "1.8L. With 256mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "325Ci": [
                ""
            ],
            "325i": [
                ""
            ],
            "325xi": [
                ""
            ],
            "330Ci": [
                ""
            ],
            "330i": [
                ""
            ],
            "330xi": [
                ""
            ],
            "525i": [
                "Automatic transmission"
            ],
            "530i": [
                ""
            ],
            "545i": [
                ""
            ],
            "645Ci": [
                ""
            ],
            "X3": [
                ""
            ],
            "X5": [
                "3.0i"
            ]
        },
        "Buick": {
            "Allure": [
                ""
            ],
            "Century": [
                ""
            ],
            "LaCrosse": [
                ""
            ],
            "LeSabre": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels and From Chassis/VIN #5U129026",
                "With 16\" Factory Wheels and To Chassis/VIN #5U129025"
            ],
            "Park Avenue": [
                "Base",
                "Ultra"
            ],
            "Rainier": [
                "4.2L",
                "5.3L"
            ],
            "Rendezvous": [
                "AWD",
                "FWD"
            ],
            "Terraza": [
                "AWD",
                "FWD"
            ]
        },
        "Cadillac": {
            "CTS": [
                "Base. With Sport Suspension",
                "Base. With Standard Suspension"
            ],
            "DeVille": [
                "With 5 Lug Wheels and From Chassis/VIN #5U129029",
                "With 5 Lug Wheels and To Chassis/VIN #5U129028"
            ],
            "Escalade": [
                "AWD",
                "RWD"
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                ""
            ],
            "XLR": [
                ""
            ]
        },
        "Chevrolet": {
            "Astro": [
                ""
            ],
            "Avalanche 1500": [
                "4WD",
                "RWD"
            ],
            "Avalanche 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Aveo": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Blazer": [
                "4WD"
            ],
            "Cavalier": [
                "With 230mm x 42mm Size Drum"
            ],
            "Classic": [
                "",
                "Base"
            ],
            "Cobalt": [
                "Base/LT/LS. With 4 Lug Wheels",
                "SS. With 5 Lug Wheels"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "With 6 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "Impala": [
                "From Chassis/VIN #59143076",
                "To Chassis/VIN #59143075"
            ],
            "Malibu": [
                "Disc rear brakes. With 276mm Diameter Front Rotor",
                "Disc rear brakes. With 296mm Diameter Front Rotor",
                "Drum rear brakes. With 276mm Diameter Front Rotor",
                "Drum rear brakes. With 296mm Diameter Front Rotor"
            ],
            "Monte Carlo": [
                "From Chassis/VIN #59143076",
                "To Chassis/VIN #59143075"
            ],
            "Optra": [
                "With 258mm Diameter Rear Rotor",
                "With 276mm Diameter Rear Rotor"
            ],
            "Silverado 1500": [
                "Crew Cab Pickup and with Disc rear brakes. With 7000 Lb GVW",
                "Crew Cab Pickup and with Drum rear brakes. With 7000 Lb GVW",
                "Disc rear brakes",
                "Disc rear brakes. With 6400 Lb GVW",
                "Disc rear brakes. With Dual Piston Caliper",
                "Disc rear brakes. With Single Piston Caliper",
                "Drum rear brakes",
                "Drum rear brakes. With 6400 Lb GVW",
                "Drum rear brakes. With Dual Piston Caliper",
                "Drum rear brakes. With Single Piston Caliper"
            ],
            "Silverado 1500 HD": [
                ""
            ],
            "Silverado 2500 HD": [
                "With Two Wheel Steering and 4.63\" Diameter Center Hole",
                "With Two Wheel Steering and 4.84\" Diameter Center Hole"
            ],
            "Silverado 3500": [
                "With 12000 Lb GVW",
                "With 9900 Lb GVW"
            ],
            "SSR": [
                ""
            ],
            "Suburban 1500": [
                "4WD",
                "RWD"
            ],
            "Suburban 2500": [
                "6.0L. With Two Wheel Steering",
                "8.1L. With Two Wheel Steering"
            ],
            "Tahoe": [
                "4WD",
                "RWD"
            ],
            "Trailblazer": [
                ""
            ],
            "Trailblazer EXT": [
                ""
            ],
            "Uplander": [
                "AWD",
                "FWD"
            ],
            "Venture": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "2.7L",
                "5.7L",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L"
            ],
            "Crossfire": [
                "Limited/Base"
            ],
            "Pacifica": [
                ""
            ],
            "PT Cruiser": [
                "Naturally Aspirated",
                "Naturally Aspirated. Without 4 Wheel ABS",
                "Turbocharged",
                "Turbocharged. Without 4 Wheel ABS"
            ],
            "Sebring": [
                "Convertible",
                "Coupe and with Disc rear brakes",
                "Sedan"
            ],
            "Town and Country": [
                "Disc rear brakes",
                "Drum rear brakes"
            ]
        },
        "Dodge": {
            "Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Dakota": [
                "",
                "Dual Upper Return Spring"
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Magnum": [
                "2.7L",
                "5.7L",
                "AWD and with 3.5L",
                "RWD and with 3.5L"
            ],
            "Neon": [
                "SRT-4",
                "SXT/SE"
            ],
            "Ram 1500": [
                "Laramie/SLT/ST",
                "Laramie/SLT/ST. Exc Mega Cab"
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Stratus": [
                "Coupe and with Disc rear brakes",
                "Sedan"
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-150": [
                ""
            ],
            "E-150 Club Wagon": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Club Wagon": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels and With 8 Lug Wheels and With 11000 Lb Axle and With 11-1/4\" Ring Gear"
            ],
            "Escape": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Excursion": [
                "4WD",
                "RWD"
            ],
            "Expedition": [
                ""
            ],
            "Explorer Sport Trac": [
                "4WD",
                "RWD"
            ],
            "Explorer": [
                "With Phenolic Piston"
            ],
            "F-150": [
                "4WD. With 6 Lug Wheels",
                "4WD. With 7 Lug Wheels",
                "RWD. With 6 Lug Wheels",
                "RWD. With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels",
                "XL/XLT/King Ranch/Lariat and with 4WD. With Dual Rear Wheels",
                "XL/XLT/King Ranch/Lariat and with 4WD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "Five Hundred": [
                ""
            ],
            "Focus": [
                "Disc rear brakes",
                "Without ABS Tone Ring and Wheel Bearing Included"
            ],
            "Freestar": [
                ""
            ],
            "Freestyle": [
                ""
            ],
            "Mustang": [
                "Base",
                "GT"
            ],
            "Ranger": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum"
            ],
            "Taurus": [
                "",
                "Sedan and with Drum rear brakes"
            ],
            "Thunderbird": [
                ""
            ]
        },
        "GMC": {
            "Canyon": [
                ""
            ],
            "Envoy": [
                "4.2L",
                "5.3L"
            ],
            "Envoy XL": [
                ""
            ],
            "Envoy XUV": [
                ""
            ],
            "Jimmy": [
                ""
            ],
            "Safari": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Sierra 1500": [
                "Crew Cab Pickup and with Disc rear brakes. With 7000 Lb GVW",
                "Crew Cab Pickup and with Drum rear brakes. With 7000 Lb GVW",
                "Disc rear brakes",
                "Disc rear brakes. With 6400 Lb GVW",
                "Disc rear brakes. With Dual Piston Caliper",
                "Disc rear brakes. With Single Piston Caliper",
                "Drum rear brakes",
                "Drum rear brakes. With 6400 Lb GVW",
                "Drum rear brakes. With Dual Piston Caliper",
                "Drum rear brakes. With Single Piston Caliper"
            ],
            "Sierra 1500 HD": [
                ""
            ],
            "Sierra 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Sierra 3500": [
                "With 12000 Lb GVW",
                "With 9900 Lb GVW"
            ],
            "Yukon": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 1500": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 2500": [
                "6.0L. With Two Wheel Steering",
                "8.1L. With Two Wheel Steering"
            ]
        },
        "Honda": {
            "Accord": [
                "Coupe and with 3.0L and GAS engine and Automatic transmission. With 282mm Diameter Front Rotor",
                "Coupe and with 3.0L and GAS engine and Automatic transmission. With 300mm Diameter Front Rotor",
                "Coupe and with 3.0L and GAS engine and Manual transmission. With 282mm Diameter Front Rotor",
                "Coupe and with 3.0L and GAS engine and Manual transmission. With 300mm Diameter Front Rotor",
                "Hybrid and with 3.0L and FULL HYBRID EV-GAS (FHEV) engine. With 282mm Diameter Front Rotor",
                "Hybrid and with 3.0L and FULL HYBRID EV-GAS (FHEV) engine. With 300mm Diameter Front Rotor",
                "Sedan and with 3.0L and GAS engine. With 282mm Diameter Front Rotor",
                "Sedan and with 3.0L and GAS engine. With 300mm Diameter Front Rotor"
            ],
            "Civic": [
                "GX/DX/Value Package and with Sedan",
                "GX/DX/Value Package and with Sedan and 1.7L",
                "LX/EX and with Sedan/Coupe",
                "LX/EX and with Sedan/Coupe and 1.7L",
                "Si and with Coupe and 1.7L and Drum rear brakes. With 4 Lug Wheels",
                "Si and with Coupe and Drum rear brakes. With 4 Lug Wheels",
                "Si and with Disc rear brakes. With 5 Lug Wheels",
                "Value Package/HX and with Coupe",
                "Value Package/HX and with Coupe and 1.7L"
            ],
            "CR-V": [
                ""
            ],
            "Element": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Elantra": [
                "Disc rear brakes. From 02/26/05",
                "Disc rear brakes. To 02/25/05",
                "Drum rear brakes. From 02/26/05",
                "Drum rear brakes. To 02/25/05"
            ],
            "Santa Fe": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Sonata": [
                "From 03/01/05"
            ],
            "Tiburon": [
                "",
                "GS/SE"
            ],
            "Tucson": [
                "4WD",
                "FWD"
            ],
            "XG350": [
                ""
            ]
        },
        "INFINITI": {
            "FX35": [
                "To 10/05"
            ],
            "FX45": [
                "To 10/05"
            ],
            "G35": [
                "AWD. With Single Piston Caliper",
                "RWD. With Single Piston Caliper"
            ],
            "QX56": [
                "From 03/05",
                "To 02/05"
            ]
        },
        "Isuzu": {
            "Ascender": [
                "113.0\" wheel base",
                "129.0\" wheel base"
            ]
        },
        "Jaguar": {
            "S-Type": [
                "Sport/Base. From Chassis/VIN #N52048"
            ],
            "Vanden Plas": [
                "From Chassis/VIN #G49701"
            ],
            "X-Type": [
                "From VIN #E24054"
            ]
        },
        "Jeep": {
            "Grand Cherokee": [
                ""
            ],
            "Liberty": [
                ""
            ],
            "TJ": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Wrangler": [
                "Disc rear brakes",
                "Drum rear brakes"
            ]
        },
        "Kia": {
            "Amanti": [
                ""
            ],
            "Magentis": [
                "From 10/05",
                "To 09/05"
            ],
            "Optima": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Spectra": [
                ""
            ],
            "Spectra5": [
                ""
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR3": [
                "4.4L"
            ]
        },
        "Lexus": {
            "ES330": [
                ""
            ],
            "GS300": [
                ""
            ],
            "GS430": [
                ""
            ],
            "GX470": [
                ""
            ],
            "IS300": [
                ""
            ],
            "RX330": [
                ""
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "LS": [
                ""
            ],
            "Navigator": [
                "To 08/23/04"
            ],
            "Town Car": [
                "Sedan"
            ]
        },
        "Mazda": {
            "3": [
                "2.0L",
                "2.3L"
            ],
            "6": [
                ""
            ],
            "B4000": [
                "With 10\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "MPV": [
                ""
            ],
            "RX-8": [
                "With Sport Suspension"
            ],
            "Tribute": [
                "2.3L",
                "2.3L and with Drum rear brakes",
                "3.0L"
            ]
        },
        "Mercedes-Benz": {
            "C230": [
                "Coupe",
                "Sedan. With Sport Package and From VIN # A660227,F565689,R138318, or With Sport Package",
                "Sedan. With Sport Package and To VIN # A660226,F565688,R138317",
                "Sedan. Without Sport Package"
            ],
            "C240": [
                "Sedan and with RWD",
                "Sedan/Wagon and with AWD",
                "Wagon and with RWD"
            ],
            "C320": [
                "AWD",
                "RWD. With Sport Package",
                "RWD. Without Sport Package"
            ],
            "CLK320": [
                ""
            ],
            "E320": [
                "AWD. With Solid Rotor",
                "AWD. With Vented Rotor"
            ],
            "E500": [
                "AWD. Without Sport Package"
            ],
            "G55 AMG": [
                "With 67mm Hub Pilot Diameter"
            ],
            "ML350": [
                ""
            ],
            "SLK350": [
                ""
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Mariner": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Montego": [
                ""
            ],
            "Monterey": [
                ""
            ],
            "Mountaineer": [
                ""
            ],
            "Sable": [
                "",
                "Sedan"
            ]
        },
        "Mini": {
            "Cooper": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor and With 4 Lug Wheels"
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L and with Drum rear brakes",
                "Disc rear brakes"
            ],
            "Endeavor": [
                ""
            ],
            "Galant": [
                "2.4L",
                "3.8L"
            ],
            "Lancer": [
                "ES. With 14\" Factory Wheels",
                "ES. With 15\" Factory Wheels",
                "OZ Rally. With 14\" Factory Wheels",
                "OZ Rally. With 15\" Factory Wheels",
                "Ralliart"
            ],
            "Outlander": [
                ""
            ]
        },
        "Nissan": {
            "350Z": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ],
            "Altima": [
                "S/SL/SE",
                "SE-R"
            ],
            "Armada": [
                "From 03/05",
                "To 02/05"
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Quest": [
                ""
            ],
            "Sentra": [
                "1.8L"
            ],
            "TITAN": [
                "From 03/05",
                "To 02/05"
            ],
            "X-Trail": [
                ""
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "Aztek": [
                "AWD and with Disc rear brakes",
                "AWD and with Drum rear brakes",
                "FWD and with Disc rear brakes",
                "FWD and with Drum rear brakes"
            ],
            "Bonneville": [
                "SE",
                "SLE. From Chassis/VIN #5U129028",
                "SLE. To Chassis/VIN #5U129027"
            ],
            "G6": [
                ""
            ],
            "Grand Am": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Grand Prix": [
                "3.8L"
            ],
            "Montana": [
                "Base and with FWD",
                "SV6 and with AWD",
                "SV6 and with FWD"
            ],
            "Pursuit": [
                ""
            ],
            "Sunfire": [
                ""
            ],
            "Vibe": [
                "",
                "AWD",
                "FWD"
            ],
            "Wave": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Wave5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ]
        },
        "Saab": {
            "9-2X": [
                "Aero",
                "Linear"
            ],
            "9-7x": [
                ""
            ]
        },
        "Saturn": {
            "Ion": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "L300": [
                ""
            ],
            "Relay": [
                "AWD",
                "FWD"
            ],
            "Vue": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ]
        },
        "Subaru": {
            "Baja": [
                "Naturally Aspirated",
                "Turbocharged. With 292mm Diameter Front Rotor"
            ],
            "Forester": [
                ""
            ],
            "Impreza": [
                "Outback Sport/RS",
                "WRX",
                "WRX STI"
            ],
            "Legacy": [
                "GT",
                "GT Limited",
                "i/Limited. With 277mm Diameter Front Rotor",
                "i/Limited. With 293mm Diameter Front Rotor"
            ],
            "Outback": [
                "Naturally Aspirated",
                "Turbocharged. With 292mm Diameter Front Rotor"
            ]
        },
        "Suzuki": {
            "Aerio": [
                ""
            ],
            "Forenza": [
                ""
            ],
            "Grand Vitara": [
                ""
            ],
            "Reno": [
                ""
            ],
            "XL-7": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 16\" Factory Wheels",
                "With 17\" Factory Wheels"
            ],
            "Avalon": [
                ""
            ],
            "Celica": [
                "",
                "Disc rear brakes"
            ],
            "Corolla": [
                "Disc rear brakes",
                "Japan Production Identified By 1st Digit Of VIN J",
                "North American Production Identified By 1st Digit Of VIN 1, 2, 4 Or 5"
            ],
            "Echo": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Matrix": [
                "",
                "AWD",
                "Base/XR and with FWD",
                "FWD"
            ],
            "Prius": [
                ""
            ],
            "RAV4": [
                ""
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "Golf": [
                "2.0L/1.9L",
                "2.8L/1.8L"
            ],
            "Passat": [
                "AWD and with 2.8L/1.8L",
                "FWD and with 2.0L/2.8L/1.8L"
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 350mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "S40": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S60": [
                "2.4/2.5T/2.5T AWD/T5. With 285mm Diameter Front Rotor",
                "2.4/2.5T/2.5T AWD/T5. With 302mm Diameter Front Rotor"
            ],
            "S80": [
                "With 286mm Diameter Front Rotor",
                "With 305mm Diameter Front Rotor"
            ],
            "V50": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "V70": [
                "2.4/2.5T/T5. With 286mm Diameter Front Rotor",
                "2.4/2.5T/T5. With 305mm Diameter Front Rotor"
            ],
            "XC70": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2006": {
        "Acura": {
            "CSX": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RL": [
                ""
            ],
            "RSX": [
                "Base",
                "Type-S"
            ],
            "TL": [
                "Automatic transmission",
                "Manual transmission"
            ],
            "TSX": [
                ""
            ]
        },
        "Audi": {
            "TT": [
                ""
            ],
            "TT Quattro": [
                "1.8L. With 256mm Diameter Rear Rotor",
                "3.2L. With 256mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "323i": [
                "With 300mm Diameter Front Rotor"
            ],
            "325Ci": [
                ""
            ],
            "325i": [
                ""
            ],
            "325xi": [
                ""
            ],
            "330Ci": [
                ""
            ],
            "330i": [
                ""
            ],
            "330xi": [
                ""
            ],
            "525i": [
                "Automatic transmission. With 324mm Diameter Front Rotor"
            ],
            "525xi": [
                ""
            ],
            "530i": [
                ""
            ],
            "530xi": [
                ""
            ],
            "550i": [
                ""
            ],
            "650i": [
                ""
            ],
            "X3": [
                ""
            ],
            "X5": [
                "3.0i"
            ]
        },
        "Buick": {
            "Allure": [
                ""
            ],
            "LaCrosse": [
                ""
            ],
            "Lucerne": [
                "3.8L",
                "4.6L"
            ],
            "Rainier": [
                "4.2L",
                "5.3L"
            ],
            "Rendezvous": [
                "AWD",
                "FWD"
            ],
            "Terraza": [
                "AWD",
                "FWD. With Beam Rear Axle",
                "FWD. With Independent Rear Suspension"
            ]
        },
        "Cadillac": {
            "CTS": [
                "Base. With Sport Suspension and With 303mm Diameter Front Rotor",
                "Base. With Sport Suspension and With 323mm Diameter Front Rotor",
                "Base. With Standard Suspension"
            ],
            "DTS": [
                "With 5 Lug Wheels"
            ],
            "Escalade": [
                "AWD",
                "RWD"
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                "With Performance Package or Without Performance Package"
            ],
            "XLR": [
                "Naturally Aspirated. With Heavy Duty Brakes",
                "Naturally Aspirated. Without Heavy Duty Brakes",
                "Supercharged"
            ]
        },
        "Chevrolet": {
            "Avalanche 1500": [
                "4WD",
                "RWD"
            ],
            "Avalanche 2500": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Aveo": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Aveo5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Cobalt": [
                "LT/LTZ/LS. With 4 Lug Wheels",
                "SS. With 5 Lug Wheels"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "Base. With Heavy Duty Brakes",
                "Base. Without Heavy Duty Brakes"
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "With 6 Lug Wheels",
                "With 8 Lug Wheels and 86mm Overall Height",
                "With 8 Lug Wheels and 91mm Overall Height"
            ],
            "HHR": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                "LT/LS. 1st Design Thru VIN #1G12T151F26F173012",
                "LT/LS. From Chassis/VIN #1G12T151F26F173013",
                "LTZ/SS. 1st Design Thru VIN #1G12T151F26F173012",
                "LTZ/SS. From Chassis/VIN #1G12T151F26F173013",
                "Maxx LS/Maxx LT/Maxx LTZ/Maxx SS"
            ],
            "Monte Carlo": [
                "Without Police Package"
            ],
            "Optra": [
                "With 258mm Diameter Rear Rotor",
                "With 276mm Diameter Rear Rotor"
            ],
            "Silverado 1500": [
                "Crew Cab Pickup and with Disc rear brakes. With 7000 Lb GVW",
                "Crew Cab Pickup and with Drum rear brakes. With 7000 Lb GVW",
                "Disc rear brakes",
                "Disc rear brakes. With 6400 Lb GVW",
                "Disc rear brakes. With Dual Piston Caliper",
                "Disc rear brakes. With Single Piston Caliper",
                "Drum rear brakes",
                "Drum rear brakes. With 6400 Lb GVW",
                "Drum rear brakes. With Dual Piston Caliper",
                "Drum rear brakes. With Single Piston Caliper"
            ],
            "Silverado 1500 HD": [
                ""
            ],
            "Silverado 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Silverado 3500": [
                "With 12000 Lb GVW",
                "With 9900 Lb GVW"
            ],
            "SSR": [
                ""
            ],
            "Suburban 1500": [
                "4WD",
                "RWD"
            ],
            "Suburban 2500": [
                "6.0L. With Two Wheel Steering",
                "8.1L. With Two Wheel Steering"
            ],
            "Tahoe": [
                "4WD",
                "RWD"
            ],
            "Trailblazer": [
                "4.2L",
                "5.3L"
            ],
            "Trailblazer EXT": [
                ""
            ],
            "Uplander": [
                "AWD",
                "FWD"
            ]
        },
        "Chrysler": {
            "300": [
                "2.7L",
                "5.7L",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L"
            ],
            "Crossfire": [
                "Limited/Base"
            ],
            "Pacifica": [
                ""
            ],
            "PT Cruiser": [
                "Naturally Aspirated",
                "Naturally Aspirated. Without 4 Wheel ABS",
                "Turbocharged",
                "Turbocharged. Without 4 Wheel ABS"
            ],
            "Sebring": [
                "2.7L"
            ],
            "Town and Country": [
                "Disc rear brakes",
                "Drum rear brakes"
            ]
        },
        "Dodge": {
            "Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Charger": [
                "2.7L",
                "3.5L. Without Police Package",
                "5.7L/3.5L. With Police Package",
                "5.7L. Without Police Package",
                "6.1L"
            ],
            "Dakota": [
                "",
                "Dual Upper Return Spring"
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Magnum": [
                "2.7L",
                "5.7L",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L. With Performance Brakes",
                "RWD and with 3.5L. Without Performance Brakes"
            ],
            "Ram 1500": [
                "Laramie/Sport/TRX4/SLT/ST. With 5 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Stratus": [
                ""
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-150": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels and With 8 Lug Wheels and With 11000 Lb Axle and With 11-1/4\" Ring Gear"
            ],
            "Escape": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                ""
            ],
            "F-150": [
                "4WD. With 6 Lug Wheels",
                "4WD. With 7 Lug Wheels",
                "RWD. With 6 Lug Wheels",
                "RWD. With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels",
                "XL/XLT/King Ranch/Lariat and with 4WD. With Dual Rear Wheels",
                "XL/XLT/King Ranch/Lariat and with 4WD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "With ABS Tone Ring",
                "Without ABS Tone Ring"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "Five Hundred": [
                ""
            ],
            "Focus": [
                "Disc rear brakes",
                "Without ABS Tone Ring and Wheel Bearing Included"
            ],
            "Freestar": [
                ""
            ],
            "Freestyle": [
                ""
            ],
            "Fusion": [
                ""
            ],
            "Mustang": [
                "Base",
                "GT"
            ],
            "Ranger": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD. With 10\" Diameter Drum",
                "RWD. With 9\" Diameter Drum"
            ],
            "Taurus": [
                ""
            ]
        },
        "GMC": {
            "Canyon": [
                ""
            ],
            "Envoy": [
                "4.2L",
                "5.3L"
            ],
            "Envoy XL": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Sierra 1500": [
                "Crew Cab Pickup and with Disc rear brakes. With 7000 Lb GVW",
                "Crew Cab Pickup and with Drum rear brakes. With 7000 Lb GVW",
                "Disc rear brakes",
                "Disc rear brakes. With 6400 Lb GVW",
                "Disc rear brakes. With Dual Piston Caliper",
                "Disc rear brakes. With Single Piston Caliper",
                "Drum rear brakes",
                "Drum rear brakes. With 6400 Lb GVW",
                "Drum rear brakes. With Dual Piston Caliper",
                "Drum rear brakes. With Single Piston Caliper"
            ],
            "Sierra 1500 HD": [
                ""
            ],
            "Sierra 2500 HD": [
                "4.63\" Diameter Center Hole",
                "4.84\" Diameter Center Hole"
            ],
            "Sierra 3500": [
                "With 12000 Lb GVW",
                "With 9900 Lb GVW"
            ],
            "Yukon": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 1500": [
                "4WD",
                "RWD"
            ],
            "Yukon XL 2500": [
                "6.0L. With Two Wheel Steering",
                "8.1L. With Two Wheel Steering"
            ]
        },
        "Honda": {
            "Accord": [
                "2.4L and with GAS engine. Excluding Vehicles Built For Canadian Market",
                "2.4L and with GAS engine. Vehicles Built For Canadian Market",
                "2.4L. Excluding Vehicles Built For Canadian Market",
                "2.4L. Vehicles Built For Canadian Market",
                "Coupe and with 3.0L and GAS engine and Automatic transmission",
                "Coupe and with 3.0L and GAS engine and Manual transmission",
                "Hybrid and with 3.0L and FULL HYBRID EV-GAS (FHEV) engine",
                "Sedan and with 3.0L and GAS engine"
            ],
            "Civic": [
                "EX",
                "GX",
                "Hybrid",
                "LX/DX",
                "Si"
            ],
            "CR-V": [
                ""
            ],
            "Element": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                "Hatchback",
                "Hatchback. To 09/30/05",
                "Sedan",
                "Sedan. To 09/30/05"
            ],
            "Azera": [
                ""
            ],
            "Elantra": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Santa Fe": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Sonata": [
                "2.4L",
                "3.3L"
            ],
            "Tiburon": [
                "",
                "GS/SE"
            ],
            "Tucson": [
                "4WD",
                "FWD"
            ]
        },
        "INFINITI": {
            "FX35": [
                ""
            ],
            "FX45": [
                ""
            ],
            "G35": [
                "With Single Piston Caliper"
            ],
            "M35": [
                ""
            ],
            "M45": [
                ""
            ],
            "QX56": [
                "With 320mm Diameter Front Rotor"
            ]
        },
        "Isuzu": {
            "Ascender": [
                "113.0\" wheel base. With 3rd Row Seating",
                "113.0\" wheel base. Without 3rd Row Seating",
                "129.0\" wheel base. With 3rd Row Seating",
                "129.0\" wheel base. Without 3rd Row Seating"
            ],
            "i-280": [
                ""
            ],
            "i-350": [
                ""
            ]
        },
        "Jaguar": {
            "Super V8": [
                ""
            ],
            "Vanden Plas": [
                "Naturally Aspirated. From Chassis/VIN #G49701",
                "Naturally Aspirated. To Chassis/VIN #G49700"
            ],
            "X-Type": [
                ""
            ]
        },
        "Jeep": {
            "Commander": [
                ""
            ],
            "Grand Cherokee": [
                "Limited/65th Anniversary Edition/Laredo/Overland",
                "SRT8"
            ],
            "Liberty": [
                ""
            ],
            "TJ": [
                "Disc rear brakes. From 10/05 or To 10/05",
                "Drum rear brakes"
            ],
            "Wrangler": [
                "Disc rear brakes",
                "Drum rear brakes",
                "Drum rear brakes. With 9\" Diameter Drum"
            ]
        },
        "Kia": {
            "Amanti": [
                ""
            ],
            "Magentis": [
                "With 4 Lug Wheels",
                "With 5 Lug Wheels"
            ],
            "Optima": [
                "With 4 Lug Wheels",
                "With 5 Lug Wheels"
            ],
            "Rio": [
                ""
            ],
            "Rio5": [
                ""
            ],
            "Sedona": [
                "From 04/28/06",
                "To 04/27/06"
            ],
            "Sorento": [
                ""
            ],
            "Spectra": [
                ""
            ],
            "Spectra5": [
                ""
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR3": [
                "4.4L"
            ],
            "Range Rover": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "Range Rover Sport": [
                "Naturally Aspirated",
                "Supercharged"
            ]
        },
        "Lexus": {
            "ES330": [
                ""
            ],
            "GS300": [
                ""
            ],
            "GS430": [
                ""
            ],
            "GX470": [
                ""
            ],
            "IS250": [
                ""
            ],
            "IS350": [
                ""
            ],
            "RX330": [
                ""
            ],
            "RX400h": [
                ""
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "LS": [
                ""
            ],
            "Mark LT": [
                "4WD. With 6 Lug Wheels",
                "4WD. With 7 Lug Wheels",
                "RWD. With 6 Lug Wheels",
                "RWD. With 7 Lug Wheels"
            ],
            "Navigator": [
                "To 08/23/04"
            ],
            "Town Car": [
                "Sedan"
            ],
            "Zephyr": [
                ""
            ]
        },
        "Mazda": {
            "3": [
                "2.3L",
                "i/GS/GX and with 2.0L"
            ],
            "5": [
                "From 02/06",
                "To 02/06"
            ],
            "6": [
                "S/i"
            ],
            "B4000": [
                "With 10\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "MPV": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ],
            "RX-8": [
                "With Sport Suspension"
            ],
            "Tribute": [
                "2.3L",
                "2.3L and with Drum rear brakes",
                "3.0L"
            ]
        },
        "Mercedes-Benz": {
            "B200": [
                ""
            ],
            "C230": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C280": [
                ""
            ],
            "C350": [
                "AWD",
                "RWD. Without Sport Package"
            ],
            "CLK350": [
                "Without Sport Package"
            ],
            "CLS500": [
                ""
            ],
            "G55 AMG": [
                "With 67mm Hub Pilot Diameter"
            ],
            "ML350": [
                "With Solid Rear Rotors and With 330mm Diameter Front Rotor"
            ],
            "ML500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "R500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "SLK280": [
                "Without Sport Package"
            ],
            "SLK350": [
                "From 02/06",
                "To 01/06"
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Mariner": [
                "Convenience/Premier/Luxury and with Drum rear brakes",
                "Hybrid and with Disc rear brakes",
                "Premier/Luxury and with Disc rear brakes"
            ],
            "Milan": [
                ""
            ],
            "Montego": [
                ""
            ],
            "Monterey": [
                ""
            ],
            "Mountaineer": [
                ""
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L",
                "3.8L"
            ],
            "Endeavor": [
                ""
            ],
            "Galant": [
                "2.4L",
                "3.8L"
            ],
            "Lancer": [
                "ES/SE/OZ Rally. With 15\" Factory Wheels",
                "ES/SE. With 14\" Factory Wheels",
                "OZ Rally. With 14\" Factory Wheels",
                "Ralliart"
            ],
            "Outlander": [
                ""
            ],
            "Raider": [
                ""
            ]
        },
        "Nissan": {
            "350Z": [
                "With Brembo Brakes"
            ],
            "Altima": [
                "S/SL/Base/SE",
                "SE-R"
            ],
            "Armada": [
                "To 02/06"
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Quest": [
                ""
            ],
            "Sentra": [
                "1.8L"
            ],
            "TITAN": [
                ""
            ],
            "X-Trail": [
                ""
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "G6": [
                "With 276mm Diameter Front Rotor",
                "With 296mm Diameter Front Rotor"
            ],
            "Grand Prix": [
                "3.8L"
            ],
            "Montana": [
                "AWD",
                "FWD"
            ],
            "Pursuit": [
                "With Rear Disc Brakes",
                "With Rear Drum Brakes"
            ],
            "Torrent": [
                ""
            ],
            "Vibe": [
                "",
                "AWD",
                "FWD"
            ],
            "Wave": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Wave5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ]
        },
        "Saab": {
            "9-2X": [
                "2.5i",
                "Aero"
            ],
            "9-7x": [
                ""
            ]
        },
        "Saturn": {
            "Ion": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "Relay": [
                "With FE1 Suspension and With FE2 Suspension and With FE3 Suspension",
                "With FE5 Suspension and With FE4 Suspension"
            ],
            "Vue": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ]
        },
        "Subaru": {
            "B9 Tribeca": [
                ""
            ],
            "Baja": [
                "Naturally Aspirated",
                "Turbocharged. With 292mm Diameter Front Rotor"
            ],
            "Forester": [
                ""
            ],
            "Impreza": [
                "Outback Sport/2.5i",
                "WRX STI"
            ],
            "Legacy": [
                "2.5i. With 292mm Diameter Front Rotor",
                "GT",
                "GT spec.B"
            ],
            "Outback": [
                "With 292mm Diameter Front Rotor"
            ]
        },
        "Suzuki": {
            "Aerio": [
                ""
            ],
            "Forenza": [
                ""
            ],
            "Grand Vitara": [
                "",
                "Base/Premium/Luxury"
            ],
            "Reno": [
                ""
            ],
            "XL-7": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 319mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "Avalon": [
                ""
            ],
            "Corolla": [
                "Disc rear brakes",
                "Japan Production Identified By 1st Digit Of VIN J",
                "North American Production Identified By 1st Digit Of VIN 1, 2, 4 Or 5"
            ],
            "Highlander": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS engine"
            ],
            "Matrix": [
                "",
                "AWD",
                "Base/XR and with FWD",
                "FWD"
            ],
            "Prius": [
                ""
            ],
            "RAV4": [
                "2.4L. With 3rd Row Seating",
                "2.4L. Without 3rd Row Seating",
                "3.5L"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Yaris": [
                ""
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "Golf": [
                "1.8L",
                "2.0L/1.9L"
            ],
            "GTI": [
                ""
            ],
            "Jetta": [
                "With 280mm Diameter Front Rotor and 7th And 8th Digit Of VIN Is \"9M\" Or \"1J\"",
                "With 288mm Diameter Front Rotor and 7th And 8th Digit Of VIN Is \"9M\" Or \"1J\""
            ],
            "Passat": [
                "AWD and with Naturally Aspirated",
                "FWD and with Naturally Aspirated",
                "FWD and with Turbocharged"
            ],
            "Rabbit": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C70": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S40": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S60": [
                "2.5T/T5. With 285mm Diameter Front Rotor",
                "2.5T/T5. With 302mm Diameter Front Rotor"
            ],
            "S80": [
                "With 285mm Diameter Front Rotor",
                "With 305mm Diameter Front Rotor"
            ],
            "V50": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "V70": [
                "2.4/2.5T. With 286mm Diameter Front Rotor",
                "2.4/2.5T. With 305mm Diameter Front Rotor"
            ],
            "XC70": [
                "With 286mm Diameter Front Rotor",
                "With 305mm Diameter Front Rotor"
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2007": {
        "Acura": {
            "CSX": [
                "Premium/Touring",
                "Type-S"
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "RL": [
                ""
            ],
            "TL": [
                "Base",
                "Type-S"
            ],
            "TSX": [
                ""
            ]
        },
        "Audi": {
            "A4 Quattro": [
                ""
            ],
            "Q7": [
                ""
            ]
        },
        "BMW": {
            "323i": [
                "With 300mm Diameter Front Rotor"
            ],
            "328i": [
                "Sedan/Coupe",
                "Wagon"
            ],
            "328xi": [
                "From 09/07",
                "To 09/07"
            ],
            "335i": [
                ""
            ],
            "335xi": [
                ""
            ],
            "525i": [
                "Automatic transmission. With 324mm Diameter Front Rotor and From 01/07"
            ],
            "525xi": [
                ""
            ],
            "530i": [
                ""
            ],
            "530xi": [
                ""
            ],
            "550i": [
                ""
            ],
            "650i": [
                ""
            ],
            "X3": [
                ""
            ],
            "X5": [
                "3.0si and with 3.0L",
                "4.8i and with 4.8L"
            ]
        },
        "Buick": {
            "Allure": [
                ""
            ],
            "LaCrosse": [
                ""
            ],
            "Lucerne": [
                "3.8L",
                "4.6L"
            ],
            "Rainier": [
                "4.2L",
                "5.3L"
            ],
            "Rendezvous": [
                ""
            ],
            "Terraza": [
                ""
            ]
        },
        "Cadillac": {
            "CTS": [
                "Base. With Sport Suspension and With 303mm Diameter Front Rotor",
                "Base. With Sport Suspension and With 323mm Diameter Front Rotor",
                "Base. With Standard Suspension"
            ],
            "DTS": [
                "With 5 Lug Wheels"
            ],
            "Escalade": [
                ""
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                "With Performance Package or Without Performance Package"
            ],
            "XLR": [
                "Naturally Aspirated. With Heavy Duty Brakes",
                "Naturally Aspirated. Without Heavy Duty Brakes",
                "Supercharged"
            ]
        },
        "Chevrolet": {
            "Avalanche": [
                ""
            ],
            "Aveo": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Aveo5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Cobalt": [
                "LT/LTZ/LS. With 4 Lug Wheels",
                "LT/LTZ/LS. With 5 Lug Wheels",
                "SS. With 5 Lug Wheels"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "Base. With Heavy Duty Brakes",
                "Base. Without Heavy Duty Brakes"
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "HHR": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Monte Carlo": [
                "Without Police Package"
            ],
            "Optra": [
                ""
            ],
            "Silverado 1500 Classic": [
                "Crew Cab Pickup and with Drum rear brakes. With 7000 Lb GVW",
                "Disc rear brakes",
                "Drum rear brakes",
                "Extended Cab Pickup and with Disc rear brakes and 4-Wheel ABS. With 7000 Lb GVW and With Vacuum Brake System",
                "Extended Cab Pickup and with Drum rear brakes and 4-Wheel ABS. With 7000 Lb GVW and With Vacuum Brake System",
                "Hybrid and with Disc rear brakes. With 6400 Lb GVW",
                "LT/WT/SS/LS and with Drum rear brakes. With 6400 Lb GVW"
            ],
            "Silverado 1500": [
                "Crew Cab Pickup and with Disc rear brakes. With 7000 Lb GVW",
                "Crew Cab Pickup and with Drum rear brakes. With 7000 Lb GVW",
                "Disc rear brakes",
                "Drum rear brakes",
                "LT/LTZ and with Disc rear brakes. With 6400 Lb GVW",
                "LT/WT/LTZ and with Drum rear brakes. With 6400 Lb GVW"
            ],
            "Silverado 1500 HD Classic": [
                ""
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 2500 HD Classic": [
                ""
            ],
            "Silverado 3500 Classic": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Suburban 1500": [
                ""
            ],
            "Suburban 2500": [
                ""
            ],
            "Tahoe": [
                ""
            ],
            "Trailblazer": [
                "4.2L",
                "5.3L"
            ],
            "Uplander": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "Base",
                "C",
                "C SRT8",
                "Limited/Touring and with AWD",
                "Limited/Touring and with RWD"
            ],
            "Aspen": [
                ""
            ],
            "Crossfire": [
                ""
            ],
            "Pacifica": [
                ""
            ],
            "PT Cruiser": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Sebring": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Town and Country": [
                "Disc rear brakes",
                "Drum rear brakes"
            ]
        },
        "Dodge": {
            "Caliber": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Caravan": [
                "Disc rear brakes",
                "Drum rear brakes"
            ],
            "Charger": [
                "2.7L",
                "5.7L. With Police Package",
                "5.7L. Without Police Package",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L. With Police Package",
                "RWD and with 3.5L. Without Police Package"
            ],
            "Dakota": [
                ""
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                ""
            ],
            "Magnum": [
                "2.7L",
                "5.7L",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L. With Performance Brakes",
                "RWD and with 3.5L. Without Heavy Duty Brakes and Without Performance Brakes",
                "RWD and with 3.5L. Without Performance Brakes and Without Heavy Duty Brakes"
            ],
            "Nitro": [
                ""
            ],
            "Ram 1500": [
                "Extended Crew Cab Pickup",
                "Standard Cab Pickup/Crew Cab Pickup"
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-150 Econoline": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Econoline": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "Edge": [
                "AWD",
                "FWD"
            ],
            "Escape": [
                "Disc rear brakes",
                "Disc rear brakes. From 01/08/07",
                "Disc rear brakes. To 01/07/07",
                "Drum rear brakes",
                "Drum rear brakes. From 01/08/07",
                "Drum rear brakes. To 01/07/07"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                ""
            ],
            "Explorer Sport Trac": [
                ""
            ],
            "F-150": [
                "4WD. With 6 Lug Wheels",
                "4WD. With 7 Lug Wheels",
                "RWD. With 6 Lug Wheels",
                "RWD. With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "With ABS Tone Ring",
                "Without ABS Tone Ring"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "Five Hundred": [
                ""
            ],
            "Focus": [
                "Disc rear brakes",
                "Without ABS Tone Ring and Wheel Bearing Included"
            ],
            "Freestar": [
                ""
            ],
            "Freestyle": [
                ""
            ],
            "Fusion": [
                ""
            ],
            "Mustang": [
                "Base",
                "GT",
                "Shelby GT500"
            ],
            "Ranger": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD. With 10\" Diameter Drum",
                "RWD. With 9\" Diameter Drum"
            ],
            "Taurus": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Envoy": [
                "Denali",
                "SLT/SLE"
            ],
            "Savana 1500": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Sierra 1500 Classic": [
                "Denali and with Disc rear brakes",
                "Hybrid and with 4 doors and Extended Cab Pickup and Disc rear brakes. With 6400 Lb Or 7000 Lb GVW and With Vacuum Brake System",
                "Hybrid and with Disc rear brakes",
                "SL/SLT/WT/SLE and with 4 doors and Extended Cab Pickup and Drum rear brakes. With 6400 Lb Or 7000 Lb GVW and With Vacuum Brake System",
                "SL/WT/SLE and with 2 doors and Standard Cab Pickup and Drum rear brakes. With 6400 Lb Or 7000 Lb GVW and With Vacuum Brake System"
            ],
            "Sierra 1500": [
                "Crew Cab Pickup and with Disc rear brakes. With 7000 Lb GVW",
                "Crew Cab Pickup and with Drum rear brakes. With 7000 Lb GVW",
                "Disc rear brakes",
                "Drum rear brakes",
                "SLT/SLE/Denali and with Disc rear brakes. With 6400 Lb GVW",
                "SLT/WT/SLE and with Drum rear brakes. With 6400 Lb GVW"
            ],
            "Sierra 1500 HD Classic": [
                ""
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 2500 HD Classic": [
                ""
            ],
            "Sierra 3500 Classic": [
                "With 12000 Lb GVW",
                "With 9900 Lb GVW"
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Yukon": [
                ""
            ],
            "Yukon XL 1500": [
                ""
            ],
            "Yukon XL 2500": [
                ""
            ]
        },
        "Honda": {
            "Accord": [
                "2.4L and with GAS engine. Excluding Vehicles Built For Canadian Market",
                "2.4L and with GAS engine. Vehicles Built For Canadian Market",
                "2.4L. Excluding Vehicles Built For Canadian Market",
                "2.4L. Vehicles Built For Canadian Market",
                "Coupe and with 3.0L and GAS engine and Automatic transmission",
                "Coupe and with 3.0L and GAS engine and Manual transmission",
                "Hybrid and with 3.0L and FULL HYBRID EV-GAS (FHEV) engine",
                "Sedan and with 3.0L and GAS engine"
            ],
            "Civic": [
                "EX",
                "GX",
                "Hybrid",
                "LX/DX",
                "Si"
            ],
            "CR-V": [
                ""
            ],
            "Element": [
                ""
            ],
            "Fit": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                ""
            ],
            "Elantra": [
                ""
            ],
            "Entourage": [
                "From 04/28/06",
                "To 04/27/06"
            ],
            "Santa Fe": [
                ""
            ],
            "Sonata": [
                "2.4L",
                "3.3L"
            ],
            "Tiburon": [
                "",
                "2.0L"
            ],
            "Tucson": [
                "4WD",
                "FWD"
            ],
            "Veracruz": [
                ""
            ]
        },
        "INFINITI": {
            "FX35": [
                ""
            ],
            "FX45": [
                ""
            ],
            "G35": [
                "VQ35HR engine designation. With Single Piston Caliper"
            ],
            "M35": [
                ""
            ],
            "M45": [
                ""
            ],
            "QX56": [
                "From 04/07",
                "With 320mm Diameter Front Rotor and To 03/07"
            ]
        },
        "Isuzu": {
            "Ascender": [
                ""
            ],
            "i-290": [
                ""
            ],
            "i-370": [
                ""
            ]
        },
        "Jaguar": {
            "S-Type": [
                "Base and with Naturally Aspirated"
            ],
            "Super V8": [
                ""
            ],
            "Vanden Plas": [
                "Naturally Aspirated"
            ],
            "X-Type": [
                ""
            ],
            "XJ8": [
                ""
            ],
            "XK": [
                ""
            ],
            "XKR": [
                ""
            ]
        },
        "Jeep": {
            "Commander": [
                ""
            ],
            "Compass": [
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Grand Cherokee": [
                "Limited/Laredo/Overland",
                "SRT8"
            ],
            "Liberty": [
                ""
            ],
            "Patriot": [
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Wrangler": [
                ""
            ]
        },
        "Kia": {
            "Amanti": [
                ""
            ],
            "Magentis": [
                ""
            ],
            "Optima": [
                ""
            ],
            "Rio": [
                ""
            ],
            "Rio5": [
                ""
            ],
            "Rondo": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Spectra": [
                "",
                "Drum rear brakes"
            ],
            "Spectra5": [
                ""
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR3": [
                "4.4L"
            ],
            "Range Rover": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "Range Rover Sport": [
                "Naturally Aspirated",
                "Supercharged"
            ]
        },
        "Lexus": {
            "ES350": [
                ""
            ],
            "GS350": [
                "AWD",
                "RWD"
            ],
            "GS430": [
                ""
            ],
            "GS450h": [
                ""
            ],
            "GX470": [
                ""
            ],
            "IS250": [
                ""
            ],
            "IS350": [
                ""
            ],
            "RX350": [
                ""
            ],
            "RX400h": [
                ""
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "Mark LT": [
                "4WD. With 6 Lug Wheels",
                "4WD. With 7 Lug Wheels",
                "RWD. With 6 Lug Wheels",
                "RWD. With 7 Lug Wheels"
            ],
            "MKX": [
                "AWD",
                "FWD"
            ],
            "MKZ": [
                ""
            ],
            "Navigator": [
                ""
            ],
            "Town Car": [
                "Sedan"
            ]
        },
        "Mazda": {
            "3": [
                "2.0L",
                "2.3L and with Naturally Aspirated",
                "Mazdaspeed and with 2.3L and Turbocharged"
            ],
            "5": [
                ""
            ],
            "6": [
                "S/i"
            ],
            "B4000": [
                "With 10\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "CX-7": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ],
            "RX-8": [
                "With Sport Suspension"
            ]
        },
        "Mercedes-Benz": {
            "B200": [
                ""
            ],
            "C230": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C280": [
                ""
            ],
            "C350": [
                "AWD",
                "RWD. Without Sport Package"
            ],
            "CL600": [
                ""
            ],
            "CLK350": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "CLS550": [
                ""
            ],
            "E550": [
                "AWD",
                "RWD. Without Sport Package"
            ],
            "G55 AMG": [
                "With 67mm Hub Pilot Diameter"
            ],
            "GL320": [
                ""
            ],
            "GL450": [
                ""
            ],
            "ML320": [
                "With 330mm Diameter Front Rotor",
                "With 350mm Diameter Front Rotor"
            ],
            "ML350": [
                "With Solid Rear Rotors and With 330mm Diameter Front Rotor"
            ],
            "ML500": [
                ""
            ],
            "R320": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "R350": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "R500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "S550": [
                "AWD. With 350mm Diameter Front Rotor"
            ],
            "S600": [
                "",
                "Armored Vehicle"
            ],
            "SLK280": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "SLK350": [
                ""
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Mariner": [
                "Disc rear brakes",
                "Disc rear brakes. From 01/08/07",
                "Disc rear brakes. To 01/07/07",
                "Drum rear brakes",
                "Drum rear brakes. From 01/08/07",
                "Drum rear brakes. To 01/07/07"
            ],
            "Milan": [
                ""
            ],
            "Montego": [
                ""
            ],
            "Monterey": [
                ""
            ],
            "Mountaineer": [
                ""
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L",
                "3.8L"
            ],
            "Endeavor": [
                ""
            ],
            "Galant": [
                "ES/SE/DE",
                "GTS",
                "Ralliart"
            ],
            "Lancer": [
                "ES/LS. With 14\" Factory Wheels",
                "ES/LS. With 15\" Factory Wheels",
                "LS Diamond. With 14\" Factory Wheels",
                "LS Diamond. With 15\" Factory Wheels",
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ],
            "Outlander": [
                ""
            ],
            "Raider": [
                ""
            ]
        },
        "Nissan": {
            "350Z": [
                "With Brembo Brakes"
            ],
            "Altima": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Quest": [
                ""
            ],
            "Sentra": [
                "S/SL/Base",
                "SE-R",
                "SE-R Spec V"
            ],
            "TITAN": [
                "From 04/07",
                "To 03/07"
            ],
            "Versa": [
                ""
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "G5": [
                "Disc rear brakes. With 4 Lug Wheels and With Rear Drum Brakes",
                "Disc rear brakes. With 5 Lug Wheels and With Rear Drum Brakes",
                "Disc rear brakes. With Rear Disc Brakes",
                "Disc rear brakes. With Rear Drum Brakes and With 4 Lug Wheels",
                "Disc rear brakes. With Rear Drum Brakes and With 5 Lug Wheels",
                "Drum rear brakes. With 4 Lug Wheels and With Rear Drum Brakes",
                "Drum rear brakes. With 5 Lug Wheels and With Rear Drum Brakes",
                "Drum rear brakes. With Rear Disc Brakes",
                "Drum rear brakes. With Rear Drum Brakes and With 4 Lug Wheels",
                "Drum rear brakes. With Rear Drum Brakes and With 5 Lug Wheels"
            ],
            "G6": [
                "With 276mm Diameter Front Rotor",
                "With 296mm Diameter Front Rotor"
            ],
            "Grand Prix": [
                "3.8L"
            ],
            "Montana": [
                ""
            ],
            "Torrent": [
                ""
            ],
            "Vibe": [
                "",
                "Base and with FWD",
                "FWD"
            ],
            "Wave": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Wave5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ]
        },
        "Saab": {
            "9-7x": [
                ""
            ]
        },
        "Saturn": {
            "Aura": [
                ""
            ],
            "Ion": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "Outlook": [
                ""
            ],
            "Relay": [
                ""
            ],
            "Vue": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ]
        },
        "Subaru": {
            "B9 Tribeca": [
                ""
            ],
            "Forester": [
                ""
            ],
            "Impreza": [
                "Outback Sport/2.5i",
                "WRX STI/WRX STI Limited"
            ],
            "Legacy": [
                "Naturally Aspirated. With 292mm Diameter Front Rotor",
                "Turbocharged"
            ],
            "Outback": [
                "With 292mm Diameter Front Rotor"
            ]
        },
        "Suzuki": {
            "Aerio": [
                ""
            ],
            "Forenza": [
                ""
            ],
            "Grand Vitara": [
                "",
                "XSport/Base/Luxury"
            ],
            "Reno": [
                ""
            ],
            "SX4": [
                "",
                "Drum rear brakes"
            ],
            "XL-7": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 319mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                "Japan Production Identified By 1st Digit Of VIN J",
                "North American Production Identified By 1st Digit Of VIN 1, 2, 4 Or 5"
            ],
            "FJ Cruiser": [
                ""
            ],
            "Highlander": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS engine"
            ],
            "Matrix": [
                "",
                "Base/XR"
            ],
            "Prius": [
                ""
            ],
            "RAV4": [
                "2.4L. With 3rd Row Seating",
                "2.4L. Without 3rd Row Seating",
                "3.5L"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Yaris": [
                ""
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "Eos": [
                ""
            ],
            "Golf City": [
                ""
            ],
            "GTI": [
                ""
            ],
            "Jetta City": [
                ""
            ],
            "Passat": [
                "AWD and with Naturally Aspirated",
                "FWD and with Naturally Aspirated",
                "FWD and with Turbocharged"
            ],
            "Rabbit": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C30": [
                ""
            ],
            "C70": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S40": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "V50": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "V70": [
                "2.4/2.5T. With 286mm Diameter Front Rotor",
                "2.4/2.5T. With 305mm Diameter Front Rotor"
            ],
            "XC70": [
                "With 286mm Diameter Front Rotor",
                "With 305mm Diameter Front Rotor"
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2008": {
        "Acura": {
            "CSX": [
                "Technology/Touring",
                "Type-S"
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "RL": [
                ""
            ],
            "TL": [
                "Base",
                "Type-S"
            ],
            "TSX": [
                ""
            ]
        },
        "Audi": {
            "A3 Quattro": [
                "With 260mm Diameter Rear Rotor",
                "With 282mm Diameter Rear Rotor",
                "With 286mm Diameter Rear Rotor"
            ],
            "A3": [
                "With 260mm Diameter Rear Rotor",
                "With 286mm Diameter Rear Rotor and To Chassis/VIN #8P8057778"
            ],
            "A4 Quattro": [
                "With 320mm Diameter Front Rotor"
            ],
            "A5 Quattro": [
                ""
            ],
            "Q7": [
                ""
            ],
            "S5": [
                ""
            ]
        },
        "BMW": {
            "128i": [
                ""
            ],
            "135i": [
                ""
            ],
            "323i": [
                ""
            ],
            "328i": [
                "Convertible/Wagon",
                "Sedan/Coupe"
            ],
            "328xi": [
                "From 09/07",
                "Sedan/Wagon/Coupe",
                "To 08/07"
            ],
            "335i": [
                ""
            ],
            "335xi": [
                ""
            ],
            "528i": [
                ""
            ],
            "528xi": [
                ""
            ],
            "535i": [
                ""
            ],
            "535xi": [
                ""
            ],
            "550i": [
                ""
            ],
            "650i": [
                ""
            ],
            "X3": [
                ""
            ],
            "X5": [
                "3.0si and with 3.0L",
                "4.8i and with 4.8L"
            ],
            "X6": [
                "xDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Allure": [
                "3.8L/3.6L",
                "5.3L"
            ],
            "Enclave": [
                ""
            ],
            "LaCrosse": [
                "3.8L/3.6L",
                "5.3L"
            ],
            "Lucerne": [
                "3.8L",
                "4.6L"
            ]
        },
        "Cadillac": {
            "CTS": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "DTS": [
                "With 5 Lug Wheels"
            ],
            "Escalade": [
                ""
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                "With Performance Package or Without Performance Package"
            ],
            "XLR": [
                "Naturally Aspirated. With Heavy Duty Brakes",
                "Naturally Aspirated. Without Heavy Duty Brakes",
                "Supercharged"
            ]
        },
        "Chevrolet": {
            "Avalanche": [
                ""
            ],
            "Aveo": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Aveo5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Cobalt": [
                "Sport. With Rear Disc Brakes",
                "SS"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "Base. With Heavy Duty Brakes",
                "Base. Without Heavy Duty Brakes"
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "HHR": [
                "LT Panel/LS Panel/LT/LS",
                "SS. With Single Piston Caliper"
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                "With 276mm Diameter Front Rotor",
                "With 296mm Diameter Front Rotor"
            ],
            "Silverado 1500": [
                "",
                "Except Vehicles Using Hold Down Pins",
                "With 6400 Lb GVW and Except Vehicles Using Hold Down Pins",
                "With 7000 Lb GVW and Except Vehicles Using Hold Down Pins",
                "With Vehicles Using Hold Down Pins"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Suburban 1500": [
                ""
            ],
            "Suburban 2500": [
                ""
            ],
            "Tahoe": [
                ""
            ],
            "Trailblazer": [
                "4.2L",
                "5.3L"
            ],
            "Uplander": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "2.7L",
                "5.7L",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L"
            ],
            "Aspen": [
                ""
            ],
            "Crossfire": [
                ""
            ],
            "Pacifica": [
                ""
            ],
            "PT Cruiser": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Sebring": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Town and Country": [
                ""
            ]
        },
        "Dodge": {
            "Avenger": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Caliber": [
                "R/T/SXT. With 276mm Diameter Front Rotor",
                "R/T/SXT. With 294mm Diameter Front Rotor",
                "R/T/SXT. With 340mm Diameter Front Rotor",
                "SRT-4. With 276mm Diameter Front Rotor",
                "SRT-4. With 294mm Diameter Front Rotor",
                "SRT-4. With 340mm Diameter Front Rotor",
                "SXT/SE. With 276mm Diameter Front Rotor",
                "SXT/SE. With 294mm Diameter Front Rotor",
                "SXT/SE. With 340mm Diameter Front Rotor"
            ],
            "Challenger": [
                ""
            ],
            "Charger": [
                "2.7L",
                "5.7L. With Police Package",
                "5.7L. Without Police Package",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L. With Police Package",
                "RWD and with 3.5L. Without Police Package"
            ],
            "Dakota": [
                ""
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                ""
            ],
            "Magnum": [
                "2.7L",
                "5.7L",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L. With Performance Brakes",
                "RWD and with 3.5L. Without Heavy Duty Brakes and Without Performance Brakes",
                "RWD and with 3.5L. Without Performance Brakes and Without Heavy Duty Brakes"
            ],
            "Nitro": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ],
            "Ram 1500": [
                "Extended Crew Cab Pickup",
                "Standard Cab Pickup/Crew Cab Pickup"
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Ram 4500": [
                ""
            ],
            "Ram 5500": [
                ""
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-150": [
                ""
            ],
            "E-150 Econoline": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Econoline": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Edge": [
                "AWD",
                "FWD"
            ],
            "Escape": [
                "Limited/XLS/XLT/Hybrid"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                ""
            ],
            "Explorer Sport Trac": [
                ""
            ],
            "F-150": [
                "4WD. With 6 Lug Wheels",
                "4WD. With 7 Lug Wheels",
                "RWD. With 6 Lug Wheels",
                "RWD. With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "With 16000-22000 Lb GVW"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "Focus": [
                "Without ABS Tone Ring and Wheel Bearing Included"
            ],
            "Fusion": [
                ""
            ],
            "Mustang": [
                "Base",
                "Bullitt/GT",
                "Shelby GT500/Shelby GT500KR"
            ],
            "Ranger": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD. With 10\" Diameter Drum",
                "RWD. With 9\" Diameter Drum"
            ],
            "Taurus": [
                ""
            ],
            "Taurus X": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Envoy": [
                "Denali",
                "SLT/SLE"
            ],
            "Savana 1500": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Sierra 1500": [
                "",
                "Except Vehicles Using Hold Down Pins",
                "With 6400 Lb GVW and Except Vehicles Using Hold Down Pins",
                "With 7000 Lb GVW and Except Vehicles Using Hold Down Pins",
                "With Vehicles Using Hold Down Pins"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Yukon": [
                ""
            ],
            "Yukon XL 1500": [
                ""
            ],
            "Yukon XL 2500": [
                ""
            ]
        },
        "Honda": {
            "Accord": [
                "EX/EX-L",
                "LX"
            ],
            "Civic": [
                "Hybrid",
                "LX/DX-G/DX",
                "LX/EX",
                "Si"
            ],
            "CR-V": [
                ""
            ],
            "Element": [
                ""
            ],
            "Fit": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                ""
            ],
            "Elantra": [
                ""
            ],
            "Entourage": [
                ""
            ],
            "Santa Fe": [
                ""
            ],
            "Sonata": [
                "2.4L. From 01/22/08",
                "2.4L. To 01/21/08",
                "3.3L. From 03/08",
                "3.3L. To 02/08"
            ],
            "Tiburon": [
                "2.0L/2.7L"
            ],
            "Tucson": [
                "4WD",
                "FWD"
            ],
            "Veracruz": [
                ""
            ]
        },
        "INFINITI": {
            "EX35": [
                ""
            ],
            "FX35": [
                ""
            ],
            "FX45": [
                ""
            ],
            "G35": [
                "With Single Piston Caliper"
            ],
            "M35": [
                ""
            ],
            "M45": [
                ""
            ],
            "QX56": [
                ""
            ]
        },
        "Isuzu": {
            "Ascender": [
                ""
            ],
            "i-290": [
                ""
            ],
            "i-370": [
                ""
            ]
        },
        "Jaguar": {
            "S-Type": [
                "Base and with Naturally Aspirated"
            ],
            "Super V8": [
                ""
            ],
            "Vanden Plas": [
                "Naturally Aspirated"
            ],
            "X-Type": [
                ""
            ],
            "XJ8": [
                ""
            ],
            "XK": [
                ""
            ],
            "XKR": [
                "Base. Without Alcon Brakes"
            ]
        },
        "Jeep": {
            "Commander": [
                ""
            ],
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Grand Cherokee": [
                "Limited/Laredo/Overland",
                "SRT8"
            ],
            "Liberty": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Wrangler": [
                ""
            ]
        },
        "Kia": {
            "Amanti": [
                ""
            ],
            "Magentis": [
                ""
            ],
            "Optima": [
                ""
            ],
            "Rio": [
                ""
            ],
            "Rio5": [
                ""
            ],
            "Rondo": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Spectra": [
                "",
                "Drum rear brakes"
            ],
            "Spectra5": [
                "",
                "Drum rear brakes"
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR2": [
                ""
            ],
            "LR3": [
                "4.4L"
            ],
            "Range Rover": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "Range Rover Sport": [
                "Naturally Aspirated"
            ]
        },
        "Lexus": {
            "ES350": [
                ""
            ],
            "GS350": [
                "AWD",
                "RWD"
            ],
            "GS450h": [
                ""
            ],
            "GS460": [
                ""
            ],
            "GX470": [
                ""
            ],
            "IS250": [
                ""
            ],
            "IS350": [
                ""
            ],
            "LS460": [
                "With Sport Package and With 356mm Diameter Front Rotor"
            ],
            "LS600h": [
                ""
            ],
            "LX570": [
                ""
            ],
            "RX350": [
                ""
            ],
            "RX400h": [
                ""
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "Mark LT": [
                "4WD. With 6 Lug Wheels",
                "4WD. With 7 Lug Wheels",
                "RWD. With 6 Lug Wheels",
                "RWD. With 7 Lug Wheels"
            ],
            "MKX": [
                "AWD",
                "FWD"
            ],
            "MKZ": [
                ""
            ],
            "Navigator": [
                ""
            ],
            "Town Car": [
                "Sedan"
            ]
        },
        "Mazda": {
            "3": [
                "2.0L",
                "2.3L and with Naturally Aspirated",
                "Mazdaspeed and with 2.3L and Turbocharged"
            ],
            "5": [
                ""
            ],
            "6": [
                ""
            ],
            "B4000": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum"
            ],
            "CX-7": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ],
            "RX-8": [
                "With Sport Suspension"
            ],
            "Tribute": [
                "",
                "With 10\" Diameter Drum",
                "With 9\" Diameter Drum"
            ]
        },
        "Mercedes-Benz": {
            "B200": [
                ""
            ],
            "C230": [
                ""
            ],
            "C350": [
                "Sport"
            ],
            "CL600": [
                ""
            ],
            "CLK350": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "CLS550": [
                ""
            ],
            "E300": [
                ""
            ],
            "E550": [
                "RWD. Without Sport Package"
            ],
            "G55 AMG": [
                "With 67mm Hub Pilot Diameter"
            ],
            "GL320": [
                ""
            ],
            "GL450": [
                ""
            ],
            "GL550": [
                ""
            ],
            "ML320": [
                "With 330mm Diameter Front Rotor",
                "With 350mm Diameter Front Rotor"
            ],
            "ML350": [
                "With Solid Rear Rotors and With 330mm Diameter Front Rotor",
                "With Vented Rear Rotors and With 350mm Diameter Front Rotor"
            ],
            "ML550": [
                ""
            ],
            "R320": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "R350": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "S450": [
                "Without Sport Package"
            ],
            "S550": [
                "AWD. With 350mm Diameter Front Rotor"
            ],
            "S600": [
                "",
                "Armored Vehicle"
            ],
            "SLK280": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "SLK350": [
                ""
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Mariner": [
                "Base/Premier/Hybrid"
            ],
            "Milan": [
                ""
            ],
            "Mountaineer": [
                ""
            ],
            "Sable": [
                ""
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L",
                "3.8L"
            ],
            "Endeavor": [
                ""
            ],
            "Galant": [
                "ES/DE",
                "Ralliart"
            ],
            "Lancer": [
                "DE and with Drum rear brakes",
                "ES/DE",
                "Evolution MR/Evolution GSR",
                "GTS"
            ],
            "Outlander": [
                "2.4L",
                "3.0L"
            ],
            "Raider": [
                ""
            ]
        },
        "Nissan": {
            "350Z": [
                "With Brembo Brakes"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Maxima": [
                ""
            ],
            "Pathfinder": [
                "4.0L"
            ],
            "Quest": [
                ""
            ],
            "Rogue": [
                ""
            ],
            "Sentra": [
                "S/SL/Base",
                "SE-R",
                "SE-R Spec V"
            ],
            "TITAN": [
                ""
            ],
            "Versa": [
                "4-Wheel ABS",
                "Non-ABS"
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "G5": [
                "Disc rear brakes. With 4 Lug Wheels and With Rear Drum Brakes",
                "Disc rear brakes. With 5 Lug Wheels and With Rear Drum Brakes",
                "Disc rear brakes. With Rear Disc Brakes",
                "Disc rear brakes. With Rear Drum Brakes and With 4 Lug Wheels",
                "Disc rear brakes. With Rear Drum Brakes and With 5 Lug Wheels",
                "Drum rear brakes. With 4 Lug Wheels and With Rear Drum Brakes",
                "Drum rear brakes. With 5 Lug Wheels and With Rear Drum Brakes",
                "Drum rear brakes. With Rear Disc Brakes",
                "Drum rear brakes. With Rear Drum Brakes and With 4 Lug Wheels",
                "Drum rear brakes. With Rear Drum Brakes and With 5 Lug Wheels"
            ],
            "G6": [
                ""
            ],
            "G8": [
                "Base"
            ],
            "Grand Prix": [
                "3.8L"
            ],
            "Montana": [
                ""
            ],
            "Torrent": [
                ""
            ],
            "Vibe": [
                "",
                "FWD"
            ],
            "Wave": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ]
        },
        "Saab": {
            "9-7x": [
                "5.3L/4.2L"
            ]
        },
        "Saturn": {
            "Astra": [
                ""
            ],
            "Aura": [
                ""
            ],
            "Outlook": [
                ""
            ],
            "Vue": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ],
            "xB": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                ""
            ],
            "Impreza": [
                "Sport/Outback Sport/2.5i/2.0R",
                "WRX",
                "WRX STI"
            ],
            "Legacy": [
                "2.5L and with Naturally Aspirated. With 292mm Diameter Front Rotor",
                "2.5L and with Turbocharged",
                "3.0L. With 18\" Factory Wheels"
            ],
            "Outback": [
                "With 292mm Diameter Front Rotor"
            ],
            "Tribeca": [
                ""
            ]
        },
        "Suzuki": {
            "Forenza": [
                ""
            ],
            "Grand Vitara": [
                "",
                "XSport/Base/Luxury"
            ],
            "Reno": [
                ""
            ],
            "SX4": [
                "",
                "Drum rear brakes"
            ],
            "XL-7": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 319mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                "Japan Production Identified By 1st Digit Of VIN J",
                "North American Production Identified By 1st Digit Of VIN 1, 2, 4 Or 5"
            ],
            "FJ Cruiser": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                ""
            ],
            "Matrix": [
                ""
            ],
            "Prius": [
                ""
            ],
            "RAV4": [
                "2.4L. With 3rd Row Seating",
                "2.4L. Without 3rd Row Seating",
                "3.5L"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Solara": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Yaris": [
                ""
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "Eos": [
                ""
            ],
            "Golf City": [
                ""
            ],
            "GTI": [
                ""
            ],
            "Jetta City": [
                ""
            ],
            "Passat": [
                "2.0L",
                "3.6L"
            ],
            "R32": [
                "With 312mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Rabbit": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor and With 4 Piston Caliper",
                "With 350mm Diameter Front Rotor and With 4 Piston Caliper",
                "With 4 Piston Caliper and With 330mm Diameter Front Rotor",
                "With 4 Piston Caliper and With 350mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C30": [
                ""
            ],
            "C70": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S40": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S60": [
                "2.5T. With 286mm Diameter Front Rotor",
                "2.5T. With 305mm Diameter Front Rotor",
                "2.5T. With 316mm Diameter Front Rotor",
                "T5. With 286mm Diameter Front Rotor",
                "T5. With 305mm Diameter Front Rotor",
                "T5. With 316mm Diameter Front Rotor"
            ],
            "V50": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "V70": [
                "With 300mm Diameter Front Rotor",
                "With 316mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2009": {
        "Acura": {
            "CSX": [
                "Technology/Touring",
                "Type-S"
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "RL": [
                ""
            ],
            "TL": [
                ""
            ],
            "TSX": [
                ""
            ]
        },
        "Audi": {
            "A4": [
                "Convertible",
                "Sedan"
            ],
            "A4 Quattro": [
                "Convertible. With 288mm Diameter Rear Rotor",
                "Convertible. With 300mm Diameter Rear Rotor",
                "Sedan/Wagon. With 288mm Diameter Rear Rotor",
                "Sedan/Wagon. With 300mm Diameter Rear Rotor"
            ],
            "A5 Quattro": [
                ""
            ],
            "Q5": [
                "With 320mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Q7": [
                ""
            ],
            "S5": [
                ""
            ],
            "TTS Quattro": [
                ""
            ]
        },
        "BMW": {
            "128i": [
                ""
            ],
            "135i": [
                ""
            ],
            "323i": [
                ""
            ],
            "328i": [
                "Convertible/Wagon",
                "Sedan/Coupe"
            ],
            "328i xDrive": [
                "",
                "With 312mm Diameter Front Rotor"
            ],
            "335d": [
                ""
            ],
            "335i": [
                ""
            ],
            "335i xDrive": [
                ""
            ],
            "528i": [
                ""
            ],
            "528i xDrive": [
                ""
            ],
            "535i": [
                ""
            ],
            "535i xDrive": [
                ""
            ],
            "550i": [
                ""
            ],
            "650i": [
                ""
            ],
            "750i": [
                ""
            ],
            "X3": [
                ""
            ],
            "X5": [
                "xDrive30i",
                "xDrive35d",
                "xDrive48i"
            ],
            "X6": [
                "xDrive35i. From 10/08",
                "xDrive35i. To 10/08",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Allure": [
                "CX/CXL",
                "Super"
            ],
            "Enclave": [
                ""
            ],
            "LaCrosse": [
                "CX/CXL",
                "Super"
            ],
            "Lucerne": [
                "3.9L",
                "4.6L"
            ]
        },
        "Cadillac": {
            "CTS": [
                "Base/Premium/Luxury. With Heavy Duty Brakes",
                "Base/Premium/Luxury. Without Heavy Duty Brakes"
            ],
            "DTS": [
                "With 5 Lug Wheels"
            ],
            "Escalade": [
                ""
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                ""
            ],
            "XLR": [
                "Supercharged"
            ]
        },
        "Chevrolet": {
            "Avalanche": [
                ""
            ],
            "Aveo": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Aveo5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Cobalt": [
                "LT/LS. With 4 Lug Wheels",
                "LT/LS. With 5 Lug Wheels",
                "SS"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "Base. With Heavy Duty Brakes",
                "Base. Without Heavy Duty Brakes"
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                ""
            ],
            "HHR": [
                "LT Panel/LS Panel/LT/LS. With 13-H7324",
                "LT Panel/LS Panel/LT/LS. With 13-H7326",
                "SS Panel/SS. With Single Piston Caliper"
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Silverado 1500": [
                "",
                "Except Vehicles Using Hold Down Pins",
                "With 6400 Lb GVW and Except Vehicles Using Hold Down Pins",
                "With 7000 Lb GVW and Except Vehicles Using Hold Down Pins",
                "With Vehicles Using Hold Down Pins"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Suburban 1500": [
                ""
            ],
            "Suburban 2500": [
                ""
            ],
            "Tahoe": [
                "Without Police Package"
            ],
            "Trailblazer": [
                "4.2L"
            ],
            "Traverse": [
                ""
            ],
            "Uplander": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "2.7L",
                "5.7L",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L"
            ],
            "Aspen": [
                ""
            ],
            "PT Cruiser": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Sebring": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Town and Country": [
                ""
            ]
        },
        "Dodge": {
            "Avenger": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Caliber": [
                "R/T/SXT. With 276mm Diameter Front Rotor",
                "R/T/SXT. With 294mm Diameter Front Rotor",
                "R/T/SXT. With 340mm Diameter Front Rotor",
                "SRT-4. With 276mm Diameter Front Rotor",
                "SRT-4. With 294mm Diameter Front Rotor",
                "SRT-4. With 340mm Diameter Front Rotor",
                "SXT/SE. With 276mm Diameter Front Rotor",
                "SXT/SE. With 294mm Diameter Front Rotor",
                "SXT/SE. With 340mm Diameter Front Rotor"
            ],
            "Challenger": [
                "3.5L",
                "5.7L",
                "6.1L"
            ],
            "Charger": [
                "2.7L",
                "5.7L. With Police Package",
                "5.7L. Without Police Package",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L. With Police Package",
                "RWD and with 3.5L. Without Police Package"
            ],
            "Dakota": [
                ""
            ],
            "Durango": [
                ""
            ],
            "Grand Caravan": [
                ""
            ],
            "Journey": [
                ""
            ],
            "Nitro": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ],
            "Ram 1500": [
                ""
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Ram 4500": [
                ""
            ],
            "Ram 5500": [
                ""
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-150": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "DIESEL engine. With Dual Rear Wheels",
                "DIESEL engine. With Single Rear Wheels",
                "GAS/FLEX engine. With Dual Rear Wheels",
                "GAS/FLEX engine. With Single Rear Wheels"
            ],
            "Edge": [
                "AWD",
                "FWD"
            ],
            "Escape": [
                "Limited/XLS/XLT/Hybrid"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                ""
            ],
            "Explorer Sport Trac": [
                ""
            ],
            "F-150": [
                "With 6 Lug Wheels",
                "With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "With 16000-22000 Lb GVW"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "Flex": [
                ""
            ],
            "Focus": [
                "",
                "7/8\" Bore"
            ],
            "Fusion": [
                ""
            ],
            "Mustang": [
                "Base",
                "Bullitt",
                "GT",
                "Shelby GT500/Shelby GT500KR"
            ],
            "Ranger": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum",
                "RWD. With 10\" Diameter Drum",
                "RWD. With 9\" Diameter Drum"
            ],
            "Taurus": [
                ""
            ],
            "Taurus X": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Envoy": [
                "4.2L",
                "5.3L"
            ],
            "Savana 1500": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "",
                "Except Vehicles Using Hold Down Pins",
                "With 6400 Lb GVW and Except Vehicles Using Hold Down Pins",
                "With 7000 Lb GVW and Except Vehicles Using Hold Down Pins",
                "With Vehicles Using Hold Down Pins"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Yukon": [
                ""
            ],
            "Yukon XL 1500": [
                ""
            ],
            "Yukon XL 2500": [
                ""
            ]
        },
        "Honda": {
            "Accord": [
                "EX/EX-L",
                "LX"
            ],
            "Civic": [
                "GX",
                "Hybrid-L/Hybrid",
                "LX/DX",
                "LX/Sport/EX",
                "Si"
            ],
            "CR-V": [
                ""
            ],
            "Element": [
                ""
            ],
            "Fit": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                "From 07/09",
                "To 06/09"
            ],
            "Elantra": [
                "L/Limited/GL/SE/GLS",
                "Touring"
            ],
            "Entourage": [
                ""
            ],
            "Genesis": [
                "3.8L",
                "4.6L"
            ],
            "Santa Fe": [
                ""
            ],
            "Sonata": [
                "2.4L",
                "3.3L"
            ],
            "Tucson": [
                "4WD",
                "FWD"
            ],
            "Veracruz": [
                ""
            ]
        },
        "INFINITI": {
            "EX35": [
                ""
            ],
            "FX35": [
                ""
            ],
            "FX50": [
                "With Dual Piston Caliper"
            ],
            "G37": [
                "AWD. With Brembo Brakes",
                "Convertible/Coupe and with RWD. Without Brembo Brakes",
                "RWD. With Brembo Brakes",
                "Sedan and with AWD. Without Brembo Brakes",
                "Sedan and with RWD. Without Brembo Brakes"
            ],
            "M35": [
                ""
            ],
            "M45": [
                ""
            ],
            "QX56": [
                ""
            ]
        },
        "Jaguar": {
            "Super V8": [
                ""
            ],
            "Vanden Plas": [
                "Naturally Aspirated"
            ],
            "XF": [
                "Naturally Aspirated. With 326mm Diameter Front Rotor"
            ],
            "XJ8": [
                ""
            ],
            "XK": [
                ""
            ],
            "XKR": [
                "Base. Without Painted Calipers"
            ]
        },
        "Jeep": {
            "Commander": [
                ""
            ],
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Grand Cherokee": [
                "Limited/Laredo/Overland",
                "SRT8"
            ],
            "Liberty": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Wrangler": [
                ""
            ]
        },
        "Kia": {
            "Amanti": [
                ""
            ],
            "Borrego": [
                ""
            ],
            "Magentis": [
                ""
            ],
            "Optima": [
                ""
            ],
            "Rio": [
                ""
            ],
            "Rio5": [
                ""
            ],
            "Rondo": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Spectra": [
                "",
                "Drum rear brakes"
            ],
            "Spectra5": [
                ""
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR2": [
                ""
            ],
            "LR3": [
                "4.4L"
            ],
            "Range Rover": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "Range Rover Sport": [
                "Naturally Aspirated"
            ]
        },
        "Lexus": {
            "ES350": [
                ""
            ],
            "GS350": [
                ""
            ],
            "GS450h": [
                ""
            ],
            "GS460": [
                "Vehicles Built For Canadian Market",
                "Vehicles Built For USA Market"
            ],
            "GX470": [
                ""
            ],
            "IS250": [
                "Vehicles Built For Canadian Market",
                "Vehicles Built For USA Market"
            ],
            "IS350": [
                "Vehicles Built For Canadian Market",
                "Vehicles Manufactured In USA"
            ],
            "LS460": [
                "AWD",
                "RWD. With Sport Package and With 356mm Diameter Front Rotor"
            ],
            "LS600h": [
                ""
            ],
            "LX570": [
                ""
            ],
            "RX350": [
                ""
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "MKS": [
                ""
            ],
            "MKX": [
                "AWD",
                "FWD"
            ],
            "MKZ": [
                ""
            ],
            "Navigator": [
                ""
            ],
            "Town Car": [
                "Sedan"
            ]
        },
        "Mazda": {
            "3": [
                "2.0L",
                "2.3L and with Naturally Aspirated",
                "Mazdaspeed and with 2.3L and Turbocharged"
            ],
            "3 Sport": [
                ""
            ],
            "5": [
                ""
            ],
            "6": [
                ""
            ],
            "B4000": [
                "4WD. With 10\" Diameter Drum",
                "4WD. With 9\" Diameter Drum"
            ],
            "CX-7": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ],
            "RX-8": [
                "Soft Suspension"
            ],
            "Tribute": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "B200": [
                ""
            ],
            "C230": [
                ""
            ],
            "C350": [
                "Sport"
            ],
            "CL550": [
                ""
            ],
            "CL600": [
                ""
            ],
            "CLK350": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "CLS550": [
                ""
            ],
            "E300": [
                ""
            ],
            "E550": [
                "AWD",
                "RWD. Without Sport Package"
            ],
            "G55 AMG": [
                "With 67mm Hub Pilot Diameter"
            ],
            "GL320": [
                ""
            ],
            "GL450": [
                ""
            ],
            "GL550": [
                ""
            ],
            "ML320": [
                "With 330mm Diameter Front Rotor",
                "With 350mm Diameter Front Rotor"
            ],
            "ML350": [
                "With Solid Rear Rotors and With 330mm Diameter Front Rotor",
                "With Vented Rear Rotors and With 350mm Diameter Front Rotor"
            ],
            "ML550": [
                ""
            ],
            "R320": [
                "With Solid Rotor"
            ],
            "R350": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "S450": [
                "Without Sport Package"
            ],
            "S550": [
                "AWD. With 350mm Diameter Front Rotor"
            ],
            "S600": [
                "",
                "Armored Vehicle"
            ],
            "SLK300": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "SLK350": [
                ""
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Mariner": [
                "Base/Premier/Hybrid"
            ],
            "Milan": [
                ""
            ],
            "Mountaineer": [
                ""
            ],
            "Sable": [
                ""
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L",
                "3.8L"
            ],
            "Galant": [
                "Ralliart",
                "Sport Edition/ES",
                "Sport V6/GT"
            ],
            "Lancer": [
                "DE and with Drum rear brakes",
                "ES/SE/DE",
                "Evolution RS/Evolution MR/Evolution GSR",
                "GTS",
                "Ralliart. From 04/09",
                "Ralliart. To 03/09"
            ],
            "Outlander": [
                "2.4L. With 7 Passenger Seating",
                "2.4L. Without 7 Passenger Seating",
                "3.0L"
            ],
            "Raider": [
                ""
            ]
        },
        "Nissan": {
            "350Z": [
                "With Brembo Brakes"
            ],
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                ""
            ],
            "Cube": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "Pathfinder": [
                "4.0L"
            ],
            "Quest": [
                ""
            ],
            "Rogue": [
                ""
            ],
            "Sentra": [
                "S/SL/Base/SR",
                "SE-R",
                "SE-R Spec V"
            ],
            "TITAN": [
                ""
            ],
            "Versa": [
                "1.6L",
                "1.6L. With 4 Wheel ABS",
                "1.6L. Without 4 Wheel ABS",
                "1.8L"
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "G3 Wave": [
                ""
            ],
            "G3": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "G5": [
                "With 4 Lug Wheels and With Rear Drum Brakes",
                "With 5 Lug Wheels and With Rear Drum Brakes",
                "With Rear Disc Brakes",
                "With Rear Drum Brakes and With 4 Lug Wheels",
                "With Rear Drum Brakes and With 5 Lug Wheels"
            ],
            "G6": [
                ""
            ],
            "G8": [
                "Base"
            ],
            "Montana": [
                ""
            ],
            "Torrent": [
                ""
            ],
            "Vibe": [
                "AWD and with AWD",
                "Base and with FWD and 1.8L",
                "Base and with FWD and 2.4L",
                "GT and with FWD and 2.4L"
            ]
        },
        "Saab": {
            "9-7x": [
                "4.2i/5.3i"
            ]
        },
        "Saturn": {
            "Astra": [
                ""
            ],
            "Aura": [
                ""
            ],
            "Outlook": [
                ""
            ],
            "Vue": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ],
            "xB": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                "Outback Sport/R/2.5i",
                "WRX/2.5 GT/WRX Premium",
                "WRX STI"
            ],
            "Legacy": [
                "2.5L and with Naturally Aspirated. With 292mm Diameter Front Rotor",
                "2.5L and with Turbocharged",
                "3.0 R Limited and with 3.0L. With 18\" Factory Wheels"
            ],
            "Outback": [
                "With 292mm Diameter Front Rotor"
            ],
            "Tribeca": [
                ""
            ]
        },
        "Suzuki": {
            "Equator": [
                "2.5L",
                "4.0L"
            ],
            "Grand Vitara": [
                ""
            ],
            "SX4": [
                "",
                "Drum rear brakes"
            ],
            "XL-7": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                "With 319mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                "",
                "Drum rear brakes"
            ],
            "FJ Cruiser": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                ""
            ],
            "Matrix": [
                "Base",
                "S and with AWD",
                "S and with FWD",
                "XRS"
            ],
            "RAV4": [
                "2.5L. With 3rd Row Seating",
                "2.5L. Without 3rd Row Seating",
                "3.5L"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ],
            "Yaris": [
                ""
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "CC": [
                "Sport/Luxury. With 312mm Diameter Front Rotor",
                "Sport/Luxury. With 340mm Diameter Front Rotor",
                "Sport/Luxury. With 345mm Diameter Front Rotor",
                "VR6/VR6 4Motion/VR6 Sport. With 312mm Diameter Front Rotor",
                "VR6/VR6 4Motion/VR6 Sport. With 340mm Diameter Front Rotor",
                "VR6/VR6 4Motion/VR6 Sport. With 345mm Diameter Front Rotor"
            ],
            "Golf City": [
                ""
            ],
            "GTI": [
                "With 282mm Diameter Rear Rotor",
                "With 286mm Diameter Rear Rotor"
            ],
            "Jetta City": [
                ""
            ],
            "Passat": [
                "2.0L",
                "3.6L"
            ],
            "Passat CC": [
                "With 312mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Rabbit": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "Routan": [
                "With 302mm Diameter Front Rotor",
                "With 330mm Diameter Front Rotor"
            ],
            "Tiguan": [
                ""
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor and With 4 Piston Caliper",
                "With 350mm Diameter Front Rotor and With 4 Piston Caliper",
                "With 4 Piston Caliper and With 330mm Diameter Front Rotor",
                "With 4 Piston Caliper and With 350mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C30": [
                ""
            ],
            "C70": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S40": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S60": [
                "2.5T. With 286mm Diameter Front Rotor",
                "2.5T. With 305mm Diameter Front Rotor",
                "T5. With 286mm Diameter Front Rotor",
                "T5. With 305mm Diameter Front Rotor"
            ],
            "V50": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2010": {
        "Acura": {
            "CSX": [
                "iTech",
                "Type-S"
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                "AWD",
                "FWD"
            ],
            "RL": [
                ""
            ],
            "TL": [
                ""
            ],
            "TSX": [
                ""
            ],
            "ZDX": [
                ""
            ]
        },
        "Audi": {
            "A4": [
                ""
            ],
            "A4 Quattro": [
                "With 300mm Diameter Rear Rotor"
            ],
            "Q5": [
                "With 320mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "TTS Quattro": [
                ""
            ]
        },
        "BMW": {
            "128i": [
                ""
            ],
            "135i": [
                ""
            ],
            "323i": [
                ""
            ],
            "328i": [
                "Convertible/Wagon",
                "Sedan/Coupe"
            ],
            "328i xDrive": [
                "",
                "With 312mm Diameter Front Rotor"
            ],
            "335d": [
                ""
            ],
            "335i": [
                ""
            ],
            "335i xDrive": [
                ""
            ],
            "528i": [
                ""
            ],
            "528i xDrive": [
                ""
            ],
            "535i": [
                "Base"
            ],
            "535i GT": [
                ""
            ],
            "535i xDrive": [
                ""
            ],
            "550i": [
                ""
            ],
            "550i GT": [
                ""
            ],
            "550i GT xDrive": [
                ""
            ],
            "650i": [
                ""
            ],
            "750i": [
                ""
            ],
            "750i xDrive": [
                ""
            ],
            "750Li": [
                ""
            ],
            "750Li xDrive": [
                ""
            ],
            "X3": [
                ""
            ],
            "X5": [
                "xDrive30i",
                "xDrive35d",
                "xDrive48i"
            ],
            "X6": [
                "xDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Allure": [
                ""
            ],
            "Enclave": [
                ""
            ],
            "LaCrosse": [
                ""
            ],
            "Lucerne": [
                "3.9L",
                "4.6L"
            ]
        },
        "Cadillac": {
            "CTS": [
                "Base/Premium/Luxury/Performance. With Heavy Duty Brakes",
                "Base/Premium/Luxury/Performance. Without Heavy Duty Brakes"
            ],
            "DTS": [
                "With 5 Lug Wheels"
            ],
            "Escalade": [
                ""
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                ""
            ]
        },
        "Chevrolet": {
            "Avalanche": [
                ""
            ],
            "Aveo": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Aveo5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Camaro": [
                "LT/LS",
                "SS"
            ],
            "Cobalt": [
                "Base/LT Team Canada/LT/LS. With 4 Lug Wheels",
                "Base/LT Team Canada/LT/LS. With 5 Lug Wheels",
                "SS"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "Base. With Heavy Duty Brakes",
                "Base. Without Heavy Duty Brakes"
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                ""
            ],
            "HHR": [
                "LT Panel/LS Panel/LT/LS",
                "LT Panel/LS Panel/LT/LS and with Drum rear brakes",
                "SS. With Single Piston Caliper"
            ],
            "Impala": [
                "With Drum In Hat Parking Brake",
                "Without Drum In Hat Parking Brake"
            ],
            "Malibu": [
                ""
            ],
            "Silverado 1500": [
                "",
                "With 6400 Lb GVW",
                "With 7000 Lb GVW"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Suburban 1500": [
                ""
            ],
            "Suburban 2500": [
                ""
            ],
            "Tahoe": [
                "Without Police Package"
            ],
            "Traverse": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "2.7L",
                "5.7L",
                "6.1L"
            ],
            "PT Cruiser": [
                ""
            ],
            "Sebring": [
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Town and Country": [
                ""
            ]
        },
        "Dodge": {
            "Avenger": [
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Caliber": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Challenger": [
                "3.5L",
                "5.7L",
                "6.1L"
            ],
            "Charger": [
                "2.7L",
                "5.7L. With Police Package",
                "5.7L. Without Police Package",
                "6.1L",
                "AWD and with 3.5L",
                "RWD and with 3.5L. With Police Package",
                "RWD and with 3.5L. Without Police Package"
            ],
            "Dakota": [
                ""
            ],
            "Grand Caravan": [
                ""
            ],
            "Journey": [
                ""
            ],
            "Nitro": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ],
            "Ram 1500": [
                ""
            ],
            "Ram 2500": [
                ""
            ],
            "Ram 3500": [
                ""
            ],
            "Ram 4500": [
                ""
            ],
            "Ram 5500": [
                ""
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-150": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "DIESEL engine. With Dual Rear Wheels",
                "DIESEL engine. With Single Rear Wheels",
                "GAS/FLEX/CNG/LPG engine. With Dual Rear Wheels",
                "GAS/FLEX/CNG/LPG engine. With Single Rear Wheels"
            ],
            "Edge": [
                ""
            ],
            "Escape": [
                "Hybrid",
                "Limited/XLS/XLT. From 06/29/10",
                "Limited/XLS/XLT. To 06/29/10"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                ""
            ],
            "Explorer Sport Trac": [
                ""
            ],
            "F-150": [
                "With 6 Lug Wheels",
                "With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "Cab & Chassis - Conventional. With 10 Lug Wheels and To 02/12/10",
                "Crew Cab Pickup. With 8 Lug Wheels and From 02/22/10"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "Flex": [
                ""
            ],
            "Focus": [
                ""
            ],
            "Fusion": [
                ""
            ],
            "Mustang": [
                "Base",
                "GT",
                "Shelby GT500"
            ],
            "Ranger": [
                "4WD",
                "RWD"
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "",
                "With 6400 Lb GVW",
                "With 7000 Lb GVW"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                ""
            ],
            "Yukon": [
                ""
            ],
            "Yukon XL 1500": [
                ""
            ],
            "Yukon XL 2500": [
                ""
            ]
        },
        "Honda": {
            "Accord Crosstour": [
                ""
            ],
            "Accord": [
                "EX/EX-L",
                "LX"
            ],
            "Civic": [
                "GX",
                "Hybrid-L/Hybrid",
                "LX/DX",
                "LX/Sport/EX/EX-L",
                "Si"
            ],
            "CR-V": [
                ""
            ],
            "Element": [
                ""
            ],
            "Fit": [
                ""
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                "From 07/06/09",
                "To 07/06/09"
            ],
            "Elantra": [
                "Hatchback",
                "Sedan",
                "Sedan. From 03/23/10",
                "Sedan. To 03/22/10"
            ],
            "Entourage": [
                ""
            ],
            "Genesis": [
                "3.8L. From 02/17/09",
                "3.8L. To 02/16/09",
                "4.6L. From 02/17/09",
                "4.6L. To 02/16/09"
            ],
            "Genesis Coupe": [
                "With 4 Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Santa Fe": [
                ""
            ],
            "Sonata": [
                "2.4L",
                "3.3L"
            ],
            "Tucson": [
                "AWD",
                "FWD"
            ],
            "Veracruz": [
                ""
            ]
        },
        "INFINITI": {
            "EX35": [
                ""
            ],
            "FX35": [
                ""
            ],
            "FX50": [
                "With Dual Piston Caliper"
            ],
            "G37": [
                "AWD. With Brembo Brakes",
                "Convertible/Coupe and with RWD. Without Brembo Brakes",
                "RWD. With Brembo Brakes",
                "Sedan and with AWD. Without Brembo Brakes",
                "Sedan and with RWD. Without Brembo Brakes"
            ],
            "M35": [
                ""
            ],
            "M45": [
                ""
            ],
            "QX56": [
                ""
            ]
        },
        "Jaguar": {
            "XF": [
                "Premium and with Naturally Aspirated. With 326mm Diameter Front Rotor",
                "Premium and with Naturally Aspirated. With 354mm Diameter Front Rotor",
                "Premium and with Naturally Aspirated. With 380mm Diameter Front Rotor",
                "Supercharged and with Supercharged. With 326mm Diameter Front Rotor",
                "Supercharged and with Supercharged. With 354mm Diameter Front Rotor",
                "Supercharged and with Supercharged. With 380mm Diameter Front Rotor"
            ],
            "XFR": [
                ""
            ],
            "XJ": [
                "Base",
                "L Supercharged/Supersport/L Supersport and with Supercharged"
            ],
            "XKR": [
                "Without Alcon Brakes"
            ]
        },
        "Jeep": {
            "Commander": [
                ""
            ],
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Grand Cherokee": [
                "Limited/North Edition/S Limited/Laredo",
                "SRT8"
            ],
            "Liberty": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Wrangler": [
                ""
            ]
        },
        "Kia": {
            "Borrego": [
                ""
            ],
            "Forte": [
                "2.0L",
                "2.4L"
            ],
            "Forte Koup": [
                "2.0L",
                "2.4L"
            ],
            "Magentis": [
                ""
            ],
            "Optima": [
                ""
            ],
            "Rio": [
                ""
            ],
            "Rio5": [
                ""
            ],
            "Rondo": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Soul": [
                "1.6L",
                "2.0L"
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR2": [
                ""
            ],
            "LR4": [
                ""
            ],
            "Range Rover": [
                "Naturally Aspirated"
            ],
            "Range Rover Sport": [
                "Naturally Aspirated",
                "Supercharged"
            ]
        },
        "Lexus": {
            "ES350": [
                ""
            ],
            "GS350": [
                ""
            ],
            "GS450h": [
                ""
            ],
            "GS460": [
                "Vehicles Built For Canadian Market",
                "Vehicles Built For USA Market"
            ],
            "GX460": [
                ""
            ],
            "HS250h": [
                ""
            ],
            "IS250": [
                "Base. Vehicles Built For Canadian Market",
                "Base. Vehicles Built For USA Market",
                "C. Vehicles Built For Canadian Market",
                "C. Vehicles Built For USA Market"
            ],
            "IS350": [
                "C/Base. Vehicles Built For Canadian Market",
                "Vehicles Manufactured In USA"
            ],
            "LS460": [
                "AWD"
            ],
            "LS600h": [
                ""
            ],
            "LX570": [
                ""
            ],
            "RX350": [
                ""
            ],
            "RX450h": [
                ""
            ],
            "SC430": [
                ""
            ]
        },
        "Lincoln": {
            "MKS": [
                ""
            ],
            "MKT": [
                ""
            ],
            "MKX": [
                ""
            ],
            "MKZ": [
                ""
            ],
            "Navigator": [
                ""
            ],
            "Town Car": [
                "Sedan"
            ]
        },
        "Mazda": {
            "3": [
                "GS/GX and with 2.0L",
                "GT and with 2.5L",
                "Mazdaspeed and with 2.3L"
            ],
            "3 Sport": [
                "GS/GT and with 2.5L",
                "GX and with 2.0L"
            ],
            "5": [
                ""
            ],
            "6": [
                ""
            ],
            "B2300": [
                "With 10.25\" Diameter Rotor",
                "With 11-1/4\" Diameter Rotor"
            ],
            "B4000": [
                "",
                "With 10\" Diameter Drum",
                "With 9\" Diameter Drum"
            ],
            "CX-7": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ],
            "RX-8": [
                "Soft Suspension"
            ],
            "Tribute": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "B200": [
                ""
            ],
            "C250": [
                ""
            ],
            "C350": [
                ""
            ],
            "CL550": [
                ""
            ],
            "CL600": [
                ""
            ],
            "CLS550": [
                ""
            ],
            "E550": [
                "Coupe. With 300mm Diameter Rear Rotor",
                "Coupe. With 320mm Diameter Rear Rotor"
            ],
            "G55 AMG": [
                "With 67mm Hub Pilot Diameter"
            ],
            "GL350": [
                ""
            ],
            "GL450": [
                ""
            ],
            "GL550": [
                ""
            ],
            "GLK350": [
                ""
            ],
            "ML350": [
                "With Solid Rear Rotors and With 330mm Diameter Front Rotor",
                "With Vented Rear Rotors and With 350mm Diameter Front Rotor"
            ],
            "ML450": [
                ""
            ],
            "ML550": [
                ""
            ],
            "S400": [
                "With Sport Package"
            ],
            "S450": [
                "Without Sport Package"
            ],
            "S550": [
                "AWD. With 350mm Diameter Front Rotor"
            ],
            "S600": [
                "",
                "Armored Vehicle"
            ],
            "SLK300": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "SLK350": [
                ""
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Mariner": [
                "Base/Premier. From 06/29/10",
                "Base/Premier. To 06/29/10",
                "Hybrid"
            ],
            "Milan": [
                ""
            ],
            "Mountaineer": [
                ""
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L",
                "3.8L"
            ],
            "Endeavor": [
                ""
            ],
            "Galant": [
                ""
            ],
            "Lancer": [
                "ES/SE/DE",
                "Evolution MR/Evolution GSR/Evolution MR Touring",
                "GTS Sportback/GTS",
                "Ralliart/Ralliart Sportback"
            ],
            "Outlander": [
                "2.4L. With 7 Passenger Seating",
                "2.4L. Without 7 Passenger Seating",
                "3.0L"
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                ""
            ],
            "Cube": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "Pathfinder": [
                "4.0L"
            ],
            "Rogue": [
                ""
            ],
            "Sentra": [
                "S/SL/Base/SR",
                "SE-R",
                "SE-R Spec V"
            ],
            "TITAN": [
                ""
            ],
            "Versa": [
                "1.6L",
                "1.6L. With 4 Wheel ABS",
                "1.6L. Without 4 Wheel ABS",
                "1.8L"
            ],
            "Xterra": [
                ""
            ]
        },
        "Pontiac": {
            "G3": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "G5": [
                "With 4 Lug Wheels and With Rear Drum Brakes",
                "With 5 Lug Wheels and With Rear Drum Brakes",
                "With Rear Disc Brakes",
                "With Rear Drum Brakes and With 4 Lug Wheels",
                "With Rear Drum Brakes and With 5 Lug Wheels"
            ],
            "G6": [
                ""
            ],
            "Vibe": [
                "AWD and with AWD",
                "Base and with FWD and 1.8L",
                "Base and with FWD and 2.4L",
                "GT and with FWD and 2.4L"
            ]
        },
        "Saturn": {
            "Outlook": [
                ""
            ],
            "Vue": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ],
            "xB": [
                ""
            ]
        },
        "Subaru": {
            "Impreza": [
                "Sport/Outback Sport/2.5i Limited/R/2.5i/2.5i Premium",
                "WRX STI",
                "WRX/WRX Limited/2.5 GT"
            ],
            "Legacy": [
                "2.5L and with Naturally Aspirated. With 292mm Diameter Front Rotor",
                "2.5L and with Turbocharged",
                "3.6L"
            ],
            "Outback": [
                "2.5L. With 292mm Diameter Front Rotor",
                "3.6L"
            ],
            "Tribeca": [
                ""
            ]
        },
        "Suzuki": {
            "Equator": [
                "2.5L",
                "4.0L"
            ],
            "Grand Vitara": [
                ""
            ],
            "Kizashi": [
                ""
            ],
            "SX4": [
                "",
                "Drum rear brakes"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                "2.4L",
                "Drum rear brakes"
            ],
            "FJ Cruiser": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                ""
            ],
            "Matrix": [
                "Base",
                "S and with AWD",
                "S and with FWD",
                "XRS"
            ],
            "Prius": [
                ""
            ],
            "RAV4": [
                "2.5L. With 3rd Row Seating",
                "2.5L. Without 3rd Row Seating",
                "3.5L"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ],
            "Yaris": [
                ""
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor"
            ],
            "CC": [
                "2.0L. With 312mm Diameter Front Rotor",
                "2.0L. With 340mm Diameter Front Rotor",
                "2.0L. With 345mm Diameter Front Rotor",
                "3.6L. With 312mm Diameter Front Rotor",
                "3.6L. With 340mm Diameter Front Rotor",
                "3.6L. With 345mm Diameter Front Rotor"
            ],
            "Golf City": [
                "7th And 8th Digit Of VIN Is \"BE\""
            ],
            "GTI": [
                "With 282mm Diameter Rear Rotor",
                "With 286mm Diameter Rear Rotor"
            ],
            "Passat CC": [
                "With 312mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Routan": [
                "With 302mm Diameter Front Rotor",
                "With 330mm Diameter Front Rotor"
            ],
            "Tiguan": [
                ""
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor and With 4 Piston Caliper",
                "With 350mm Diameter Front Rotor and With 4 Piston Caliper",
                "With 4 Piston Caliper and With 330mm Diameter Front Rotor",
                "With 4 Piston Caliper and With 350mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C30": [
                ""
            ],
            "C70": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S40": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "V50": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "XC60": [
                ""
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2011": {
        "Acura": {
            "CSX": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                "AWD",
                "FWD"
            ],
            "RL": [
                ""
            ],
            "TL": [
                ""
            ],
            "TSX": [
                ""
            ],
            "ZDX": [
                ""
            ]
        },
        "Audi": {
            "A4": [
                ""
            ],
            "A5 Quattro": [
                ""
            ],
            "A5": [
                "With 300mm Diameter Rear Rotor"
            ],
            "Q5": [
                "From 06/20/11",
                "To 06/19/11"
            ],
            "Q7": [
                "With 330mm Diameter Rear Rotor",
                "With 358mm Diameter Rear Rotor"
            ],
            "S4": [
                "With 345mm Diameter Front Rotor"
            ],
            "S5": [
                "From 11/08/10",
                "To 11/08/10"
            ],
            "TTS Quattro": [
                ""
            ]
        },
        "BMW": {
            "128i": [
                ""
            ],
            "135i": [
                ""
            ],
            "323i": [
                ""
            ],
            "328i": [
                "Convertible/Wagon",
                "Sedan/Coupe"
            ],
            "328i xDrive": [
                "",
                "With 312mm Diameter Front Rotor"
            ],
            "335d": [
                ""
            ],
            "335i": [
                ""
            ],
            "335i xDrive": [
                ""
            ],
            "335is": [
                ""
            ],
            "528i": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "535i GT": [
                ""
            ],
            "535i GT xDrive": [
                ""
            ],
            "535i": [
                "With 330mm Diameter Rear Rotor",
                "With 345mm Diameter Rear Rotor"
            ],
            "535i xDrive": [
                ""
            ],
            "550i": [
                ""
            ],
            "550i GT": [
                ""
            ],
            "550i GT xDrive": [
                ""
            ],
            "550i xDrive": [
                ""
            ],
            "740i": [
                ""
            ],
            "740Li": [
                ""
            ],
            "750i": [
                ""
            ],
            "750i xDrive": [
                ""
            ],
            "750Li": [
                ""
            ],
            "750Li xDrive": [
                ""
            ],
            "X3": [
                "xDrive28i"
            ],
            "X5": [
                "xDrive35d",
                "xDrive50i"
            ],
            "X6": [
                "xDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "LaCrosse": [
                ""
            ],
            "Lucerne": [
                "3.9L",
                "4.6L"
            ]
        },
        "Cadillac": {
            "CTS": [
                "Base/Coupe/Premium/Luxury/Performance. With Heavy Duty Brakes",
                "Base/Coupe/Premium/Luxury/Performance. Without Heavy Duty Brakes"
            ],
            "DTS": [
                "With 5 Lug Wheels"
            ],
            "Escalade": [
                ""
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                ""
            ]
        },
        "Chevrolet": {
            "Avalanche": [
                ""
            ],
            "Aveo": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Aveo5": [
                "With Hub Assembly",
                "Without Hub Assembly"
            ],
            "Camaro": [
                "LT/LS",
                "SS"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "Base. With Heavy Duty Brakes",
                "Base. Without Heavy Duty Brakes"
            ],
            "Cruze": [
                ""
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                ""
            ],
            "HHR": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Silverado 1500": [
                "",
                "Base/XFE/LT/WT/LTZ/LS",
                "Hybrid",
                "With 6400 Lb GVW",
                "With 7000 Lb GVW"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Suburban 1500": [
                ""
            ],
            "Suburban 2500": [
                ""
            ],
            "Tahoe": [
                "Without Police Package"
            ],
            "Traverse": [
                ""
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "200": [
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "300": [
                "3.6L",
                "5.7L"
            ],
            "Town and Country": [
                ""
            ]
        },
        "Dodge": {
            "Avenger": [
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Caliber": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Challenger": [
                "3.6L",
                "5.7L",
                "6.4L"
            ],
            "Charger": [
                "3.6L. With Police Package",
                "3.6L. Without Police Package",
                "5.7L"
            ],
            "Grand Caravan": [
                ""
            ],
            "Journey": [
                ""
            ],
            "Nitro": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ]
        },
        "Ford": {
            "Crown Victoria": [
                ""
            ],
            "E-150": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Edge": [
                ""
            ],
            "Escape": [
                "Limited Hybrid/Hybrid",
                "Limited/XLS/XLT"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                ""
            ],
            "F-150": [
                "With 6 Lug Wheels",
                "With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "Crew Cab Pickup. With 8 Lug Wheels and From 02/22/10",
                "With 10 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "With 16000-22000 Lb GVW"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-59 Commercial Stripped Chassis": [
                "With Under 24000 Lb GVW"
            ],
            "Fiesta": [
                "S/SES/Base/SE/SEL"
            ],
            "Flex": [
                ""
            ],
            "Focus": [
                ""
            ],
            "Fusion": [
                ""
            ],
            "Mustang": [
                "Base",
                "GT. With 4 Piston Caliper",
                "GT. With Dual Piston Caliper",
                "Shelby GT500"
            ],
            "Ranger": [
                "4WD",
                "RWD"
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "",
                "With 6400 Lb GVW",
                "With 7000 Lb GVW"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                ""
            ],
            "Yukon": [
                ""
            ],
            "Yukon XL 1500": [
                ""
            ],
            "Yukon XL 2500": [
                ""
            ]
        },
        "Honda": {
            "Accord Crosstour": [
                "AWD",
                "FWD",
                "FWD/AWD"
            ],
            "Accord": [
                "EX",
                "LX/SE"
            ],
            "Civic": [
                "GX",
                "Hybrid",
                "LX/DX-G/LX-S/DX",
                "LX/EX",
                "Si"
            ],
            "CR-V": [
                ""
            ],
            "CR-Z": [
                ""
            ],
            "Element": [
                ""
            ],
            "Fit": [
                ""
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                ""
            ],
            "Elantra": [
                "1.8L",
                "2.0L"
            ],
            "Equus": [
                ""
            ],
            "Genesis": [
                "3.8L",
                "4.6L"
            ],
            "Genesis Coupe": [
                "With 4 Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Santa Fe": [
                ""
            ],
            "Sonata": [
                ""
            ],
            "Tucson": [
                "AWD",
                "FWD"
            ],
            "Veracruz": [
                ""
            ]
        },
        "INFINITI": {
            "EX35": [
                ""
            ],
            "FX35": [
                ""
            ],
            "FX50": [
                "With Dual Piston Caliper"
            ],
            "G25": [
                ""
            ],
            "G37": [
                "AWD. With Brembo Brakes",
                "Convertible/Coupe and with RWD. Without Brembo Brakes",
                "RWD. With Brembo Brakes",
                "Sedan and with AWD. Without Brembo Brakes",
                "Sedan and with RWD. Without Brembo Brakes"
            ],
            "M37": [
                "With Dual Piston Caliper"
            ],
            "M56": [
                "With Dual Piston Caliper"
            ],
            "QX56": [
                ""
            ]
        },
        "Jaguar": {
            "XF": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "XFR": [
                ""
            ],
            "XJ": [
                "Naturally Aspirated",
                "Supercharged/L Supercharged/Supersport/L Supersport and with Supercharged"
            ],
            "XKR": [
                "Without Alcon Brakes"
            ]
        },
        "Jeep": {
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Liberty": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Wrangler": [
                ""
            ]
        },
        "Kia": {
            "Borrego": [
                ""
            ],
            "Forte": [
                "2.0L",
                "2.4L"
            ],
            "Forte Koup": [
                "2.0L",
                "2.4L"
            ],
            "Optima": [
                "2.0L",
                "2.4L"
            ],
            "Rio": [
                ""
            ],
            "Rio5": [
                ""
            ],
            "Rondo": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Soul": [
                "1.6L",
                "2.0L"
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR2": [
                ""
            ],
            "LR4": [
                ""
            ],
            "Range Rover": [
                "Naturally Aspirated"
            ],
            "Range Rover Sport": [
                "Naturally Aspirated",
                "Supercharged"
            ]
        },
        "Lexus": {
            "CT200h": [
                "With 259mm Diameter Rear Rotor",
                "With 279mm Diameter Rear Rotor"
            ],
            "ES350": [
                ""
            ],
            "GS350": [
                "RWD. Vehicles Built For Canadian Market",
                "Vehicles Built For USA Market"
            ],
            "GS450h": [
                "Vehicles Built For Canadian Market",
                "Vehicles Built For USA Market"
            ],
            "GS460": [
                "Thru 12/31/10 and Vehicles Built For Canadian Market",
                "Vehicles Built For USA Market"
            ],
            "GX460": [
                ""
            ],
            "HS250h": [
                ""
            ],
            "IS250": [
                "Base. Vehicles Built For Canadian Market",
                "Base. Vehicles Built For USA Market",
                "C. Vehicles Built For Canadian Market",
                "C. Vehicles Built For USA Market"
            ],
            "IS350": [
                "Vehicles Built For Canadian Market",
                "Vehicles Built For USA Market"
            ],
            "LS460": [
                "AWD"
            ],
            "LS600h": [
                ""
            ],
            "LX570": [
                ""
            ],
            "RX350": [
                ""
            ],
            "RX450h": [
                ""
            ]
        },
        "Lincoln": {
            "MKS": [
                ""
            ],
            "MKT": [
                ""
            ],
            "MKX": [
                ""
            ],
            "MKZ": [
                ""
            ],
            "Navigator": [
                ""
            ],
            "Town Car": [
                "Sedan"
            ]
        },
        "Mazda": {
            "2": [
                ""
            ],
            "3": [
                "2.0L",
                "2.5L",
                "Mazdaspeed and with 2.3L"
            ],
            "3 Sport": [
                "2.0L",
                "2.5L"
            ],
            "6": [
                ""
            ],
            "CX-7": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ],
            "RX-8": [
                "Soft Suspension"
            ],
            "Tribute": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "B200": [
                ""
            ],
            "C250": [
                ""
            ],
            "C350": [
                ""
            ],
            "CL550": [
                ""
            ],
            "CL600": [
                ""
            ],
            "CLS550": [
                ""
            ],
            "E350": [
                "Convertible/Coupe. With 322mm Diameter Front Rotor",
                "Sedan. With 322mm Diameter Front Rotor"
            ],
            "E550": [
                "Coupe. With 300mm Diameter Rear Rotor",
                "Coupe. With 320mm Diameter Rear Rotor"
            ],
            "G55 AMG": [
                "With 67mm Hub Pilot Diameter"
            ],
            "GL350": [
                ""
            ],
            "GL450": [
                ""
            ],
            "GL550": [
                ""
            ],
            "GLK350": [
                ""
            ],
            "ML350": [
                "AWD. With Solid Rear Rotors and With 330mm Diameter Front Rotor",
                "AWD. With Vented Rear Rotors and With 350mm Diameter Front Rotor"
            ],
            "ML450": [
                ""
            ],
            "ML550": [
                ""
            ],
            "S400": [
                "With Sport Package"
            ],
            "S450": [
                "Without Sport Package"
            ],
            "S550": [
                "AWD. With 350mm Diameter Front Rotor"
            ],
            "S600": [
                "",
                "Armored Vehicle"
            ],
            "SL550": [
                "With Sport Package"
            ],
            "SLK300": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "SLK350": [
                ""
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ]
        },
        "Mercury": {
            "Grand Marquis": [
                ""
            ],
            "Mariner": [
                "Base/Premier",
                "Hybrid"
            ],
            "Milan": [
                ""
            ]
        },
        "Mini": {
            "Cooper Countryman": [
                "With 294mm Diameter Front Rotor",
                "With 307mm Diameter Front Rotor"
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L",
                "3.8L"
            ],
            "Endeavor": [
                ""
            ],
            "Galant": [
                ""
            ],
            "Lancer": [
                "DE and with Drum rear brakes",
                "ES/SE Sportback/SE",
                "Evolution MR/Evolution GSR",
                "GTS Sportback/GTS",
                "Ralliart/Ralliart Sportback"
            ],
            "Outlander": [
                "2.4L. With 7 Passenger Seating",
                "2.4L. Without 7 Passenger Seating",
                "3.0L"
            ],
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                ""
            ],
            "Cube": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Juke": [
                ""
            ],
            "LEAF": [
                ""
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                "Convertible",
                "Sport Utility"
            ],
            "Pathfinder": [
                "4.0L"
            ],
            "Quest": [
                ""
            ],
            "Rogue": [
                ""
            ],
            "Sentra": [
                "S/SL/Base/SR",
                "SE-R",
                "SE-R Spec V"
            ],
            "TITAN": [
                ""
            ],
            "Versa": [
                "1.6L",
                "1.6L. With 4 Wheel ABS",
                "1.6L. Without 4 Wheel ABS",
                "1.8L"
            ],
            "Xterra": [
                ""
            ]
        },
        "Porsche": {
            "Cayenne": [
                "S/Base. With 350mm Diameter Front Rotor",
                "S/Base. With 360mm Diameter Front Rotor"
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                ""
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "Dakota": [
                ""
            ]
        },
        "Saab": {
            "9-4X": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ],
            "xB": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                "Outback Sport/2.5i/2.5i Premium",
                "WRX Limited",
                "WRX STI/WRX STI Limited"
            ],
            "Legacy": [
                "2.5L and with Naturally Aspirated. With 292mm Diameter Front Rotor",
                "2.5L and with Turbocharged",
                "3.6L"
            ],
            "Outback": [
                "2.5L. With 292mm Diameter Front Rotor",
                "3.6L"
            ],
            "Tribeca": [
                ""
            ]
        },
        "Suzuki": {
            "Equator": [
                "2.5L",
                "4.0L"
            ],
            "Grand Vitara": [
                ""
            ],
            "Kizashi": [
                ""
            ],
            "SX4": [
                "",
                "Drum rear brakes"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                "",
                "Drum rear brakes"
            ],
            "FJ Cruiser": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                ""
            ],
            "Matrix": [
                "Base",
                "S and with AWD",
                "S and with FWD"
            ],
            "Prius": [
                ""
            ],
            "RAV4": [
                "2.5L. With 3rd Row Seating",
                "2.5L. Without 3rd Row Seating",
                "3.5L"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ],
            "Yaris": [
                ""
            ]
        },
        "Volkswagen": {
            "CC": [
                "2.0L. With 312mm Diameter Front Rotor",
                "2.0L. With 340mm Diameter Front Rotor",
                "2.0L. With 345mm Diameter Front Rotor",
                "3.6L. With 312mm Diameter Front Rotor",
                "3.6L. With 340mm Diameter Front Rotor",
                "3.6L. With 345mm Diameter Front Rotor"
            ],
            "GTI": [
                ""
            ],
            "Jetta": [
                "Drum rear brakes. With 280mm Diameter Front Rotor",
                "Drum rear brakes. With 288mm Diameter Front Rotor",
                "Drum rear brakes. With 312mm Diameter Front Rotor",
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "Routan": [
                "With 302mm Diameter Front Rotor",
                "With 330mm Diameter Front Rotor"
            ],
            "Tiguan": [
                ""
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C30": [
                ""
            ],
            "C70": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S40": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "V50": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "XC60": [
                ""
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2012": {
        "Acura": {
            "MDX": [
                ""
            ],
            "RDX": [
                "AWD",
                "FWD"
            ],
            "RL": [
                ""
            ],
            "TL": [
                ""
            ],
            "TSX": [
                ""
            ],
            "ZDX": [
                ""
            ]
        },
        "Audi": {
            "A4": [
                ""
            ],
            "A4 Quattro": [
                ""
            ],
            "Q5": [
                "With 320mm Diameter Front Rotor"
            ],
            "Q7": [
                "With 330mm Diameter Rear Rotor",
                "With 358mm Diameter Rear Rotor"
            ],
            "S4": [
                ""
            ],
            "TTS Quattro": [
                ""
            ]
        },
        "BMW": {
            "128i": [
                ""
            ],
            "135i": [
                ""
            ],
            "328i": [
                "Convertible/Wagon and with 3.0L. With 312mm Diameter Front Rotor",
                "Convertible/Wagon and with 3.0L. With 330mm Diameter Front Rotor",
                "Coupe and with 3.0L. With 312mm Diameter Front Rotor",
                "Coupe and with 3.0L. With 330mm Diameter Front Rotor"
            ],
            "328i xDrive": [
                "Base",
                "With 312mm Diameter Front Rotor"
            ],
            "335i": [
                "Convertible/Coupe. With Blue Painted Calipers and With 370mm Diameter Front Rotor",
                "Convertible/Coupe. Without Blue Painted Calipers"
            ],
            "335i xDrive": [
                "Coupe"
            ],
            "335is": [
                ""
            ],
            "528i": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "528i xDrive": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "535i GT": [
                ""
            ],
            "535i GT xDrive": [
                ""
            ],
            "535i": [
                "With 330mm Diameter Rear Rotor",
                "With 345mm Diameter Rear Rotor"
            ],
            "535i xDrive": [
                ""
            ],
            "550i": [
                ""
            ],
            "550i GT": [
                ""
            ],
            "550i GT xDrive": [
                ""
            ],
            "550i xDrive": [
                ""
            ],
            "640i": [
                ""
            ],
            "650i": [
                ""
            ],
            "650i xDrive": [
                ""
            ],
            "740i": [
                ""
            ],
            "740Li": [
                ""
            ],
            "750i": [
                ""
            ],
            "750i xDrive": [
                ""
            ],
            "750Li": [
                ""
            ],
            "750Li xDrive": [
                ""
            ],
            "ActiveHybrid 5": [
                ""
            ],
            "X3": [
                "From 10/11",
                "To 10/11"
            ],
            "X5": [
                "xDrive35i",
                "xDrive50i"
            ],
            "X6": [
                "xDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "Verano": [
                ""
            ]
        },
        "Cadillac": {
            "Escalade": [
                ""
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                ""
            ]
        },
        "Chevrolet": {
            "Avalanche": [
                ""
            ],
            "Camaro": [
                "LT/LS",
                "SS"
            ],
            "Captiva Sport": [
                ""
            ],
            "Colorado": [
                "LT/WT"
            ],
            "Cruze": [
                ""
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                ""
            ],
            "Impala": [
                "With Police Package",
                "Without Police Package"
            ],
            "Malibu": [
                ""
            ],
            "Orlando": [
                ""
            ],
            "Silverado 1500": [
                "",
                "With 6400 Lb GVW",
                "With 7000 Lb GVW"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                ""
            ],
            "Suburban 1500": [
                ""
            ],
            "Suburban 2500": [
                ""
            ],
            "Tahoe": [
                "Without Police Package"
            ],
            "Traverse": [
                ""
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "Base",
                "C",
                "Limited and with AWD",
                "Limited and with RWD",
                "S and with 5.7L",
                "S and with AWD and 3.6L",
                "S and with RWD and 3.6L",
                "SRT8"
            ],
            "Town and Country": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper and From 03/24/12",
                "With Single Piston Front Caliper and To 03/23/12"
            ]
        },
        "Dodge": {
            "Caliber": [
                "With 276mm Diameter Front Rotor",
                "With 294mm Diameter Front Rotor"
            ],
            "Challenger": [
                "5.7L",
                "6.4L"
            ],
            "Charger": [
                "5.7L. With Police Package",
                "5.7L. Without Police Package",
                "6.4L",
                "AWD and with 3.6L",
                "RWD and with 3.6L"
            ],
            "Grand Caravan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper and From 03/24/12",
                "With Single Piston Front Caliper and To 03/23/12"
            ],
            "Journey": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ]
        },
        "Fiat": {
            "500": [
                "Naturally Aspirated",
                "Turbocharged and with GAS engine"
            ]
        },
        "Ford": {
            "E-150": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Edge": [
                ""
            ],
            "Escape": [
                "Limited Hybrid/Hybrid",
                "Limited/XLS/XLT"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                ""
            ],
            "F-150": [
                "With 6 Lug Wheels",
                "With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "Crew Cab Pickup. With 8 Lug Wheels",
                "With 10 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "From 16000 Lb to 22000 Lb GVW"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-59 Commercial Stripped Chassis": [
                "With Under 24000 Lb GVW"
            ],
            "Fiesta": [
                "S/SES/SE/SEL"
            ],
            "Flex": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Focus": [
                "",
                "FMSI=1004"
            ],
            "Fusion": [
                ""
            ],
            "Mustang": [
                "Base",
                "Boss 302/Shelby GT500",
                "GT. With 4 Piston Caliper and With Brembo Calipers",
                "GT. With Dual Piston Caliper"
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "",
                "With 6400 Lb GVW",
                "With 7000 Lb GVW"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                ""
            ],
            "Yukon": [
                ""
            ],
            "Yukon XL 1500": [
                ""
            ],
            "Yukon XL 2500": [
                ""
            ]
        },
        "Honda": {
            "Accord": [
                "EX/EX-L/HFP",
                "LX/SE"
            ],
            "Civic": [
                "Hybrid",
                "LX/DX",
                "LX/EX/EX-L",
                "Si HFP/Si"
            ],
            "CR-V": [
                "AWD",
                "FWD"
            ],
            "CR-Z": [
                ""
            ],
            "Crosstour": [
                "AWD",
                "FWD",
                "FWD/AWD"
            ],
            "Fit": [
                ""
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                ""
            ],
            "Elantra": [
                "1.8L",
                "2.0L"
            ],
            "Equus": [
                ""
            ],
            "Genesis": [
                "3.8L",
                "5.0L"
            ],
            "Genesis Coupe": [
                "With 4 Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Santa Fe": [
                ""
            ],
            "Sonata": [
                ""
            ],
            "Tucson": [
                "AWD",
                "FWD"
            ],
            "Veloster": [
                ""
            ],
            "Veracruz": [
                ""
            ]
        },
        "INFINITI": {
            "EX35": [
                ""
            ],
            "FX35": [
                ""
            ],
            "FX50": [
                "With Dual Piston Caliper"
            ],
            "G25": [
                ""
            ],
            "G37": [
                "AWD. With Brembo Brakes",
                "Convertible/Coupe and with RWD. Without Brembo Brakes",
                "RWD. With Brembo Brakes",
                "Sedan and with AWD. Without Brembo Brakes",
                "Sedan and with RWD. Without Brembo Brakes"
            ],
            "M35h": [
                "With Dual Piston Caliper"
            ],
            "M37": [
                "With Dual Piston Caliper"
            ],
            "M56": [
                "With Dual Piston Caliper"
            ],
            "QX56": [
                ""
            ]
        },
        "Jaguar": {
            "XF": [
                "Naturally Aspirated",
                "Supercharged"
            ],
            "XFR": [
                ""
            ],
            "XJ": [
                "Naturally Aspirated",
                "Supercharged/L Supercharged/Supersport/L Supersport and with Supercharged"
            ],
            "XK": [
                ""
            ],
            "XKR-S": [
                "Without Alcon Brakes"
            ],
            "XKR": [
                "Without Alcon Brakes"
            ]
        },
        "Jeep": {
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Liberty": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Wrangler": [
                ""
            ]
        },
        "Kia": {
            "Forte": [
                "2.0L",
                "2.4L"
            ],
            "Forte Koup": [
                "2.0L",
                "2.4L"
            ],
            "Forte5": [
                "With 15\" Factory Wheels",
                "With 16\" Factory Wheels"
            ],
            "Optima": [
                "2.0L",
                "2.4L"
            ],
            "Rio": [
                "LX/EX/LX+",
                "SX"
            ],
            "Rondo": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Soul": [
                ""
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR4": [
                ""
            ],
            "Range Rover Evoque": [
                ""
            ],
            "Range Rover": [
                "Naturally Aspirated"
            ],
            "Range Rover Sport": [
                "Naturally Aspirated",
                "Supercharged"
            ]
        },
        "Lexus": {
            "CT200h": [
                "With 259mm Diameter Rear Rotor",
                "With 279mm Diameter Rear Rotor"
            ],
            "ES350": [
                ""
            ],
            "GX460": [
                ""
            ],
            "HS250h": [
                ""
            ],
            "IS250": [
                "C. Vehicles Built For Canadian Market",
                "C. Vehicles Built For USA Market"
            ],
            "IS350": [
                "C/Base. Vehicles Built For Canadian Market",
                "C/Base. Vehicles Built For USA Market"
            ],
            "LS460": [
                "AWD"
            ],
            "LS600h": [
                ""
            ],
            "RX350": [
                ""
            ],
            "RX450h": [
                ""
            ]
        },
        "Lincoln": {
            "MKS": [
                "From 02/06/12",
                "To 02/05/12"
            ],
            "MKT": [
                ""
            ],
            "MKX": [
                ""
            ],
            "MKZ": [
                ""
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "2": [
                ""
            ],
            "3": [
                "2.0L",
                "2.5L",
                "Mazdaspeed and with 2.3L"
            ],
            "3 Sport": [
                "GS/GT and with 2.5L",
                "GS/GX and with 2.0L",
                "GS-SKY and with 2.0L"
            ],
            "5": [
                ""
            ],
            "6": [
                ""
            ],
            "CX-7": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "C350": [
                ""
            ],
            "CL550": [
                ""
            ],
            "CL600": [
                ""
            ],
            "CLS550": [
                ""
            ],
            "E350": [
                "Convertible/Coupe. With 322mm Diameter Front Rotor",
                "Sedan. With 322mm Diameter Front Rotor"
            ],
            "GL350": [
                ""
            ],
            "GL450": [
                ""
            ],
            "GL550": [
                ""
            ],
            "GLK350": [
                ""
            ],
            "ML350": [
                "Bluetec 4Matic. Without Sport Package"
            ],
            "S350": [
                "With Sport Package"
            ],
            "S400": [
                "With Sport Package"
            ],
            "S550": [
                "AWD. With 350mm Diameter Front Rotor",
                "RWD. With Sport Package and With 350mm Diameter Front Rotor"
            ],
            "S600": [
                "",
                "Armored Vehicle"
            ],
            "SL550": [
                "With Sport Package"
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ]
        },
        "Mitsubishi": {
            "Eclipse": [
                "2.4L",
                "3.8L"
            ],
            "Galant": [
                ""
            ],
            "Lancer": [
                "DE and with Drum rear brakes",
                "ES/SE Sportback/ES Sportback/SE",
                "Evolution MR/Evolution GSR",
                "GT Sportback/GT",
                "Ralliart"
            ],
            "Outlander Sport": [
                ""
            ],
            "Outlander": [
                "With 7 Passenger Seating",
                "Without 7 Passenger Seating"
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                ""
            ],
            "Cube": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Juke": [
                ""
            ],
            "LEAF": [
                ""
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                "Convertible",
                "Sport Utility"
            ],
            "NV1500": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                "4.0L"
            ],
            "Quest": [
                ""
            ],
            "Rogue": [
                ""
            ],
            "Sentra": [
                "S/SL/Base/SR",
                "SE-R",
                "SE-R Spec V"
            ],
            "TITAN": [
                ""
            ],
            "Versa": [
                "1.6L",
                "1.8L"
            ],
            "Xterra": [
                ""
            ]
        },
        "Porsche": {
            "Cayenne": [
                "S/Base/S Hybrid. With 350mm Diameter Front Rotor",
                "S/Base/S Hybrid. With 360mm Diameter Front Rotor"
            ]
        },
        "Ram": {
            "1500": [
                "With 5 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "2500": [
                ""
            ],
            "3500": [
                ""
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ],
            "xB": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                "Limited/Sport/Base/Sport Premium/Premium/Sport Limited/Touring",
                "WRX STI/WRX STI Limited",
                "WRX/WRX Premium"
            ],
            "Legacy": [
                "2.5L. With 292mm Diameter Front Rotor",
                "3.6L"
            ],
            "Outback": [
                "2.5L. With 292mm Diameter Front Rotor",
                "3.6L"
            ],
            "Tribeca": [
                ""
            ]
        },
        "Suzuki": {
            "Equator": [
                "2.5L and with",
                "4.0L"
            ],
            "Grand Vitara": [
                ""
            ],
            "Kizashi": [
                ""
            ],
            "SX4": [
                "",
                "Drum rear brakes"
            ],
            "SX4 Crossover": [
                ""
            ]
        },
        "Tesla": {
            "S": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                ""
            ],
            "FJ Cruiser": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Matrix": [
                "Base",
                "S and with AWD",
                "S and with FWD"
            ],
            "Prius": [
                ""
            ],
            "Prius C": [
                ""
            ],
            "Prius Plug-In": [
                ""
            ],
            "Prius V": [
                ""
            ],
            "RAV4": [
                "2.5L. With 3rd Row Seating",
                "2.5L. Without 3rd Row Seating",
                "3.5L"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ],
            "Yaris": [
                "L/LE",
                "SE"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "Naturally Aspirated. With 288mm Diameter Front Rotor",
                "Turbocharged. With 312mm Diameter Front Rotor"
            ],
            "CC": [
                "2.0L. With 312mm Diameter Front Rotor and To Chassis/VIN #3C-C-550000",
                "2.0L. With 340mm Diameter Front Rotor",
                "2.0L. With 345mm Diameter Front Rotor and To Chassis/VIN #3C-C-550000",
                "3.6L. With 312mm Diameter Front Rotor and To Chassis/VIN #3C-C-550000",
                "3.6L. With 340mm Diameter Front Rotor",
                "3.6L. With 345mm Diameter Front Rotor and To Chassis/VIN #3C-C-550000"
            ],
            "Golf R": [
                ""
            ],
            "GTI": [
                ""
            ],
            "Jetta": [
                "Drum rear brakes. With 280mm Diameter Front Rotor",
                "Drum rear brakes. With 288mm Diameter Front Rotor",
                "Drum rear brakes. With 312mm Diameter Front Rotor",
                "With 280mm Diameter Front Rotor",
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "Passat": [
                ""
            ],
            "Routan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Tiguan": [
                "S/SE/SEL"
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C30": [
                ""
            ],
            "C70": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "XC60": [
                ""
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2013": {
        "Acura": {
            "ILX": [
                "1.5L",
                "2.0L",
                "2.4L"
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "TL": [
                ""
            ],
            "TSX": [
                ""
            ],
            "ZDX": [
                ""
            ]
        },
        "Audi": {
            "A4": [
                ""
            ],
            "A4 allroad": [
                ""
            ],
            "A6": [
                "With 320mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "allroad": [
                ""
            ],
            "Q5": [
                "FLEX engine",
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS/DIESEL engine"
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S8": [
                "With Cast Iron Disc",
                "With Ceramic Composite Brakes"
            ],
            "TTS Quattro": [
                ""
            ]
        },
        "BMW": {
            "128i": [
                ""
            ],
            "135i": [
                ""
            ],
            "135is": [
                ""
            ],
            "320i": [
                ""
            ],
            "320i xDrive": [
                ""
            ],
            "328i": [
                "Convertible and with 3.0L. With 330mm Diameter Front Rotor",
                "Convertible and with 3.0L. With 340mm Diameter Front Rotor",
                "Coupe and with 3.0L. With 330mm Diameter Front Rotor",
                "Coupe and with 3.0L. With 340mm Diameter Front Rotor"
            ],
            "335i xDrive": [
                "Coupe"
            ],
            "335is": [
                ""
            ],
            "528i": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "528i xDrive": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "535i GT": [
                ""
            ],
            "535i GT xDrive": [
                ""
            ],
            "535i": [
                "With 330mm Diameter Rear Rotor",
                "With 345mm Diameter Rear Rotor"
            ],
            "535i xDrive": [
                ""
            ],
            "550i": [
                ""
            ],
            "550i GT": [
                ""
            ],
            "550i GT xDrive": [
                ""
            ],
            "550i xDrive": [
                ""
            ],
            "640i": [
                ""
            ],
            "640i Gran Coupe": [
                ""
            ],
            "650i": [
                ""
            ],
            "650i Gran Coupe": [
                ""
            ],
            "650i xDrive": [
                ""
            ],
            "650i xDrive Gran Coupe": [
                ""
            ],
            "740i": [
                ""
            ],
            "740Li": [
                ""
            ],
            "740Li xDrive": [
                ""
            ],
            "750i": [
                ""
            ],
            "750i xDrive": [
                ""
            ],
            "750Li": [
                ""
            ],
            "750Li xDrive": [
                ""
            ],
            "ActiveHybrid 5": [
                ""
            ],
            "ActiveHybrid 7": [
                ""
            ],
            "X1": [
                "xDrive28i",
                "xDrive35i"
            ],
            "X3": [
                ""
            ],
            "X5": [
                "xDrive35i",
                "xDrive50i"
            ],
            "X6": [
                "xDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "Encore": [
                ""
            ],
            "Verano": [
                ""
            ]
        },
        "Cadillac": {
            "ATS": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "Escalade": [
                ""
            ],
            "Escalade ESV": [
                ""
            ],
            "Escalade EXT": [
                ""
            ],
            "SRX": [
                ""
            ],
            "XTS": [
                "With 6 Lug Wheels and With Heavy Duty Brakes",
                "Without Heavy Duty Brakes and With 5 Lug Wheels"
            ]
        },
        "Chevrolet": {
            "Avalanche": [
                ""
            ],
            "Camaro": [
                "LT/LS",
                "SS"
            ],
            "Captiva Sport": [
                ""
            ],
            "Corvette": [
                "Base. With Heavy Duty Brakes",
                "Base. Without Heavy Duty Brakes"
            ],
            "Cruze": [
                "",
                "With 268mm Diameter Rear Rotor",
                "With 292mm Diameter Rear Rotor"
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                ""
            ],
            "Impala": [
                "With Police Package",
                "Without Police Package"
            ],
            "Malibu": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Orlando": [
                ""
            ],
            "Silverado 1500": [
                "",
                "With 6400 Lb GVW",
                "With 7000 Lb GVW"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                "LT/LTZ/LS",
                "RS"
            ],
            "Spark": [
                "Without Hub Assembly"
            ],
            "Suburban 1500": [
                ""
            ],
            "Suburban 2500": [
                ""
            ],
            "Tahoe": [
                "Without Police Package"
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                ""
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "5.7L",
                "6.4L",
                "AWD and with 3.6L",
                "RWD and with 3.6L"
            ],
            "Town and Country": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ]
        },
        "Dodge": {
            "Challenger": [
                "5.7L",
                "6.4L"
            ],
            "Charger": [
                "5.7L. With Police Package",
                "5.7L. Without Police Package",
                "6.4L",
                "AWD and with 3.6L",
                "RWD and with 3.6L"
            ],
            "Dart": [
                ""
            ],
            "Grand Caravan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Journey": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ]
        },
        "Fiat": {
            "500": [
                "BATTERY EV (EV/BEV) engine",
                "Naturally Aspirated and with GAS engine",
                "Turbocharged and with GAS engine"
            ]
        },
        "Ford": {
            "C-Max": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "PLUG-IN HYBRID EV-GAS (PHEV) engine"
            ],
            "E-150": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Edge": [
                ""
            ],
            "Escape": [
                "2.0L",
                "2.5L",
                "AWD and with 1.6L",
                "FWD and with 1.6L"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                "Limited/Base/XLT. With Heavy Duty Brakes",
                "Limited/Sport/Base/XLT. Without Heavy Duty Brakes",
                "Sport. With Heavy Duty Brakes"
            ],
            "F-150": [
                "With 6 Lug Wheels",
                "With 7 Lug Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "Platinum and with RWD and 6.2L. With Single Rear Wheels",
                "Platinum and with RWD and 6.7L. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "XL/XLT/King Ranch/Lariat and with RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "From 16000 Lb to 22000 Lb GVW"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-59 Commercial Stripped Chassis": [
                "With Under 24000 Lb GVW"
            ],
            "Fiesta": [
                "S/SES/Titanium/SE"
            ],
            "Flex": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Focus": [
                "S/Titanium/Electric/SE",
                "S/Titanium/Electric/SE. FMSI=1004",
                "ST. With 320mm Diameter Rotor",
                "ST. With 335mm Diameter Rotor"
            ],
            "Fusion": [
                "Energi SE/Energi Titanium",
                "S/Titanium/SE Hybrid/Titanium Hybrid/SE"
            ],
            "Mustang": [
                "Boss 302"
            ],
            "Police Interceptor Sedan": [
                ""
            ],
            "Police Interceptor Utility": [
                ""
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "",
                "With 6400 Lb GVW",
                "With 7000 Lb GVW"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                ""
            ],
            "Yukon": [
                ""
            ],
            "Yukon XL 1500": [
                ""
            ],
            "Yukon XL 2500": [
                ""
            ]
        },
        "Honda": {
            "Accord": [
                "EX-L and with 2.4L",
                "EX-L and with 3.5L",
                "LX",
                "Sport/EX",
                "Touring"
            ],
            "Civic": [
                "EX/EX-L/Touring",
                "Hybrid-L/Hybrid",
                "LX and with Automatic transmission",
                "LX and with Manual transmission",
                "Si"
            ],
            "CR-V": [
                "AWD",
                "FWD"
            ],
            "CR-Z": [
                ""
            ],
            "Crosstour": [
                ""
            ],
            "Fit": [
                "DX",
                "DX and with GAS engine",
                "EV",
                "EV and with BATTERY EV (EV/BEV) engine",
                "LX/Sport/Base",
                "LX/Sport/Base and with GAS engine"
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                ""
            ],
            "Elantra": [
                ""
            ],
            "Elantra Coupe": [
                ""
            ],
            "Elantra GT": [
                ""
            ],
            "Equus": [
                ""
            ],
            "Genesis": [
                "3.8L",
                "5.0L"
            ],
            "Genesis Coupe": [
                "With 4 Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Santa Fe": [
                "3.3L"
            ],
            "Santa Fe Sport": [
                "2.4L/2.0L"
            ],
            "Santa Fe XL": [
                "3.3L"
            ],
            "Sonata": [
                ""
            ],
            "Tucson": [
                "AWD",
                "FWD"
            ],
            "Veloster": [
                "Naturally Aspirated",
                "Turbocharged"
            ]
        },
        "INFINITI": {
            "EX37": [
                ""
            ],
            "FX37": [
                ""
            ],
            "FX50": [
                "With Dual Piston Caliper"
            ],
            "G37": [
                "AWD. With Brembo Brakes",
                "Convertible/Coupe and with RWD. Without Brembo Brakes",
                "RWD. With Brembo Brakes",
                "Sedan and with AWD. Without Brembo Brakes",
                "Sedan and with RWD. Without Brembo Brakes"
            ],
            "JX35": [
                ""
            ],
            "M35h": [
                "With Dual Piston Caliper"
            ],
            "M37": [
                "With Dual Piston Caliper"
            ],
            "M56": [
                "With Dual Piston Caliper"
            ],
            "QX56": [
                ""
            ]
        },
        "Jaguar": {
            "XF": [
                "2.0L",
                "3.0L",
                "5.0L. With 380mm Diameter Front Rotor"
            ],
            "XFR": [
                ""
            ],
            "XFR-S": [
                ""
            ],
            "XJ": [
                "5.0L and with Supercharged",
                "Naturally Aspirated"
            ],
            "XK": [
                ""
            ],
            "XKR": [
                "5.0L. Without Alcon Brakes"
            ],
            "XKR-S": [
                "With 380mm Diameter Front Rotor and Without Alcon Brakes",
                "Without Alcon Brakes and With 380mm Diameter Front Rotor"
            ]
        },
        "Jeep": {
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Wrangler": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ]
        },
        "Kia": {
            "Forte": [
                "2.0L",
                "2.4L"
            ],
            "Forte Koup": [
                "2.0L",
                "2.4L"
            ],
            "Forte5": [
                "With 280mm Diameter Front Rotor",
                "With 300mm Diameter Front Rotor"
            ],
            "Optima": [
                "2.0L. With Electric Parking Brake",
                "2.0L. With Manual Parking Brake",
                "2.4L. With Electric Parking Brake",
                "2.4L. With Manual Parking Brake"
            ],
            "Rio": [
                "LX/EX/LX+",
                "SX"
            ],
            "Sorento": [
                ""
            ],
            "Soul": [
                ""
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR4": [
                ""
            ],
            "Range Rover": [
                ""
            ],
            "Range Rover Evoque": [
                ""
            ],
            "Range Rover Sport": [
                "Naturally Aspirated",
                "Supercharged"
            ]
        },
        "Lexus": {
            "CT200h": [
                "With 259mm Diameter Rear Rotor",
                "With 279mm Diameter Rear Rotor"
            ],
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GS350": [
                "Base",
                "F Sport and with AWD"
            ],
            "GS450h": [
                "With 334mm Diameter Front Rotor"
            ],
            "GX460": [
                ""
            ],
            "IS250": [
                "C. Vehicles Built For Canadian Market",
                "C. Vehicles Built For USA Market"
            ],
            "IS350": [
                "C/Base. Vehicles Built For Canadian Market",
                "C/Base. Vehicles Built For USA Market"
            ],
            "LS460": [
                "L and with AWD"
            ],
            "LS600h": [
                ""
            ],
            "LX570": [
                ""
            ],
            "RX350": [
                ""
            ],
            "RX450h": [
                ""
            ]
        },
        "Lincoln": {
            "MKS": [
                ""
            ],
            "MKX": [
                ""
            ],
            "MKZ": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS engine"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "2": [
                ""
            ],
            "3": [
                "2.0L",
                "2.5L",
                "Mazdaspeed and with 2.3L"
            ],
            "3 Sport": [
                "GS-SKY and with 2.0L",
                "GT and with 2.5L",
                "GX and with 2.0L"
            ],
            "5": [
                ""
            ],
            "6": [
                ""
            ],
            "CX-5": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "B250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C300": [
                "4Matic and with",
                "4Matic Sport/4Matic Luxury"
            ],
            "C350": [
                ""
            ],
            "CL550": [
                ""
            ],
            "CL600": [
                ""
            ],
            "CLS550": [
                ""
            ],
            "E350": [
                "Convertible/Coupe. With 322mm Diameter Front Rotor",
                "Sedan. With 322mm Diameter Front Rotor"
            ],
            "E400": [
                "Hybrid. With 322mm Diameter Front Rotor"
            ],
            "GL350": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "GLK250": [
                ""
            ],
            "GLK350": [
                ""
            ],
            "ML350": [
                "Without Sport Package"
            ],
            "S550": [
                "AWD. With 350mm Diameter Front Rotor"
            ],
            "S600": [
                "",
                "Armored Vehicle"
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ]
        },
        "Mini": {
            "Cooper Paceman": [
                "Base. With 280mm Diameter Rear Rotor",
                "Base. With 296mm Diameter Rear Rotor",
                "S/S ALL4. With 280mm Diameter Rear Rotor",
                "S/S ALL4. With 296mm Diameter Rear Rotor"
            ]
        },
        "Mitsubishi": {
            "Lancer": [
                "DE and with Drum rear brakes",
                "ES/SE Sportback/ES Sportback/SE",
                "Evolution MR/Evolution GSR",
                "GT Sportback/GT",
                "Ralliart"
            ],
            "Outlander": [
                "2.4L",
                "3.0L"
            ],
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                "Coupe",
                "Sedan"
            ],
            "Armada": [
                ""
            ],
            "Cube": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Juke": [
                ""
            ],
            "LEAF": [
                ""
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Quest": [
                ""
            ],
            "Rogue": [
                ""
            ],
            "Sentra": [
                ""
            ],
            "TITAN": [
                ""
            ],
            "Versa": [
                "1.6L"
            ],
            "Xterra": [
                ""
            ]
        },
        "Porsche": {
            "Cayenne": [
                "With 350mm Diameter Front Rotor",
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                ""
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ]
        },
        "Scion": {
            "iQ": [
                "EV"
            ],
            "tC": [
                ""
            ],
            "xB": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                "Limited/Sport/Base/Sport Premium/Premium/Sport Limited/Touring",
                "WRX STI/WRX STI Limited",
                "WRX/WRX Limited/WRX Premium"
            ],
            "Legacy": [
                "2.5L. With 292mm Diameter Front Rotor",
                "3.6L"
            ],
            "Outback": [
                "2.5L. With 292mm Diameter Front Rotor",
                "3.6L"
            ],
            "Tribeca": [
                ""
            ],
            "WRX": [
                ""
            ],
            "WRX STI": [
                ""
            ],
            "XV Crosstrek": [
                "With 292mm Diameter Front Rotor"
            ]
        },
        "Suzuki": {
            "Grand Vitara": [
                ""
            ],
            "Kizashi": [
                ""
            ],
            "SX4": [
                ""
            ]
        },
        "Tesla": {
            "S": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                ""
            ],
            "FJ Cruiser": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                ""
            ],
            "Matrix": [
                "Base",
                "S and with AWD",
                "S and with FWD"
            ],
            "Prius": [
                ""
            ],
            "Prius C": [
                ""
            ],
            "Prius Plug-In": [
                ""
            ],
            "Prius V": [
                ""
            ],
            "RAV4": [
                "LE",
                "Limited/EV/XLE"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ],
            "Yaris": [
                "L/LE",
                "SE"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "2.5L. With 253mm Diameter Rear Rotor",
                "2.5L. With 272mm Diameter Rear Rotor"
            ],
            "CC": [
                "AWD",
                "FWD"
            ],
            "Golf R": [
                ""
            ],
            "Passat": [
                ""
            ],
            "Routan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Tiguan": [
                ""
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C30": [
                ""
            ],
            "C70": [
                "With 300mm Diameter Front Rotor",
                "With 320mm Diameter Front Rotor"
            ],
            "S60": [
                "With 300mm Diameter Front Rotor",
                "With 316mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ],
            "XC60": [
                ""
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2014": {
        "Acura": {
            "ILX": [
                "1.5L",
                "2.0L",
                "2.4L"
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "RLX": [
                "Base",
                "Sport Hybrid SH-AWD"
            ],
            "TL": [
                ""
            ],
            "TSX": [
                ""
            ]
        },
        "Audi": {
            "A4": [
                ""
            ],
            "A4 Quattro": [
                ""
            ],
            "A5": [
                ""
            ],
            "A5 Quattro": [
                ""
            ],
            "A6 Quattro": [
                "2.0L. With 345mm Diameter Front Rotor",
                "With 356mm Diameter Front Rotor"
            ],
            "A6": [
                "With 345mm Diameter Front Rotor",
                "With 356mm Diameter Front Rotor"
            ],
            "A7 Quattro": [
                "With 345mm Diameter Front Rotor",
                "With 356mm Diameter Front Rotor"
            ],
            "allroad": [
                ""
            ],
            "Q5": [
                "FLEX engine",
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS/DIESEL engine"
            ],
            "Q7": [
                ""
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S8": [
                "With Cast Iron Disc",
                "With Ceramic Composite Brakes"
            ],
            "SQ5": [
                "With 380mm Diameter Front Rotor"
            ],
            "TTS Quattro": [
                ""
            ]
        },
        "BMW": {
            "320i": [
                ""
            ],
            "320i xDrive": [
                ""
            ],
            "328d": [
                "With 312mm Diameter Front Rotor"
            ],
            "528i": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "528i xDrive": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "535d": [
                ""
            ],
            "535d xDrive": [
                ""
            ],
            "535i": [
                ""
            ],
            "535i GT": [
                ""
            ],
            "535i GT xDrive": [
                ""
            ],
            "535i xDrive": [
                ""
            ],
            "550i": [
                ""
            ],
            "550i GT": [
                ""
            ],
            "550i GT xDrive": [
                ""
            ],
            "550i xDrive": [
                ""
            ],
            "640i": [
                ""
            ],
            "640i Gran Coupe": [
                ""
            ],
            "640i xDrive": [
                ""
            ],
            "640i xDrive Gran Coupe": [
                ""
            ],
            "650i": [
                ""
            ],
            "650i Gran Coupe": [
                ""
            ],
            "650i xDrive": [
                ""
            ],
            "650i xDrive Gran Coupe": [
                ""
            ],
            "740i": [
                ""
            ],
            "740Li": [
                ""
            ],
            "740Li xDrive": [
                ""
            ],
            "750i": [
                ""
            ],
            "750i xDrive": [
                ""
            ],
            "750Li": [
                ""
            ],
            "750Li xDrive": [
                ""
            ],
            "ActiveHybrid 5": [
                ""
            ],
            "ActiveHybrid 7": [
                ""
            ],
            "i3": [
                ""
            ],
            "M235i": [
                "With 340mm Diameter Front Rotor"
            ],
            "X1": [
                "xDrive28i"
            ],
            "X3": [
                ""
            ],
            "X5": [
                "xDrive35i/sDrive35i",
                "xDrive50i. Without M Performance Brakes"
            ],
            "X6": [
                "xDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "Encore": [
                ""
            ],
            "Verano": [
                ""
            ]
        },
        "Cadillac": {
            "ATS": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "CTS": [
                "Luxury and with 3.0L. Without Heavy Duty Brakes",
                "Luxury and with Wagon and 3.0L. With Heavy Duty Brakes",
                "Performance and with Wagon/Coupe and 3.6L. With Heavy Duty Brakes",
                "Premium/Performance and with Wagon/Coupe and 3.6L. Without Heavy Duty Brakes"
            ],
            "Escalade": [
                ""
            ],
            "Escalade ESV": [
                ""
            ],
            "SRX": [
                ""
            ],
            "XTS": [
                "With 6 Lug Wheels and With Heavy Duty Brakes",
                "Without Heavy Duty Brakes and With 5 Lug Wheels"
            ]
        },
        "Chevrolet": {
            "Camaro": [
                "LT/LS",
                "SS"
            ],
            "Captiva Sport": [
                ""
            ],
            "Cruze": [
                "DIESEL engine",
                "GAS engine",
                "GAS engine and with Drum rear brakes"
            ],
            "Equinox": [
                ""
            ],
            "Express 1500": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Impala Limited": [
                "LT/LTZ/LS",
                "Police"
            ],
            "Malibu": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Orlando": [
                ""
            ],
            "Silverado 1500": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                "LT/LTZ/LS",
                "RS"
            ],
            "Spark EV": [
                ""
            ],
            "Spark": [
                "Without Hub Assembly"
            ],
            "Suburban 1500": [
                ""
            ],
            "Tahoe": [
                "Without Police Package"
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                ""
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "5.7L",
                "6.4L",
                "AWD and with 3.6L",
                "RWD and with 3.6L"
            ],
            "Town and Country": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ]
        },
        "Dodge": {
            "Challenger": [
                "5.7L",
                "6.4L"
            ],
            "Charger": [
                "6.4L",
                "AWD and with 3.6L. With 345mm Diameter Front Rotor",
                "AWD and with 3.6L. With 370mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L",
                "RWD and with 3.6L",
                "RWD and with 3.6L. With 370mm Diameter Front Rotor",
                "RWD and with 6.4L. With 370mm Diameter Front Rotor"
            ],
            "Dart": [
                ""
            ],
            "Grand Caravan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Journey": [
                ""
            ]
        },
        "Fiat": {
            "500": [
                "BATTERY EV (EV/BEV) engine",
                "Naturally Aspirated and with GAS engine",
                "Turbocharged and with GAS engine"
            ],
            "500L": [
                ""
            ]
        },
        "Ford": {
            "C-Max": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "PLUG-IN HYBRID EV-GAS (PHEV) engine"
            ],
            "E-150": [
                ""
            ],
            "E-250": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Edge": [
                ""
            ],
            "Escape": [
                "2.0L",
                "2.5L",
                "AWD and with 1.6L",
                "FWD and with 1.6L"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "F-150": [
                "With 6 Lug Wheels",
                "With 7 Lug Wheels"
            ],
            "F-250 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "From 16000 Lb to 22000 Lb GVW"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-59 Commercial Stripped Chassis": [
                "With Under 24000 Lb GVW"
            ],
            "Fiesta": [
                "S/Titanium/SE",
                "ST"
            ],
            "Flex": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Focus": [
                "S/Titanium/Electric/SE",
                "S/Titanium/Electric/SE. FMSI=1004",
                "ST. With 320mm Diameter Rotor",
                "ST. With 335mm Diameter Rotor"
            ],
            "Fusion": [
                "Energi SE/Energi Titanium",
                "S/Titanium/S Hybrid/SE Hybrid/Titanium Hybrid/SE"
            ],
            "Mustang": [
                "Base and with Automatic transmission. With Performance Brakes",
                "Base and with Manual transmission. With Performance Brakes"
            ],
            "Police Interceptor Sedan": [
                ""
            ],
            "Police Interceptor Utility": [
                ""
            ],
            "Special Service Police Sedan": [
                ""
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO"
            ],
            "Transit Connect": [
                "104.8\" wheel base",
                "120.6\" wheel base"
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Savana 1500": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                ""
            ],
            "Yukon": [
                ""
            ],
            "Yukon XL 1500": [
                ""
            ]
        },
        "Honda": {
            "Accord": [
                "EX-L/Touring and with 2.4L",
                "EX-L/Touring and with 3.5L",
                "Sport/EX/Hybrid Touring/Hybrid"
            ],
            "Civic": [
                "EX/EX-L",
                "Hybrid",
                "Hybrid-L/Hybrid",
                "LX and with Automatic CVT transmission",
                "LX and with Manual transmission",
                "Si",
                "Touring"
            ],
            "CR-V": [
                "AWD",
                "FWD"
            ],
            "CR-Z": [
                ""
            ],
            "Crosstour": [
                ""
            ],
            "Fit": [
                "EV",
                "EV and with BATTERY EV (EV/BEV) engine"
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                ""
            ],
            "Elantra": [
                ""
            ],
            "Elantra Coupe": [
                ""
            ],
            "Elantra GT": [
                ""
            ],
            "Equus": [
                ""
            ],
            "Genesis": [
                "3.8L",
                "5.0L"
            ],
            "Genesis Coupe": [
                "2.0T/2.0T Premium/3.8 Grand Touring",
                "2.0T R-Spec/3.8 R-Spec/3.8 Ultimate"
            ],
            "Santa Fe": [
                "3.3L"
            ],
            "Santa Fe Sport": [
                "2.4L/2.0L"
            ],
            "Santa Fe XL": [
                "3.3L"
            ],
            "Sonata": [
                ""
            ],
            "Tucson": [
                "AWD",
                "FWD"
            ],
            "Veloster": [
                "Naturally Aspirated",
                "Turbocharged"
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q60": [
                "Sport/Premium Sport/Premium. With Single Piston Caliper",
                "With Single Piston Caliper"
            ],
            "Q70": [
                "With Dual Piston Caliper"
            ],
            "QX50": [
                ""
            ],
            "QX60": [
                ""
            ],
            "QX70": [
                "With Dual Piston Caliper"
            ],
            "QX80": [
                ""
            ]
        },
        "Jaguar": {
            "XF": [
                "3.0L",
                "5.0L. With 380mm Diameter Front Rotor"
            ],
            "XFR": [
                ""
            ],
            "XFR-S": [
                ""
            ],
            "XJ": [
                "Supercharged/L Supercharged and with 5.0L"
            ],
            "XJR": [
                ""
            ],
            "XK": [
                ""
            ],
            "XKR-S": [
                "Base. Without Alcon Brakes and With 380mm Diameter Front Rotor"
            ],
            "XKR": [
                "Without Alcon Brakes and With 380mm Diameter Front Rotor"
            ]
        },
        "Jeep": {
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Wrangler": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ]
        },
        "Kia": {
            "Cadenza": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Forte Koup": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Forte": [
                "With 280mm Diameter Front Rotor",
                "With 300mm Diameter Front Rotor"
            ],
            "Forte5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Optima": [
                "2.0L. With Electric Parking Brake",
                "2.0L. With Manual Parking Brake",
                "2.4L. With Electric Parking Brake",
                "2.4L. With Manual Parking Brake"
            ],
            "Rio": [
                "LX/EX",
                "SX"
            ],
            "Rondo": [
                "With Electric Parking Brake",
                "With Electric Parking Brake or With Manual Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                "With Plain Caliper",
                "With Red Painted Calipers"
            ],
            "Soul": [
                ""
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "LR4": [
                ""
            ],
            "Range Rover": [
                "3.0L",
                "5.0L"
            ],
            "Range Rover Evoque": [
                ""
            ],
            "Range Rover Sport": [
                "3.0L",
                "5.0L"
            ]
        },
        "Lexus": {
            "CT200h": [
                ""
            ],
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GS350": [
                "Base/F Sport and with AWD"
            ],
            "GS450h": [
                "With 334mm Diameter Front Rotor"
            ],
            "GX460": [
                ""
            ],
            "IS250": [
                "Base and with AWD",
                "Base and with RWD. With F Sport Package",
                "Base and with RWD. Without F Sport Package",
                "C/C F Sport"
            ],
            "IS350": [
                "Base and with AWD. With F Sport Package",
                "Base and with RWD. With F Sport Package",
                "Base. Without F Sport Package",
                "C/C F Sport",
                "F Sport and with AWD",
                "F Sport and with RWD"
            ],
            "LS460": [
                "L and with AWD"
            ],
            "LS600h": [
                ""
            ],
            "LX570": [
                ""
            ],
            "RX350": [
                ""
            ],
            "RX450h": [
                ""
            ]
        },
        "Lincoln": {
            "MKS": [
                ""
            ],
            "MKX": [
                ""
            ],
            "MKZ": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS engine"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "2": [
                ""
            ],
            "5": [
                ""
            ],
            "6": [
                "i/Grand Touring"
            ],
            "CX-5": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "B Electric Drive": [
                ""
            ],
            "B250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C300": [
                "4Matic Sport/4Matic Luxury/4Matic"
            ],
            "C350": [
                ""
            ],
            "CL550": [
                ""
            ],
            "CLA250": [
                "AWD. With Sport Package",
                "FWD/AWD. Without Sport Package"
            ],
            "CLS550": [
                ""
            ],
            "E250": [
                "With 322mm Diameter Front Rotor"
            ],
            "E350": [
                "Convertible/Coupe. With 322mm Diameter Front Rotor",
                "Sedan. With 322mm Diameter Front Rotor"
            ],
            "E400": [
                "Hybrid. With 322mm Diameter Front Rotor"
            ],
            "GL350": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "GL450": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "GL550": [
                "With AMG Package"
            ],
            "GLK250": [
                ""
            ],
            "GLK350": [
                ""
            ],
            "ML350": [
                "Without Sport Package"
            ],
            "ML550": [
                "With Sport Package"
            ],
            "ML63 AMG": [
                "With Armored Body and With AMG Package"
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ]
        },
        "Mini": {
            "Cooper Countryman": [
                "Base. With 280mm Diameter Rear Rotor",
                "S ALL4. With 280mm Diameter Rear Rotor"
            ],
            "Cooper Paceman": [
                "Base. With 280mm Diameter Rear Rotor",
                "S/S ALL4. With 280mm Diameter Rear Rotor"
            ]
        },
        "Mitsubishi": {
            "Lancer": [
                "DE and with Drum rear brakes",
                "ES/ES Sportback/SE",
                "Evolution MR/Evolution GSR",
                "GT Sportback/GT",
                "Ralliart"
            ],
            "Outlander": [
                "ES/SE"
            ],
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                ""
            ],
            "Cube": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Juke": [
                "Nismo RS",
                "S/SL/Nismo/SV"
            ],
            "LEAF": [
                "Excluding Vehicles Manufactured In Japan",
                "Vehicles Manufactured In Japan"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Quest": [
                ""
            ],
            "Rogue Select": [
                ""
            ],
            "Rogue": [
                "With 3rd Row Seating",
                "Without 3rd Row Seating"
            ],
            "Sentra": [
                ""
            ],
            "TITAN": [
                ""
            ],
            "Versa": [
                ""
            ],
            "Versa Note": [
                ""
            ],
            "Xterra": [
                ""
            ]
        },
        "Porsche": {
            "Cayenne": [
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                ""
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "ProMaster 1500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 2500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 3500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ]
        },
        "Scion": {
            "tC": [
                ""
            ],
            "xB": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "2.0L",
                "2.5L. With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                "Limited/Sport/Base/Sport Premium/Premium/Sport Limited/Touring",
                "WRX STI/WRX STI Limited",
                "WRX/WRX Limited/WRX Premium"
            ],
            "Legacy": [
                "2.5L. With 292mm Diameter Front Rotor",
                "3.6L"
            ],
            "Outback": [
                "2.5L. With 292mm Diameter Front Rotor",
                "3.6L"
            ],
            "Tribeca": [
                ""
            ],
            "WRX STI": [
                ""
            ],
            "WRX": [
                "With 15\" Factory Wheels",
                "With 17\" Factory Wheels"
            ],
            "XV Crosstrek": [
                "With 292mm Diameter Front Rotor"
            ]
        },
        "Tesla": {
            "S": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                ""
            ],
            "FJ Cruiser": [
                ""
            ],
            "Highlander": [
                "GAS engine",
                "Hybrid LE/Hybrid XLE and with FULL HYBRID EV-GAS (FHEV) engine",
                "Hybrid Limited and with FULL HYBRID EV-GAS (FHEV) engine"
            ],
            "Land Cruiser": [
                ""
            ],
            "Matrix": [
                "With 259mm Diameter Rear Rotor",
                "With 279mm Diameter Rear Rotor"
            ],
            "Prius": [
                ""
            ],
            "Prius C": [
                ""
            ],
            "Prius Plug-In": [
                ""
            ],
            "Prius V": [
                ""
            ],
            "RAV4": [
                "LE",
                "Limited/EV/XLE"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ],
            "Yaris": [
                "Disc rear brakes",
                "Drum rear brakes",
                "L/LE and with Drum rear brakes. From 04/14",
                "L/LE and with Drum rear brakes. To 03/14"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "Base/Sportline/Highline/Comfortline/Highline TDI/Comfortline TDI/TDI. With 253mm Diameter Rear Rotor",
                "Base/Sportline/Highline/Comfortline/Highline TDI/Comfortline TDI/TDI. With 272mm Diameter Rear Rotor",
                "R-Line/GSR. With 253mm Diameter Rear Rotor",
                "R-Line/GSR. With 272mm Diameter Rear Rotor"
            ],
            "CC": [
                "4 Motion and with AWD and 3.6L",
                "AWD",
                "FWD"
            ],
            "Passat": [
                ""
            ],
            "Routan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Tiguan": [
                ""
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "S60": [
                "With 300mm Diameter Front Rotor",
                "With 316mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ],
            "XC60": [
                ""
            ],
            "XC90": [
                "With 316mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor",
                "With 336mm Diameter Front Rotor"
            ]
        }
    },
    "2015": {
        "Acura": {
            "ILX": [
                "1.5L",
                "2.0L",
                "2.4L"
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "RLX": [
                "Base/Tech/Elite",
                "Sport Hybrid SH-AWD"
            ],
            "TLX": [
                ""
            ]
        },
        "Audi": {
            "A3": [
                "1.8L",
                "2.0L. To 03/16/15"
            ],
            "A3 Quattro": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "A4": [
                ""
            ],
            "A4 Quattro": [
                ""
            ],
            "A5": [
                ""
            ],
            "A5 Quattro": [
                ""
            ],
            "A6": [
                ""
            ],
            "A6 Quattro": [
                "With 345mm Diameter Front Rotor",
                "With 356mm Diameter Front Rotor"
            ],
            "A7 Quattro": [
                "With 345mm Diameter Front Rotor",
                "With 356mm Diameter Front Rotor"
            ],
            "allroad": [
                ""
            ],
            "Q3": [
                ""
            ],
            "Q3 Quattro": [
                ""
            ],
            "Q5": [
                "FLEX engine",
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS/DIESEL engine"
            ],
            "Q7": [
                ""
            ],
            "S3": [
                ""
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S8": [
                "With Cast Iron Disc",
                "With Ceramic Composite Brakes"
            ],
            "SQ5": [
                "With 380mm Diameter Front Rotor"
            ],
            "TTS Quattro": [
                ""
            ]
        },
        "BMW": {
            "320i": [
                ""
            ],
            "320i xDrive": [
                ""
            ],
            "328d": [
                "With 312mm Diameter Front Rotor"
            ],
            "528i": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "528i xDrive": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "535d": [
                ""
            ],
            "535d xDrive": [
                ""
            ],
            "535i": [
                ""
            ],
            "535i GT": [
                ""
            ],
            "535i GT xDrive": [
                ""
            ],
            "535i xDrive": [
                ""
            ],
            "550i": [
                ""
            ],
            "550i GT": [
                ""
            ],
            "550i GT xDrive": [
                ""
            ],
            "550i xDrive": [
                ""
            ],
            "640i": [
                ""
            ],
            "640i Gran Coupe": [
                ""
            ],
            "640i xDrive": [
                ""
            ],
            "640i xDrive Gran Coupe": [
                ""
            ],
            "650i": [
                ""
            ],
            "650i Gran Coupe": [
                ""
            ],
            "650i xDrive": [
                ""
            ],
            "650i xDrive Gran Coupe": [
                ""
            ],
            "740i": [
                ""
            ],
            "740Li": [
                ""
            ],
            "740Li xDrive": [
                ""
            ],
            "750i": [
                ""
            ],
            "750i xDrive": [
                ""
            ],
            "750Li": [
                ""
            ],
            "750Li xDrive": [
                ""
            ],
            "ActiveHybrid 5": [
                ""
            ],
            "ActiveHybrid 7": [
                ""
            ],
            "i3": [
                ""
            ],
            "M235i": [
                "With 340mm Diameter Front Rotor"
            ],
            "M235i xDrive": [
                "With 340mm Diameter Front Rotor"
            ],
            "X1": [
                "xDrive28i/sDrive28i"
            ],
            "X3": [
                ""
            ],
            "X4": [
                ""
            ],
            "X5": [
                "xDrive35i/sDrive35i",
                "xDrive50i"
            ],
            "X6": [
                "xDrive35i/sDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "Encore": [
                ""
            ],
            "Verano": [
                ""
            ]
        },
        "Cadillac": {
            "ATS": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "CTS": [
                "Base/Premium/Luxury/Performance and with 2.0L. With 17\" Factory Wheels",
                "Base/Premium/Luxury/Performance and with 2.0L. With 18\" Factory Wheels",
                "Premium/Luxury/Performance and with 3.6L. With 17\" Factory Wheels",
                "Premium/Luxury/Performance and with 3.6L. With 18\" Factory Wheels",
                "Vsport/Vsport Premium and with 3.6L. With Performance Brake Lining",
                "Vsport/Vsport Premium and with 3.6L. Without Performance Brake Lining"
            ],
            "Escalade ESV": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "SRX": [
                ""
            ],
            "XTS": [
                "With 6 Lug Wheels and With Heavy Duty Brakes",
                "Without Heavy Duty Brakes and With 5 Lug Wheels"
            ]
        },
        "Chevrolet": {
            "Camaro": [
                "LT/LS",
                "SS"
            ],
            "Captiva Sport": [
                ""
            ],
            "City Express": [
                ""
            ],
            "Colorado": [
                ""
            ],
            "Cruze": [
                "DIESEL engine",
                "GAS engine",
                "GAS engine and with Drum rear brakes"
            ],
            "Equinox": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Impala Limited": [
                "LT/LTZ/LS",
                "Police"
            ],
            "Malibu": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Silverado 1500": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                ""
            ],
            "Spark": [
                "",
                "Without Hub Assembly"
            ],
            "Spark EV": [
                ""
            ],
            "Suburban": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Tahoe": [
                "Without Police Package and With 2 Piston Caliper",
                "Without Police Package and With 6 Piston Front Brembo Calipers"
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                ""
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "200": [
                "With 305mm Diameter Front Rotor",
                "With 330mm Diameter Front Rotor"
            ],
            "300": [
                "5.7L",
                "AWD and with 3.6L",
                "RWD and with 3.6L"
            ],
            "Town and Country": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ]
        },
        "Dodge": {
            "Challenger": [
                "R/T/SXT Plus/R/T Plus",
                "Scat Pack",
                "SRT Hellcat/SRT 392"
            ],
            "Charger": [
                "AWD and with 3.6L. With 345mm Diameter Front Rotor",
                "AWD and with 3.6L. With 370mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L. With 320mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L. With 345mm Diameter Front Rotor",
                "R/T Scat Pack and with 6.4L",
                "R/T Scat Pack and with RWD and 6.4L. With 370mm Diameter Front Rotor",
                "RWD and with 3.6L. With 320mm Diameter Front Rotor",
                "RWD and with 3.6L. With 345mm Diameter Front Rotor",
                "RWD and with 6.4L. With 370mm Diameter Front Rotor",
                "SRT 392 and with 6.4L",
                "SRT 392 and with RWD and 6.4L. With 370mm Diameter Front Rotor"
            ],
            "Dart": [
                ""
            ],
            "Grand Caravan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Journey": [
                ""
            ]
        },
        "Fiat": {
            "500": [
                "BATTERY EV (EV/BEV) engine",
                "Naturally Aspirated and with GAS engine",
                "Turbocharged and with GAS engine"
            ],
            "500L": [
                ""
            ]
        },
        "Ford": {
            "C-Max": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "PLUG-IN HYBRID EV-GAS (PHEV) engine"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "Edge": [
                "With 316mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Escape": [
                "2.0L",
                "2.5L",
                "AWD and with 1.6L",
                "FWD and with 1.6L"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                "Base. With Heavy Duty Brakes",
                "Base. Without Heavy Duty Brakes",
                "Limited/Sport/XLT. With Heavy Duty Brakes",
                "Limited/Sport/XLT. Without Heavy Duty Brakes"
            ],
            "F-150": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "F-250 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "Cab & Chassis and with RWD. With Dual Rear Wheels",
                "Cab & Chassis and with RWD. With Single Rear Wheels",
                "Standard Cab Pickup/Extended Cab Pickup/Crew Cab Pickup and with RWD. With Dual Rear Wheels",
                "Standard Cab Pickup/Extended Cab Pickup/Crew Cab Pickup and with RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-53 Motorhome Chassis": [
                "From 16000 Lb to 22000 Lb GVW"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-59 Commercial Stripped Chassis": [
                ""
            ],
            "Fiesta": [
                "S/Titanium/SE",
                "ST"
            ],
            "Flex": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Focus": [
                "S/Titanium/Electric/SE",
                "S/Titanium/Electric/SE. FMSI=1004",
                "ST. With 320mm Diameter Rotor",
                "ST. With 335mm Diameter Rotor"
            ],
            "Fusion": [
                "Energi SE/Energi Titanium",
                "S/Titanium/S Hybrid/SE Hybrid/Titanium Hybrid/SE"
            ],
            "Mustang": [
                "GT Premium/GT 50 Years Limited Edition/GT and with 5.0L. With Brembo Brakes",
                "GT Premium/GT and with 5.0L. Without Brembo Brakes",
                "V6 and with 3.7L. With Brembo Brakes",
                "V6 and with 3.7L. Without Brembo Brakes"
            ],
            "Police Interceptor Sedan": [
                ""
            ],
            "Police Interceptor Utility": [
                ""
            ],
            "Special Service Police Sedan": [
                ""
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO. With Performance Package"
            ],
            "Transit-150": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-250": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-350 HD": [
                "With 6 Lug Wheels"
            ],
            "Transit-350": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                ""
            ],
            "Yukon": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Yukon XL": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ]
        },
        "Honda": {
            "Accord": [
                "EX-L and with 2.4L",
                "EX-L and with 3.5L",
                "LX",
                "Sport/EX/Hybrid Touring/Hybrid",
                "Touring"
            ],
            "Civic": [
                "DX",
                "EX and with Coupe and Automatic CVT transmission",
                "EX and with Coupe and Manual transmission",
                "EX-L",
                "Hybrid-L/Hybrid",
                "LX and with Automatic CVT transmission",
                "LX and with Manual transmission",
                "Si",
                "Touring"
            ],
            "CR-V": [
                "AWD",
                "FWD"
            ],
            "CR-Z": [
                ""
            ],
            "Crosstour": [
                ""
            ],
            "Fit": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                ""
            ],
            "Elantra": [
                ""
            ],
            "Elantra GT": [
                ""
            ],
            "Equus": [
                ""
            ],
            "Genesis": [
                "3.8L",
                "5.0L"
            ],
            "Genesis Coupe": [
                "3.8/3.8 GT",
                "3.8 R-Spec/3.8 Ultimate"
            ],
            "Santa Fe": [
                "3.3L"
            ],
            "Santa Fe Sport": [
                "2.4L/2.0L"
            ],
            "Santa Fe XL": [
                "3.3L"
            ],
            "Sonata": [
                "FULL HYBRID EV-GAS (FHEV) engine. With Electric Parking Brake",
                "FULL HYBRID EV-GAS (FHEV) engine. With Manual Parking Brake",
                "GAS engine. With Electric Parking Brake",
                "GAS engine. With Manual Parking Brake"
            ],
            "Tucson": [
                "AWD and with GAS engine",
                "FWD and with FUEL CELL EV (FCEV) engine",
                "FWD and with GAS engine"
            ],
            "Veloster": [
                "Naturally Aspirated",
                "Turbocharged"
            ]
        },
        "INFINITI": {
            "Q40": [
                ""
            ],
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q60": [
                "With Single Piston Caliper"
            ],
            "Q70": [
                "With Dual Piston Caliper"
            ],
            "Q70L": [
                "With Dual Piston Caliper"
            ],
            "QX50": [
                ""
            ],
            "QX60": [
                ""
            ],
            "QX70": [
                "With Single Piston Caliper"
            ],
            "QX80": [
                ""
            ]
        },
        "Jaguar": {
            "XF": [
                "5.0L. With 380mm Diameter Front Rotor",
                "Sport/Portfolio and with 3.0L"
            ],
            "XFR": [
                ""
            ],
            "XFR-S": [
                ""
            ],
            "XJ": [
                "Base/L Portfolio and with 3.0L",
                "Supercharged/L Supercharged and with 5.0L"
            ],
            "XJR": [
                ""
            ],
            "XK": [
                ""
            ],
            "XKR-S": [
                "Without Alcon Brakes"
            ],
            "XKR": [
                "Without Alcon Brakes and With 380mm Diameter Front Rotor"
            ]
        },
        "Jeep": {
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Renegade": [
                ""
            ],
            "Wrangler": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ]
        },
        "Kia": {
            "Cadenza": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Forte Koup": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Forte": [
                "With 280mm Diameter Front Rotor",
                "With 300mm Diameter Front Rotor"
            ],
            "Forte5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "K900": [
                "5.0L"
            ],
            "Optima": [
                "2.0L. With Electric Parking Brake",
                "2.0L. With Manual Parking Brake",
                "2.4L. With Electric Parking Brake",
                "2.4L. With Manual Parking Brake"
            ],
            "Rio": [
                "LX/EX",
                "SX"
            ],
            "Rondo": [
                "With Electric Parking Brake",
                "With Electric Parking Brake or With Manual Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                "With Plain Caliper",
                "With Red Painted Calipers"
            ],
            "Soul": [
                ""
            ],
            "Soul EV": [
                ""
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "Discovery Sport": [
                ""
            ],
            "LR4": [
                ""
            ],
            "Range Rover": [
                "3.0L",
                "5.0L"
            ],
            "Range Rover Evoque": [
                ""
            ],
            "Range Rover Sport": [
                "3.0L",
                "5.0L"
            ]
        },
        "Lexus": {
            "CT200h": [
                ""
            ],
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GS350": [
                "Base/F Sport and with AWD"
            ],
            "GS450h": [
                "Without F Sport Package"
            ],
            "GX460": [
                ""
            ],
            "IS250": [
                "Base and with RWD. With F Sport Package",
                "F Sport and with AWD"
            ],
            "IS350": [
                "Base",
                "C/C F Sport",
                "F Sport and with AWD",
                "F Sport and with RWD"
            ],
            "LS460": [
                "L and with AWD"
            ],
            "LS600h": [
                ""
            ],
            "LX570": [
                ""
            ],
            "NX200t": [
                ""
            ],
            "NX300h": [
                ""
            ],
            "RC350": [
                "AWD. Without F Sport Package"
            ],
            "RX350": [
                ""
            ],
            "RX450h": [
                ""
            ]
        },
        "Lincoln": {
            "MKC": [
                ""
            ],
            "MKS": [
                ""
            ],
            "MKX": [
                ""
            ],
            "MKZ": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS engine"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "5": [
                ""
            ],
            "6": [
                ""
            ],
            "CX-5": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "B Electric Drive": [
                ""
            ],
            "B250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C300": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C350": [
                ""
            ],
            "C400": [
                ""
            ],
            "CLA250": [
                "AWD. With Sport Package",
                "FWD/AWD. Without Sport Package"
            ],
            "CLS550": [
                ""
            ],
            "E250": [
                "With 322mm Diameter Front Rotor"
            ],
            "E350": [
                "4Matic. With 322mm Diameter Front Rotor"
            ],
            "E400": [
                "Convertible/Coupe. With 322mm Diameter Front Rotor",
                "Sedan/Wagon. With 322mm Diameter Front Rotor"
            ],
            "E550": [
                "AWD. With 320mm Diameter Rear Rotor",
                "RWD. With 300mm Diameter Rear Rotor"
            ],
            "GL350": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "GL550": [
                "With AMG Package"
            ],
            "GLA250": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "GLK250": [
                ""
            ],
            "GLK350": [
                ""
            ],
            "ML250": [
                "With Armored Body and With AMG Package",
                "Without Sport Package"
            ],
            "ML350": [
                "Without Sport Package"
            ],
            "ML63 AMG": [
                "With Armored Body and With AMG Package"
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ]
        },
        "Mini": {
            "Cooper": [
                "2.0L/1.5L. With 280mm Diameter Front Rotor and With 4 Lug Wheels",
                "2.0L/1.5L. With 280mm Diameter Front Rotor and With 5 Lug Wheels",
                "2.0L/1.5L. With 294mm Diameter Front Rotor and With 4 Lug Wheels",
                "2.0L/1.5L. With 294mm Diameter Front Rotor and With 5 Lug Wheels",
                "2.0L/1.5L. With 5 Lug Wheels and With 280mm Diameter Front Rotor",
                "John Cooper Works and with 2.0L. With 316mm Diameter Front Rotor"
            ],
            "Cooper Paceman": [
                "Base. With John Cooper Works Package",
                "Base. Without John Cooper Works Package",
                "S/S ALL4. With John Cooper Works Package",
                "S/S ALL4. Without John Cooper Works Package"
            ]
        },
        "Mitsubishi": {
            "Lancer": [
                "ES/SE Sportback/SE",
                "Evolution MR/Evolution GSR",
                "Ralliart"
            ],
            "Outlander": [
                ""
            ],
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Juke": [
                "Nismo RS",
                "S/SL/Nismo/SV"
            ],
            "LEAF": [
                "Excluding Vehicles Manufactured In Japan",
                "Vehicles Manufactured In Japan"
            ],
            "Micra": [
                ""
            ],
            "Murano": [
                ""
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Quest": [
                ""
            ],
            "Rogue Select": [
                ""
            ],
            "Rogue": [
                "With 3rd Row Seating",
                "Without 3rd Row Seating"
            ],
            "Sentra": [
                ""
            ],
            "TITAN": [
                ""
            ],
            "Versa": [
                ""
            ],
            "Versa Note": [
                ""
            ],
            "Xterra": [
                ""
            ]
        },
        "Porsche": {
            "Cayenne": [
                "S/Base. With 360mm Diameter Front Rotor"
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                ""
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "ProMaster 1500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 2500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 3500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster City": [
                ""
            ]
        },
        "Scion": {
            "tC": [
                ""
            ],
            "xB": [
                ""
            ]
        },
        "Subaru": {
            "Forester": [
                "2.0L",
                "2.5L. With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                ""
            ],
            "Legacy": [
                "2.5L",
                "3.6L"
            ],
            "Outback": [
                ""
            ],
            "WRX": [
                ""
            ],
            "WRX STI": [
                ""
            ],
            "XV Crosstrek": [
                "With 292mm Diameter Front Rotor"
            ]
        },
        "Tesla": {
            "S": [
                ""
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                ""
            ],
            "Prius": [
                ""
            ],
            "Prius C": [
                ""
            ],
            "Prius Plug-In": [
                ""
            ],
            "Prius V": [
                ""
            ],
            "RAV4": [
                "LE",
                "Limited/Limited Platinum/XLE"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "4WD. With 5 Lug Wheels",
                "4WD. With 6 Lug Wheels",
                "RWD. With 5 Lug Wheels",
                "RWD. With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ],
            "Yaris": [
                "Disc rear brakes",
                "Drum rear brakes",
                "L/LE and with Drum rear brakes"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "Base/Classic/Sportline/Trendline/Comfortline/Comfortline TDI/TDI. With 253mm Diameter Rear Rotor",
                "Base/Classic/Sportline/Trendline/Comfortline/Comfortline TDI/TDI. With 272mm Diameter Rear Rotor",
                "R-Line. With 253mm Diameter Rear Rotor",
                "R-Line. With 272mm Diameter Rear Rotor"
            ],
            "CC": [
                "FWD"
            ],
            "e-Golf": [
                ""
            ],
            "Golf R": [
                ""
            ],
            "Golf SportWagen": [
                "DIESEL engine. With 253mm Diameter Rear Rotor",
                "S/Trendline/Highline/Comfortline/SE/SEL. With 253mm Diameter Rear Rotor",
                "S/Trendline/Highline/Comfortline/SE/SEL. With 272mm Diameter Rear Rotor"
            ],
            "GTI": [
                "With 312mm Diameter Front Rotor and Without Performance Package",
                "Without Performance Package and With 312mm Diameter Front Rotor"
            ],
            "Passat": [
                "From 07/01/14"
            ],
            "Tiguan": [
                ""
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "V60 Cross Country": [
                ""
            ],
            "XC60": [
                ""
            ]
        }
    },
    "2016": {
        "Acura": {
            "ILX": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "RLX": [
                "Base",
                "Sport Hybrid SH-AWD"
            ],
            "TLX": [
                ""
            ]
        },
        "Audi": {
            "A3": [
                "1.8L",
                "2.0L"
            ],
            "A3 Quattro": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "A3 Sportback e-tron": [
                ""
            ],
            "A4": [
                ""
            ],
            "A4 Quattro": [
                ""
            ],
            "A5": [
                ""
            ],
            "A5 Quattro": [
                ""
            ],
            "A6 Quattro": [
                ""
            ],
            "A7 Quattro": [
                "With 400mm Diameter Front Rotor and With Ceramic Composite Brakes",
                "With Ceramic Composite Brakes and With 400mm Diameter Front Rotor"
            ],
            "allroad": [
                ""
            ],
            "Q3": [
                ""
            ],
            "Q3 Quattro": [
                ""
            ],
            "Q5": [
                "FLEX engine",
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS/DIESEL engine"
            ],
            "S3": [
                ""
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S7": [
                "With 400mm Diameter Front Rotor and With Cast Iron Disc",
                "With 400mm Diameter Front Rotor and With Ceramic Composite Brakes",
                "With Cast Iron Disc and With 400mm Diameter Front Rotor",
                "With Ceramic Composite Brakes and With 400mm Diameter Front Rotor"
            ],
            "S8": [
                "With Cast Iron Disc",
                "With Ceramic Composite Brakes"
            ],
            "SQ5": [
                "With 380mm Diameter Front Rotor"
            ],
            "TT Quattro": [
                "Base. With 272mm Diameter Rear Rotor",
                "Base. With 300mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "328d": [
                "With 312mm Diameter Front Rotor"
            ],
            "528i": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "528i xDrive": [
                "Without Performance Brakes and With 330mm Diameter Front Rotor"
            ],
            "535d": [
                ""
            ],
            "535d xDrive": [
                ""
            ],
            "535i": [
                ""
            ],
            "535i GT": [
                ""
            ],
            "535i GT xDrive": [
                ""
            ],
            "535i xDrive": [
                ""
            ],
            "550i": [
                ""
            ],
            "550i GT xDrive": [
                ""
            ],
            "550i xDrive": [
                ""
            ],
            "640i": [
                ""
            ],
            "640i Gran Coupe": [
                ""
            ],
            "640i xDrive": [
                ""
            ],
            "640i xDrive Gran Coupe": [
                ""
            ],
            "650i": [
                ""
            ],
            "650i Gran Coupe": [
                ""
            ],
            "650i xDrive": [
                ""
            ],
            "650i xDrive Gran Coupe": [
                ""
            ],
            "ActiveHybrid 5": [
                ""
            ],
            "i3": [
                ""
            ],
            "M235i": [
                "With 340mm Diameter Front Rotor"
            ],
            "M235i xDrive": [
                "With 340mm Diameter Front Rotor"
            ],
            "X1": [
                ""
            ],
            "X3": [
                ""
            ],
            "X4": [
                "xDrive28i"
            ],
            "X5": [
                "xDrive35i/xDrive35d/sDrive35i",
                "xDrive50i"
            ],
            "X6": [
                "xDrive35i/sDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "Encore": [
                ""
            ],
            "Envision": [
                "With 288mm Diameter Rear Rotor",
                "With 315mm Diameter Rear Rotor"
            ],
            "Verano": [
                ""
            ]
        },
        "Cadillac": {
            "CT6": [
                "With 321mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "CTS": [
                "Base/Premium/Luxury and with RWD",
                "Base/Premium/Luxury/Performance and with AWD",
                "Vsport/Vsport Premium and with RWD. With Performance Brake Lining",
                "Vsport/Vsport Premium and with RWD. Without Performance Brake Lining"
            ],
            "Escalade ESV": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "SRX": [
                ""
            ],
            "XTS": [
                "With 6 Lug Wheels and With Heavy Duty Brakes",
                "Without Heavy Duty Brakes and With 5 Lug Wheels"
            ]
        },
        "Chevrolet": {
            "Camaro": [
                "LT and with 3.6L/2.0L. With Brembo Calipers",
                "LT and with 3.6L/2.0L. Without Brembo Calipers",
                "SS and with 3.6L. With Brembo Brakes",
                "SS and with 6.2L. With Brembo Brakes"
            ],
            "City Express": [
                ""
            ],
            "Colorado": [
                ""
            ],
            "Cruze Limited": [
                "",
                "Drum rear brakes"
            ],
            "Cruze": [
                "With 264mm Diameter Rear Rotor",
                "With 268mm Diameter Rear Rotor"
            ],
            "Equinox": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                "With Dual Rear Wheels"
            ],
            "Impala": [
                ""
            ],
            "Impala Limited": [
                "LT/LTZ/LS",
                "Police"
            ],
            "Malibu": [
                "Carryover Model",
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Malibu Limited": [
                "With 16\" Factory Wheels",
                "With 17\" Factory Wheels"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                ""
            ],
            "Spark": [
                ""
            ],
            "Spark EV": [
                ""
            ],
            "Suburban 3500 HD": [
                ""
            ],
            "Suburban": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Tahoe": [
                "Without Police Package and With 2 Piston Caliper",
                "Without Police Package and With 6 Piston Front Brembo Calipers"
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                ""
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "200": [
                "With 305mm Diameter Front Rotor",
                "With 330mm Diameter Front Rotor"
            ],
            "300": [
                "5.7L. Without Brembo Brakes"
            ],
            "Town and Country": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ]
        },
        "Dodge": {
            "Challenger": [
                "R/T",
                "SRT 392"
            ],
            "Charger": [
                "AWD and with 3.6L. With 345mm Diameter Front Rotor",
                "AWD and with 3.6L. With 370mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L. With 320mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L. With 345mm Diameter Front Rotor",
                "R/T Scat Pack and with 6.4L",
                "R/T Scat Pack and with RWD and 6.4L. With 370mm Diameter Front Rotor",
                "RWD and with 3.6L. With 320mm Diameter Front Rotor",
                "RWD and with 3.6L. With 345mm Diameter Front Rotor",
                "RWD and with 6.4L. With 370mm Diameter Front Rotor",
                "SRT 392 and with 6.4L",
                "SRT 392 and with RWD and 6.4L. With 370mm Diameter Front Rotor"
            ],
            "Dart": [
                ""
            ],
            "Grand Caravan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Journey": [
                ""
            ]
        },
        "Fiat": {
            "500": [
                "BATTERY EV (EV/BEV) engine",
                "Naturally Aspirated and with GAS engine",
                "Turbocharged and with GAS engine"
            ],
            "500L": [
                ""
            ],
            "500X": [
                ""
            ]
        },
        "Ford": {
            "C-Max": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "PLUG-IN HYBRID EV-GAS (PHEV) engine"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "Edge": [
                "With 316mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Escape": [
                "2.0L",
                "2.5L",
                "AWD and with 1.6L",
                "FWD and with 1.6L"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "F-150": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "F-250 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "Cab & Chassis and with RWD. With Dual Rear Wheels",
                "Cab & Chassis and with RWD. With Single Rear Wheels",
                "Standard Cab Pickup/Extended Cab Pickup/Crew Cab Pickup and with RWD. With Dual Rear Wheels",
                "Standard Cab Pickup/Extended Cab Pickup/Crew Cab Pickup and with RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "With 10 Lug Wheels",
                "With 8 Lug Wheels"
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-59 Commercial Stripped Chassis": [
                "With Over 23000 Lb GVW",
                "With Under 23000 Lb GVW"
            ],
            "Fiesta": [
                "S/Titanium/SE",
                "ST"
            ],
            "Flex": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Focus": [
                "RS",
                "RS. FMSI=1004",
                "S/Titanium/Electric/SE",
                "S/Titanium/Electric/SE. FMSI=1004",
                "SE and with Disc rear brakes",
                "ST. With 320mm Diameter Rotor",
                "ST. With 335mm Diameter Rotor",
                "Titanium/Electric"
            ],
            "Fusion": [
                "Energi SE/Energi Titanium",
                "S/Titanium/S Hybrid/SE Hybrid/Titanium Hybrid/SE"
            ],
            "Mustang": [
                "GT Premium/GT and with 5.0L. With Brembo Brakes",
                "GT Premium/GT and with 5.0L. Without Brembo Brakes",
                "V6 and with 3.7L"
            ],
            "Police Interceptor Sedan": [
                ""
            ],
            "Police Interceptor Utility": [
                ""
            ],
            "Special Service Police Sedan": [
                ""
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO"
            ],
            "Transit-150": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-250": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-350 HD": [
                "With 5 Lug Wheels",
                "With 6 Lug Wheels"
            ],
            "Transit-350": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                ""
            ],
            "Yukon": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Yukon XL": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ]
        },
        "Honda": {
            "Accord": [
                "EX/EX-L and with 2.4L",
                "EX-L and with 3.5L",
                "LX and with 2.4L",
                "LX-S and with 2.4L",
                "Sport/Touring"
            ],
            "Civic": [
                ""
            ],
            "CR-V": [
                "AWD",
                "FWD"
            ],
            "Fit": [
                ""
            ],
            "HR-V": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                "Base",
                "Limited"
            ],
            "Elantra": [
                ""
            ],
            "Elantra GT": [
                "From 06/29/15",
                "To 06/29/15"
            ],
            "Equus": [
                ""
            ],
            "Genesis": [
                "3.8L",
                "5.0L"
            ],
            "Genesis Coupe": [
                "3.8 and with 3.8L",
                "3.8 GT",
                "3.8 R-Spec/3.8 Ultimate"
            ],
            "Santa Fe": [
                "3.3L"
            ],
            "Santa Fe Sport": [
                "2.4L/2.0L"
            ],
            "Santa Fe XL": [
                "3.3L"
            ],
            "Sonata": [
                "FULL HYBRID EV-GAS (FHEV) engine. With Electric Parking Brake",
                "FULL HYBRID EV-GAS (FHEV) engine. With Manual Parking Brake",
                "GAS engine. With Electric Parking Brake",
                "GAS engine. With Manual Parking Brake"
            ],
            "Tucson": [
                "FUEL CELL EV (FCEV) engine",
                "GAS engine"
            ],
            "Veloster": [
                "Naturally Aspirated",
                "Turbocharged"
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q70": [
                "With Dual Piston Caliper"
            ],
            "Q70L": [
                "With Dual Piston Caliper"
            ],
            "QX50": [
                ""
            ],
            "QX60": [
                ""
            ],
            "QX70": [
                "With Single Piston Caliper"
            ],
            "QX80": [
                ""
            ]
        },
        "Jaguar": {
            "XF": [
                "2.0L. With 325mm Diameter Rear Rotor and With 350mm Diameter Front Rotor",
                "3.0L. With 325mm Diameter Rear Rotor and With 350mm Diameter Front Rotor"
            ],
            "XJ": [
                "5.0L",
                "Base and with 3.0L. With Electric Parking Brake",
                "Base and with 3.0L. With Manual Parking Brake",
                "L Portfolio/R-Sport and with 3.0L. With Electric Parking Brake",
                "L Portfolio/R-Sport and with 3.0L. With Manual Parking Brake"
            ],
            "XJR": [
                "With 380mm Diameter Front Rotor"
            ]
        },
        "Jeep": {
            "Compass": [
                "",
                "Drum rear brakes",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Renegade": [
                ""
            ],
            "Wrangler": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ]
        },
        "Kia": {
            "Cadenza": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Forte Koup": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Forte": [
                "With 280mm Diameter Front Rotor",
                "With 300mm Diameter Front Rotor"
            ],
            "Forte5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "K900": [
                "3.8L",
                "5.0L"
            ],
            "Optima": [
                "Hybrid EX/Hybrid LX/Hybrid EX Premium/Hybrid. With Electric Parking Brake",
                "Hybrid EX/Hybrid LX/Hybrid EX Premium/Hybrid. With Manual Parking Brake",
                "LX/EX/LX 1.6T. With Electric Parking Brake",
                "LX/EX/LX 1.6T. With Manual Parking Brake",
                "SX/SXL/SX Limited. With Electric Parking Brake",
                "SX/SXL/SX Limited. With Manual Parking Brake"
            ],
            "Rio": [
                "LX/EX",
                "SX"
            ],
            "Rondo": [
                "With Electric Parking Brake",
                "With Electric Parking Brake or With Manual Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Soul": [
                ""
            ],
            "Soul EV": [
                "From Chassis/VIN #160921",
                "To Chassis/VIN #160920"
            ],
            "Sportage": [
                "AWD",
                "FWD"
            ]
        },
        "Land Rover": {
            "Discovery Sport": [
                "With 325mm Diameter Front Rotor",
                "With 349mm Diameter Front Rotor"
            ],
            "LR4": [
                ""
            ],
            "Range Rover": [
                "3.0L",
                "5.0L"
            ],
            "Range Rover Evoque": [
                "With 300mm Diameter Front Rotor",
                "With 325mm Diameter Front Rotor",
                "With 349mm Diameter Front Rotor"
            ],
            "Range Rover Sport": [
                "3.0L",
                "5.0L"
            ]
        },
        "Lexus": {
            "CT200h": [
                ""
            ],
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GS200t": [
                "Base. Without Sport Package"
            ],
            "GS350": [
                "AWD",
                "Base and with RWD. Without F Sport Package"
            ],
            "GS450h": [
                "Without F Sport Package"
            ],
            "GX460": [
                ""
            ],
            "IS200t": [
                "F Sport"
            ],
            "IS300": [
                ""
            ],
            "IS350": [
                "AWD",
                "RWD"
            ],
            "LS460": [
                "Base and with AWD. With Sport Package and Without F Sport Package",
                "L and with AWD"
            ],
            "LS600h": [
                ""
            ],
            "LX570": [
                ""
            ],
            "NX200t": [
                ""
            ],
            "NX300h": [
                ""
            ],
            "RC200t": [
                "Base. Without F Sport Package"
            ],
            "RC300": [
                "Without F Sport Package"
            ],
            "RC350": [
                "AWD. Without F Sport Package"
            ],
            "RX350": [
                "Excluding Vehicles Manufactured In Japan"
            ],
            "RX450h": [
                ""
            ]
        },
        "Lincoln": {
            "MKC": [
                ""
            ],
            "MKS": [
                ""
            ],
            "MKZ": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS engine"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "5": [
                ""
            ],
            "6": [
                ""
            ],
            "CX-3": [
                "AWD",
                "FWD"
            ],
            "CX-5": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ]
        },
        "Mercedes-Benz": {
            "B250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C300": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C350e": [
                ""
            ],
            "C450 AMG": [
                ""
            ],
            "CLA250": [
                "AWD. With Sport Package",
                "FWD/AWD. Without Sport Package"
            ],
            "CLS550": [
                ""
            ],
            "E250": [
                "With 322mm Diameter Front Rotor"
            ],
            "E350": [
                "With 322mm Diameter Front Rotor"
            ],
            "E400": [
                "Sedan. With 322mm Diameter Front Rotor",
                "Sedan. With 344mm Diameter Front Rotor"
            ],
            "E550": [
                "AWD. With 320mm Diameter Rear Rotor",
                "RWD. With 300mm Diameter Rear Rotor"
            ],
            "GL350": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "GL550": [
                "With AMG Package"
            ],
            "GLA250": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "GLE300d": [
                "Without Sport Appearance Package"
            ],
            "GLE350": [
                "Without Sport Appearance Package"
            ],
            "GLE400": [
                "With AMG Package",
                "Without Sport Package"
            ],
            "GLE550e": [
                "With AMG Package"
            ],
            "Metris": [
                ""
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ]
        },
        "Mini": {
            "Cooper": [
                "Base. To 10/15",
                "S and with Convertible",
                "S and with Hatchback"
            ],
            "Cooper Clubman": [
                "Base and with 1.5L",
                "S and with 2.0L"
            ],
            "Cooper Paceman": [
                "Base",
                "S ALL4"
            ]
        },
        "Mitsubishi": {
            "Lancer": [
                "ES/SE Limited Edition/SE/DE",
                "GTS"
            ],
            "Outlander": [
                ""
            ],
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Juke": [
                "Nismo RS",
                "SL/Nismo/SV"
            ],
            "LEAF": [
                ""
            ],
            "Maxima": [
                ""
            ],
            "Micra": [
                ""
            ],
            "Murano": [
                ""
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Quest": [
                ""
            ],
            "Rogue": [
                "With 3rd Row Seating",
                "Without 3rd Row Seating"
            ],
            "Sentra": [
                ""
            ],
            "TITAN XD": [
                ""
            ],
            "Versa": [
                ""
            ],
            "Versa Note": [
                ""
            ]
        },
        "Porsche": {
            "Cayenne": [
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                ""
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "ProMaster 1500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 2500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 3500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster City": [
                ""
            ]
        },
        "Scion": {
            "iA": [
                ""
            ],
            "iM": [
                ""
            ],
            "tC": [
                ""
            ]
        },
        "Subaru": {
            "Crosstrek": [
                "With 292mm Diameter Front Rotor"
            ],
            "Forester": [
                "2.0L",
                "2.5L. With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                ""
            ],
            "Legacy": [
                "2.5L",
                "3.6L"
            ],
            "Outback": [
                ""
            ],
            "WRX STI": [
                ""
            ],
            "WRX": [
                "With Eyesight Package (Steering Responsive Fog Lights)",
                "Without Eyesight Package (Steering Responsive Fog Lights)"
            ]
        },
        "Tesla": {
            "S": [
                "From 04/16",
                "To 03/16"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                "With 340mm Diameter Front Rotor",
                "With 354mm Diameter Front Rotor"
            ],
            "Mirai": [
                ""
            ],
            "Prius": [
                ""
            ],
            "Prius C": [
                ""
            ],
            "Prius V": [
                ""
            ],
            "RAV4": [
                "LE",
                "Limited/Hybrid Limited/Hybrid XLE/SE/XLE"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "RWD. With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ],
            "Yaris": [
                "Disc rear brakes",
                "Drum rear brakes",
                "L/LE and with Drum rear brakes"
            ]
        },
        "Volkswagen": {
            "Beetle": [
                "Classic/Trendline/Comfortline. With 253mm Diameter Rear Rotor",
                "Classic/Trendline/Comfortline. With 272mm Diameter Rear Rotor"
            ],
            "CC": [
                "AWD",
                "FWD",
                "V6 Executive 4Motion and with AWD"
            ],
            "e-Golf": [
                ""
            ],
            "Golf R": [
                ""
            ],
            "Golf SportWagen": [
                ""
            ],
            "GTI": [
                "With 312mm Diameter Front Rotor and Without Performance Package",
                "Without Performance Package and With 312mm Diameter Front Rotor"
            ],
            "Passat": [
                ""
            ],
            "Tiguan": [
                ""
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "S60 Cross Country": [
                ""
            ],
            "V60 Cross Country": [
                ""
            ],
            "XC60": [
                "From Chassis/VIN #785804",
                "To Chassis/VIN #785803"
            ]
        }
    },
    "2017": {
        "Acura": {
            "ILX": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "RLX": [
                "Base",
                "Sport Hybrid SH-AWD"
            ],
            "TLX": [
                ""
            ]
        },
        "Alfa Romeo": {
            "Giulia": [
                "TI/Base"
            ]
        },
        "Audi": {
            "A3 Quattro": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "A3 Sportback e-tron": [
                ""
            ],
            "A3": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "A4 allroad": [
                ""
            ],
            "A5 Quattro": [
                ""
            ],
            "A7 Quattro": [
                "With 400mm Diameter Front Rotor and With Ceramic Composite Brakes",
                "With Ceramic Composite Brakes and With 400mm Diameter Front Rotor"
            ],
            "Q3": [
                ""
            ],
            "Q3 Quattro": [
                ""
            ],
            "Q5": [
                "2.0L",
                "3.0L"
            ],
            "S3": [
                ""
            ],
            "S5": [
                ""
            ],
            "S7": [
                "With 400mm Diameter Front Rotor and With Cast Iron Disc",
                "With 400mm Diameter Front Rotor and With Ceramic Composite Brakes",
                "With Cast Iron Disc and With 400mm Diameter Front Rotor",
                "With Ceramic Composite Brakes and With 400mm Diameter Front Rotor"
            ],
            "S8": [
                "With Cast Iron Disc",
                "With Ceramic Composite Brakes"
            ],
            "SQ5": [
                "With 380mm Diameter Front Rotor"
            ],
            "TT Quattro": [
                "Base. With 272mm Diameter Rear Rotor",
                "Base. With 300mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "328d": [
                ""
            ],
            "328d xDrive": [
                ""
            ],
            "535i GT": [
                ""
            ],
            "535i GT xDrive": [
                ""
            ],
            "640i": [
                ""
            ],
            "640i Gran Coupe": [
                ""
            ],
            "640i xDrive": [
                ""
            ],
            "640i xDrive Gran Coupe": [
                ""
            ],
            "650i": [
                ""
            ],
            "650i Gran Coupe": [
                ""
            ],
            "650i xDrive": [
                ""
            ],
            "650i xDrive Gran Coupe": [
                ""
            ],
            "i3": [
                ""
            ],
            "M240i": [
                "With 340mm Diameter Front Rotor"
            ],
            "M240i xDrive": [
                "With 340mm Diameter Front Rotor"
            ],
            "X1": [
                ""
            ],
            "X3": [
                ""
            ],
            "X4": [
                "xDrive28i"
            ],
            "X5": [
                "xDrive35i/xDrive35d/sDrive35i",
                "xDrive40e",
                "xDrive50i"
            ],
            "X6": [
                "xDrive35i/sDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "Encore": [
                ""
            ],
            "Envision": [
                "With 288mm Diameter Rear Rotor",
                "With 315mm Diameter Rear Rotor"
            ],
            "LaCrosse": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "Verano": [
                ""
            ]
        },
        "Cadillac": {
            "ATS": [
                "Base/Luxury and with 2.0L. With 321mm Diameter Front Rotor",
                "V. With 300mm Diameter Front Rotor",
                "V. With 321mm Diameter Front Rotor"
            ],
            "CT6": [
                "With 321mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "CTS": [
                "2.0L",
                "3.6L and with Naturally Aspirated",
                "3.6L and with Turbocharged. With Performance Brake Lining",
                "3.6L and with Turbocharged. Without Performance Brake Lining"
            ],
            "Escalade ESV": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "XT5": [
                ""
            ],
            "XTS": [
                "Without Heavy Duty Brakes"
            ]
        },
        "Chevrolet": {
            "Bolt EV": [
                ""
            ],
            "Camaro": [
                "LT/LS. With Brembo Calipers",
                "LT/LS. Without Brembo Calipers"
            ],
            "City Express": [
                ""
            ],
            "Colorado": [
                ""
            ],
            "Cruze": [
                ""
            ],
            "Equinox": [
                ""
            ],
            "Express 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Express 4500": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                ""
            ],
            "Spark": [
                ""
            ],
            "Suburban 3500 HD": [
                ""
            ],
            "Tahoe": [
                "Without Police Package and With 2 Piston Caliper"
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                "",
                "1.4L"
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "200": [
                "With 305mm Diameter Front Rotor",
                "With 330mm Diameter Front Rotor"
            ],
            "300": [
                "5.7L. Without Brembo Brakes",
                "AWD and with 3.6L. Without Brembo Brakes",
                "RWD and with 3.6L. Without Brembo Brakes"
            ],
            "Pacifica": [
                ""
            ]
        },
        "Dodge": {
            "Challenger": [
                "R/T/GT",
                "SRT 392"
            ],
            "Charger": [
                "6.4L. With 4 Piston Caliper",
                "AWD and with 3.6L. With 345mm Diameter Front Rotor",
                "AWD and with 3.6L. With 370mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L. With 320mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L. With 345mm Diameter Front Rotor",
                "Pursuit and with RWD and 5.7L. With 345mm Diameter Front Rotor",
                "Pursuit and with RWD and 5.7L. With 370mm Diameter Front Rotor",
                "RWD and with 3.6L. With 320mm Diameter Front Rotor",
                "RWD and with 3.6L. With 345mm Diameter Front Rotor",
                "RWD and with 5.7L. With 345mm Diameter Front Rotor",
                "RWD and with 5.7L. With 370mm Diameter Front Rotor"
            ],
            "Grand Caravan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Journey": [
                ""
            ]
        },
        "Fiat": {
            "500": [
                "BATTERY EV (EV/BEV) engine",
                "Naturally Aspirated and with GAS engine",
                "Turbocharged and with GAS engine"
            ],
            "500L": [
                ""
            ],
            "500X": [
                ""
            ]
        },
        "Ford": {
            "C-Max": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "PLUG-IN HYBRID EV-GAS (PHEV) engine"
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "Edge": [
                "With 316mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Escape": [
                "2.0L",
                "2.5L",
                "AWD and with 1.5L",
                "FWD and with 1.5L"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "F-150": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "F-250 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                ""
            ],
            "F-550 Super Duty": [
                "4 X 2",
                "4 X 4"
            ],
            "F-59 Commercial Stripped Chassis": [
                "With Over 22000 Lb GVW",
                "With Under 22000 Lb GVW"
            ],
            "Fiesta": [
                "S/Titanium/SE",
                "ST"
            ],
            "Flex": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Focus": [
                "RS",
                "RS. FMSI=1004",
                "S/Titanium/Electric/SE/SEL",
                "S/Titanium/Electric/SE/SEL. FMSI=1004",
                "SE/SEL and with Disc rear brakes",
                "ST. With 320mm Diameter Rotor",
                "ST. With 335mm Diameter Rotor",
                "Titanium/Electric"
            ],
            "Fusion": [
                "Energi SE/Energi Titanium/Energi Platinum",
                "S/Platinum/Titanium/S Hybrid/SE Hybrid/Titanium Hybrid/Platinum Hybrid/SE",
                "Sport"
            ],
            "Mustang": [
                "GT Premium/GT and with 5.0L. With Brembo Brakes",
                "GT Premium/GT and with 5.0L. Without Brembo Brakes",
                "V6 and with 3.7L"
            ],
            "Police Interceptor Sedan": [
                ""
            ],
            "Police Interceptor Utility": [
                ""
            ],
            "Special Service Police Sedan": [
                ""
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO"
            ],
            "Transit-150": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-250": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-350 HD": [
                "With 6 Lug Wheels"
            ],
            "Transit-350": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "Genesis": {
            "G80": [
                "3.8L",
                "5.0L"
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Acadia Limited": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 2500": [
                "86mm Overall Height",
                "91mm Overall Height"
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                "Except Vehicles Manufactured In Mexico",
                "Vehicles Manufactured In Mexico"
            ],
            "Yukon": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Yukon XL": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ]
        },
        "Honda": {
            "Accord": [
                "EX",
                "EX-L and with 2.4L",
                "EX-L and with 3.5L",
                "Hybrid EX-L/Hybrid Touring/Hybrid",
                "LX",
                "LX-S",
                "Sport/Sport Special Edition/Touring"
            ],
            "Civic": [
                "LX/Sport/EX/EX-L/LX-P/Touring",
                "Si"
            ],
            "Clarity": [
                ""
            ],
            "CR-V": [
                ""
            ],
            "Fit": [
                ""
            ],
            "HR-V": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Azera": [
                "Base",
                "Limited"
            ],
            "Elantra": [
                "1.6L",
                "2.0L"
            ],
            "Elantra GT": [
                ""
            ],
            "Ioniq": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Santa Fe": [
                ""
            ],
            "Santa Fe Sport": [
                ""
            ],
            "Santa Fe XL": [
                ""
            ],
            "Tucson": [
                "FUEL CELL EV (FCEV) engine",
                "GAS engine"
            ],
            "Veloster": [
                "Naturally Aspirated",
                "Turbocharged"
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q60": [
                "With Dual Piston Caliper"
            ],
            "Q70": [
                "With Dual Piston Caliper"
            ],
            "Q70L": [
                "With Dual Piston Caliper"
            ],
            "QX30": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "QX50": [
                ""
            ],
            "QX60": [
                ""
            ],
            "QX70": [
                "With Single Piston Caliper"
            ],
            "QX80": [
                ""
            ]
        },
        "Jaguar": {
            "F-Pace": [
                "DIESEL engine. With 325mm Diameter Front Rotor",
                "DIESEL engine. With 380mm Diameter Front Rotor"
            ],
            "XE": [
                "3.0L"
            ],
            "XF": [
                "3.0L and with GAS engine. With 325mm Diameter Rear Rotor and With 350mm Diameter Front Rotor"
            ],
            "XJ": [
                "5.0L. With 355mm Diameter Front Rotor",
                "5.0L. With 380mm Diameter Front Rotor",
                "L Portfolio/R-Sport and with RWD and 3.0L. With 355mm Diameter Front Rotor"
            ]
        },
        "Jeep": {
            "Patriot": [
                "",
                "With 262mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "Renegade": [
                ""
            ],
            "Wrangler": [
                "With 302mm Diameter Front Rotor",
                "With 332mm Diameter Front Rotor"
            ]
        },
        "Kia": {
            "Forte Koup": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Forte": [
                "With 280mm Diameter Front Rotor",
                "With 300mm Diameter Front Rotor"
            ],
            "Forte5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "K900": [
                "3.8L",
                "5.0L"
            ],
            "Niro": [
                ""
            ],
            "Optima": [
                "LX/Hybrid Premium/Hybrid EX/Hybrid LX/Hybrid EX Premium/LX 1.6T/Plug-In Hybrid EX. With Electric Parking Brake",
                "LX/Hybrid Premium/Hybrid EX/Hybrid LX/Hybrid EX Premium/LX 1.6T/Plug-In Hybrid EX. With Manual Parking Brake",
                "SX/SXL/SX Limited. With Electric Parking Brake",
                "SX/SXL/SX Limited. With Manual Parking Brake"
            ],
            "Rio": [
                "With 14\" Factory Wheels",
                "With 15\" Factory Wheels"
            ],
            "Rondo": [
                "With Electric Parking Brake",
                "With Electric Parking Brake or With Manual Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Soul": [
                "1.6L and with Turbocharged",
                "Naturally Aspirated"
            ],
            "Soul EV": [
                ""
            ],
            "Sportage": [
                "Naturally Aspirated. With Electric Parking Brake",
                "Naturally Aspirated. With Manual Parking Brake",
                "Turbocharged. With Electric Parking Brake",
                "Turbocharged. With Manual Parking Brake"
            ]
        },
        "Land Rover": {
            "Discovery": [
                ""
            ],
            "Discovery Sport": [
                "With 325mm Diameter Front Rotor",
                "With 349mm Diameter Front Rotor"
            ],
            "Range Rover": [
                "DIESEL engine",
                "GAS engine"
            ],
            "Range Rover Evoque": [
                "With 300mm Diameter Front Rotor",
                "With 325mm Diameter Front Rotor",
                "With 349mm Diameter Front Rotor"
            ],
            "Range Rover Sport": [
                "HSE/SE and with DIESEL engine",
                "HSE/SE and with GAS engine",
                "Supercharged/Autobiography/SVR/HSE Dynamic and with GAS engine"
            ]
        },
        "Lexus": {
            "CT200h": [
                ""
            ],
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GS200t": [
                "Base. Without F Sport Package"
            ],
            "GS350": [
                "AWD",
                "Base and with RWD. Without F Sport Package"
            ],
            "GS450h": [
                "Without F Sport Package"
            ],
            "GX460": [
                ""
            ],
            "IS200t": [
                "Base. With F Sport Package",
                "Base. Without F Sport Package",
                "F Sport"
            ],
            "IS300": [
                ""
            ],
            "IS350": [
                "AWD",
                "RWD"
            ],
            "LS460": [
                "Base and with AWD. With Sport Package and Without F Sport Package",
                "L and with AWD"
            ],
            "LX570": [
                ""
            ],
            "NX200t": [
                ""
            ],
            "NX300h": [
                ""
            ],
            "RC200t": [
                "Base. Without F Sport Package"
            ],
            "RC300": [
                "Without F Sport Package"
            ],
            "RC350": [
                "AWD. Without F Sport Package"
            ],
            "RX350": [
                "Excluding Vehicles Manufactured In Japan"
            ],
            "RX450h": [
                ""
            ]
        },
        "Lincoln": {
            "MKC": [
                ""
            ],
            "MKT": [
                "With Vented Rear Rotors and Without Drum In Hat Parking Brake"
            ],
            "MKZ": [
                "2.0L",
                "3.0L"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "5": [
                ""
            ],
            "6": [
                ""
            ],
            "CX-3": [
                "AWD",
                "FWD"
            ],
            "CX-5": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ]
        },
        "Mercedes-Benz": {
            "B250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C300": [
                "4Matic and with Sedan. With Sport Package and With Vented Rear Rotors",
                "Base and with Sedan and RWD. With Sport Package and With Vented Rear Rotors",
                "Coupe and with RWD. With Sport Package and With Vented Rear Rotors",
                "Sedan/Coupe. Without Sport Package"
            ],
            "C350e": [
                ""
            ],
            "C43 AMG": [
                ""
            ],
            "CLA250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "CLS550": [
                ""
            ],
            "E400": [
                "With 322mm Diameter Front Rotor",
                "With 344mm Diameter Front Rotor"
            ],
            "E43 AMG": [
                ""
            ],
            "GLA250": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "GLC43 AMG": [
                ""
            ],
            "GLE350": [
                "Without Sport Appearance Package"
            ],
            "GLE400": [
                "With AMG Package",
                "Without Sport Package"
            ],
            "GLE550e": [
                "With AMG Package"
            ],
            "GLS350d": [
                ""
            ],
            "GLS450": [
                "With AMG Package",
                "Without Sport Package"
            ],
            "Metris": [
                ""
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ]
        },
        "Mini": {
            "Cooper Clubman": [
                "Base/ALL4",
                "John Cooper Works ALL4. With Sport Package",
                "S ALL4",
                "S. With Sport Package",
                "S. Without Sport Package"
            ],
            "Cooper Countryman": [
                "Base/ALL4",
                "S/S ALL4"
            ],
            "Cooper": [
                "S"
            ]
        },
        "Mitsubishi": {
            "Mirage G4": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Mirage": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Outlander Sport": [
                ""
            ],
            "Outlander": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Juke": [
                "Nismo RS",
                "S/SL/Nismo/SV"
            ],
            "LEAF": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Maxima": [
                ""
            ],
            "Micra": [
                ""
            ],
            "Murano": [
                ""
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Qashqai": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Quest": [
                ""
            ],
            "Rogue Sport": [
                ""
            ],
            "Rogue": [
                "With 3rd Row Seating",
                "Without 3rd Row Seating"
            ],
            "Sentra": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "TITAN": [
                ""
            ],
            "TITAN XD": [
                ""
            ],
            "Versa": [
                ""
            ],
            "Versa Note": [
                ""
            ]
        },
        "Porsche": {
            "Cayenne": [
                "S/Base/S E-Hybrid. With 360mm Diameter Front Rotor"
            ],
            "Macan": [
                "Base",
                "S. Without Ceramic Composite Brakes"
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                ""
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "ProMaster 1500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 2500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 3500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster City": [
                ""
            ]
        },
        "Subaru": {
            "BRZ": [
                "Base. With Brembo Brakes",
                "Base. Without Brembo Brakes",
                "Limited/Premium. With Brembo Brakes",
                "Limited/Premium. Without Brembo Brakes"
            ],
            "Crosstrek": [
                "With 292mm Diameter Front Rotor"
            ],
            "Forester": [
                "2.0L",
                "2.5L. With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                "With 276mm Diameter Front Rotor",
                "With 293mm Diameter Front Rotor"
            ],
            "Legacy": [
                "2.5L",
                "3.6L"
            ],
            "Outback": [
                ""
            ],
            "WRX STI": [
                ""
            ],
            "WRX": [
                "With Eyesight Package (Steering Responsive Fog Lights)",
                "Without Eyesight Package (Steering Responsive Fog Lights)"
            ]
        },
        "Tesla": {
            "3": [
                "With Gray Painted Calipers"
            ],
            "S": [
                "With Brembo Calipers",
                "With Single Piston Rear Caliper"
            ],
            "X": [
                "With Brembo Calipers",
                "With Single Piston Rear Caliper"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "86": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "Camry": [
                ""
            ],
            "Corolla": [
                ""
            ],
            "Corolla iM": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                "With 340mm Diameter Front Rotor",
                "With 354mm Diameter Front Rotor"
            ],
            "Mirai": [
                ""
            ],
            "Prius": [
                ""
            ],
            "Prius Prime": [
                ""
            ],
            "Prius V": [
                ""
            ],
            "RAV4": [
                "LE",
                "Limited/Hybrid Limited/Platinum/Hybrid XLE/Hybrid SE/XLE Plus/SE/XLE"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Yaris": [
                "Disc rear brakes",
                "Drum rear brakes",
                "L/LE and with Drum rear brakes"
            ],
            "Yaris iA": [
                ""
            ]
        },
        "Volkswagen": {
            "CC": [
                "",
                "4 Motion"
            ],
            "e-Golf": [
                ""
            ],
            "Golf Alltrack": [
                "With 253mm Diameter Rear Rotor",
                "With 272mm Diameter Rear Rotor"
            ],
            "Golf R": [
                ""
            ],
            "Golf SportWagen": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "GTI": [
                "With 312mm Diameter Front Rotor and Without Performance Package",
                "Without Performance Package and With 312mm Diameter Front Rotor"
            ],
            "Jetta": [
                "1.8L/1.4L. With 253mm Diameter Rear Rotor",
                "1.8L/1.4L. With 272mm Diameter Rear Rotor",
                "2.0L. With 253mm Diameter Rear Rotor",
                "2.0L. With 272mm Diameter Rear Rotor"
            ],
            "Passat": [
                ""
            ],
            "Tiguan": [
                ""
            ],
            "Tiguan Limited": [
                "With 312mm Diameter Front Rotor"
            ],
            "Touareg": [
                "With 330mm Diameter Front Rotor",
                "With 360mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "S60 Cross Country": [
                ""
            ],
            "V60 Cross Country": [
                ""
            ],
            "XC60": [
                "With 324mm Diameter Front Rotor",
                "With 328mm Diameter Front Rotor"
            ]
        }
    },
    "2018": {
        "Acura": {
            "ILX": [
                ""
            ],
            "MDX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "RLX": [
                "Base",
                "Sport Hybrid SH-AWD"
            ],
            "TLX": [
                ""
            ]
        },
        "Alfa Romeo": {
            "Giulia": [
                "TI/Base"
            ],
            "Stelvio": [
                "TI/Base"
            ]
        },
        "Audi": {
            "A3 Quattro": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "A3 Sportback e-tron": [
                ""
            ],
            "A3": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "A4 allroad": [
                ""
            ],
            "A5 Quattro": [
                "With 314mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "A5 Sportback": [
                "With 314mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "Q3": [
                ""
            ],
            "Q3 Quattro": [
                ""
            ],
            "Q5": [
                "With Brembo Calipers",
                "Without Brembo Calipers"
            ],
            "S3": [
                ""
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S5 Sportback": [
                ""
            ],
            "SQ5": [
                ""
            ],
            "TT Quattro": [
                "Base. With 272mm Diameter Rear Rotor",
                "Base. With 300mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "328d": [
                ""
            ],
            "328d xDrive": [
                ""
            ],
            "640i": [
                ""
            ],
            "640i Gran Coupe": [
                ""
            ],
            "640i xDrive": [
                ""
            ],
            "640i xDrive Gran Coupe": [
                ""
            ],
            "640i xDrive Gran Turismo": [
                "With 345mm Diameter Rear Rotor"
            ],
            "650i": [
                ""
            ],
            "650i Gran Coupe": [
                ""
            ],
            "650i xDrive": [
                ""
            ],
            "650i xDrive Gran Coupe": [
                ""
            ],
            "i3s": [
                ""
            ],
            "M240i": [
                "With 340mm Diameter Front Rotor",
                "With 370mm Diameter Front Rotor and With M Performance Brakes"
            ],
            "M240i xDrive": [
                "With 340mm Diameter Front Rotor",
                "With 370mm Diameter Front Rotor and With M Performance Brakes"
            ],
            "X1": [
                ""
            ],
            "X2": [
                "xDrive28i/sDrive28i"
            ],
            "X4": [
                "xDrive28i"
            ],
            "X5": [
                "xDrive35i/xDrive35d/sDrive35i",
                "xDrive40e",
                "xDrive50i"
            ],
            "X6": [
                "xDrive35i/sDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                "With 321mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Encore": [
                ""
            ],
            "Envision": [
                "With 288mm Diameter Rear Rotor",
                "With 315mm Diameter Rear Rotor"
            ],
            "LaCrosse": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ]
        },
        "Cadillac": {
            "ATS": [
                "Base/Luxury. With Brembo Brakes and Without Slotted Brake Rotors",
                "Base. Without Brembo Brakes and Without Slotted Brake Rotors",
                "V. With Brembo Brakes and Without Slotted Brake Rotors"
            ],
            "CT6": [
                "With 321mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "CTS": [
                "2.0L",
                "3.6L and with Naturally Aspirated",
                "3.6L and with Turbocharged. With Performance Brake Lining",
                "3.6L and with Turbocharged. Without Performance Brake Lining"
            ],
            "Escalade ESV": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "XT5": [
                ""
            ],
            "XTS": [
                "Without Heavy Duty Brakes"
            ]
        },
        "Chevrolet": {
            "Bolt EV": [
                ""
            ],
            "Camaro": [
                "LT/LS. With Brembo Calipers",
                "LT/LS. Without Brembo Calipers"
            ],
            "City Express": [
                ""
            ],
            "Colorado": [
                ""
            ],
            "Cruze": [
                ""
            ],
            "Equinox": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "Express 2500": [
                ""
            ],
            "Express 4500": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                ""
            ],
            "Spark": [
                ""
            ],
            "Suburban 3500 HD": [
                ""
            ],
            "Tahoe": [
                "Without Police Package and With 2 Piston Caliper"
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                "",
                "1.4L. Excluding Vehicles Manufactured In Mexico",
                "Excluding Vehicles Manufactured In Mexico"
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "300": [
                "5.7L. Without Brembo Brakes",
                "AWD and with 3.6L. Without Brembo Brakes",
                "RWD and with 3.6L. Without Brembo Brakes"
            ],
            "Pacifica": [
                ""
            ]
        },
        "Dodge": {
            "Challenger": [
                "SRT 392",
                "SXT. With 320mm Diameter Front Rotor"
            ],
            "Charger": [
                "6.4L. With 4 Piston Caliper",
                "AWD and with 3.6L. With 345mm Diameter Front Rotor",
                "AWD and with 3.6L. With 370mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L. With 320mm Diameter Front Rotor",
                "Pursuit and with RWD and 3.6L. With 345mm Diameter Front Rotor",
                "Pursuit and with RWD and 5.7L. With 345mm Diameter Front Rotor",
                "Pursuit and with RWD and 5.7L. With 370mm Diameter Front Rotor",
                "RWD and with 3.6L. With 320mm Diameter Front Rotor",
                "RWD and with 3.6L. With 345mm Diameter Front Rotor",
                "RWD and with 5.7L. With 345mm Diameter Front Rotor",
                "RWD and with 5.7L. With 370mm Diameter Front Rotor"
            ],
            "Grand Caravan": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Journey": [
                ""
            ]
        },
        "Fiat": {
            "500": [
                "E and with BATTERY EV (EV/BEV) engine",
                "Pop/Lounge/c Pop/c Lounge"
            ],
            "500L": [
                ""
            ],
            "500X": [
                ""
            ]
        },
        "Ford": {
            "C-Max": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "EcoSport": [
                "AWD",
                "FWD"
            ],
            "Edge": [
                "With 316mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Escape": [
                "2.0L",
                "2.5L",
                "AWD and with 1.5L",
                "FWD and with 1.5L"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "F-150": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "F-250 Super Duty": [
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                "4 X 2",
                "4 X 4"
            ],
            "F-550 Super Duty": [
                "4 X 2",
                "4 X 4"
            ],
            "F-59 Commercial Stripped Chassis": [
                "With Over 22000 Lb GVW",
                "With Under 22000 Lb GVW"
            ],
            "Fiesta": [
                "S/Titanium/SE",
                "ST"
            ],
            "Flex": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Focus": [
                "RS",
                "RS. FMSI=1004",
                "S/Titanium/Electric/SE/SEL",
                "S/Titanium/Electric/SE/SEL. FMSI=1004",
                "SE/SEL and with Disc rear brakes",
                "ST. With 320mm Diameter Rotor",
                "ST. With 335mm Diameter Rotor",
                "Titanium/Electric"
            ],
            "Fusion": [
                "Energi SE/Energi Titanium/Energi Platinum",
                "S/Platinum/Titanium/S Hybrid/SE Hybrid/Titanium Hybrid/Platinum Hybrid/SE",
                "Sport"
            ],
            "Mustang": [
                "GT Premium/GT and with 5.0L. With Brembo Brakes",
                "GT Premium/GT and with 5.0L. Without Brembo Brakes"
            ],
            "Police Interceptor Sedan": [
                ""
            ],
            "Police Interceptor Utility": [
                ""
            ],
            "Special Service Police Sedan": [
                ""
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO"
            ],
            "Transit-150": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-250": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-350 HD": [
                "With 6 Lug Wheels"
            ],
            "Transit-350": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit Connect": [
                "From 05/28/18",
                "To 05/28/18"
            ]
        },
        "Genesis": {
            "G80": [
                "3.3L",
                "AWD and with 5.0L"
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 2500": [
                ""
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "Yukon": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Yukon XL": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ]
        },
        "Honda": {
            "Accord": [
                "EX-L and with 1.5L",
                "EX-L and with 2.0L",
                "LX/EX",
                "Sport/Hybrid EX-L/Hybrid Touring/Touring/Hybrid"
            ],
            "Civic": [
                "LX/EX and with Hatchback",
                "LX/Sport/EX/EX-L/LX-P/Touring",
                "Si",
                "Sport"
            ],
            "Clarity": [
                ""
            ],
            "CR-V": [
                ""
            ],
            "Fit": [
                ""
            ],
            "HR-V": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Elantra": [
                "1.4L/2.0L",
                "1.6L",
                "2.0L"
            ],
            "Elantra GT": [
                "Base. With Electric Parking Brake",
                "Base. With Manual Parking Brake",
                "Sport/Sport Ultimate"
            ],
            "Ioniq": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Kona": [
                "SE/SEL and with FWD",
                "Ultimate/Limited and with FWD",
                "Ultimate/Limited/SE/SEL and with AWD"
            ],
            "Santa Fe": [
                ""
            ],
            "Santa Fe Sport": [
                ""
            ],
            "Santa Fe XL": [
                ""
            ],
            "Tucson": [
                ""
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q60": [
                "With Dual Piston Caliper"
            ],
            "Q70": [
                "With Dual Piston Caliper"
            ],
            "Q70L": [
                "With Dual Piston Caliper"
            ],
            "QX30": [
                "Base/Premium/Luxury. With Solid Rear Rotors",
                "Base/Premium/Luxury. With Vented Rear Rotors"
            ],
            "QX60": [
                ""
            ],
            "QX80": [
                ""
            ]
        },
        "Jaguar": {
            "E-Pace": [
                "Base. With 325mm Diameter Front Rotor",
                "Base. With 349mm Diameter Front Rotor",
                "S/SE. With 325mm Diameter Front Rotor",
                "S/SE. With 349mm Diameter Front Rotor"
            ],
            "F-Pace": [
                "2.0L. With 325mm Diameter Front Rotor",
                "2.0L. With 380mm Diameter Front Rotor"
            ],
            "XE": [
                "3.0L"
            ],
            "XF": [
                "2.0L and with GAS engine. With 325mm Diameter Rear Rotor and With 350mm Diameter Front Rotor",
                "2.0L and with GAS engine. With 350mm Diameter Front Rotor and With 325mm Diameter Rear Rotor",
                "3.0L. With 325mm Diameter Rear Rotor and With 350mm Diameter Front Rotor"
            ],
            "XJ": [
                "L Portfolio/R-Sport and with RWD and 3.0L",
                "Supercharged/L Supercharged and with 5.0L. With 380mm Diameter Front Rotor"
            ],
            "XJR575": [
                "With 380mm Diameter Front Rotor"
            ]
        },
        "Jeep": {
            "Compass": [
                ""
            ],
            "Renegade": [
                ""
            ],
            "Wrangler JK": [
                "With 332mm Diameter Front Rotor"
            ],
            "Wrangler": [
                "Rubicon. With Heavy Duty Brakes and Brake Code BR2 & BR6",
                "Sport. Without Heavy Duty Brakes and Brake Code BRY"
            ]
        },
        "Kia": {
            "Forte": [
                "With 280mm Diameter Front Rotor",
                "With 300mm Diameter Front Rotor"
            ],
            "Forte5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Niro": [
                "With 262mm Diameter Rear Rotor",
                "With 284mm Diameter Rear Rotor"
            ],
            "Optima": [
                "LX/Hybrid Premium/Hybrid EX/Hybrid LX/Hybrid EX Premium/LX 1.6T/Plug-In Hybrid EX/Plug-In Hybrid EX Premium. With Electric Parking Brake",
                "LX/Hybrid Premium/Hybrid EX/Hybrid LX/Hybrid EX Premium/LX 1.6T/Plug-In Hybrid EX/Plug-In Hybrid EX Premium. With Manual Parking Brake",
                "SX/SX Turbo/SXL Turbo. With Electric Parking Brake",
                "SX/SX Turbo/SXL Turbo. With Manual Parking Brake"
            ],
            "Rio": [
                "Except Vehicles Manufactured In Mexico",
                "Vehicles Manufactured In Mexico"
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Soul EV": [
                ""
            ],
            "Soul": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Sportage": [
                "Naturally Aspirated. With Electric Parking Brake",
                "Naturally Aspirated. With Manual Parking Brake",
                "Turbocharged. With Electric Parking Brake",
                "Turbocharged. With Manual Parking Brake"
            ],
            "Stinger": [
                "2.0L",
                "3.3L"
            ]
        },
        "Land Rover": {
            "Discovery": [
                "DIESEL engine",
                "Supercharged and with GAS engine"
            ],
            "Range Rover": [
                "3.0L and with DIESEL engine. With Dual Piston Front Caliper",
                "HSE and with 3.0L and Supercharged and GAS engine"
            ],
            "Range Rover Evoque": [
                "With 300mm Diameter Front Rotor",
                "With 325mm Diameter Front Rotor",
                "With 349mm Diameter Front Rotor"
            ],
            "Range Rover Sport": [
                "SVR"
            ]
        },
        "Lexus": {
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GS300": [
                "Base. Without F Sport Package"
            ],
            "GS350": [
                "AWD",
                "Base and with RWD. Without F Sport Package"
            ],
            "GS450h": [
                "Without F Sport Package"
            ],
            "GX460": [
                ""
            ],
            "IS300": [
                "3.5L",
                "Base and with 2.0L",
                "F Sport and with 2.0L"
            ],
            "IS350": [
                "AWD",
                "RWD"
            ],
            "LX570": [
                ""
            ],
            "NX300": [
                ""
            ],
            "NX300h": [
                ""
            ],
            "RC300": [
                "Without F Sport Package"
            ],
            "RC350": [
                "AWD. Without F Sport Package"
            ],
            "RX350": [
                "Excluding Vehicles Manufactured In Japan"
            ],
            "RX350L": [
                ""
            ],
            "RX450h": [
                ""
            ],
            "RX450hL": [
                ""
            ]
        },
        "Lincoln": {
            "Continental": [
                "With 316mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "MKC": [
                "2.3L",
                "AWD and with 2.0L",
                "FWD and with 2.0L"
            ],
            "MKT": [
                "With Vented Rear Rotors and Without Drum In Hat Parking Brake"
            ],
            "MKX": [
                "With 345mm Diameter Front Rotor"
            ],
            "MKZ": [
                "2.0L",
                "3.0L"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "6": [
                ""
            ],
            "CX-3": [
                "AWD",
                "FWD"
            ],
            "CX-5": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ]
        },
        "Mercedes-Benz": {
            "B250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C300": [
                "4Matic and with Sedan/Coupe. With Sport Package and With Vented Rear Rotors",
                "Sedan/Coupe and with RWD. With Sport Package and With Vented Rear Rotors",
                "Sedan/Coupe. Without Sport Package"
            ],
            "C43 AMG": [
                ""
            ],
            "CLA250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "CLS550": [
                ""
            ],
            "E300": [
                "With Sport Package and With 360mm Diameter Front Rotor",
                "Without Sport Package"
            ],
            "E400": [
                ""
            ],
            "E43 AMG": [
                ""
            ],
            "GLA250": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "GLC350e": [
                ""
            ],
            "GLC43 AMG": [
                ""
            ],
            "GLE350": [
                "Without Sport Appearance Package"
            ],
            "GLE400": [
                "With AMG Package"
            ],
            "GLE550e": [
                "With AMG Package"
            ],
            "GLS450": [
                "With AMG Package",
                "Without Sport Package"
            ],
            "Metris": [
                ""
            ],
            "Sprinter 2500": [
                ""
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels"
            ],
            "Sprinter 3500XD": [
                "With Dual Rear Wheels and With Manual Parking Brake"
            ]
        },
        "Mini": {
            "Cooper Clubman": [
                "Base/ALL4",
                "John Cooper Works ALL4. With Sport Package",
                "S ALL4",
                "S. With Sport Package",
                "S. Without Sport Package"
            ],
            "Cooper Countryman": [
                "Base/ALL4",
                "John Cooper Works ALL4",
                "S E ALL4",
                "S/S ALL4"
            ],
            "Cooper": [
                "S"
            ]
        },
        "Mitsubishi": {
            "Eclipse Cross": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Mirage G4": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Mirage": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Outlander PHEV": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Outlander Sport": [
                ""
            ],
            "Outlander": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                ""
            ],
            "Armada": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Kicks": [
                ""
            ],
            "LEAF": [
                "S/SL/SV. With Manual Parking Brake",
                "S. With Electric Parking Brake",
                "SL/SV. With Electric Parking Brake"
            ],
            "Maxima": [
                ""
            ],
            "Micra": [
                ""
            ],
            "Murano": [
                ""
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Qashqai": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Rogue Sport": [
                ""
            ],
            "Sentra": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "TITAN": [
                ""
            ],
            "TITAN XD": [
                ""
            ],
            "Versa": [
                ""
            ],
            "Versa Note": [
                ""
            ]
        },
        "Porsche": {
            "Cayenne": [
                "S/Platinum Edition/Base/S E-Hybrid/S E-Hybrid Platinum Edition. With 360mm Diameter Front Rotor"
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                ""
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "ProMaster 1500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 2500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 3500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster City": [
                ""
            ]
        },
        "Subaru": {
            "BRZ": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ],
            "Crosstrek": [
                ""
            ],
            "Forester": [
                "2.0L",
                "2.5L. With 292mm Diameter Front Rotor"
            ],
            "Impreza": [
                "With 276mm Diameter Front Rotor",
                "With 293mm Diameter Front Rotor"
            ],
            "Legacy": [
                "2.5L",
                "3.6L"
            ],
            "Outback": [
                ""
            ],
            "WRX STI": [
                ""
            ],
            "WRX": [
                "With Eyesight Package (Steering Responsive Fog Lights)",
                "Without Eyesight Package (Steering Responsive Fog Lights)"
            ]
        },
        "Tesla": {
            "3": [
                "With Gray Painted Calipers"
            ],
            "S": [
                "With Brembo Calipers",
                "With Single Piston Rear Caliper"
            ],
            "X": [
                "With Brembo Calipers",
                "With Single Piston Rear Caliper"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "86": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "C-HR": [
                ""
            ],
            "Camry": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Corolla": [
                ""
            ],
            "Corolla iM": [
                ""
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                "With 340mm Diameter Front Rotor",
                "With 354mm Diameter Front Rotor"
            ],
            "Mirai": [
                ""
            ],
            "Prius": [
                ""
            ],
            "Prius Prime": [
                ""
            ],
            "Prius V": [
                ""
            ],
            "RAV4": [
                "LE",
                "Limited/Hybrid Limited/Platinum/Adventure/Hybrid XLE/Hybrid SE/SE/XLE"
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Yaris": [
                "Disc rear brakes",
                "Drum rear brakes",
                "L/LE and with Drum rear brakes"
            ],
            "Yaris iA": [
                ""
            ]
        },
        "Volkswagen": {
            "Atlas": [
                ""
            ],
            "e-Golf": [
                ""
            ],
            "Golf": [
                ""
            ],
            "Golf Alltrack": [
                "With 253mm Diameter Rear Rotor",
                "With 272mm Diameter Rear Rotor"
            ],
            "Golf R": [
                ""
            ],
            "Golf SportWagen": [
                "With 288mm Diameter Front Rotor",
                "With 312mm Diameter Front Rotor"
            ],
            "GTI": [
                "With 312mm Diameter Front Rotor and Without Performance Package",
                "With Performance Package",
                "Without Performance Package and With 312mm Diameter Front Rotor"
            ],
            "Jetta": [
                "1.8L/1.4L. With 253mm Diameter Rear Rotor",
                "1.8L/1.4L. With 272mm Diameter Rear Rotor",
                "2.0L. With 253mm Diameter Rear Rotor",
                "2.0L. With 272mm Diameter Rear Rotor"
            ],
            "Passat": [
                ""
            ],
            "Tiguan": [
                ""
            ],
            "Tiguan Limited": [
                ""
            ]
        },
        "Volvo": {
            "S60 Cross Country": [
                ""
            ],
            "V60 Cross Country": [
                ""
            ]
        }
    },
    "2019": {
        "Acura": {
            "ILX": [
                ""
            ],
            "MDX": [
                "Base/SH-AWD"
            ],
            "RDX": [
                ""
            ],
            "RLX": [
                "Base",
                "Sport Hybrid SH-AWD"
            ],
            "TLX": [
                ""
            ]
        },
        "Alfa Romeo": {
            "Giulia": [
                "Sport/TI/Base"
            ],
            "Stelvio": [
                "Sport/TI/Base"
            ]
        },
        "Audi": {
            "A3 Quattro": [
                "With 312mm Diameter Front Rotor",
                "With 340mm Diameter Front Rotor"
            ],
            "A4 allroad": [
                ""
            ],
            "A5 Quattro": [
                "With 314mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "A5 Sportback": [
                "With 314mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "A6 Quattro": [
                "2.0L",
                "3.0L"
            ],
            "A7 Sportback": [
                "With 375mm Diameter Front Rotor"
            ],
            "A8 Quattro": [
                "3.0L. With 375mm Diameter Front Rotor",
                "4.0L. With 375mm Diameter Front Rotor"
            ],
            "Q3": [
                ""
            ],
            "Q8": [
                "With 375mm Diameter Front Rotor"
            ],
            "S3": [
                ""
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S5 Sportback": [
                ""
            ],
            "SQ5": [
                ""
            ],
            "TT Quattro": [
                "With 272mm Diameter Rear Rotor",
                "With 300mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "330i": [
                "With Blue Painted Calipers and With 345mm Diameter Rear Rotor"
            ],
            "640i xDrive Gran Turismo": [
                "With 345mm Diameter Rear Rotor"
            ],
            "M240i": [
                "With 340mm Diameter Front Rotor",
                "With 370mm Diameter Front Rotor and With M Performance Brakes"
            ],
            "M240i xDrive": [
                "With 340mm Diameter Front Rotor",
                "With 370mm Diameter Front Rotor and With M Performance Brakes"
            ],
            "X1": [
                ""
            ],
            "X2": [
                "M35i",
                "xDrive28i/sDrive28i"
            ],
            "X6": [
                "xDrive35i/sDrive35i",
                "xDrive50i"
            ]
        },
        "Buick": {
            "Enclave": [
                "With 321mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Encore": [
                ""
            ],
            "LaCrosse": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ]
        },
        "Cadillac": {
            "ATS": [
                "Base/Luxury. With Brembo Brakes and Without Slotted Brake Rotors",
                "Base. Without Brembo Brakes and Without Slotted Brake Rotors",
                "V. With Brembo Brakes and Without Slotted Brake Rotors"
            ],
            "CTS": [
                "2.0L",
                "3.6L and with Naturally Aspirated",
                "3.6L and with Turbocharged. With Performance Brake Lining",
                "3.6L and with Turbocharged. Without Performance Brake Lining"
            ],
            "Escalade ESV": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "XT4": [
                ""
            ],
            "XT5": [
                ""
            ],
            "XTS": [
                "Without Heavy Duty Brakes"
            ]
        },
        "Chevrolet": {
            "Blazer": [
                ""
            ],
            "Bolt EV": [
                ""
            ],
            "Camaro": [
                "LT/LS. With 4 Piston Brembo Calipers",
                "LT/LS. With 6 Piston Brembo Calipers",
                "LT/LS. Without Brembo Calipers"
            ],
            "Colorado": [
                ""
            ],
            "Cruze": [
                ""
            ],
            "Equinox": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "Express 2500": [
                ""
            ],
            "Express 4500": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Silverado 1500": [
                "With 4 Piston Front Caliper and New Body Style"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                ""
            ],
            "Spark": [
                ""
            ],
            "Suburban 3500 HD": [
                ""
            ],
            "Tahoe": [
                "Without Police Package and With 2 Piston Caliper"
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                "1.4L. Vehicles Manufactured In USA",
                "Vehicles Manufactured In USA"
            ],
            "Volt": [
                ""
            ]
        },
        "Chrysler": {
            "Pacifica": [
                ""
            ]
        },
        "Dodge": {
            "Challenger": [
                "R/T/GT. With Brembo Brakes",
                "R/T Scat Pack. With 4 Piston Caliper",
                "SXT and with AWD"
            ],
            "Grand Caravan": [
                "With Dual Piston Front Caliper"
            ],
            "Journey": [
                ""
            ]
        },
        "Fiat": {
            "500": [
                "E",
                "Pop/Lounge/c Pop/c Lounge/1957 Retro Edition"
            ],
            "500L": [
                ""
            ],
            "500X": [
                ""
            ]
        },
        "Ford": {
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "EcoSport": [
                "AWD",
                "FWD"
            ],
            "Edge": [
                "2.0L. With 316mm Diameter Front Rotor",
                "2.0L. With 345mm Diameter Front Rotor",
                "ST and with 2.7L. With Red Painted Calipers"
            ],
            "Escape": [
                "2.0L",
                "2.5L",
                "AWD and with 1.5L",
                "FWD and with 1.5L"
            ],
            "Expedition": [
                ""
            ],
            "Explorer": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "F-150": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "F-250 Super Duty": [
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                ""
            ],
            "F-550 Super Duty": [
                "4 X 2",
                "4 X 4"
            ],
            "F-59 Commercial Stripped Chassis": [
                "With Over 22000 Lb GVW",
                "With Under 22000 Lb GVW"
            ],
            "Fiesta": [
                "S/SE",
                "ST"
            ],
            "Flex": [
                "With Heavy Duty Brakes",
                "Without Heavy Duty Brakes"
            ],
            "Fusion": [
                "SE Hybrid/Titanium Hybrid/SEL Hybrid",
                "Sport"
            ],
            "Mustang": [
                "GT Premium/GT and with 5.0L. Without Brembo Brakes"
            ],
            "Police Interceptor Sedan": [
                ""
            ],
            "Police Interceptor Utility": [
                ""
            ],
            "Police Responder Hybrid": [
                ""
            ],
            "Ranger": [
                ""
            ],
            "SSV Plug-In Hybrid": [
                ""
            ],
            "Taurus": [
                "Limited/SE/SEL",
                "SHO. With Performance Package",
                "SHO. Without Performance Package"
            ],
            "Transit-150": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-250": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit-350 HD": [
                "With 6 Lug Wheels"
            ],
            "Transit-350": [
                "With 5 Lug Wheels and Without 4600 Lb Front Axle"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "Genesis": {
            "G70": [
                "2.0L and with Automatic transmission",
                "3.3L/2.0L and with Manual transmission"
            ],
            "G80": [
                "3.3L",
                "5.0L"
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 2500": [
                ""
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "Yukon": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Yukon XL": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ]
        },
        "Honda": {
            "Accord": [
                "EX-L and with 2.0L",
                "LX/EX/EX-L and with 1.5L",
                "Sport/Hybrid EX-L/Hybrid Touring/Hybrid EX/Touring/Hybrid"
            ],
            "Civic": [
                "LX/Sport/EX/EX-L/Sport Touring/Touring/DX",
                "Si"
            ],
            "Clarity": [
                ""
            ],
            "CR-V": [
                ""
            ],
            "Fit": [
                ""
            ],
            "HR-V": [
                ""
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Passport": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Elantra": [
                "1.4L/2.0L",
                "1.6L",
                "2.0L"
            ],
            "Elantra GT": [
                "Base. With Electric Parking Brake",
                "Base. With Manual Parking Brake"
            ],
            "Ioniq": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Kona Electric": [
                ""
            ],
            "Kona": [
                "SE/SEL and with FWD",
                "Ultimate/Limited and with FWD",
                "Ultimate/Limited/SE/SEL and with AWD"
            ],
            "Nexo": [
                ""
            ],
            "Santa Fe": [
                "With Dual Piston Front Caliper",
                "With Single Piston Front Caliper"
            ],
            "Santa Fe XL": [
                ""
            ],
            "Tucson": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Veloster N": [
                "With Performance Package",
                "Without Performance Package"
            ],
            "Veloster": [
                "Naturally Aspirated",
                "Turbocharged"
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q60": [
                "With Dual Piston Caliper"
            ],
            "Q70": [
                "With Dual Piston Caliper"
            ],
            "Q70L": [
                "With Dual Piston Caliper"
            ],
            "QX30": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "QX50": [
                ""
            ],
            "QX60": [
                ""
            ],
            "QX80": [
                ""
            ]
        },
        "Jaguar": {
            "E-Pace": [
                "With 325mm Diameter Front Rotor"
            ],
            "XE": [
                "3.0L. With Vented Rear Rotors"
            ],
            "XF": [
                "2.0L and with GAS engine. With 350mm Diameter Front Rotor and With 325mm Diameter Rear Rotor",
                "3.0L. With 325mm Diameter Rear Rotor and With 350mm Diameter Front Rotor",
                "DIESEL engine. With 350mm Diameter Front Rotor and With 325mm Diameter Rear Rotor"
            ],
            "XJ": [
                "Supercharged/L Supercharged and with 5.0L",
                "XJ50 and with 5.0L. With 325mm Diameter Rear Rotor"
            ]
        },
        "Jeep": {
            "Compass": [
                "With Heavy Duty Brakes"
            ],
            "Renegade": [
                ""
            ],
            "Wrangler": [
                "Rubicon. With Heavy Duty Brakes and Brake Code BR2 & BR6",
                "Sport. Without Heavy Duty Brakes and Brake Code BRY"
            ]
        },
        "Kia": {
            "Forte": [
                ""
            ],
            "Niro EV": [
                ""
            ],
            "Niro": [
                "With 262mm Diameter Rear Rotor",
                "With 284mm Diameter Rear Rotor"
            ],
            "Optima": [
                "LX/Hybrid EX/Hybrid LX/Hybrid EX Premium/Plug-In Hybrid EX. With Electric Parking Brake",
                "LX/Hybrid EX/Hybrid LX/Hybrid EX Premium/Plug-In Hybrid EX. With Manual Parking Brake",
                "SX. With Electric Parking Brake",
                "SX. With Manual Parking Brake"
            ],
            "Rio": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Soul EV": [
                ""
            ],
            "Soul": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Sportage": [
                "Naturally Aspirated. With Electric Parking Brake",
                "Naturally Aspirated. With Manual Parking Brake",
                "Turbocharged. With Electric Parking Brake",
                "Turbocharged. With Manual Parking Brake"
            ],
            "Stinger": [
                "2.0L",
                "3.3L"
            ]
        },
        "Land Rover": {
            "Discovery": [
                "DIESEL engine",
                "Supercharged and with GAS engine"
            ],
            "Range Rover Evoque": [
                "With 300mm Diameter Front Rotor",
                "With 325mm Diameter Front Rotor",
                "With 349mm Diameter Front Rotor"
            ],
            "Range Rover Sport": [
                "SVR"
            ],
            "Range Rover": [
                "SV Autobiography/SV Autobiography Dynamic and with 5.0L"
            ]
        },
        "Lexus": {
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GS300": [
                "Base"
            ],
            "GS350": [
                "AWD",
                "Base and with RWD. Without F Sport Package"
            ],
            "GX460": [
                ""
            ],
            "IS300": [
                "3.5L",
                "Base and with 2.0L",
                "F Sport and with 2.0L"
            ],
            "IS350": [
                "AWD",
                "RWD"
            ],
            "LX570": [
                ""
            ],
            "NX300": [
                ""
            ],
            "NX300h": [
                ""
            ],
            "RC300": [
                "Without F Sport Package"
            ],
            "RC350": [
                "AWD. Without F Sport Package"
            ],
            "RX350": [
                ""
            ],
            "RX350L": [
                ""
            ],
            "RX450h": [
                ""
            ],
            "RX450hL": [
                ""
            ],
            "UX200": [
                ""
            ],
            "UX250h": [
                ""
            ]
        },
        "Lincoln": {
            "Continental": [
                "With 316mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "MKC": [
                "2.3L",
                "AWD and with 2.0L",
                "FWD and with 2.0L"
            ],
            "MKT": [
                "With Vented Rear Rotors and Without Drum In Hat Parking Brake"
            ],
            "MKZ": [
                "2.0L",
                "3.0L"
            ],
            "Nautilus": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "3": [
                "AWD",
                "FWD"
            ],
            "3 Sport": [
                "AWD",
                "FWD"
            ],
            "6": [
                "Naturally Aspirated"
            ],
            "CX-3": [
                "AWD",
                "FWD"
            ],
            "CX-5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ]
        },
        "Mercedes-Benz": {
            "A220": [
                "With Standard Brakes"
            ],
            "B250": [
                "With Sport Package",
                "Without Sport Package"
            ],
            "C300": [
                "Without Sport Package"
            ],
            "C43 AMG": [
                ""
            ],
            "CLA250": [
                "",
                "With Sport Package"
            ],
            "CLS450": [
                ""
            ],
            "E300": [
                "With Sport Package and With 360mm Diameter Front Rotor",
                "Without Sport Package"
            ],
            "E450": [
                "Convertible/Coupe"
            ],
            "GLA250": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "GLC350e": [
                ""
            ],
            "GLC43 AMG": [
                ""
            ],
            "GLE400": [
                "With AMG Package",
                "Without Sport Package"
            ],
            "GLS450": [
                "With AMG Package",
                "Without Sport Package"
            ],
            "Metris": [
                ""
            ],
            "Sprinter 1500": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sprinter 2500": [
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ],
            "Sprinter 3500XD": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ],
            "Sprinter 4500": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ]
        },
        "Mini": {
            "Cooper Clubman": [
                "Base/ALL4",
                "John Cooper Works ALL4. With Sport Package",
                "S ALL4",
                "S. With Sport Package",
                "S. Without Sport Package"
            ],
            "Cooper Countryman": [
                "Base/ALL4. To 04/19",
                "John Cooper Works ALL4",
                "John Cooper Works ALL4. With 360mm Diameter Front Rotor",
                "S E ALL4",
                "S/S ALL4. To 04/19"
            ],
            "Cooper": [
                "S"
            ]
        },
        "Mitsubishi": {
            "Eclipse Cross": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Mirage G4": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Mirage": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Outlander PHEV": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Outlander Sport": [
                ""
            ],
            "Outlander": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                "AWD. With Electric Parking Brake",
                "AWD. With Manual Parking Brake",
                "FWD. With Manual Parking Brake"
            ],
            "Armada": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "Frontier": [
                "4WD",
                "RWD and with 2.5L",
                "RWD and with 4.0L"
            ],
            "Kicks": [
                ""
            ],
            "LEAF": [
                "SL/SV/SL Plus/SV Plus. With Electric Parking Brake",
                "SL/SV/SL Plus/SV Plus. With Manual Parking Brake"
            ],
            "Maxima": [
                ""
            ],
            "Micra": [
                ""
            ],
            "Murano": [
                ""
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Qashqai": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Rogue": [
                "FULL HYBRID EV-GAS (FHEV) engine. With Electric Parking Brake",
                "FULL HYBRID EV-GAS (FHEV) engine. With Manual Parking Brake",
                "GAS engine. With Electric Parking Brake",
                "GAS engine. With Manual Parking Brake"
            ],
            "Rogue Sport": [
                "S/SV. With Manual Parking Brake",
                "S. With Electric Parking Brake",
                "SL/SV. With Electric Parking Brake",
                "SL. With Manual Parking Brake"
            ],
            "Sentra": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "TITAN": [
                ""
            ],
            "TITAN XD": [
                ""
            ],
            "Versa": [
                ""
            ],
            "Versa Note": [
                ""
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "1500 Classic": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                "With Single Rear Wheels"
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "ProMaster 1500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 2500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 3500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster City": [
                ""
            ]
        },
        "Subaru": {
            "Ascent": [
                ""
            ],
            "BRZ": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ],
            "Crosstrek": [
                "GAS engine",
                "PLUG-IN HYBRID EV-GAS (PHEV) engine"
            ],
            "Forester": [
                "With 294mm Diameter Front Rotor",
                "With 316mm Diameter Front Rotor"
            ],
            "Impreza": [
                "With 276mm Diameter Front Rotor",
                "With 293mm Diameter Front Rotor"
            ],
            "Legacy": [
                "2.5L",
                "3.6L"
            ],
            "Outback": [
                ""
            ],
            "WRX STI": [
                ""
            ],
            "WRX": [
                "With Eyesight Package (Steering Responsive Fog Lights)",
                "Without Eyesight Package (Steering Responsive Fog Lights)"
            ]
        },
        "Tesla": {
            "3": [
                "With Gray Painted Calipers"
            ],
            "S": [
                "With Brembo Calipers",
                "With Single Piston Rear Caliper"
            ],
            "X": [
                "With Brembo Calipers",
                "With Single Piston Rear Caliper"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "86": [
                "Base/GT. With Brembo Brakes",
                "Base/GT. Without Brembo Brakes",
                "TRD Special Edition. With Brembo Brakes",
                "TRD Special Edition. Without Brembo Brakes"
            ],
            "Avalon": [
                ""
            ],
            "C-HR": [
                "Excluding Vehicles Manufactured In Japan and From 05/18",
                "To 06/18 and Vehicles Manufactured In Japan"
            ],
            "Camry": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Corolla": [
                "1.8L",
                "2.0L"
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                "With 340mm Diameter Front Rotor",
                "With 354mm Diameter Front Rotor"
            ],
            "Mirai": [
                ""
            ],
            "Prius": [
                ""
            ],
            "Prius AWD-e": [
                ""
            ],
            "Prius Prime": [
                "From 05/19",
                "To 04/19"
            ],
            "RAV4": [
                ""
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Yaris": [
                "L/LE/XLE"
            ]
        },
        "Volkswagen": {
            "Arteon": [
                "With 312mm Diameter Front Rotor",
                "With 340mm Diameter Front Rotor"
            ],
            "Atlas": [
                ""
            ],
            "e-Golf": [
                ""
            ],
            "Golf": [
                "1.4L"
            ],
            "Golf Alltrack": [
                "With 253mm Diameter Rear Rotor",
                "With 272mm Diameter Rear Rotor"
            ],
            "Golf R": [
                ""
            ],
            "Golf SportWagen": [
                "With 288mm Diameter Front Rotor"
            ],
            "GTI": [
                "S/Autobahn/SE/Rabbit Edition",
                "S/Autobahn/SE/Rabbit Edition. Performance Package and w/ Electric Parking Brake, or Performance Package and w/o Electric Parking Brake"
            ],
            "Jetta": [
                "1.4L",
                "2.0L"
            ],
            "Passat": [
                ""
            ],
            "Tiguan": [
                ""
            ]
        }
    },
    "2020": {
        "Acura": {
            "ILX": [
                ""
            ],
            "MDX": [
                "Base/SH-AWD"
            ],
            "RDX": [
                ""
            ],
            "RLX": [
                "Base",
                "Sport Hybrid SH-AWD"
            ],
            "TLX": [
                ""
            ]
        },
        "Alfa Romeo": {
            "Stelvio": [
                "Sport/TI/Base"
            ]
        },
        "Audi": {
            "A3 Quattro": [
                "With 312mm Diameter Front Rotor",
                "With 340mm Diameter Front Rotor"
            ],
            "A3": [
                "With 312mm Diameter Front Rotor"
            ],
            "A4 allroad": [
                "From 11/25/19",
                "To 11/25/19"
            ],
            "A6 Quattro": [
                "2.0L. From 11/25/19",
                "2.0L. To 11/25/19",
                "3.0L. From 11/25/19",
                "3.0L. To 11/25/19"
            ],
            "Q3": [
                ""
            ],
            "Q5 PHEV": [
                "From 01/06/20",
                "To 01/06/20"
            ],
            "S3": [
                ""
            ],
            "S4": [
                "From 11/25/19",
                "To 11/25/19"
            ],
            "S5": [
                "From 11/25/19",
                "To 11/25/19"
            ],
            "S5 Sportback": [
                "From 11/25/19",
                "To 11/25/19"
            ],
            "SQ5": [
                "From 01/06/20",
                "To 01/06/20"
            ],
            "TT Quattro": [
                "With 272mm Diameter Rear Rotor",
                "With 300mm Diameter Rear Rotor"
            ]
        },
        "BMW": {
            "228i xDrive Gran Coupe": [
                "With Blue Painted Calipers",
                "Without Blue Painted Calipers"
            ],
            "330i": [
                "With Blue Painted Calipers and With 345mm Diameter Rear Rotor"
            ],
            "M240i": [
                "With 340mm Diameter Front Rotor",
                "With 370mm Diameter Front Rotor and With M Performance Brakes"
            ],
            "M240i xDrive": [
                "With 340mm Diameter Front Rotor",
                "With 370mm Diameter Front Rotor and With M Performance Brakes"
            ],
            "X1": [
                "xDrive28i/sDrive28i"
            ],
            "X2": [
                "M35i",
                "xDrive28i/sDrive28i"
            ]
        },
        "Buick": {
            "Encore": [
                ""
            ],
            "Encore GX": [
                ""
            ],
            "Regal TourX": [
                "With 321mm Diameter Front Rotor"
            ]
        },
        "Cadillac": {
            "CT4": [
                "With 321mm Diameter Front Rotor and With 4 Piston Front Caliper",
                "With 4 Piston Front Caliper and With 321mm Diameter Front Rotor"
            ],
            "Escalade ESV": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "XT4": [
                "",
                "With Performance Brake Lining"
            ],
            "XT5": [
                ""
            ],
            "XT6": [
                ""
            ]
        },
        "Chevrolet": {
            "Blazer": [
                ""
            ],
            "Bolt EV": [
                ""
            ],
            "Camaro": [
                "LT/LS. With 4 Piston Brembo Calipers",
                "LT/LS. With 6 Piston Front Brembo Calipers",
                "LT/LS. Without Brembo Calipers"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "Without Z51 Performance Package and With 339mm Diameter Rear Rotor"
            ],
            "Equinox": [
                "1.5L. With 300mm Diameter Front Rotor",
                "2.0L. With 321mm Diameter Front Rotor and From Chassis / VIN # LS723983",
                "2.0L. With 321mm Diameter Front Rotor and To Chassis / VIN # LS723983"
            ],
            "Express 2500": [
                ""
            ],
            "Express 4500": [
                ""
            ],
            "Impala": [
                ""
            ],
            "Malibu": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Silverado 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Sonic": [
                ""
            ],
            "Spark": [
                ""
            ],
            "Suburban": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Tahoe": [
                "Without Police Package and With 2 Piston Caliper"
            ],
            "Traverse": [
                "From Chassis / VIN # LJ29652",
                "To Chassis / VIN # LJ29652"
            ],
            "Trax": [
                "1.4L. Vehicles Manufactured In USA",
                "Vehicles Manufactured In USA"
            ]
        },
        "Chrysler": {
            "Voyager": [
                ""
            ]
        },
        "Dodge": {
            "Challenger": [
                "R/T/GT. With Brembo Brakes",
                "R/T/GT. Without Brembo Brakes",
                "R/T Scat Pack. With 4 Piston Caliper",
                "SXT and with AWD"
            ],
            "Charger": [
                "Pursuit and with RWD. With 370mm Diameter Front Rotor",
                "R/T/GT. With Brembo Brakes",
                "R/T/GT. Without Brembo Brakes and With 345mm Diameter Front Rotor",
                "Scat Pack. With 4 Piston Caliper"
            ],
            "Grand Caravan": [
                ""
            ],
            "Journey": [
                ""
            ]
        },
        "Fiat": {
            "500L": [
                ""
            ],
            "500X": [
                ""
            ]
        },
        "Ford": {
            "EcoSport": [
                "AWD",
                "FWD"
            ],
            "Escape": [
                ""
            ],
            "Expedition": [
                ""
            ],
            "F-150": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "F-250 Super Duty": [
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                ""
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-600 Super Duty": [
                ""
            ],
            "Fusion": [
                "SE Hybrid/Titanium Hybrid/SEL Hybrid"
            ],
            "Mustang": [
                "GT Premium/GT and with 5.0L. Without Brembo Brakes"
            ],
            "Police Interceptor Utility": [
                "With Electric Parking Brake"
            ],
            "Police Responder Hybrid": [
                ""
            ],
            "Ranger": [
                ""
            ],
            "SSV Plug-In Hybrid": [
                ""
            ],
            "Transit-150": [
                "AWD. With 6 Lug Wheels"
            ],
            "Transit-250": [
                "AWD. With 6 Lug Wheels"
            ],
            "Transit-350": [
                "AWD. With 6 Lug Wheels"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "Genesis": {
            "G70": [
                "2.0L and with Automatic transmission. Without Performance Brakes",
                "3.3L/2.0L and with Manual transmission"
            ],
            "G80": [
                "3.3L",
                "5.0L"
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 2500": [
                ""
            ],
            "Savana 4500": [
                ""
            ],
            "Sierra 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor and To Chassis / VIN # LS723983"
            ],
            "Yukon": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Yukon XL": [
                "With 2 Piston Caliper",
                "With 6 Piston Front Brembo Calipers"
            ]
        },
        "Honda": {
            "Accord": [
                "EX-L and with 2.0L",
                "LX/EX/EX-L and with 1.5L",
                "Sport/Hybrid EX-L/Hybrid Touring/Hybrid EX/Touring/Hybrid"
            ],
            "Civic": [
                "EX/EX-L and with Hatchback and 1.5L",
                "EX/EX-L/Touring and with Sedan and 1.5L",
                "LX/Sport and with 2.0L",
                "LX/Sport/Sport Touring and with 1.5L",
                "Si and with Sedan and 1.5L"
            ],
            "Clarity": [
                ""
            ],
            "CR-V": [
                "1.5L and with GAS engine",
                "2.0L and with FULL HYBRID EV-GAS (FHEV) engine"
            ],
            "Fit": [
                ""
            ],
            "HR-V": [
                ""
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Passport": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Elantra": [
                "1.4L/2.0L",
                "1.6L",
                "2.0L"
            ],
            "Elantra GT": [
                "Base",
                "N Line"
            ],
            "Ioniq": [
                "With Manual Parking Brake"
            ],
            "Kona Electric": [
                ""
            ],
            "Kona": [
                "SE/SEL and with FWD",
                "Ultimate/Limited and with FWD",
                "Ultimate/Limited/SE/SEL and with AWD"
            ],
            "Nexo": [
                ""
            ],
            "Palisade": [
                ""
            ],
            "Santa Fe": [
                ""
            ],
            "Sonata": [
                "1.6L/2.0L",
                "2.5L and with Naturally Aspirated"
            ],
            "Tucson": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Veloster N": [
                "With Performance Package",
                "Without Performance Package"
            ],
            "Veloster": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Venue": [
                ""
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q60": [
                "With Dual Piston Caliper"
            ],
            "QX50": [
                ""
            ],
            "QX60": [
                ""
            ],
            "QX80": [
                ""
            ]
        },
        "Jaguar": {
            "E-Pace": [
                "With 325mm Diameter Front Rotor",
                "With 349mm Diameter Front Rotor"
            ],
            "XF": [
                "With 350mm Diameter Front Rotor and With 325mm Diameter Rear Rotor"
            ]
        },
        "Jeep": {
            "Compass": [
                "With Heavy Duty Brakes"
            ],
            "Gladiator": [
                ""
            ],
            "Renegade": [
                ""
            ],
            "Wrangler": [
                "Rubicon. With Heavy Duty Brakes and Brake Code BR2 & BR6",
                "Sport. Without Heavy Duty Brakes and Brake Code BRY"
            ]
        },
        "Kia": {
            "Forte": [
                "1.6L",
                "2.0L"
            ],
            "Forte5": [
                "2.0L. With Electric Parking Brake",
                "2.0L. With Manual Parking Brake"
            ],
            "Niro EV": [
                ""
            ],
            "Niro": [
                "With Manual Parking Brake"
            ],
            "Rio": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Sorento": [
                ""
            ],
            "Soul": [
                "1.6L and with Turbocharged",
                "2.0L and with Naturally Aspirated"
            ],
            "Soul EV": [
                ""
            ],
            "Sportage": [
                "Naturally Aspirated. With Electric Parking Brake",
                "Naturally Aspirated. With Manual Parking Brake",
                "Turbocharged. With Electric Parking Brake",
                "Turbocharged. With Manual Parking Brake"
            ],
            "Stinger": [
                "2.0L",
                "3.3L"
            ],
            "Telluride": [
                ""
            ]
        },
        "Land Rover": {
            "Discovery": [
                "DIESEL engine",
                "Supercharged and with GAS engine"
            ],
            "Range Rover": [
                "SV Autobiography/SV Autobiography Dynamic and with GAS engine. With 350mm Diameter Front Rotor",
                "SV Autobiography/SV Autobiography Dynamic and with GAS engine. With 363mm Diameter Front Rotor",
                "SV Autobiography/SV Autobiography Dynamic and with GAS engine. With 380mm Diameter Front Rotor"
            ]
        },
        "Lexus": {
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GS350": [
                "Base and with RWD. Without F Sport Package"
            ],
            "GX460": [
                ""
            ],
            "IS300": [
                "3.5L",
                "Base and with 2.0L",
                "F Sport and with 2.0L"
            ],
            "IS350": [
                "AWD",
                "Base and with RWD. Without F Sport Package",
                "RWD. With F Sport Package"
            ],
            "LX570": [
                ""
            ],
            "NX300": [
                ""
            ],
            "NX300h": [
                ""
            ],
            "RC300": [
                "Without F Sport Package"
            ],
            "RC350": [
                "AWD. Without F Sport Package"
            ],
            "RX350": [
                "Excluding Vehicles Manufactured In Japan"
            ],
            "RX350L": [
                ""
            ],
            "RX450h": [
                ""
            ],
            "RX450hL": [
                ""
            ],
            "UX200": [
                ""
            ],
            "UX250h": [
                ""
            ]
        },
        "Lincoln": {
            "Aviator": [
                "With 345mm Diameter Front Rotor and With Standard Brakes",
                "With 363mm Diameter Front Rotor and With Performance Brakes",
                "With Performance Brakes and With 363mm Diameter Front Rotor"
            ],
            "Continental": [
                "With 316mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Corsair": [
                ""
            ],
            "MKZ": [
                "2.0L",
                "3.0L"
            ],
            "Nautilus": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "3": [
                "AWD",
                "FWD"
            ],
            "3 Sport": [
                "FWD"
            ],
            "6": [
                "Naturally Aspirated"
            ],
            "CX-3": [
                "AWD",
                "FWD"
            ],
            "CX-30": [
                "With 264mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "CX-5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "CX-9": [
                ""
            ],
            "MX-5 Miata": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ]
        },
        "Mercedes-Benz": {
            "A220": [
                "With Standard Brakes"
            ],
            "C300": [
                "Without Sport Package"
            ],
            "C43 AMG": [
                ""
            ],
            "CLA250": [
                "With Standard Brakes"
            ],
            "CLS450": [
                ""
            ],
            "E350": [
                "With Sport Package and With 360mm Diameter Front Rotor"
            ],
            "E450": [
                "Convertible/Coupe"
            ],
            "GLA250": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "GLB250": [
                "With Sport Package"
            ],
            "GLC350e": [
                ""
            ],
            "GLC43 AMG": [
                ""
            ],
            "Metris": [
                ""
            ],
            "Sprinter 1500": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sprinter 2500": [
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500XD": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ],
            "Sprinter 4500": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ]
        },
        "Mini": {
            "Cooper": [
                "Base and with GAS engine",
                "John Cooper Works and with GAS engine",
                "S and with GAS engine"
            ],
            "Cooper Clubman": [
                "John Cooper Works ALL4. With Sport Package",
                "S. With Sport Package"
            ],
            "Cooper Countryman": [
                "John Cooper Works ALL4",
                "John Cooper Works ALL4. With 360mm Diameter Front Rotor"
            ]
        },
        "Mitsubishi": {
            "Eclipse Cross": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Mirage G4": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Mirage": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Outlander PHEV": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Outlander Sport": [
                ""
            ],
            "Outlander": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "370Z": [
                "With Dual Piston Caliper"
            ],
            "Altima": [
                "AWD. With Electric Parking Brake",
                "AWD. With Manual Parking Brake",
                "FWD. With Manual Parking Brake"
            ],
            "Armada": [
                ""
            ],
            "Frontier": [
                ""
            ],
            "Kicks": [
                ""
            ],
            "LEAF": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                ""
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Qashqai": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Rogue Sport": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Rogue": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sentra": [
                "",
                "Disc rear brakes"
            ],
            "TITAN": [
                ""
            ],
            "TITAN XD": [
                ""
            ],
            "Versa": [
                ""
            ]
        },
        "Ram": {
            "1500": [
                ""
            ],
            "1500 Classic": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "ProMaster 1500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 2500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster 3500": [
                "With Solid Rotor",
                "With Vented Rotor"
            ],
            "ProMaster City": [
                ""
            ]
        },
        "Subaru": {
            "Ascent": [
                ""
            ],
            "BRZ": [
                "With Brembo Brakes"
            ],
            "Crosstrek": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Forester": [
                "With 294mm Diameter Front Rotor",
                "With 316mm Diameter Front Rotor"
            ],
            "Impreza": [
                "With 276mm Diameter Front Rotor",
                "With 293mm Diameter Front Rotor"
            ],
            "Legacy": [
                ""
            ],
            "Outback": [
                ""
            ],
            "WRX STI": [
                ""
            ],
            "WRX": [
                "With Eyesight Package (Steering Responsive Fog Lights)"
            ]
        },
        "Tesla": {
            "3": [
                "With Gray Painted Calipers"
            ],
            "Y": [
                "With Gray Painted Calipers"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "86": [
                "With Brembo Brakes",
                "Without Brembo Brakes"
            ],
            "Avalon": [
                "Limited/XSE/Touring/XLE",
                "TRD"
            ],
            "C-HR": [
                "Vehicles Manufactured In Japan",
                "With Electric Parking Brake and Excluding Vehicles Manufactured In Japan"
            ],
            "Camry": [
                "Hybrid LE/Hybrid XLE/Hybrid SE/XLE",
                "L/LE/SE",
                "TRD",
                "XSE. With TRD Package",
                "XSE. Without TRD Package"
            ],
            "Corolla": [
                "FULL HYBRID EV-GAS (FHEV) engine. With Electric Parking Brake",
                "FULL HYBRID EV-GAS (FHEV) engine. With Manual Parking Brake",
                "GAS engine. With Electric Parking Brake",
                "GAS engine. With Manual Parking Brake"
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                "With 340mm Diameter Front Rotor",
                "With 354mm Diameter Front Rotor"
            ],
            "Mirai": [
                ""
            ],
            "Prius": [
                ""
            ],
            "Prius AWD-e": [
                ""
            ],
            "Prius Prime": [
                ""
            ],
            "RAV4": [
                ""
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Yaris": [
                "L/LE/XLE"
            ]
        },
        "Volkswagen": {
            "Arteon": [
                "",
                "340mm Front Rotor, 310mm Rear Rotor"
            ],
            "Atlas": [
                ""
            ],
            "Atlas Cross Sport": [
                ""
            ],
            "e-Golf": [
                ""
            ],
            "Golf": [
                ""
            ],
            "GTI": [
                "S/SE",
                "S/SE. Performance Package and w/ Electric Parking Brake, or Performance Package and w/o Electric Parking Brake"
            ],
            "Jetta": [
                "1.4L",
                "2.0L"
            ],
            "Passat": [
                ""
            ],
            "Tiguan": [
                ""
            ]
        }
    },
    "2021": {
        "Acura": {
            "ILX": [
                ""
            ],
            "RDX": [
                ""
            ],
            "TLX": [
                "2.0L",
                "3.0L"
            ]
        },
        "Audi": {
            "A4 allroad": [
                ""
            ],
            "A5 Quattro": [
                "With 314mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "A6 Quattro": [
                "2.0L",
                "3.0L"
            ],
            "A7 Sportback": [
                "With 375mm Diameter Front Rotor"
            ],
            "A8 Quattro": [
                "3.0L and with MILD HYBRID EV-GAS (MHEV) engine. With 375mm Diameter Front Rotor",
                "4.0L. With 375mm Diameter Front Rotor"
            ],
            "Q3": [
                ""
            ],
            "Q5 PHEV": [
                ""
            ],
            "Q5 Sportback": [
                ""
            ],
            "Q5": [
                "With 338mm Diameter Front Rotor",
                "With 350mm Diameter Front Rotor"
            ],
            "Q8": [
                "With 375mm Diameter Front Rotor"
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S5 Sportback": [
                ""
            ],
            "SQ5": [
                ""
            ],
            "SQ5 Sportback": [
                ""
            ],
            "TT Quattro": [
                ""
            ]
        },
        "BMW": {
            "228i Gran Coupe": [
                "With Blue Painted Calipers",
                "Without Blue Painted Calipers"
            ],
            "228i xDrive Gran Coupe": [
                "With Blue Painted Calipers",
                "Without Blue Painted Calipers"
            ],
            "X1": [
                ""
            ],
            "X2": [
                "M35i",
                "xDrive28i/sDrive28i"
            ]
        },
        "Buick": {
            "Enclave": [
                "With 321mm Diameter Front Rotor",
                "With 345mm Diameter Front Rotor"
            ],
            "Encore": [
                ""
            ],
            "Encore GX": [
                ""
            ],
            "Envision": [
                "",
                "2.0L"
            ]
        },
        "Cadillac": {
            "CT4": [
                "With 321mm Diameter Front Rotor and With 4 Piston Front Caliper",
                "With 4 Piston Front Caliper and With 321mm Diameter Front Rotor"
            ],
            "Escalade ESV": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "XT4": [
                "",
                "With Performance Brake Lining"
            ],
            "XT5": [
                ""
            ],
            "XT6": [
                ""
            ]
        },
        "Chevrolet": {
            "Blazer": [
                ""
            ],
            "Bolt EV": [
                ""
            ],
            "Camaro": [
                "LT and with 2.0L",
                "LT. With 321mm Diameter Front Rotor",
                "LT. With 4 Piston Brembo Calipers"
            ],
            "Colorado": [
                ""
            ],
            "Corvette": [
                "Without Z51 Performance Package and With 339mm Diameter Rear Rotor"
            ],
            "Equinox": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "Express 2500": [
                ""
            ],
            "Malibu": [
                "With Electric Parking Brake"
            ],
            "Silverado 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Spark": [
                ""
            ],
            "Suburban": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Tahoe": [
                "With 6 Piston Front Brembo Calipers and Without Police Package",
                "Without Police Package and With 4 Piston Front Caliper",
                "Without Police Package and With 6 Piston Front Brembo Calipers"
            ],
            "Trailblazer": [
                ""
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                ""
            ]
        },
        "Chrysler": {
            "Grand Caravan": [
                ""
            ],
            "Voyager": [
                ""
            ]
        },
        "Dodge": {
            "Challenger": [
                "R/T/GT. With Brembo Brakes",
                "R/T/GT. Without Brembo Brakes",
                "SRT Super Stock",
                "SXT and with AWD"
            ],
            "Charger": [
                "Pursuit and with RWD. With 370mm Diameter Front Rotor",
                "R/T/GT. With Brembo Brakes",
                "R/T/GT. Without Brembo Brakes",
                "Scat Pack and with RWD. With 370mm Diameter Front Rotor",
                "Scat Pack. With 4 Piston Caliper",
                "Scat Pack. With 6 Piston Calipers",
                "SXT and with AWD",
                "SXT and with RWD. With 320mm Diameter Front Rotor"
            ]
        },
        "Fiat": {
            "500X": [
                ""
            ]
        },
        "Ford": {
            "Bronco": [
                ""
            ],
            "Bronco Sport": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "EcoSport": [
                "AWD",
                "FWD"
            ],
            "Escape": [
                ""
            ],
            "Expedition": [
                ""
            ],
            "F-150": [
                "With 336mm Diameter Rear Rotor",
                "With 350mm Diameter Rear Rotor",
                "With Standard Brakes and With 336mm Diameter Rear Rotor"
            ],
            "F-250 Super Duty": [
                "4WD. With Single Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                ""
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-600 Super Duty": [
                ""
            ],
            "Mustang Mach-E": [
                "GT. Without Performance Package",
                "Premium/Select/First Edition/California Route 1"
            ],
            "Police Interceptor Utility": [
                "With Electric Parking Brake"
            ],
            "Ranger": [
                ""
            ],
            "Transit-150": [
                "AWD. With 6 Lug Wheels"
            ],
            "Transit-250": [
                "AWD. With 6 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 111mm Bolt Circle",
                "RWD. With 5 Lug Wheels and With 115mm Bolt Circle"
            ],
            "Transit-350": [
                "AWD. With 6 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 111mm Bolt Circle",
                "RWD. With 5 Lug Wheels and With 115mm Bolt Circle"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "Genesis": {
            "G70": [
                "2.0L and with Automatic transmission. Without Performance Brakes",
                "3.3L/2.0L and with Manual transmission"
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 2500": [
                ""
            ],
            "Sierra 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                "With 300mm Diameter Front Rotor",
                "With 321mm Diameter Front Rotor"
            ],
            "Yukon": [
                "With 4 Piston Front Caliper"
            ],
            "Yukon XL": [
                "With 4 Piston Front Caliper"
            ]
        },
        "Honda": {
            "Accord": [
                "LX/EX-L",
                "Sport/Sport SE/Hybrid EX-L/Hybrid Touring/Hybrid EX/Touring/Hybrid"
            ],
            "Civic": [
                "EX and with Hatchback and 1.5L",
                "EX and with Sedan and 1.5L",
                "EX-L",
                "LX/Sport and with 1.5L",
                "LX/Sport and with 2.0L",
                "Sport Touring"
            ],
            "Clarity": [
                ""
            ],
            "CR-V": [
                "GAS engine"
            ],
            "HR-V": [
                ""
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Passport": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Elantra": [
                "N Line. With Electric Parking Brake",
                "N Line. With Manual Parking Brake",
                "Ultimate/Limited/Limited Hybrid/Preferred/SE/Essential/SEL Hybrid/Preferred Hybrid/Ultimate Hybrid/SEL. With Electric Parking Brake",
                "Ultimate/Limited/Limited Hybrid/Preferred/SE/Essential/SEL Hybrid/Preferred Hybrid/Ultimate Hybrid/SEL. With Manual Parking Brake"
            ],
            "Ioniq": [
                "With Manual Parking Brake"
            ],
            "Kona Electric": [
                ""
            ],
            "Kona": [
                "SE/SEL and with FWD",
                "Ultimate/Limited and with FWD",
                "Ultimate/Limited/SE/SEL and with AWD"
            ],
            "Palisade": [
                ""
            ],
            "Santa Fe": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS engine"
            ],
            "Sonata": [
                "Hybrid Limited/Hybrid SEL/Hybrid Ultimate/Hybrid Blue and with 2.0L",
                "Limited/SEL Plus and with 1.6L",
                "N Line",
                "SE/SEL and with 2.5L and Naturally Aspirated"
            ],
            "Tucson": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Veloster N": [
                ""
            ],
            "Veloster": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Venue": [
                ""
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q60": [
                "With Dual Piston Caliper"
            ],
            "QX50": [
                ""
            ],
            "QX80": [
                ""
            ]
        },
        "Jeep": {
            "Compass": [
                "With Heavy Duty Brakes"
            ],
            "Gladiator": [
                ""
            ],
            "Renegade": [
                ""
            ],
            "Wrangler": [
                "Without Heavy Duty Brakes and Brake Code BRY"
            ]
        },
        "Kia": {
            "Forte": [
                "1.6L",
                "2.0L"
            ],
            "Forte5": [
                "1.6L. With Electric Parking Brake",
                "1.6L. With Manual Parking Brake",
                "2.0L. With Electric Parking Brake",
                "2.0L. With Manual Parking Brake"
            ],
            "K5": [
                "1.6L",
                "2.5L"
            ],
            "Niro EV": [
                ""
            ],
            "Niro": [
                "With Manual Parking Brake"
            ],
            "Rio": [
                ""
            ],
            "Sedona": [
                ""
            ],
            "Seltos": [
                "Automatic Dual Clutch transmission. With Electric Parking Brake",
                "Automatic Dual Clutch transmission. With Manual Parking Brake",
                "AWD and with Automatic CVT transmission. With Electric Parking Brake",
                "AWD and with Automatic CVT transmission. With Manual Parking Brake",
                "FWD and with Automatic CVT transmission. With Electric Parking Brake",
                "FWD and with Automatic CVT transmission. With Manual Parking Brake"
            ],
            "Sorento": [
                "FULL HYBRID EV-GAS (FHEV) engine",
                "GAS engine"
            ],
            "Soul": [
                "1.6L and with Turbocharged",
                "2.0L and with Naturally Aspirated"
            ],
            "Soul EV": [
                ""
            ],
            "Sportage": [
                "Naturally Aspirated. With Electric Parking Brake",
                "Naturally Aspirated. With Manual Parking Brake",
                "Turbocharged. With Electric Parking Brake",
                "Turbocharged. With Manual Parking Brake"
            ],
            "Stinger": [
                "2.0L",
                "3.3L"
            ],
            "Telluride": [
                ""
            ]
        },
        "Land Rover": {
            "Range Rover Sport": [
                "SVR/SVR Carbon Edition and with 5.0L. With 350mm Diameter Front Rotor",
                "SVR/SVR Carbon Edition and with 5.0L. With 363mm Diameter Front Rotor",
                "SVR/SVR Carbon Edition and with 5.0L. With 380mm Diameter Front Rotor"
            ]
        },
        "Lexus": {
            "ES250": [
                ""
            ],
            "ES300h": [
                "Excluding Vehicles Manufactured In Japan"
            ],
            "ES350": [
                "Excluding Vehicles Manufactured In Japan"
            ],
            "GX460": [
                ""
            ],
            "IS350": [
                "Base"
            ],
            "LX570": [
                ""
            ],
            "NX300": [
                ""
            ],
            "NX300h": [
                ""
            ],
            "RC350": [
                "Base. Without F Sport Package"
            ],
            "RX350": [
                ""
            ],
            "RX350L": [
                ""
            ],
            "RX450h": [
                ""
            ],
            "RX450hL": [
                ""
            ],
            "UX200": [
                ""
            ],
            "UX250h": [
                ""
            ]
        },
        "Lincoln": {
            "Aviator": [
                "With 345mm Diameter Front Rotor and With Standard Brakes",
                "With 363mm Diameter Front Rotor and With Performance Brakes",
                "With Performance Brakes and With 363mm Diameter Front Rotor"
            ],
            "Corsair": [
                "GAS engine"
            ],
            "Nautilus": [
                "With Solid Rear Rotors",
                "With Vented Rear Rotors"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "3": [
                "AWD",
                "FWD"
            ],
            "3 Sport": [
                "AWD",
                "FWD"
            ],
            "6": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "CX-3": [
                "AWD",
                "FWD"
            ],
            "CX-30": [
                "With 264mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "CX-5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "CX-9": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "A220": [
                "With Standard Brakes"
            ],
            "C300": [
                "Without Sport Package"
            ],
            "C43 AMG": [
                ""
            ],
            "CLA250": [
                "With Standard Brakes"
            ],
            "E350": [
                "With Sport Package and With 360mm Diameter Front Rotor"
            ],
            "E450": [
                ""
            ],
            "E53 AMG": [
                "With 360mm Diameter Front Rotor",
                "With 370mm Diameter Front Rotor"
            ],
            "GLB250": [
                "With Sport Package"
            ],
            "GLC43 AMG": [
                ""
            ],
            "Metris": [
                "To 04/01/21"
            ],
            "Sprinter 1500": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sprinter 2500": [
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500XD": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ],
            "Sprinter 4500": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ]
        },
        "Mini": {
            "Cooper": [
                "Base and with GAS engine",
                "John Cooper Works and with GAS engine",
                "John Cooper Works GP and with GAS engine",
                "S and with GAS engine"
            ],
            "Cooper Clubman": [
                "John Cooper Works ALL4"
            ],
            "Cooper Countryman": [
                "Base/ALL4",
                "John Cooper Works ALL4",
                "S/S ALL4"
            ]
        },
        "Mitsubishi": {
            "Mirage G4": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Mirage": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Outlander PHEV": [
                ""
            ],
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "Altima": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Armada": [
                ""
            ],
            "Frontier": [
                ""
            ],
            "Kicks": [
                "S and with Drum rear brakes",
                "SV/SR and with Disc rear brakes"
            ],
            "LEAF": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                "To 11/20"
            ],
            "NV1500": [
                ""
            ],
            "NV200": [
                "With Taxi Package",
                "Without Taxi Package"
            ],
            "NV2500": [
                ""
            ],
            "NV3500": [
                ""
            ],
            "Qashqai": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Rogue Sport": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sentra": [
                "",
                "Disc rear brakes"
            ],
            "TITAN": [
                ""
            ],
            "TITAN XD": [
                ""
            ],
            "Versa": [
                ""
            ]
        },
        "Ram": {
            "1500": [
                "5.7L/3.6L/3.0L",
                "6.2L"
            ],
            "1500 Classic": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ],
            "ProMaster City": [
                ""
            ]
        },
        "Subaru": {
            "Ascent": [
                ""
            ],
            "Crosstrek": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Forester": [
                "With 294mm Diameter Front Rotor",
                "With 316mm Diameter Front Rotor"
            ],
            "Impreza": [
                "With 276mm Diameter Front Rotor",
                "With 293mm Diameter Front Rotor"
            ],
            "Legacy": [
                ""
            ],
            "Outback": [
                ""
            ],
            "WRX": [
                "With Eyesight Package (Steering Responsive Fog Lights)"
            ]
        },
        "Tesla": {
            "3": [
                "With Gray Painted Calipers"
            ],
            "S": [
                "Long Range/Long Range Plus. With Single Piston Rear Caliper and From 02/21"
            ],
            "Y": [
                "With Gray Painted Calipers"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                "Limited/Hybrid Limited/Hybrid XLE/XSE/Hybrid XSE/Touring/XLE",
                "TRD"
            ],
            "C-HR": [
                "Vehicles Manufactured In Japan",
                "With Electric Parking Brake and Excluding Vehicles Manufactured In Japan"
            ],
            "Camry": [
                "LE/SE/SE Nightshade and with AWD",
                "LE/SE/SE Nightshade and with FWD"
            ],
            "Corolla": [
                "FULL HYBRID EV-GAS (FHEV) engine. With Electric Parking Brake",
                "FULL HYBRID EV-GAS (FHEV) engine. With Manual Parking Brake",
                "GAS engine. With Electric Parking Brake",
                "GAS engine. With Manual Parking Brake"
            ],
            "Highlander": [
                ""
            ],
            "Land Cruiser": [
                ""
            ],
            "Prius": [
                ""
            ],
            "Prius AWD-e": [
                ""
            ],
            "Prius Prime": [
                ""
            ],
            "RAV4": [
                ""
            ],
            "RAV4 Prime": [
                ""
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ]
        },
        "Volkswagen": {
            "Arteon": [
                "",
                "340mm Front Rotor, 310mm Rear Rotor"
            ],
            "Atlas Cross Sport": [
                "To 09/28/20"
            ],
            "Atlas": [
                "To 09/28/20"
            ],
            "Golf": [
                "To 09/30/20"
            ],
            "GTI": [
                "",
                "Performance Package and w/ Electric Parking Brake, or Performance Package and w/o Electric Parking Brake"
            ],
            "Jetta": [
                "1.4L",
                "2.0L"
            ],
            "Passat": [
                ""
            ],
            "Tiguan": [
                ""
            ]
        },
        "Volvo": {
            "XC40 Recharge": [
                ""
            ]
        }
    },
    "2022": {
        "Acura": {
            "ILX": [
                ""
            ],
            "MDX": [
                "3.0L",
                "3.5L"
            ],
            "RDX": [
                ""
            ],
            "TLX": [
                "2.0L",
                "3.0L"
            ]
        },
        "Audi": {
            "A4 allroad": [
                ""
            ],
            "A5 Quattro": [
                "With 314mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "A6 Quattro": [
                "2.0L"
            ],
            "Q5 PHEV": [
                ""
            ],
            "Q5 Sportback": [
                ""
            ],
            "Q8": [
                "With 375mm Diameter Front Rotor"
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S5 Sportback": [
                ""
            ],
            "SQ5": [
                ""
            ],
            "SQ5 Sportback": [
                ""
            ],
            "TT Quattro": [
                ""
            ]
        },
        "BMW": {
            "228i Gran Coupe": [
                "With Blue Painted Calipers",
                "Without Blue Painted Calipers"
            ],
            "228i xDrive Gran Coupe": [
                "With Blue Painted Calipers",
                "Without Blue Painted Calipers"
            ],
            "iX": [
                "With 345mm Diameter Rear Rotor"
            ],
            "X1": [
                ""
            ],
            "X2": [
                "M35i",
                "xDrive28i/sDrive28i"
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "Encore": [
                ""
            ],
            "Encore GX": [
                ""
            ],
            "Envision": [
                "",
                "2.0L"
            ]
        },
        "Cadillac": {
            "CT4": [
                "With 321mm Diameter Front Rotor and With 4 Piston Front Caliper",
                "With 4 Piston Front Caliper and With 321mm Diameter Front Rotor"
            ],
            "Escalade ESV": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "XT4": [
                "",
                "With Performance Brake Lining"
            ]
        },
        "Chevrolet": {
            "Blazer": [
                ""
            ],
            "Bolt EUV": [
                "LT"
            ],
            "Bolt EV": [
                ""
            ],
            "Camaro": [
                "LS and with 2.0L. Without Brembo Brakes",
                "LT and with 2.0L. With 321mm Diameter Front Rotor",
                "LT and with 2.0L. Without 1LE Performance and With 4 Piston Front Brembo Calipers",
                "LT. With 321mm Diameter Front Rotor and Without Brembo Brakes",
                "LT. Without Brembo Brakes and With 321mm Diameter Front Rotor",
                "LT1. With 1LE Performance and With 4 Piston Front Brembo Calipers and w/ Track Package"
            ],
            "Colorado": [
                ""
            ],
            "Equinox": [
                "With 300mm Diameter Front Rotor"
            ],
            "Express 2500": [
                ""
            ],
            "Malibu": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Silverado 1500 LTD": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Silverado 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Spark": [
                ""
            ],
            "Suburban": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Tahoe": [
                "With 6 Piston Front Brembo Calipers and Without Police Package",
                "Without Police Package and With 4 Piston Front Caliper",
                "Without Police Package and With 6 Piston Front Brembo Calipers"
            ],
            "Trailblazer": [
                ""
            ],
            "Traverse": [
                ""
            ],
            "Trax": [
                ""
            ]
        },
        "Chrysler": {
            "Grand Caravan": [
                ""
            ],
            "Voyager": [
                ""
            ]
        },
        "Dodge": {
            "Challenger": [
                "R/T/GT. With Brembo Brakes",
                "R/T/GT. Without Brembo Brakes",
                "R/T Scat Pack. With 4 Piston Caliper",
                "SRT Super Stock",
                "SXT and with AWD",
                "SXT and with RWD. With Brembo Brakes"
            ],
            "Charger": [
                "Pursuit and with RWD. With 370mm Diameter Front Rotor",
                "R/T/GT. With Brembo Brakes",
                "R/T/GT. Without Brembo Brakes",
                "Scat Pack. With 4 Piston Caliper",
                "SXT and with AWD",
                "SXT and with RWD. With 320mm Diameter Front Rotor"
            ]
        },
        "Ford": {
            "Bronco": [
                "2.3L/2.7L",
                "3.0L"
            ],
            "Bronco Sport": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "EcoSport": [
                "AWD"
            ],
            "Escape": [
                ""
            ],
            "Expedition": [
                ""
            ],
            "F-150 Lightning": [
                ""
            ],
            "F-150": [
                "With 336mm Diameter Rear Rotor",
                "With 350mm Diameter Rear Rotor",
                "With Standard Brakes and With 336mm Diameter Rear Rotor"
            ],
            "F-250 Super Duty": [
                "4WD",
                "RWD"
            ],
            "F-350 Super Duty": [
                "4WD. With Dual Rear Wheels",
                "4WD. With Single Rear Wheels",
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels"
            ],
            "F-450 Super Duty": [
                ""
            ],
            "F-550 Super Duty": [
                ""
            ],
            "F-600 Super Duty": [
                ""
            ],
            "Maverick": [
                ""
            ],
            "Mustang": [
                "5.0L. With 6 Piston Calipers"
            ],
            "Mustang Mach-E": [
                "GT. Without Performance Package",
                "Premium/Select/California Route 1"
            ],
            "Ranger": [
                ""
            ],
            "Transit-150": [
                "AWD. With 6 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 111mm Bolt Circle",
                "RWD. With 5 Lug Wheels and With 115mm Bolt Circle"
            ],
            "Transit-250": [
                "AWD. With 6 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 111mm Bolt Circle",
                "RWD. With 5 Lug Wheels and With 115mm Bolt Circle"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "Genesis": {
            "G70": [
                "2.0L",
                "3.3L. With 330mm Diameter Rear Rotor",
                "3.3L. With 340mm Diameter Rear Rotor"
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Canyon": [
                ""
            ],
            "Savana 2500": [
                ""
            ],
            "Sierra 1500 Limited": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                "With 300mm Diameter Front Rotor"
            ],
            "Yukon": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Yukon XL": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ]
        },
        "Honda": {
            "Accord": [
                "LX/EX-L",
                "Sport/Sport SE/Touring/Hybrid"
            ],
            "Civic": [
                "LX/Sport/EX/Sport Touring/Touring"
            ],
            "CR-V": [
                "GAS engine"
            ],
            "HR-V": [
                ""
            ],
            "Insight": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Passport": [
                ""
            ],
            "Pilot": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Accent": [
                ""
            ],
            "Elantra": [
                "N Line. With Electric Parking Brake",
                "N Line. With Manual Parking Brake",
                "Ultimate/Limited/Limited Hybrid/Preferred/GLS Premium/Limited Tech/SE/Essential/Preferred Hybrid/Ultimate Hybrid/Blue Hybrid/SEL/GLS. With Electric Parking Brake",
                "Ultimate/Limited/Limited Hybrid/Preferred/GLS Premium/Limited Tech/SE/Essential/Preferred Hybrid/Ultimate Hybrid/Blue Hybrid/SEL/GLS. With Manual Parking Brake"
            ],
            "Ioniq 5": [
                ""
            ],
            "Ioniq": [
                "With Manual Parking Brake"
            ],
            "Kona": [
                "AWD. With Electric Parking Brake",
                "AWD. With Manual Parking Brake",
                "FWD and with 1.6L. With Electric Parking Brake",
                "FWD and with 1.6L. With Manual Parking Brake",
                "FWD and with 2.0L. With Electric Parking Brake",
                "FWD and with 2.0L. With Manual Parking Brake"
            ],
            "Kona Electric": [
                ""
            ],
            "Palisade": [
                ""
            ],
            "Santa Cruz": [
                ""
            ],
            "Santa Fe": [
                "GAS engine",
                "PLUG-IN HYBRID EV-GAS (PHEV)/FULL HYBRID EV-GAS (FHEV) engine"
            ],
            "Sonata": [
                "N Line",
                "Preferred/SE/SEL and with 2.5L and Naturally Aspirated"
            ],
            "Tucson": [
                ""
            ],
            "Venue": [
                ""
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "Q60": [
                "With Dual Piston Caliper"
            ],
            "QX50": [
                ""
            ],
            "QX55": [
                ""
            ],
            "QX60": [
                ""
            ],
            "QX80": [
                ""
            ]
        },
        "Jeep": {
            "Compass": [
                "Brake Code BRF"
            ],
            "Gladiator": [
                ""
            ],
            "Grand Cherokee WK": [
                "With Vented Rear Rotors"
            ],
            "Grand Wagoneer": [
                ""
            ],
            "Renegade": [
                ""
            ],
            "Wagoneer": [
                ""
            ]
        },
        "Kia": {
            "Carnival": [
                ""
            ],
            "EV6": [
                ""
            ],
            "Forte": [
                "1.6L. With Electric Parking Brake",
                "1.6L. With Manual Parking Brake",
                "2.0L. With Electric Parking Brake",
                "2.0L. With Manual Parking Brake"
            ],
            "Forte5": [
                "1.6L. With Electric Parking Brake",
                "1.6L. With Manual Parking Brake",
                "2.0L. With Electric Parking Brake",
                "2.0L. With Manual Parking Brake"
            ],
            "K5": [
                "1.6L",
                "2.5L"
            ],
            "Niro EV": [
                ""
            ],
            "Niro": [
                "With Manual Parking Brake"
            ],
            "Rio": [
                ""
            ],
            "Seltos": [
                "AWD. With Electric Parking Brake",
                "AWD. With Manual Parking Brake",
                "FWD and with Automatic CVT transmission. With Electric Parking Brake",
                "FWD and with Automatic CVT transmission. With Manual Parking Brake"
            ],
            "Sorento": [
                "GAS engine",
                "PLUG-IN HYBRID EV-GAS (PHEV)/FULL HYBRID EV-GAS (FHEV) engine"
            ],
            "Soul": [
                "1.6L and with Turbocharged",
                "2.0L and with Naturally Aspirated"
            ],
            "Soul EV": [
                ""
            ],
            "Sportage": [
                "Naturally Aspirated. With Electric Parking Brake",
                "Naturally Aspirated. With Manual Parking Brake",
                "Turbocharged. With Electric Parking Brake",
                "Turbocharged. With Manual Parking Brake"
            ],
            "Stinger": [
                "3.3L. With Brembo Brakes"
            ],
            "Telluride": [
                ""
            ]
        },
        "Lexus": {
            "ES250": [
                ""
            ],
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GX460": [
                ""
            ],
            "LX600": [
                ""
            ],
            "NX250": [
                ""
            ],
            "NX350": [
                ""
            ],
            "NX350h": [
                ""
            ],
            "RX350": [
                ""
            ],
            "RX350L": [
                ""
            ],
            "RX450h": [
                ""
            ],
            "RX450hL": [
                ""
            ],
            "UX200": [
                ""
            ],
            "UX250h": [
                ""
            ]
        },
        "Lincoln": {
            "Aviator": [
                "With 345mm Diameter Front Rotor and With Standard Brakes",
                "With 363mm Diameter Front Rotor and With Performance Brakes",
                "With Performance Brakes and With 363mm Diameter Front Rotor"
            ],
            "Corsair": [
                "GAS engine"
            ],
            "Nautilus": [
                "With Solid Rear Rotors",
                "With Solid Rear Rotors and With 350mm Diameter Front Rotor",
                "With Vented Rear Rotors"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "3": [
                "AWD",
                "FWD"
            ],
            "3 Sport": [
                "AWD",
                "FWD"
            ],
            "CX-3": [
                "AWD",
                "FWD"
            ],
            "CX-30": [
                "With 264mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "CX-5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "CX-9": [
                ""
            ],
            "MX-30 EV": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "A220": [
                "With Standard Brakes"
            ],
            "C43 AMG": [
                ""
            ],
            "CLA250": [
                "With Standard Brakes"
            ],
            "E450": [
                ""
            ],
            "EQB 300": [
                ""
            ],
            "EQB 350": [
                ""
            ],
            "GLB250": [
                "With Sport Package"
            ],
            "GLC43 AMG": [
                ""
            ],
            "Sprinter 1500": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Sprinter 2500": [
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500": [
                "RWD. With Dual Rear Wheels",
                "RWD. With Single Rear Wheels and With Electric Parking Brake",
                "RWD. With Single Rear Wheels and With Manual Parking Brake",
                "With Dual Rear Wheels",
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500XD": [
                "RWD. With Dual Rear Wheels and With Manual Parking Brake",
                "RWD. With Single Rear Wheels and With Electric Parking Brake",
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ],
            "Sprinter 4500": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ]
        },
        "Mini": {
            "Cooper": [
                "Base and with GAS engine",
                "John Cooper Works and with GAS engine",
                "S and with GAS engine"
            ],
            "Cooper Clubman": [
                "John Cooper Works ALL4"
            ],
            "Cooper Countryman": [
                "Base/ALL4",
                "John Cooper Works ALL4",
                "S/S ALL4"
            ]
        },
        "Mitsubishi": {
            "Eclipse Cross": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Mirage G4": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Mirage": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Outlander": [
                ""
            ],
            "Outlander PHEV": [
                ""
            ],
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "Altima": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Armada": [
                ""
            ],
            "Frontier": [
                ""
            ],
            "Kicks": [
                "S and with Drum rear brakes",
                "SV/SR and with Disc rear brakes"
            ],
            "LEAF": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Maxima": [
                ""
            ],
            "Murano": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Qashqai": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Rogue Sport": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Rogue": [
                "Vehicles Manufactured In Japan"
            ],
            "Sentra": [
                "",
                "Disc rear brakes"
            ],
            "TITAN": [
                ""
            ],
            "TITAN XD": [
                ""
            ],
            "Versa": [
                ""
            ]
        },
        "Ram": {
            "1500": [
                "5.7L/3.6L/3.0L",
                "6.2L"
            ],
            "1500 Classic": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                "With Single Rear Wheels"
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ]
        },
        "Subaru": {
            "Ascent": [
                ""
            ],
            "BRZ": [
                "With 292mm Diameter Front Rotor"
            ],
            "Crosstrek": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Forester": [
                "With 294mm Diameter Front Rotor",
                "With 316mm Diameter Front Rotor"
            ],
            "Impreza": [
                "With 276mm Diameter Front Rotor",
                "With 293mm Diameter Front Rotor"
            ],
            "Legacy": [
                ""
            ],
            "Outback": [
                ""
            ]
        },
        "Tesla": {
            "3": [
                "With Gray Painted Calipers"
            ],
            "S": [
                "Base. With Single Piston Rear Caliper"
            ],
            "X": [
                "Base. With Single Piston Rear Caliper"
            ],
            "Y": [
                "With Gray Painted Calipers"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "Avalon": [
                ""
            ],
            "C-HR": [
                "Vehicles Manufactured In Japan"
            ],
            "Camry": [
                "LE/Hybrid LE/Hybrid XLE/Hybrid SE/SE/SE Nightshade/XLE. With Electric Parking Brake",
                "LE/Hybrid LE/Hybrid XLE/Hybrid SE/SE/SE Nightshade/XLE. With Manual Parking Brake",
                "TRD. With Electric Parking Brake",
                "TRD. With Manual Parking Brake"
            ],
            "Corolla Cross": [
                ""
            ],
            "Corolla": [
                "FULL HYBRID EV-GAS (FHEV) engine. With Electric Parking Brake",
                "FULL HYBRID EV-GAS (FHEV) engine. With Manual Parking Brake",
                "GAS engine. With Electric Parking Brake",
                "GAS engine. With Manual Parking Brake"
            ],
            "GR86": [
                "With 292mm Diameter Front Rotor"
            ],
            "Highlander": [
                ""
            ],
            "Prius": [
                ""
            ],
            "Prius AWD-e": [
                ""
            ],
            "Prius Prime": [
                ""
            ],
            "RAV4": [
                ""
            ],
            "RAV4 Prime": [
                ""
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ]
        },
        "Volkswagen": {
            "Arteon": [
                "",
                "340mm Front Rotor, 310mm Rear Rotor"
            ],
            "Atlas": [
                ""
            ],
            "Atlas Cross Sport": [
                ""
            ],
            "Passat": [
                ""
            ],
            "Taos": [
                "AWD. With 288mm Diameter Front Rotor",
                "AWD. With 312mm Diameter Front Rotor",
                "FWD. With 288mm Diameter Front Rotor",
                "FWD. With 312mm Diameter Front Rotor"
            ],
            "Tiguan": [
                ""
            ]
        },
        "Volvo": {
            "C40 Recharge": [
                ""
            ],
            "XC40 Recharge": [
                ""
            ]
        }
    },
    "2023": {
        "Acura": {
            "MDX": [
                "3.0L",
                "3.5L"
            ],
            "RDX": [
                ""
            ],
            "TLX": [
                "2.0L",
                "3.0L"
            ]
        },
        "Audi": {
            "A4 allroad": [
                ""
            ],
            "A5 Quattro": [
                "With 314mm Diameter Front Rotor",
                "With 338mm Diameter Front Rotor"
            ],
            "A6 Quattro": [
                "2.0L"
            ],
            "Q5 PHEV": [
                ""
            ],
            "Q5 Sportback": [
                ""
            ],
            "S4": [
                ""
            ],
            "S5": [
                ""
            ],
            "S5 Sportback": [
                ""
            ],
            "SQ5": [
                ""
            ],
            "SQ5 Sportback": [
                ""
            ]
        },
        "Buick": {
            "Enclave": [
                ""
            ],
            "Encore GX": [
                ""
            ],
            "Envision": [
                "",
                "2.0L"
            ]
        },
        "Cadillac": {
            "CT4": [
                "With 321mm Diameter Front Rotor and With 4 Piston Front Caliper",
                "With 4 Piston Front Caliper and With 321mm Diameter Front Rotor"
            ],
            "Escalade ESV": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Escalade": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "XT4": [
                "",
                "With Performance Brake Lining"
            ]
        },
        "Chevrolet": {
            "Blazer": [
                ""
            ],
            "Bolt EV": [
                ""
            ],
            "Equinox": [
                ""
            ],
            "Express 2500": [
                ""
            ],
            "Malibu": [
                ""
            ],
            "Silverado 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Single Rear Wheels"
            ],
            "Suburban": [
                "With 4 Piston Front Caliper"
            ],
            "Tahoe": [
                "With 6 Piston Front Brembo Calipers and Without Police Package",
                "Without Police Package and With 4 Piston Front Caliper",
                "Without Police Package and With 6 Piston Front Brembo Calipers"
            ],
            "Trailblazer": [
                ""
            ],
            "Traverse": [
                ""
            ]
        },
        "Chrysler": {
            "Grand Caravan": [
                ""
            ],
            "Voyager": [
                ""
            ]
        },
        "Dodge": {
            "Challenger": [
                "R/T/GT. With Brembo Brakes",
                "SXT and with AWD",
                "SXT and with RWD. With Brembo Brakes"
            ],
            "Charger": [
                "Pursuit and with RWD. With 370mm Diameter Front Rotor",
                "R/T/GT. Without Brembo Brakes",
                "SXT and with AWD",
                "SXT and with RWD. With 320mm Diameter Front Rotor"
            ],
            "Hornet": [
                "Without Red Painted Calipers"
            ]
        },
        "Ford": {
            "Bronco": [
                "2.3L/2.7L",
                "3.0L"
            ],
            "Bronco Sport": [
                ""
            ],
            "E-350 Super Duty": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "E-450 Super Duty": [
                ""
            ],
            "Escape": [
                ""
            ],
            "Expedition": [
                ""
            ],
            "F-150 Lightning": [
                "With 336mm Diameter Rear Rotor",
                "With 350mm Diameter Rear Rotor"
            ],
            "F-150": [
                "With 336mm Diameter Rear Rotor",
                "With 350mm Diameter Rear Rotor",
                "With Standard Brakes and With 336mm Diameter Rear Rotor"
            ],
            "Maverick": [
                ""
            ],
            "Mustang Mach-E": [
                "GT. Without Performance Package",
                "Premium/Select/California Route 1"
            ],
            "Ranger": [
                ""
            ],
            "Transit-150": [
                "AWD. With 6 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 111mm Bolt Circle",
                "RWD. With 5 Lug Wheels and With 115mm Bolt Circle"
            ],
            "Transit-250": [
                "AWD. With 6 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 111mm Bolt Circle",
                "RWD. With 5 Lug Wheels and With 115mm Bolt Circle"
            ],
            "Transit-350": [
                "AWD. With 6 Lug Wheels",
                "RWD. With 5 Lug Wheels and With 111mm Bolt Circle",
                "RWD. With 5 Lug Wheels and With 115mm Bolt Circle"
            ],
            "Transit-350 HD": [
                "RWD. With Dual Rear Wheels and With Solid Rear Rotors"
            ],
            "Transit Connect": [
                ""
            ]
        },
        "Genesis": {
            "G70": [
                "2.0L. With Brembo Brakes",
                "2.0L. Without Brembo Brakes"
            ]
        },
        "GMC": {
            "Acadia": [
                ""
            ],
            "Savana 2500": [
                ""
            ],
            "Sierra 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                "With 300mm Diameter Front Rotor"
            ],
            "Yukon": [
                "With 4 Piston Front Caliper"
            ],
            "Yukon XL": [
                "With 4 Piston Front Caliper"
            ]
        },
        "Honda": {
            "Accord": [
                "1.5L",
                "2.0L"
            ],
            "Civic": [
                "LX/Sport/EX/Sport Touring/Touring"
            ],
            "CR-V": [
                "GAS engine"
            ],
            "HR-V": [
                ""
            ],
            "Odyssey": [
                ""
            ],
            "Passport": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Elantra": [
                "GLS Premium Hibrido/Limited/Limited Hybrid/Luxury/Preferred/GLS Premium/Limited Tech/SE/Essential/Preferred Hybrid/Ultimate Hybrid/Blue Hybrid/SEL/GLS. With Electric Parking Brake",
                "GLS Premium Hibrido/Limited/Limited Hybrid/Luxury/Preferred/GLS Premium/Limited Tech/SE/Essential/Preferred Hybrid/Ultimate Hybrid/Blue Hybrid/SEL/GLS. With Manual Parking Brake",
                "N Line and with Turbocharged. With Electric Parking Brake",
                "N Line and with Turbocharged. With Manual Parking Brake"
            ],
            "Ioniq 5": [
                ""
            ],
            "Ioniq 6": [
                ""
            ],
            "Kona": [
                "AWD. With Electric Parking Brake",
                "AWD. With Manual Parking Brake",
                "FWD and with 2.0L. With Electric Parking Brake",
                "FWD and with 2.0L. With Manual Parking Brake"
            ],
            "Kona Electric": [
                ""
            ],
            "Palisade": [
                ""
            ],
            "Santa Cruz": [
                ""
            ],
            "Santa Fe": [
                "GAS engine",
                "PLUG-IN HYBRID EV-GAS (PHEV)/FULL HYBRID EV-GAS (FHEV) engine"
            ],
            "Sonata": [
                "Hybrid Limited/Hybrid SEL/Hybrid Ultimate/Hybrid Blue and with 2.0L",
                "Limited/Sport/SEL Plus and with 1.6L",
                "N Line",
                "Preferred/SE/SEL and with 2.5L and Naturally Aspirated"
            ],
            "Tucson": [
                ""
            ],
            "Venue": [
                ""
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "QX55": [
                ""
            ],
            "QX60": [
                ""
            ],
            "QX80": [
                ""
            ]
        },
        "Jeep": {
            "Compass": [
                ""
            ],
            "Gladiator": [
                ""
            ],
            "Grand Wagoneer": [
                ""
            ],
            "Grand Wagoneer L": [
                ""
            ],
            "Wagoneer": [
                ""
            ],
            "Wagoneer L": [
                ""
            ]
        },
        "Kia": {
            "Carnival": [
                ""
            ],
            "EV6": [
                "Long Range/Wind/Standard Range/GT-Line"
            ],
            "Forte": [
                "1.6L. With Electric Parking Brake",
                "2.0L. With Electric Parking Brake"
            ],
            "K5": [
                "1.6L",
                "2.5L"
            ],
            "Niro EV": [
                ""
            ],
            "Rio": [
                ""
            ],
            "Seltos": [
                "AWD. With Electric Parking Brake",
                "AWD. With Manual Parking Brake",
                "FWD and with Automatic CVT transmission. With Electric Parking Brake",
                "FWD and with Automatic CVT transmission. With Manual Parking Brake"
            ],
            "Sorento": [
                "GAS engine",
                "PLUG-IN HYBRID EV-GAS (PHEV)/FULL HYBRID EV-GAS (FHEV) engine"
            ],
            "Soul EV": [
                ""
            ],
            "Sportage": [
                ""
            ]
        },
        "Lexus": {
            "ES250": [
                ""
            ],
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "GX460": [
                ""
            ],
            "LX600": [
                ""
            ],
            "NX250": [
                ""
            ],
            "NX350": [
                ""
            ],
            "NX350h": [
                ""
            ],
            "RZ450e": [
                ""
            ],
            "UX250h": [
                ""
            ]
        },
        "Lincoln": {
            "Aviator": [
                "AWD. With 363mm Diameter Front Rotor and With Performance Brakes",
                "AWD. With Performance Brakes and With 363mm Diameter Front Rotor",
                "RWD. With 345mm Diameter Front Rotor and With Standard Brakes"
            ],
            "Corsair": [
                "GAS engine"
            ],
            "Nautilus": [
                "With Solid Rear Rotors",
                "With Solid Rear Rotors and With 350mm Diameter Front Rotor",
                "With Vented Rear Rotors"
            ],
            "Navigator": [
                ""
            ]
        },
        "Mazda": {
            "3": [
                "AWD",
                "FWD"
            ],
            "3 Sport": [
                "AWD",
                "FWD"
            ],
            "CX-30": [
                "With 264mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "CX-5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "CX-50": [
                ""
            ],
            "CX-9": [
                ""
            ],
            "MX-30 EV": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "C43 AMG": [
                "Convertible/Coupe and with 3.0L and GAS engine"
            ],
            "CLA250": [
                "With Standard Brakes"
            ],
            "GLB250": [
                "With Sport Package"
            ],
            "Sprinter 1500": [
                "With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ],
            "Sprinter 2500": [
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ],
            "Sprinter 3500XD": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ],
            "Sprinter 4500": [
                "With Dual Rear Wheels and With Manual Parking Brake",
                "With Single Rear Wheels and With Electric Parking Brake"
            ]
        },
        "Mini": {
            "Cooper Clubman": [
                "John Cooper Works ALL4"
            ],
            "Cooper Countryman": [
                "John Cooper Works ALL4"
            ]
        },
        "Mitsubishi": {
            "Mirage G4": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Mirage": [
                "With 1 Mounting Hole",
                "With 2 Mounting Holes"
            ],
            "Outlander": [
                ""
            ],
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "Altima": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Armada": [
                ""
            ],
            "Frontier": [
                ""
            ],
            "Kicks": [
                "S and with Drum rear brakes",
                "SV/SR and with Disc rear brakes"
            ],
            "LEAF": [
                "With Electric Parking Brake"
            ],
            "Murano": [
                ""
            ],
            "Pathfinder": [
                ""
            ],
            "Qashqai": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Rogue": [
                ""
            ],
            "Sentra": [
                "Disc rear brakes"
            ],
            "TITAN": [
                ""
            ],
            "TITAN XD": [
                ""
            ],
            "Versa": [
                ""
            ]
        },
        "Ram": {
            "1500": [
                "5.7L/3.6L/3.0L",
                "6.2L"
            ],
            "1500 Classic": [
                ""
            ],
            "2500": [
                ""
            ],
            "3500": [
                "With Single Rear Wheels"
            ],
            "4500": [
                ""
            ],
            "5500": [
                ""
            ]
        },
        "Subaru": {
            "Ascent": [
                ""
            ],
            "BRZ": [
                "With 292mm Diameter Front Rotor"
            ],
            "Crosstrek": [
                "With Electric Parking Brake",
                "With Manual Parking Brake"
            ],
            "Forester": [
                "With 316mm Diameter Front Rotor"
            ],
            "Impreza": [
                "With 276mm Diameter Front Rotor",
                "With 293mm Diameter Front Rotor"
            ],
            "Legacy": [
                ""
            ],
            "Outback": [
                ""
            ],
            "Solterra": [
                ""
            ],
            "WRX": [
                "With Electric Parking Brake"
            ]
        },
        "Tesla": {
            "S": [
                "Base. With Single Piston Rear Caliper"
            ],
            "X": [
                "Base. With Single Piston Rear Caliper"
            ]
        },
        "Toyota": {
            "4Runner": [
                ""
            ],
            "bZ4X": [
                ""
            ],
            "Camry": [
                "LE/Hybrid LE/Hybrid XLE/Hybrid SE/SE/Hybrid XSE/XLE. With Electric Parking Brake",
                "LE/Hybrid LE/Hybrid XLE/Hybrid SE/SE/Hybrid XSE/XLE. With Manual Parking Brake",
                "TRD"
            ],
            "Corolla": [
                ""
            ],
            "Corolla Cross": [
                ""
            ],
            "Crown": [
                "Limited",
                "Platinum"
            ],
            "GR86": [
                "With 292mm Diameter Front Rotor"
            ],
            "Highlander": [
                ""
            ],
            "Prius": [
                "AWD"
            ],
            "RAV4": [
                ""
            ],
            "RAV4 Prime": [
                ""
            ],
            "Sequoia": [
                ""
            ],
            "Sienna": [
                ""
            ],
            "Tacoma": [
                "",
                "With 6 Lug Wheels"
            ],
            "Tundra": [
                ""
            ],
            "Venza": [
                ""
            ]
        },
        "Volkswagen": {
            "Arteon": [
                "340mm Front Rotor, 310mm Rear Rotor"
            ],
            "Atlas": [
                ""
            ],
            "Atlas Cross Sport": [
                ""
            ],
            "Taos": [
                "AWD. With 288mm Diameter Front Rotor",
                "AWD. With 312mm Diameter Front Rotor",
                "FWD. With 288mm Diameter Front Rotor",
                "FWD. With 312mm Diameter Front Rotor"
            ]
        },
        "Volvo": {
            "C40 Recharge": [
                ""
            ],
            "XC40 Recharge": [
                ""
            ]
        }
    },
    "2024": {
        "Acura": {
            "Integra": [
                "1.5L"
            ],
            "RDX": [
                ""
            ]
        },
        "Buick": {
            "Encore GX": [
                ""
            ]
        },
        "Cadillac": {
            "Escalade ESV": [
                "With 4 Piston Front Caliper"
            ],
            "Escalade": [
                "With 4 Piston Front Caliper"
            ]
        },
        "Chevrolet": {
            "Blazer": [
                ""
            ],
            "Equinox": [
                "With Single Piston Front Caliper"
            ],
            "Express 2500": [
                ""
            ],
            "Silverado 1500": [
                "With 4 Piston Front Caliper"
            ],
            "Silverado 2500 HD": [
                ""
            ],
            "Silverado 3500 HD": [
                "With Single Rear Wheels"
            ],
            "Suburban": [
                "With 4 Piston Front Caliper"
            ],
            "Trailblazer": [
                ""
            ]
        },
        "Chrysler": {
            "Grand Caravan": [
                ""
            ],
            "Voyager": [
                ""
            ]
        },
        "Ford": {
            "F-150": [
                "With 336mm Diameter Rear Rotor",
                "With 350mm Diameter Rear Rotor",
                "With Standard Brakes and With 336mm Diameter Rear Rotor"
            ]
        },
        "GMC": {
            "Savana 2500": [
                ""
            ],
            "Sierra 1500": [
                "With 4 Piston Front Caliper",
                "With 6 Piston Front Brembo Calipers"
            ],
            "Sierra 2500 HD": [
                ""
            ],
            "Sierra 3500 HD": [
                "With Dual Rear Wheels",
                "With Single Rear Wheels"
            ],
            "Terrain": [
                "With Single Piston Front Caliper"
            ],
            "Yukon XL": [
                "With 4 Piston Front Caliper"
            ]
        },
        "Honda": {
            "Accord": [
                "1.5L",
                "2.0L"
            ],
            "Civic": [
                "LX/Sport/EX/Sport Touring/Touring"
            ],
            "Passport": [
                ""
            ],
            "Ridgeline": [
                ""
            ]
        },
        "Hyundai": {
            "Elantra": [
                "Turbocharged. With Electric Parking Brake",
                "Turbocharged. With Manual Parking Brake"
            ],
            "Palisade": [
                ""
            ],
            "Santa Cruz": [
                ""
            ],
            "Sonata": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "Tucson": [
                ""
            ]
        },
        "INFINITI": {
            "Q50": [
                "With Dual Piston Caliper"
            ],
            "QX80": [
                ""
            ]
        },
        "Jeep": {
            "Grand Wagoneer": [
                ""
            ],
            "Grand Wagoneer L": [
                ""
            ],
            "Wagoneer": [
                ""
            ],
            "Wagoneer L": [
                ""
            ]
        },
        "Kia": {
            "Carnival": [
                ""
            ],
            "Forte": [
                "1.6L. With Electric Parking Brake",
                "2.0L. With Electric Parking Brake"
            ],
            "K5": [
                "1.6L",
                "2.5L"
            ],
            "Niro EV": [
                ""
            ],
            "Seltos": [
                "AWD. With Electric Parking Brake",
                "AWD. With Manual Parking Brake",
                "FWD. With Electric Parking Brake"
            ],
            "Sorento": [
                "GAS engine. With 305mm Diameter Rear Rotor",
                "GAS engine. With 325mm Diameter Rear Rotor",
                "PLUG-IN HYBRID EV-GAS (PHEV)/FULL HYBRID EV-GAS (FHEV) engine"
            ],
            "Sportage": [
                ""
            ]
        },
        "Lexus": {
            "ES250": [
                ""
            ],
            "ES300h": [
                ""
            ],
            "ES350": [
                ""
            ],
            "UX250h": [
                ""
            ]
        },
        "Mazda": {
            "3": [
                "AWD",
                "FWD"
            ],
            "3 Sport": [
                "AWD",
                "FWD"
            ],
            "CX-30": [
                "With 264mm Diameter Rear Rotor",
                "With 302mm Diameter Rear Rotor"
            ],
            "CX-5": [
                "Naturally Aspirated",
                "Turbocharged"
            ],
            "CX-50": [
                ""
            ]
        },
        "Mercedes-Benz": {
            "Sprinter 2500": [
                "With Single Rear Wheels and With Electric Parking Brake",
                "With Single Rear Wheels and With Manual Parking Brake"
            ]
        },
        "Mitsubishi": {
            "Outlander Sport": [
                ""
            ],
            "RVR": [
                ""
            ]
        },
        "Nissan": {
            "Murano": [
                ""
            ],
            "TITAN XD": [
                ""
            ]
        },
        "Ram": {
            "1500": [
                "5.7L/3.6L",
                "6.2L"
            ],
            "2500": [
                ""
            ],
            "3500": [
                "With Single Rear Wheels"
            ]
        },
        "Subaru": {
            "Ascent": [
                ""
            ],
            "Crosstrek": [
                ""
            ],
            "Forester": [
                "With 316mm Diameter Front Rotor"
            ],
            "Legacy": [
                ""
            ],
            "Outback": [
                ""
            ]
        },
        "Toyota": {
            "Camry": [
                "SE Nightshade/Hybrid SE Nightshade. With Electric Parking Brake",
                "SE Nightshade/Hybrid SE Nightshade. With Manual Parking Brake"
            ],
            "Corolla": [
                ""
            ],
            "RAV4": [
                ""
            ],
            "Sequoia": [
                ""
            ],
            "Tundra": [
                ""
            ]
        },
        "Volkswagen": {
            "Atlas": [
                ""
            ],
            "Atlas Cross Sport": [
                ""
            ]
        },
        "Volvo": {
            "C40 Recharge": [
                ""
            ]
        }
    },
    "2025": {
        "Ford": {
            "F-150": [
                "With 336mm Diameter Rear Rotor",
                "With 350mm Diameter Rear Rotor",
                "With Standard Brakes and With 336mm Diameter Rear Rotor"
            ]
        },
        "Hyundai": {
            "Sonata": [
                "Naturally Aspirated"
            ]
        },
        "Kia": {
            "K5": [
                "Turbocharged"
            ],
            "Niro EV": [
                ""
            ],
            "Seltos": [
                "AWD. With Electric Parking Brake",
                "FWD. With Electric Parking Brake"
            ]
        },
        "Mazda": {
            "3": [
                "AWD",
                "FWD"
            ],
            "3 Sport": [
                "AWD",
                "FWD"
            ],
            "CX-30": [
                "With 264mm Diameter Rear Rotor"
            ]
        },
        "Toyota": {
            "Corolla": [
                ""
            ]
        }
    }
}